import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from 'react';
import { useLocation, useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import ReactDOM, { flushSync } from 'react-dom';
import ReactFlow, { 
  MiniMap, 
  Controls, 
  Background, 
  useNodesState, 
  useEdgesState,
  ConnectionLineType, 
  MarkerType, 
  Position 
} from 'reactflow';
import 'reactflow/dist/style.css';
import dagre from 'dagre';
import html2canvas from 'html2canvas';
import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fontsource-variable/geist/wght.css';
import './App.css';
import './features/experiencia-cliente/components/ExperienciaClienteDetalhesModal.css';
import './features/board/components/BoardColumnFilter.css';
import './features/board/components/TechnicianColumnMinimize.css';
import './features/board/components/TechnicianColumnStack.css';
import {
  applyTechnicianColumnStack,
  applyVerticalGroupStacks,
  areTechnicianColumnStacksEqual,
  getTechnicianColumnSlots,
  getTechnicianStackGroupSize,
  normalizeStackMembers,
  pruneTechnicianColumnStacks,
  unstackTechnicianColumn,
} from './features/board/utils/technicianColumnStacks';
import { TechnicianStackedColumnResizable } from './features/board/components/TechnicianStackedColumnResizable';
import Login from './Login';
import LoginNovo from './LoginNovo';
import EsqueceuSenha from './EsqueceuSenha';
import RedefinirSenha from './RedefinirSenha';
import CxPublicRatingPage from './features/customer-experience/components/CxPublicRatingPage';
import TechnicianPublicRoadmapPage from './features/technician-panel/public/TechnicianPublicRoadmapPage';
import packageJson from '../package.json';
import jsPDF from 'jspdf';
import { OpenOSModal, OpenOsV2MockOverlay } from './features/new-os';
import { OpenColumnBoard, BoardOrderContextMenu, BoardOrderDeleteOverlay, BoardOnlyTechniciansWithOSCheckbox, BoardFiltrarSLATrigger, BoardFiltrarSLAModal, BoardMinimizedTechniciansBar, RefreshLoadingModal, LoadingStepsList, mapAppLoadingStepStatus, deleteOrder as boardDeleteOrder, isExcluirOSDisabledForGroup, isBoardLiveServiceGroup, normalizeTechnicianLiveServiceGroups, useOnlyTechniciansWithOSFilter, useAuditLog, useOrderDetailsAuditLogs, useOrderDetailsHistorico, filterTechnicianColumnsByHasOrders, filterTechnicianColumnsByFuturaRange, getTechnicianOrderCount, getAlterarTecnicoMenuItem, buildAreasWithTechniciansFromTeamData, OrderDetailsModal, OrderDetailsModalV2, OrderDetailsMockOverlay, OrderDetailsFooter, OrderDetailsAuditLogs, OrderDetailsHistoricoProcesso, TechnicianCityGroup, TechnicianColumn, OpenColumnCityGroup, OpenColumnVirtualCityList, isOrderRetornoByRequestStatus, isOrderPedidoLiberado, isOrderWithinSlaFiltrarDeadline, useFuturaRetornoTabsEnabled, useFuturaRetornoTechnicianLogic, FuturaRetornoTechnicianTabs, FuturaRetornoTechnicianOrdersPanel, getAllTechnicianOrdersForCondtTabs, computeFuturaCondtTabListsWithMatcher, pickFuturaRetornoTabForSearch, computeFuturaRetornoBoardBellState, computeFuturaRetornoBoardBellTechnicianSummary, FuturaRetornoBoardBellFilterButton, FuturaDateFilterButton, FuturaDateFilterPeriodPortal, getBoardClienteExibicao, getBoardClienteTooltipNome, TechnicianMenuModals, useTechnicianMenu, shouldCloseTechnicianMenuOnOutsideClick, OrderStatusModal } from './features/board';
import { TechnicianSessionVirtualList } from './features/board/components/TechnicianSessionVirtualList';
import {
  estimateTechnicianCityBlockSize,
  estimateTechnicianForecastBlockSize,
} from './features/board/utils/technicianSessionVirtual';
import FutureDateModal from './features/board/components/FutureDateModal';
import { RouteModal } from './features/board/components/RouteModal';
import { useClearMultiOrderSelectionOnOutsideClick } from './features/board/hooks/useClearMultiOrderSelectionOnOutsideClick';
import { useBoardTrackableTechnicians } from './features/board/hooks/useBoardTrackableTechnicians';
import { useBoardActiveLunchTechnicians } from './features/board/hooks/useBoardActiveLunchTechnicians';
import { useBoardTechnicianAvatars } from './features/board/hooks/useBoardTechnicianAvatars';
import { getBoardDragOrderIds, isBoardOrderDragEvent, sameBoardOrderId } from './features/board/utils/boardOrderDrag';
import {
  collectOrderIdsFromCityGroups,
  collectOrderIdsFromTechnicianGroups,
  toggleOrderSelectionInColumnScope,
  toggleCityOrdersSelectionInOpenScope,
} from './features/board/utils/boardOrderColumnSelection';
import { isBoardReadyOrder, reuseBoardOrders } from './features/board/utils/reuseBoardMappedOrder';
import { assembleBoardTeamData } from './features/board/utils/assembleBoardTeamData';
import {
  fetchBoardBootstrap,
  applyBoardBootstrapConfigs,
  applyBoardBootstrapBell,
  applyBoardBootstrapTeam,
} from './features/board/services/boardBootstrapClient';
import { getHydratedBoardFilterTechnicians, getVisibleBoardTechnicianNames, hasActiveBoardTeamFilters } from './features/board/utils/getVisibleBoardTechnicianNames';
import {
  mergeCacheIntoEmptyTechnicianGroups,
  isTechnicianBoardGroupsEmpty,
} from './features/board/utils/mergeCacheIntoEmptyTechnicianGroups';
import { hydrateTechnicianCondtAuxGroups } from './features/board/utils/hydrateTechnicianCondtAuxGroups';
import {
  BOARD_ORDERS_LIST_VIEW,
  withBoardOrdersListView,
} from './features/board/utils/boardOrdersListView';
import {
  mergeBoardOrderDetailPayload,
  needsBoardOrderFullLookup,
} from './features/board/utils/mergeBoardOrderDetailPayload';
import { BoardTechnicianColumnsSkeleton } from './features/board/components/BoardTechnicianColumnsSkeleton';
import './features/board/components/TechnicianColumnSessionDropOverlay.css';
import { CheckoutViewModal } from './features/checkout-view';
import { /* ConfigStatusView, */ ConfigStatusView2, ProcessConfigSkeleton, PROCESS_SKELETON_BY_SUBMENU, ConfigColunasView, EmailNotificationsConfigPage, CondicoesIntervencaoConfig, DefeitosVerveConfig, OficinaConfig, ProcessConfigSidebar } from './features/process-config';
import { GoConfig } from './features/go-config';
import { ConfigOryaAssistant } from './features/config-assistant';
import './features/config-assistant/ConfigOryaAssistant.css';
import MarcaSubgruposCadastrosConfig from './features/process-config/components/MarcaSubgruposCadastrosConfig';
import { sendSeraAtendidaAmanha, sendSeraAtendidaHoje } from './features/process-config/services/emailNotificationsService';
import { fetchCheckoutContador } from './features/checkout-view/services/checkoutViewService';
import { validateBoardDragSpecialty, BOARD_SPECIALTY_DRAG_MSG } from './features/board/services/boardDragSpecialtyService';
import { validateBoardDragClienteContrato } from './features/board/services/boardDragClienteContratoService';
import { validateBoardDragPrevistoGoSync, BOARD_DRAG_MSG_PREVISTO_GO_OFFLINE } from './features/board/services/boardDragPrevistoGoSyncService';
import { enrichOrderResultsWithContratoVenc } from './features/board/services/boardContratoVencService';
import BoardDragValidationModal from './features/board/components/BoardDragValidationModal';
import './features/board/components/BoardDragValidationModal.css';
import './features/board/components/TechnicianColumnModern.css';
import './features/board/toolbar/BoardClickUpFilterChip.css';
import './features/board/components/OpenColumnModern.css';
import './features/board/components/OpenColumnCollapse.css';
import './features/board/components/BoardListContentVisibility.css';
import { buildEncaminharPanelConfig } from './features/board/utils/orderDetailsEncaminharUtils';
import { BoardEncaminharAgendaOverlay } from './features/board/components/BoardEncaminharAgendaOverlay';
import { resolveBoardEncaminharRouteOrigin } from './features/board/utils/boardEncaminharRouteUtils';
import { createEmptyTechnicianBoardGroups } from './features/board/utils/boardEncaminharChamadoUtils';
import { OficinaView } from './features/oficina';
// import { EquipeView } from './features/equipe'; // substituído por Equipe2View em /cadastros/equipe
import { Equipe2View } from './features/equipe2';
import { FechamentoPage } from './features/fechamento';
import useOpenOsDetailsFromNav from './features/pg-native/useOpenOsDetailsFromNav';
import { EquipmentConsultSearchModal, EquipmentConsultDetailModal } from './features/equipment-consult';
// import { GestaoTecnicosPage } from './features/cadastros/tecnicos'; // funções migradas para Gestão de equipe
import { CompatibilidadeEquipamentosPage } from './features/cadastros/compatibilidade-equipamentos';
import { MonitoramentoPage } from './features/monitoramento';
import { GestaoReembolsosPage, FINANCEIRO_ROUTES, FINANCEIRO_REEMBOLSOS_ROUTE } from './features/financeiro';
import { KitTecnicoPage, ESTOQUE_ROUTES, ESTOQUE_KIT_TECNICO_ROUTE } from './features/estoque';
import {
  RoadmapSchedulePage,
  ROADMAP_SCHEDULE_ROUTE,
} from './features/roadmap-schedule';
import { CannyUserSection, CannySuccessOverlay, HubFeedbackView, ChangelogDropdown } from './features/canny';
import { PassPolicyModal, fetchPassPolicy, AuthHistoryModal } from './features/security';
import { TechnicianPanelMockModal, TECHNICIAN_PANEL_ROUTE, getRememberedTechnicianPanelTechnician, clearRememberedTechnicianPanelTechnician } from './features/technician-panel';
import { createTechnicianRoadmapShare } from './features/technician-panel/services/technicianPanelApi';
import {
  openRoadmapSharePanel,
  routeShareFingerprint,
} from './features/technician-panel/utils/roadmapSharePanel';
import './features/technician-panel/utils/roadmapSharePanel.css';
import { UserManagementList } from './features/user-management/components/UserManagementList';
import { UserFormSecurityTabs } from './features/user-management/components/UserFormSecurityTabs';
import { UserFormConnectedAccounts } from './features/user-management/components/UserFormConnectedAccounts';
import { UserFormCoordinatorUnlinkModal } from './features/user-management/components/UserFormCoordinatorUnlinkModal';
import { UserFormTechnicianOsBlockModal } from './features/user-management/components/UserFormTechnicianOsBlockModal';
import { UserFormTabErrorBanner } from './features/user-management/components/UserFormTabErrorBanner';
import { userFormTabHasError } from './features/user-management/utils/userFormTabErrors';
import { useCxExpToast } from './features/customer-experience/components/CxExpSonnerToast';
import {
  fetchUserProfilePhotoUrl,
  useUserProfilePhotos,
} from './features/user-management/hooks/useUserProfilePhotos';
import { exportUsersToXlsx } from './features/user-management/utils/userManagementExport';
import { validatePasswordForPolicy } from './features/security/passwordPolicyValidation';
import { UsersCustomersView } from './features/users-customers';
import CustomersAffiliateIcon from './components/icons/IconAffiliate';
import { IntegracoesPage } from './features/integracoes';
import { IconAdjustmentsAlt, IconFileAnalytics, IconHelpHexagon, IconPackages, IconPointerCollaboration2, IconSparkles, IconWallet } from '@tabler/icons-react';
import { PainelControleView } from './features/painel-controle';
import { ConfigHubView, ConfigSectionTopBar, useConfigSectionParam } from './features/config-hub';
import GoogleOauthPopup from './features/painel-controle/GoogleOauthPopup';
import { RefreshCw, MonitorCheck, Headset, FilePen, Trash, Bolt, GraduationCap, MessageCircleCode, KeyRound, LogOut, Pencil, Signpost, Ticket, BetweenVerticalStart, Tags, Bug, Wrench, Mail, CircleUser, CircleUserRound, ShieldCheck, Cog, ChevronDown, Settings, PrinterCheck, Minus, ScanSearch, Forward, Info, BadgeCheck, Package, Store, Gauge, RotateCcw, Unplug, PackagePlus, Server, Hash, Send, Eye, EyeOff, Trash2, Building2, HardDrive, Image as ImageIconLucide, Ellipsis, Route as RouteIcon, Calendar, CalendarClock, Group, CircleCheck, Workflow, Users, Plug, Sparkles, History, Banknote, Rows2 } from 'lucide-react';
import { UserProfileModal } from './features/profile';
import { UserAppearanceMenuItem } from './features/shell/UserAppearanceMenu';
import { playThemeCoverTransition, isThemeCoverRunning } from './features/shell/ThemeCoverTransition';
import {
  normalizeBlacktheme,
  resolveThemeFromPreference,
  THEME_PREF,
} from './features/shell/themePreference';
import { getApiBaseUrl } from './utils/apiConfig';
import { clearAuthSession, hasAuthSession, markAuthSession, resolveSessionUserId } from './utils/authSession';
import {
  canAccessFullAnalisesMenu,
  canAccessExperienciaClienteModule,
  canAccessRelatoriosAsCoordenador,
  canAccessRelatoriosModule,
  canShowAnalisesNav,
} from './utils/userAnalisesAccess';
import {
  canAccessFinanceiroMenu,
  canShowReembolsoPermissionGroup,
  hasGoAppLicense,
  canAccessCompatibilidadeEquipamentos,
  isGoPremiumLicense,
  isFinanceiroOnlyMode,
} from './utils/userFinanceiroAccess';
import { compressProfileImage, PROFILE_IMAGE_ACCEPT } from './utils/compressProfileImage';
import { compressCompanyLogo, COMPANY_LOGO_ACCEPT } from './utils/compressCompanyLogo';
import SessionExpiredModal from './components/SessionExpiredModal';
import { strTrim, hasDefeitoAlert, normalizeHexColor, defeitoAlertTooltipText } from './features/board/utils/defeitoAlertBadge';
import { BoardSearchWithFilters } from './features/board/board-search-filters';
import {
  getAvailablePrevisaoKeys,
  nextPrevisaoSelection,
  previsaoSelectionEquals,
} from './features/board/board-search-filters/syncPrevisaoFilterFromGroups';
import { OryaVirtualTour } from './features/board/tour/OryaVirtualTour';
import { getOryaTourSettings } from './features/board/tour/oryaTourConstants';
import { setAprenderVersionNavIntent } from './features/documentation/utils/aprenderNavIntent';
import { BoardToolbarAreaClickUpChip, BoardToolbarCoordenadorClickUpChip, BoardToolbarMenuClickUpButton, BoardToolbarRefreshClickUpButton, BoardToolbarTecnicosClickUpChip, BoardTechnicianViewSubmenu, BoardTechnicianViewModal } from './features/board/toolbar';
import { useOpenColumnCollapsedPreference } from './features/board/hooks/useOpenColumnCollapsedPreference';
import {
  normalizeOpenColumnMinimized,
  normalizeTechnicianColumnStack,
  persistBoardViewPrefs,
} from './features/board/utils/boardViewPrefs';
import { BoardChatToolbarButton, CustomersOnlyModeShell, BOARD_CADASTRO_ROUTE, CUSTOMERS_ONLY_TABS_HOST_ID } from './features/board-chat';
import {
  patchConversationOs,
  notifyConversationOsUpdated,
} from './features/board-chat/services/boardChatService';
import {
  countOpenOrdersByStatus,
  fetchOsStatusInicial,
} from './features/board-chat/services/boardNovosChamadosService';
import { useCustomersOpenOrdersPoll } from './features/board-chat/hooks/useCustomersOpenOrdersPoll';
import { computeEmAbertoPickerCounts } from './features/board/board-search-filters/computeEmAbertoPickerCounts';
import { orderMatchesTipoOSFilter, orderMatchesUserOsTypeRestriction, userOsLoadFlagsToBoardLetters } from './features/board/board-search-filters/tipoOsFilterUtils';
import {
  buildRouteDefeitoPrintRows,
  enrichRouteOrdersDefeitoObs,
  escapeRoutePrintHtml,
  ROUTE_PRINT_DEFEITO_CSS,
} from './features/board/utils/routePrintReportUtils';

/** Submenu Processos → Especialidade técnica — ícone printer-check (Lucide) */
const EspecialidadeTecnicaMenuIcon = PrinterCheck;

const RelatoriosPage = React.lazy(() => import('./features/relatorios').then((m) => ({ default: m.RelatoriosPage })));
const ExperienciaClientePage = React.lazy(() => import('./features/experiencia-cliente').then((m) => ({ default: m.ExperienciaClientePage })));
const ExperienciaClienteAvPendentesPage = React.lazy(() => import('./features/experiencia-cliente').then((m) => ({ default: m.ExperienciaClienteAvPendentesPage })));
const DocumentationView = React.lazy(() => import('./features/documentation').then((m) => ({ default: m.DocumentationView })));

/** Rotas de Configurações (admin): URL dedicada por aba */
const CONFIG_ROUTE_HOME = '/configuracoes';
const CONFIG_ROUTE_PROCESSOS = '/configuracoes/processos';
const CONFIG_ROUTE_GO = '/configuracoes/go';
const CONFIG_ROUTE_USUARIOS = '/configuracoes/usuarios';
const CONFIG_ROUTE_CUSTOMERS = '/configuracoes/customers';
const CONFIG_ROUTE_EMPRESA = '/configuracoes/empresa';
const CONFIG_ROUTE_PAINEL_CONTROLE = '/configuracoes/painel-controle';
const INTEGRACOES_ROUTE_BASE = '/configuracoes/integracoes';
const INTEGRACOES_ROUTE_LOGISTICA = '/configuracoes/integracoes/1';
const INTEGRACOES_ROUTE_AREA_TECNICA = '/configuracoes/integracoes/2';
const INTEGRACOES_ROUTES = [
  INTEGRACOES_ROUTE_BASE,
  INTEGRACOES_ROUTE_LOGISTICA,
  INTEGRACOES_ROUTE_AREA_TECNICA
];
const CONFIG_ROUTES = [
  CONFIG_ROUTE_PROCESSOS,
  CONFIG_ROUTE_GO,
  CONFIG_ROUTE_USUARIOS,
  CONFIG_ROUTE_CUSTOMERS,
  CONFIG_ROUTE_EMPRESA,
  CONFIG_ROUTE_PAINEL_CONTROLE
];
const CONFIG_BAR_ROUTES = [...CONFIG_ROUTES, ...INTEGRACOES_ROUTES];
const isConfigHomePath = (pathname) =>
  pathname === CONFIG_ROUTE_HOME || pathname === `${CONFIG_ROUTE_HOME}/`;
const isConfigAreaPath = (pathname) =>
  isConfigHomePath(pathname) ||
  CONFIG_BAR_ROUTES.includes(pathname) ||
  String(pathname || '').startsWith(`${CONFIG_ROUTE_HOME}/`);

const CONFIG_PATH_TO_SECTION = {
  [CONFIG_ROUTE_PROCESSOS]: 'process',
  [CONFIG_ROUTE_GO]: 'go',
  [CONFIG_ROUTE_USUARIOS]: 'users',
  [CONFIG_ROUTE_CUSTOMERS]: 'usersCustomers',
  [CONFIG_ROUTE_EMPRESA]: 'company',
  [CONFIG_ROUTE_PAINEL_CONTROLE]: 'painelControle',
  [INTEGRACOES_ROUTE_BASE]: 'integrations',
  [INTEGRACOES_ROUTE_LOGISTICA]: 'integrations',
  [INTEGRACOES_ROUTE_AREA_TECNICA]: 'integrations'
};
const CONFIG_SECTION_TO_PATH = {
  process: CONFIG_ROUTE_PROCESSOS,
  go: CONFIG_ROUTE_GO,
  users: CONFIG_ROUTE_USUARIOS,
  usersCustomers: CONFIG_ROUTE_CUSTOMERS,
  company: CONFIG_ROUTE_EMPRESA,
  painelControle: CONFIG_ROUTE_PAINEL_CONTROLE
};

/** Rotas full-page fora do kanban; sync com window e exclusão do item Board/Oficina ativo */
const APP_FULL_PAGE_ROUTES = [
  '/fechamento',
  '/relatorios',
  '/analise/experiencia-cliente',
  '/analise/experiencia-cliente/av-pendentes',
  '/hubfeedback',
  '/monitoramento',
  '/aprender',
  '/cadastros/equipe',
  '/cadastros/compatibilidade-equipamentos',
  // '/cadastros/tecnicos', // oculto — funções em Gestão de equipe
  ...FINANCEIRO_ROUTES,
  ...ESTOQUE_ROUTES,
  ...INTEGRACOES_ROUTES,
  ...CONFIG_ROUTES,
  CONFIG_ROUTE_HOME
];
const CADASTROS_ROUTES = ['/cadastros/equipe', '/cadastros/compatibilidade-equipamentos'];

let API_BASE_URL = getApiBaseUrl();

// Mock data removido - agora usando dados reais da base de dados

// Dados de ordens são carregados via API - inicialização vazia
const availableOrders = [];

// Componente de configuração do banco de dados (movido para fora para evitar recriação)
const DatabaseConfig = ({ 
  dbConfig, 
  setDbConfig, 
  connectionStatus, 
  setConnectionStatus, 
  isTestingConnection, 
  setIsTestingConnection, 
  connectionTested, 
  setConnectionTested 
}) => {
  const handleInputChange = (field, value) => {
    setDbConfig(prev => ({
      ...prev,
      [field]: value
    }));
    // Reset status quando alterar configurações
    setConnectionStatus(null);
    setConnectionTested(false);
  };

  const testConnection = async () => {
    if (!dbConfig.host || !dbConfig.database || !dbConfig.username || !dbConfig.password) {
      setConnectionStatus({
        success: false,
        message: 'Por favor, preencha todos os campos obrigatórios.'
      });
      return;
    }

    setIsTestingConnection(true);
    setConnectionStatus(null);

    try {
      console.log('🔄 Testando conexão com o banco de dados...');
      const response = await fetch(`${API_BASE_URL}/api/config/database/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          host: dbConfig.host,
          database: dbConfig.database,
          username: dbConfig.username,
          password: dbConfig.password
        })
      });

      const result = await response.json();
      
      if (result.success) {
        console.log('✅ Conexão testada com sucesso!');
        setConnectionStatus({
          success: true,
          message: result.message
        });
        setConnectionTested(true);
      } else {
        console.log('❌ Erro na conexão:', result.message);
        setConnectionStatus({
          success: false,
          message: result.message
        });
        setConnectionTested(false);
      }
    } catch (error) {
      console.error('❌ Erro ao testar conexão:', error);
      setConnectionStatus({
        success: false,
        message: `Erro de conexão: ${error.message}`
      });
      setConnectionTested(false);
    } finally {
      setIsTestingConnection(false);
    }
  };

  const saveConfiguration = async () => {
    if (!connectionTested) {
      setConnectionStatus({
        success: false,
        message: 'É necessário testar a conexão antes de salvar.'
      });
      return;
    }

    try {
      console.log('💾 Salvando configuração do banco de dados...');
      const response = await fetch(`${API_BASE_URL}/api/config/database/save`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          host: dbConfig.host,
          database: dbConfig.database,
          username: dbConfig.username,
          password: dbConfig.password
        })
      });

      const result = await response.json();
      
      if (result.success) {
        console.log('✅ Configuração salva com sucesso!');
        setConnectionStatus({
          success: true,
          message: result.message
        });
      } else {
        console.log('❌ Erro ao salvar:', result.message);
        setConnectionStatus({
          success: false,
          message: result.message
        });
      }
    } catch (error) {
      console.error('❌ Erro ao salvar configuração:', error);
      setConnectionStatus({
        success: false,
        message: `Erro ao salvar: ${error.message}`
      });
    }
  };

  return (
    <div className="database-config" style={{ pointerEvents: 'none', userSelect: 'none', opacity: 0.8, cursor: 'not-allowed' }}>
      <h3 className="config-title">Configuração do Banco de Dados</h3>
      <p className="config-description">Configure a conexão com o Microsoft SQL Server</p>
      
      <div className="config-form">
        <div className="form-group">
          <label htmlFor="host">IP ou Hostname *</label>
          <input
            type="text"
            id="host"
            value={dbConfig.host}
            onChange={(e) => handleInputChange('host', e.target.value)}
            placeholder="192.168.1.100 ou servidor.empresa.com"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="database">Nome da Base de Dados *</label>
          <input
            type="text"
            id="database"
            value={dbConfig.database}
            onChange={(e) => handleInputChange('database', e.target.value)}
            placeholder="PainelOS_DB"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="username">Usuário *</label>
          <input
            type="text"
            id="username"
            value={dbConfig.username}
            onChange={(e) => handleInputChange('username', e.target.value)}
            placeholder="sa ou usuario_db"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Senha *</label>
          <input
            type="password"
            id="password"
            value={dbConfig.password}
            onChange={(e) => handleInputChange('password', e.target.value)}
            placeholder="••••••••"
            className="form-input"
          />
        </div>

        <div className="form-actions">
          <button 
            onClick={testConnection}
            disabled={isTestingConnection}
            className="btn-test"
          >
            {isTestingConnection ? 'Testando...' : 'Testar Conexão'}
          </button>

          <button 
            onClick={saveConfiguration}
            disabled={!connectionTested}
            className="btn-save"
          >
            Salvar Configuração
          </button>
        </div>

        {connectionStatus && (
          <div className={`connection-status ${connectionStatus.success ? 'success' : 'error'}`}>
            <span className="status-icon">
              {connectionStatus.success ? '✓' : '✗'}
            </span>
            <span className="status-message">{connectionStatus.message}</span>
          </div>
        )}
      </div>
    </div>
  );
};

// Componente de configuração dos processos
const PROCESS_CONFIG_SUBMENUS = [
  'config-status-2',
  'coluna-em-aberto',
  'condicoes-intervencao',
  'defeitos-verve',
  'cadastros-marcas-subgrupos',
  'notificacoes-email',
  'oficina',
];

const ProcessConfig = ({ userDisplayName = '' }) => {
  // Estados para controle de carregamento e mensagens
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');
  
  // Estado para controlar qual submenu está ativo (?s= do hub de busca)
  const [activeSubmenu, setActiveSubmenu] = useConfigSectionParam(
    'config-status-2',
    PROCESS_CONFIG_SUBMENUS
  );
  
  // Estado para configuração de busca de equipamento
  const [equipmentSearchType, setEquipmentSearchType] = useState('serie-patrimonio'); // 'serie-patrimonio' ou 'patrimonio-only'
  const [isLoadingEquipmentSearch, setIsLoadingEquipmentSearch] = useState(false);
  const [equipmentSearchReady, setEquipmentSearchReady] = useState(false);
  const [isSavingEquipmentSearch, setIsSavingEquipmentSearch] = useState(false);
  const [equipmentSearchMessage, setEquipmentSearchMessage] = useState('');
  // Estados controlados para cada campo (renderização garantida pelo React)
  const [statusInservice, setStatusInservice] = useState('');
  const [statusDeslocamento, setStatusDeslocamento] = useState('');
  const [statusRetorno, setStatusRetorno] = useState('');
  const [statusForward, setStatusForward] = useState('');
  const [statusTomorrow, setStatusTomorrow] = useState('');
  const [statusUptodate, setStatusUptodate] = useState('');
  const [statusFinish, setStatusFinish] = useState('');
  const [osCorretiva, setOsCorretiva] = useState(''); // OS Corretiva
  const [osEstoque, setOsEstoque] = useState(''); // OS Estoque
  const [osPreventiva, setOsPreventiva] = useState(''); // OS Preventiva
  const [osAfericao, setOsAfericao] = useState(''); // OS Afericao
  const [osDesinstalacao, setOsDesinstalacao] = useState(''); // OS Desinstalacao
  const [osRecarga, setOsRecarga] = useState(''); // OS Recarga
  const [osBalcao, setOsBalcao] = useState(''); // OS Balcao
  const [habilitarTrocaStatus, setHabilitarTrocaStatus] = useState(false);
  const [enviarProximoDiaAutomatico, setEnviarProximoDiaAutomatico] = useState(false);
  const [futureTomorrowSchedule, setFutureTomorrowSchedule] = useState('04:30');
  const [futureTomorrowScheduleModalOpen, setFutureTomorrowScheduleModalOpen] = useState(false);
  const [retornoPorCondicaoIntervencao, setRetornoPorCondicaoIntervencao] = useState(false);

  // Estado para múltiplos status "Em Aberto"
  const [statusOpenTags, setStatusOpenTags] = useState([]);
  const [statusOpenInput, setStatusOpenInput] = useState('');
  const statusOpenInputRef = useRef(null);
  /** Código reservado de pré-atendimento (Customers) — não pode ser usado em status de Processos. */
  const [reservedPreServiceStatus, setReservedPreServiceStatus] = useState('');

  const [retiradaAtivaTags, setRetiradaAtivaTags] = useState([]);
  const [retiradaAtivaInput, setRetiradaAtivaInput] = useState('');
  const retiradaAtivaInputRef = useRef(null);

  // Estados para Automação (modal — Para atender no próximo dia)
  const [automationProximoDiaModalOpen, setAutomationProximoDiaModalOpen] = useState(false);
  const [automationData, setAutomationData] = useState({
    day1_sun: false,
    day2_mon: false,
    day3_tue: false,
    day4_wed: false,
    day5_thu: false,
    day6_fri: false,
    day7_sat: false,
    schedule: '',
    tipoagend: 1
  });
  const [isLoadingAutomation, setIsLoadingAutomation] = useState(true);
  const [automationError, setAutomationError] = useState(false);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  // Automação ao lado de RETORNO (modal)
  const [automationRetornoModalOpen, setAutomationRetornoModalOpen] = useState(false);
  const [automationStatusPedidoDisponivel, setAutomationStatusPedidoDisponivel] = useState('');
  const [automationStatusOsEncaminhar, setAutomationStatusOsEncaminhar] = useState('');

  // Função para carregar dados da API
  const loadData = async () => {
    try {
      setIsLoading(true);
      setMessage('');
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/process`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        // Definir valores usando setState para garantir renderização
        const inserviceValue = result.data.status_inservice || '';
        const forwardValue = result.data.status_forward || '';
        const tomorrowValue = result.data.status_tomorrow || '';
        const uptodateValue = result.data.status_uptodate || '';
        const finishValue = result.data.status_finish || '';
        
        // Usar setState para atualizar os valores (garante renderização)
        setStatusInservice(inserviceValue);
        setStatusForward(forwardValue);
        setStatusTomorrow(tomorrowValue);
        setStatusUptodate(uptodateValue);
        setStatusFinish(finishValue);
        
        // Carregar status_deslocamento de LCMY_SYS_PROCESS
        try {
          const deslocamentoResponse = await fetch(`${API_BASE_URL}/api/config/deslocamento`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          const deslocamentoResult = await deslocamentoResponse.json();
          
          if (deslocamentoResult.success && deslocamentoResult.data) {
            const deslocamentoValue = deslocamentoResult.data.codstatus || '';
            setStatusDeslocamento(deslocamentoValue);
          }
        } catch (error) {
          console.warn('⚠️ Erro ao carregar status_deslocamento:', error);
        }
        // Carregar status RETORNO (OS de retorno) de LCMY_SYS_PROCESS
        try {
          const retornoResponse = await fetch(`${API_BASE_URL}/api/config/retorno`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          const retornoResult = await retornoResponse.json();
          if (retornoResult.success && retornoResult.data) {
            setStatusRetorno(retornoResult.data.codstatus || '');
          }
        } catch (error) {
          console.warn('⚠️ Erro ao carregar status retorno:', error);
        }
        // Automação Retorno (status pedido disponível + status OS após encaminhar)
        try {
          const autoRetornoResponse = await fetch(`${API_BASE_URL}/api/config/automation-retorno`, {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
          });
          const autoRetornoResult = await autoRetornoResponse.json();
          if (autoRetornoResult.success && autoRetornoResult.data) {
            setAutomationStatusPedidoDisponivel(autoRetornoResult.data.statusPedidoDisponivel || '');
            setAutomationStatusOsEncaminhar(autoRetornoResult.data.statusOsEncaminhar || '');
          }
        } catch (error) {
          console.warn('⚠️ Erro ao carregar automação retorno:', error);
        }

        try {
          const preRes = await fetch(`${API_BASE_URL}/api/config/vc-sys-config/os-status-inicial`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          const preResult = await preRes.json();
          if (preResult.success && preResult.data) {
            const pre = String(preResult.data.preServiceStatus || '')
              .trim()
              .toUpperCase();
            setReservedPreServiceStatus(pre.length === 2 ? pre : '');
          } else {
            setReservedPreServiceStatus('');
          }
        } catch (error) {
          console.warn('⚠️ Erro ao carregar status pré-atendimento:', error);
          setReservedPreServiceStatus('');
        }

        // Carregar múltiplos status "Em Aberto"
        // IMPORTANTE: Mapear diretamente cada campo do banco para o índice correspondente do array
        // Isso garante que os índices do array correspondam exatamente aos campos ao salvar:
        // Índice 0 → status_open, Índice 1 → status_open1, ..., Índice 8 → status_open8
        // Preservar duplicatas (ex: status_open = status_open1 em dados antigos) para manter alinhamento
        // IMPORTANTE: Não remover duplicatas, apenas valores vazios do final para exibição na UI
        const openTags = [
          result.data.status_open || '',
          result.data.status_open1 || '',
          result.data.status_open2 || '',
          result.data.status_open3 || '',
          result.data.status_open4 || '',
          result.data.status_open5 || '',
          result.data.status_open6 || '',
          result.data.status_open7 || '',
          result.data.status_open8 || ''
        ];
        
        // Remover apenas valores vazios do final do array para exibição na UI
        // Preservar todos os valores não-vazios (incluindo duplicatas) para manter alinhamento de índices
        let filteredTags = [...openTags];
        while (filteredTags.length > 0 && filteredTags[filteredTags.length - 1] === '') {
          filteredTags.pop();
        }
        
        setStatusOpenTags(filteredTags);
      } else {
        // Deixar em branco se não houver dados
        setStatusInservice('');
        setStatusForward('');
        setStatusTomorrow('');
        setStatusUptodate('');
        setStatusFinish('');
        setStatusOpenTags([]);
      }
      
      // Carregar configuração de OS Corretiva
      try {
        const osCorretivaResponse = await fetch(`${API_BASE_URL}/api/config/os-corretiva`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osCorretivaResult = await osCorretivaResponse.json();
        
        if (osCorretivaResult.success && osCorretivaResult.data) {
          setOsCorretiva(osCorretivaResult.data.codstatus || '');
        } else {
          setOsCorretiva('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Corretiva:', error);
        setOsCorretiva('');
      }

      // Carregar configuração de OS Estoque
      try {
        const osEstoqueResponse = await fetch(`${API_BASE_URL}/api/config/os-estoque`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osEstoqueResult = await osEstoqueResponse.json();
        
        if (osEstoqueResult.success && osEstoqueResult.data) {
          setOsEstoque(osEstoqueResult.data.codstatus || '');
        } else {
          setOsEstoque('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Estoque:', error);
        setOsEstoque('');
      }

      // Carregar configuração de OS Preventiva
      try {
        const osPreventivaResponse = await fetch(`${API_BASE_URL}/api/config/os-preventiva`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osPreventivaResult = await osPreventivaResponse.json();
        
        if (osPreventivaResult.success && osPreventivaResult.data) {
          setOsPreventiva(osPreventivaResult.data.codstatus || '');
        } else {
          setOsPreventiva('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Preventiva:', error);
        setOsPreventiva('');
      }

      // Carregar configuração de OS Afericao
      try {
        const osAfericaoResponse = await fetch(`${API_BASE_URL}/api/config/os-afericao`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osAfericaoResult = await osAfericaoResponse.json();
        
        if (osAfericaoResult.success && osAfericaoResult.data) {
          setOsAfericao(osAfericaoResult.data.codstatus || '');
        } else {
          setOsAfericao('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Afericao:', error);
        setOsAfericao('');
      }

      // Carregar configuração de OS Desinstalacao
      try {
        const osDesinstalacaoResponse = await fetch(`${API_BASE_URL}/api/config/os-desinstalacao`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osDesinstalacaoResult = await osDesinstalacaoResponse.json();
        
        if (osDesinstalacaoResult.success && osDesinstalacaoResult.data) {
          setOsDesinstalacao(osDesinstalacaoResult.data.codstatus || '');
        } else {
          setOsDesinstalacao('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Desinstalacao:', error);
        setOsDesinstalacao('');
      }

      // Carregar configuração de OS Recarga
      try {
        const osRecargaResponse = await fetch(`${API_BASE_URL}/api/config/os-recarga`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osRecargaResult = await osRecargaResponse.json();
        if (osRecargaResult.success && osRecargaResult.data) {
          setOsRecarga(osRecargaResult.data.codstatus || '');
        } else {
          setOsRecarga('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Recarga:', error);
        setOsRecarga('');
      }

      // Carregar configuração de OS Balcao
      try {
        const osBalcaoResponse = await fetch(`${API_BASE_URL}/api/config/os-balcao`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const osBalcaoResult = await osBalcaoResponse.json();
        if (osBalcaoResult.success && osBalcaoResult.data) {
          setOsBalcao(osBalcaoResult.data.codstatus || '');
        } else {
          setOsBalcao('');
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar OS Balcao:', error);
        setOsBalcao('');
      }

      try {
        const retiradaRes = await fetch(`${API_BASE_URL}/api/config/retirada-ativa-abertura-os`, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const retiradaJson = await retiradaRes.json();
        if (retiradaJson.success && retiradaJson.data && Array.isArray(retiradaJson.data.codstatusList)) {
          setRetiradaAtivaTags(retiradaJson.data.codstatusList);
        } else {
          setRetiradaAtivaTags([]);
        }
      } catch (error) {
        console.warn('Erro ao carregar status retirada ativa:', error);
        setRetiradaAtivaTags([]);
      }

      // Troca de status em conclusão de OS (Fechamento)
      try {
        const res = await fetch(`${API_BASE_URL}/api/config/troca-status-conclusao`, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await res.json();
        if (data.success && data.data) {
          setHabilitarTrocaStatus((data.data.codstatus || '00') === '01');
        } else {
          setHabilitarTrocaStatus(false);
        }
      } catch (error) {
        console.error('❌ [ProcessConfig] Erro ao carregar troca status conclusão:', error);
        setHabilitarTrocaStatus(false);
      }
      try {
        const resFuturo = await fetch(`${API_BASE_URL}/api/config/alteracao-status-futuro-amanha`, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const dataFuturo = await resFuturo.json();
        if (dataFuturo.success && dataFuturo.data) {
          setEnviarProximoDiaAutomatico((dataFuturo.data.codstatus || '00') === '01');
          const sch = dataFuturo.data.schedule;
          setFutureTomorrowSchedule(
            sch != null && String(sch).trim() !== '' ? String(sch).trim() : '04:30'
          );
        } else {
          setEnviarProximoDiaAutomatico(false);
          setFutureTomorrowSchedule('04:30');
        }
      } catch (error) {
        console.warn('⚠️ Erro ao carregar alteração status futuro amanhã:', error);
        setEnviarProximoDiaAutomatico(false);
        setFutureTomorrowSchedule('04:30');
      }
      try {
        const resRetCond = await fetch(`${API_BASE_URL}/api/config/retornos-condicao-intervencao`, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const dataRetCond = await resRetCond.json();
        if (dataRetCond.success && dataRetCond.data) {
          setRetornoPorCondicaoIntervencao((dataRetCond.data.codstatus || '00') === '01');
        } else {
          setRetornoPorCondicaoIntervencao(false);
        }
      } catch (error) {
        console.warn('⚠️ Erro ao carregar retorno condição intervenção:', error);
        setRetornoPorCondicaoIntervencao(false);
      }
    } catch (error) {
      console.error('❌ [ProcessConfig] Erro ao carregar dados:', error);
      console.error('Stack:', error.stack);
      setMessage('Erro ao carregar dados da API');
      // Deixar em branco em caso de erro
      setStatusInservice('');
      setStatusForward('');
      setStatusTomorrow('');
      setStatusUptodate('');
      setStatusFinish('');
      setStatusOpenTags([]);
      setOsCorretiva('');
      setOsEstoque('');
      setOsPreventiva('');
      setOsAfericao('');
      setOsDesinstalacao('');
      setOsRecarga('');
      setRetiradaAtivaTags([]);
      setHabilitarTrocaStatus(false);
      setEnviarProximoDiaAutomatico(false);
      setFutureTomorrowSchedule('04:30');
      setRetornoPorCondicaoIntervencao(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Handlers para automação
  const handleAutomationDayChange = (dayKey) => {
    setAutomationData(prev => ({
      ...prev,
      [dayKey]: !prev[dayKey]
    }));
    // Limpar erro quando usuário começar a preencher
    if (automationError) {
      setAutomationError(false);
      setMessage('');
    }
  };

  const handleAutomationScheduleChange = (e) => {
    let value = e.target.value;
    
    // Remover caracteres não numéricos exceto ':'
    value = value.replace(/[^\d:]/g, '');
    
    // Limitar tamanho
    if (value.length > 5) {
      value = value.substring(0, 5);
    }
    
    // Adicionar ':' automaticamente após 2 dígitos
    if (value.length === 2 && !value.includes(':')) {
      value = value + ':';
    }
    
    setAutomationData(prev => ({
      ...prev,
      schedule: value
    }));
    
    // Limpar erro quando usuário começar a preencher
    if (automationError) {
      setAutomationError(false);
      setMessage('');
    }
  };

  const handleAutomationTipoagendChange = (e) => {
    const value = parseInt(e.target.value);
    setAutomationData(prev => ({
      ...prev,
      tipoagend: value
    }));
  };

  // Handlers para automação (Retorno): código 2 dígitos alfanumérico
  const handleAutomationStatusPedidoDisponivel = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 2) setAutomationStatusPedidoDisponivel(value);
  };
  const handleAutomationStatusOsEncaminhar = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 2) setAutomationStatusOsEncaminhar(value);
  };

  // Função para validar horário
  const validateSchedule = (schedule) => {
    if (!schedule || schedule.trim() === '') {
      return { valid: true, message: '' };
    }
    
    const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
    if (!timeRegex.test(schedule)) {
      return { valid: false, message: 'Horário inválido. Use o formato hh:mm (ex: 02:30)' };
    }
    
    return { valid: true, message: '' };
  };

  /** Agendamento "Enviar para PRÓXIMO DIA automaticamente": apenas 00:01–05:00. */
  const validateFutureTomorrowSchedule = (schedule) => {
    if (!schedule || schedule.trim() === '') {
      return { valid: false, message: 'Informe o horário entre 00:01 e 05:00.' };
    }
    const formatCheck = validateSchedule(schedule);
    if (!formatCheck.valid) return formatCheck;
    const m = String(schedule).trim().match(/^(\d{2}):(\d{2})$/);
    const mins = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    if (mins < 1 || mins > 300) {
      return { valid: false, message: 'Horário permitido: de 00:01 até 05:00.' };
    }
    return { valid: true, message: '' };
  };

  const handleFutureTomorrowScheduleChange = (e) => {
    setFutureTomorrowSchedule(e.target.value);
  };

  // Função para formatar data sem alterações de fuso horário (usar métodos locais)
  const formatDateLocal = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    // Usar métodos locais para evitar problemas de fuso horário
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  // Função para gerar relatório de logs em PDF
  const generateLogsReport = async () => {
    try {
      setIsGeneratingReport(true);
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/automation/logs`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const result = await response.json();
      
      if (!result.success || !result.data) {
        setMessage('Erro ao buscar logs de automação');
        setIsGeneratingReport(false);
        return;
      }

      const logs = result.data;
      
      if (logs.length === 0) {
        setMessage('Nenhum log de execução encontrado');
        setIsGeneratingReport(false);
        return;
      }

      // Criar PDF em formato A4 retrato
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;
      const contentWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      // Função para adicionar nova página se necessário
      const checkNewPage = (requiredHeight) => {
        if (yPosition + requiredHeight > pageHeight - margin) {
          pdf.addPage();
          yPosition = margin;
          return true;
        }
        return false;
      };

      // Cabeçalho
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(26, 32, 44);
      pdf.text('Relatório de Logs de Automação', margin, yPosition);
      yPosition += 10;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(100, 116, 139);
      pdf.text(`Gerado em: ${formatDateLocal(new Date().toISOString())}`, margin, yPosition);
      yPosition += 15;

      // Processar cada log
      logs.forEach((log, index) => {
        checkNewPage(60);

        // Separador entre registros
        if (index > 0) {
          pdf.setDrawColor(226, 232, 240);
          pdf.line(margin, yPosition, pageWidth - margin, yPosition);
          yPosition += 8;
        }

        // Data e hora
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(26, 32, 44);
        const startDate = formatDateLocal(log.started_at);
        const endDate = formatDateLocal(log.finished_at);
        pdf.text(`Execução: ${startDate}`, margin, yPosition);
        yPosition += 6;
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`Finalizada: ${endDate}`, margin, yPosition);
        yPosition += 6;

        // Status
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'bold');
        const statusColor = log.status === 'success' ? [34, 197, 94] : log.status === 'error' ? [239, 68, 68] : [251, 191, 36];
        pdf.setTextColor(statusColor[0], statusColor[1], statusColor[2]);
        pdf.text(`Status: ${log.status.toUpperCase()}`, margin, yPosition);
        yPosition += 6;

        // Processar affected_records_details se existir
        if (log.affected_records_details) {
          try {
            let details = typeof log.affected_records_details === 'string' 
              ? JSON.parse(log.affected_records_details) 
              : log.affected_records_details;

            // Normalizar para array
            let records = [];
            
            if (Array.isArray(details)) {
              // Já é um array direto
              records = details;
            } else if (details.records && Array.isArray(details.records)) {
              // Tem propriedade records com array
              records = details.records;
            } else if (details && typeof details === 'object' && details.OS) {
              // É um objeto único com dados
              records = [details];
            }

            if (records.length > 0) {
              pdf.setFontSize(10);
              pdf.setFont('helvetica', 'bold');
              pdf.setTextColor(26, 32, 44);
              pdf.text('Ordens de Serviço Afetadas:', margin, yPosition);
              yPosition += 6;

              // Cabeçalho da tabela
              pdf.setFontSize(8);
              pdf.setFont('helvetica', 'bold');
              pdf.setTextColor(100, 116, 139);
              let xPos = margin;
              pdf.text('OS', xPos, yPosition);
              xPos += 25;
              pdf.text('Seq. Ant.', xPos, yPosition);
              xPos += 20;
              pdf.text('Seq. Nova', xPos, yPosition);
              xPos += 20;
              pdf.text('Status Ant.', xPos, yPosition);
              xPos += 25;
              pdf.text('Status Novo', xPos, yPosition);
              yPosition += 5;

              // Linha separadora
              pdf.setDrawColor(203, 213, 225);
              pdf.line(margin, yPosition, pageWidth - margin, yPosition);
              yPosition += 4;

              // Dados das OS
              pdf.setFont('helvetica', 'normal');
              pdf.setTextColor(26, 32, 44);
              records.forEach((record) => {
                checkNewPage(8);
                xPos = margin;
                
                // OS
                const os = record.OS || record.TB02130_CODIGO || '-';
                pdf.text(String(os), xPos, yPosition);
                xPos += 25;
                
                // Ordem Anterior
                const ordemAnt = record.Ordem_Anterior !== undefined && record.Ordem_Anterior !== null 
                  ? String(record.Ordem_Anterior) 
                  : '-';
                pdf.text(ordemAnt, xPos, yPosition);
                xPos += 20;
                
                // Ordem Nova
                const ordemNova = record.Ordem_Nova !== undefined && record.Ordem_Nova !== null 
                  ? String(record.Ordem_Nova) 
                  : '-';
                pdf.text(ordemNova, xPos, yPosition);
                xPos += 20;
                
                // Status Anterior
                const statusAnt = record.Status_Anterior || record.Status_AnteriorOldStatus || '-';
                pdf.text(String(statusAnt), xPos, yPosition);
                xPos += 25;
                
                // Status Novo
                const statusNovo = record.Status_Novo || record.TB02130_STATUS || '-';
                pdf.text(String(statusNovo), xPos, yPosition);
                yPosition += 5;
              });
            }
          } catch (parseError) {
            console.error('Erro ao processar affected_records_details:', parseError);
          }
        }

        yPosition += 5;
      });

      // Rodapé
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(148, 163, 184);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pageWidth - margin - 30,
          pageHeight - 10
        );
      }

      // Salvar PDF
      const fileName = `relatorio_logs_automacao_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);

      setMessage('Relatório gerado com sucesso!');
      setIsGeneratingReport(false);
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      setMessage('Erro ao gerar relatório de logs');
      setIsGeneratingReport(false);
    }
  };

  // Função para validar dados de automação
  const validateAutomationData = () => {
    // Verificar se pelo menos um dia da semana está marcado
    const hasDaySelected = 
      automationData.day1_sun || 
      automationData.day2_mon || 
      automationData.day3_tue || 
      automationData.day4_wed || 
      automationData.day5_thu || 
      automationData.day6_fri || 
      automationData.day7_sat;
    
    // Verificar se horário está preenchido
    const hasSchedule = automationData.schedule && automationData.schedule.trim() !== '';
    
    // Se não há dias selecionados e não há horário, a automação não está configurada
    // Nesse caso, não é necessário validar (automação está desabilitada/vazia)
    if (!hasDaySelected && !hasSchedule) {
      return { valid: true, message: '' };
    }
    
    // Se há algum dado preenchido (dia ou horário), validar completamente
    if (!hasDaySelected) {
      return {
        valid: false,
        message: 'Termine de preencher os dados da automação em Para atender no próximo dia: selecione pelo menos um dia da semana.'
      };
    }
    
    if (!hasSchedule) {
      return {
        valid: false,
        message: 'Termine de preencher os dados da automação em Para atender no próximo dia: informe o horário.'
      };
    }
    
    // Verificar se horário está preenchido e válido
    const scheduleValidation = validateSchedule(automationData.schedule);
    if (!scheduleValidation.valid) {
      return {
        valid: false,
        message: scheduleValidation.message
      };
    }
    
    return { valid: true, message: '' };
  };

  // Função para salvar dados
  const saveData = async () => {
    try {
      setIsSaving(true);
      setMessage('');
      setAutomationError(false);
      
      // Validar dados de automação antes de salvar
      const automationValidation = validateAutomationData();
      if (!automationValidation.valid) {
        setMessage(automationValidation.message);
        setAutomationError(true);
        setIsSaving(false);
        return;
      }

      if (enviarProximoDiaAutomatico) {
        const sch = (futureTomorrowSchedule || '').trim();
        if (!sch) {
          setMessage('Informe o horário de execução do agendamento (ícone ao lado de “Enviar para PRÓXIMO DIA automaticamente”).');
          setIsSaving(false);
          return;
        }
        const schVal = validateFutureTomorrowSchedule(sch);
        if (!schVal.valid) {
          setMessage(schVal.message);
          setIsSaving(false);
          return;
        }
      }

      if (statusOpenTags.some((tag) => tag === '') || retiradaAtivaTags.some((tag) => tag === '')) {
        setMessage('Preencha ou remova os status em branco antes de salvar.');
        setIsSaving(false);
        return;
      }

      const preReserved = String(reservedPreServiceStatus || '')
        .trim()
        .toUpperCase();
      if (preReserved.length === 2) {
        const conflictLabels = [];
        const check = (cod, label) => {
          if (String(cod || '').trim().toUpperCase() === preReserved) conflictLabels.push(label);
        };
        check(statusInservice, 'Em serviço');
        check(statusDeslocamento, 'Em deslocamento');
        check(statusRetorno, 'Retorno de peças');
        check(statusForward, 'Encaminhado ao técnico');
        check(statusTomorrow, 'Próximo dia');
        check(statusUptodate, 'Em dia ou futura');
        check(statusFinish, 'Finalizado');
        statusOpenTags.forEach((tag) => check(tag, 'OS em aberto'));
        if (conflictLabels.length) {
          setMessage(
            `O status "${preReserved}" está reservado para pré-atendimento (Customers). Ajuste: ${[...new Set(conflictLabels)].join(', ')}.`
          );
          setIsSaving(false);
          return;
        }
      }
      
      // Garantir que o array tenha 9 elementos ao salvar (preenchendo com '' se necessário)
      // Isso preserva o alinhamento correto dos índices com os campos do banco
      const paddedTags = [...statusOpenTags];
      while (paddedTags.length < 9) {
        paddedTags.push('');
      }
      
      const formData = {
        status_inservice: statusInservice || '',
        status_forward: statusForward || '',
        status_tomorrow: statusTomorrow || '',
        status_uptodate: statusUptodate || '',
        status_open: paddedTags[0] || '',
        status_open1: paddedTags[1] || '',
        status_open2: paddedTags[2] || '',
        status_open3: paddedTags[3] || '',
        status_open4: paddedTags[4] || '',
        status_open5: paddedTags[5] || '',
        status_open6: paddedTags[6] || '',
        status_open7: paddedTags[7] || '',
        status_open8: paddedTags[8] || '',
        status_finish: statusFinish || ''
      };
      
      const token = localStorage.getItem('authToken');
      
      // Salvar configurações de processo
      const processResponse = await fetch(`${API_BASE_URL}/api/config/process`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const processResult = await processResponse.json();

      if (!processResult.success) {
        setMessage(processResult.message || 'Erro ao salvar configurações de processo');
        setIsSaving(false);
        return;
      }
      
      // Salvar status_deslocamento em LCMY_SYS_PROCESS
      if (processResult.success) {
        try {
          const deslocamentoResponse = await fetch(`${API_BASE_URL}/api/config/deslocamento`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ codstatus: statusDeslocamento || '' })
          });
          await deslocamentoResponse.json();
        } catch (error) {
          console.warn('⚠️ Erro ao salvar status_deslocamento:', error);
        }
        try {
          const retornoResponse = await fetch(`${API_BASE_URL}/api/config/retorno`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ codstatus: statusRetorno || '' })
          });
          await retornoResponse.json();
        } catch (error) {
          console.warn('⚠️ Erro ao salvar status retorno:', error);
        }
        try {
          await fetch(`${API_BASE_URL}/api/config/automation-retorno`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              statusPedidoDisponivel: automationStatusPedidoDisponivel || '',
              statusOsEncaminhar: automationStatusOsEncaminhar || ''
            })
          });
        } catch (error) {
          console.warn('⚠️ Erro ao salvar automação retorno:', error);
        }
      }
      
      // Salvar configurações de automação
      const automationResponse = await fetch(`${API_BASE_URL}/api/config/automation`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(automationData)
      });

      const automationResult = await automationResponse.json();
      
      // Salvar configuração de OS Corretiva
      const osCorretivaResponse = await fetch(`${API_BASE_URL}/api/config/os-corretiva`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osCorretiva || '' })
      });

      const osCorretivaResult = await osCorretivaResponse.json();

      // Salvar configuração de OS Estoque
      const osEstoqueResponse = await fetch(`${API_BASE_URL}/api/config/os-estoque`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osEstoque || '' })
      });

      const osEstoqueResult = await osEstoqueResponse.json();

      // Salvar configuração de OS Preventiva
      const osPreventivaResponse = await fetch(`${API_BASE_URL}/api/config/os-preventiva`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osPreventiva || '' })
      });

      const osPreventivaResult = await osPreventivaResponse.json();

      // Salvar configuração de OS Afericao
      const osAfericaoResponse = await fetch(`${API_BASE_URL}/api/config/os-afericao`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osAfericao || '' })
      });

      const osAfericaoResult = await osAfericaoResponse.json();

      // Salvar configuração de OS Desinstalacao
      const osDesinstalacaoResponse = await fetch(`${API_BASE_URL}/api/config/os-desinstalacao`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osDesinstalacao || '' })
      });

      const osDesinstalacaoResult = await osDesinstalacaoResponse.json();

      // Salvar configuração de OS Recarga
      const osRecargaResponse = await fetch(`${API_BASE_URL}/api/config/os-recarga`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osRecarga || '' })
      });
      const osRecargaResult = await osRecargaResponse.json();

      // Salvar configuração de OS Balcao
      const osBalcaoResponse = await fetch(`${API_BASE_URL}/api/config/os-balcao`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codstatus: osBalcao || '' })
      });
      const osBalcaoResult = await osBalcaoResponse.json();

      const retiradaAtivaResponse = await fetch(`${API_BASE_URL}/api/config/retirada-ativa-abertura-os`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ codstatusList: retiradaAtivaTags })
      });
      const retiradaAtivaResult = await retiradaAtivaResponse.json();

      // Salvar configuração "Troca de status em conclusão de OS" (Fechamento)
      const trocaStatusResponse = await fetch(`${API_BASE_URL}/api/config/troca-status-conclusao`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ codstatus: habilitarTrocaStatus ? '01' : '00' })
      });
      const trocaStatusResult = await trocaStatusResponse.json();

      const alteracaoFuturoResponse = await fetch(`${API_BASE_URL}/api/config/alteracao-status-futuro-amanha`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codstatus: enviarProximoDiaAutomatico ? '01' : '00',
          ...(enviarProximoDiaAutomatico
            ? { schedule: (futureTomorrowSchedule || '04:30').trim() }
            : {})
        })
      });
      const alteracaoFuturoResult = await alteracaoFuturoResponse.json();

      const retornoCondIntervResponse = await fetch(`${API_BASE_URL}/api/config/retornos-condicao-intervencao`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ codstatus: retornoPorCondicaoIntervencao ? '01' : '00' })
      });
      const retornoCondIntervResult = await retornoCondIntervResponse.json();

      const equipmentSearchCodstatus = equipmentSearchType === 'patrimonio-only' ? '01' : '00';
      const equipmentSearchResponse = await fetch(`${API_BASE_URL}/api/config/equipment-search`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ codstatus: equipmentSearchCodstatus })
      });
      const equipmentSearchResult = await equipmentSearchResponse.json();
      
      if (processResult.success && automationResult.success && osCorretivaResult.success && osEstoqueResult.success && osPreventivaResult.success && osAfericaoResult.success && osDesinstalacaoResult.success && osRecargaResult.success && osBalcaoResult.success && retiradaAtivaResult.success && trocaStatusResult.success && alteracaoFuturoResult.success && retornoCondIntervResult.success && equipmentSearchResult.success) {
        setMessage('Configurações salvas com sucesso!');
        setAutomationError(false);
      } else {
        const errors = [];
        if (!processResult.success) errors.push('processo');
        if (!automationResult.success) {
          errors.push('automação');
          setAutomationError(true);
          // Verificar se há mensagem específica do backend
          const errorMessage = automationResult.message || 'Erro ao salvar configuração de automação';
          if (errorMessage.includes('automação') || errorMessage.includes('horário') || errorMessage.includes('dados')) {
            setMessage('Termine de preencher os dados da automação em Para atender no próximo dia.');
          } else {
            setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}. ${errorMessage}`);
          }
        } else if (!osCorretivaResult.success) {
          errors.push('OS corretiva');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osEstoqueResult.success) {
          errors.push('OS estoque');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osPreventivaResult.success) {
          errors.push('OS preventiva');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osAfericaoResult.success) {
          errors.push('OS afericao');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osDesinstalacaoResult.success) {
          errors.push('OS desinstalacao');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osRecargaResult.success) {
          errors.push('OS recarga');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!osBalcaoResult.success) {
          errors.push('OS balcao');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!retiradaAtivaResult.success) {
          errors.push('status retirada ativa');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!trocaStatusResult.success) {
          errors.push('fechamento (troca de status)');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!alteracaoFuturoResult.success) {
          errors.push('envio automático próximo dia');
          setMessage(alteracaoFuturoResult.message || `Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!retornoCondIntervResult.success) {
          errors.push('retorno por condição de intervenção');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else if (!equipmentSearchResult.success) {
          errors.push('busca pelo equipamento');
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        } else {
          setMessage(`Erro ao salvar configurações de: ${errors.join(', ')}`);
        }
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setMessage('Erro ao salvar configurações');
    } finally {
      setIsSaving(false);
    }
  };

  // Funções para converter para maiúsculas e atualizar estado
  const isReservedPreServiceCod = (raw) => {
    const pre = String(reservedPreServiceStatus || '')
      .trim()
      .toUpperCase();
    const cod = String(raw || '')
      .trim()
      .toUpperCase();
    return pre.length === 2 && cod.length === 2 && pre === cod;
  };

  const rejectReservedPreService = (raw, label) => {
    if (!isReservedPreServiceCod(raw)) return false;
    setMessage(
      `O status "${String(raw).trim().toUpperCase()}"${
        label ? ` (${label})` : ''
      } está reservado para pré-atendimento (Customers). Use um código diferente.`
    );
    return true;
  };

  const handleInserviceChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Em serviço')) return;
      setStatusInservice(value);
    }
  };

  const handleDeslocamentoChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Em deslocamento')) return;
      setStatusDeslocamento(value);
    }
  };

  const handleRetornoChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Retorno de peças')) return;
      setStatusRetorno(value);
    }
  };

  const handleForwardChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Encaminhado ao técnico')) return;
      setStatusForward(value);
    }
  };

  const handleTomorrowChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Próximo dia')) return;
      setStatusTomorrow(value);
    }
  };

  const handleUptodateChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Em dia ou futura')) return;
      setStatusUptodate(value);
    }
  };

  const handleFinishChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      if (value.length === 2 && rejectReservedPreService(value, 'Finalizado')) return;
      setStatusFinish(value);
    }
  };

  const handleOsCorretivaChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsCorretiva(value);
    }
  };

  const handleOsEstoqueChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsEstoque(value);
    }
  };

  const handleOsPreventivaChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsPreventiva(value);
    }
  };

  const handleOsAfericaoChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsAfericao(value);
    }
  };

  const handleOsDesinstalacaoChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsDesinstalacao(value);
    }
  };

  const handleOsRecargaChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsRecarga(value);
    }
  };

  const handleOsBalcaoChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setOsBalcao(value);
    }
  };

  // Funções para gerenciar tags "Em Aberto"
  const handleStatusOpenInput = (e) => {
    const value = e.target.value.toUpperCase();
    // Permitir apenas letras e números, máximo 2 caracteres
    if (value.length <= 2) {
      setStatusOpenInput(value);
    }
  };

  const addStatusOpenTag = () => {
    const trimmedValue = statusOpenInput.trim();
    if (trimmedValue && trimmedValue.length === 2 && statusOpenTags.length < 9) {
      if (rejectReservedPreService(trimmedValue, 'OS em aberto')) {
        setStatusOpenInput('');
        return;
      }
      // Verificar se já não existe
      if (!statusOpenTags.includes(trimmedValue)) {
        setStatusOpenTags([...statusOpenTags, trimmedValue]);
      }
      setStatusOpenInput('');
      // Focar no input novamente
      if (statusOpenInputRef.current) {
        statusOpenInputRef.current.focus();
      }
    }
  };

  const addEmptyStatusOpenTag = () => {
    if (statusOpenTags.length >= 9 || statusOpenTags.some((tag) => tag === '')) return;
    setStatusOpenTags([...statusOpenTags, '']);
    setStatusOpenInput('');
  };

  const handleStatusOpenKeyDown = (e) => {
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      addStatusOpenTag();
    } else if (e.key === 'Backspace' && statusOpenInput === '' && statusOpenTags.length > 0) {
      // Remover última tag ao pressionar backspace com input vazio
      const newTags = [...statusOpenTags];
      newTags.pop();
      setStatusOpenTags(newTags);
    }
  };

  const removeStatusOpenTag = (indexToRemove) => {
    setStatusOpenTags(statusOpenTags.filter((_, index) => index !== indexToRemove));
  };

  const updateStatusOpenTag = (indexToUpdate, newValue) => {
    const trimmedValue = String(newValue).trim().toUpperCase();
    if (trimmedValue.length !== 2) return;
    if (rejectReservedPreService(trimmedValue, 'OS em aberto')) return;
    if (statusOpenTags.some((tag, index) => index !== indexToUpdate && tag === trimmedValue)) return;
    const next = [...statusOpenTags];
    next[indexToUpdate] = trimmedValue;
    setStatusOpenTags(next);
  };

  const handleRetiradaAtivaInput = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 2) {
      setRetiradaAtivaInput(value);
    }
  };

  const addRetiradaAtivaTag = () => {
    const trimmedValue = retiradaAtivaInput.trim();
    if (trimmedValue && trimmedValue.length === 2) {
      if (!retiradaAtivaTags.includes(trimmedValue)) {
        setRetiradaAtivaTags([...retiradaAtivaTags, trimmedValue]);
      }
      setRetiradaAtivaInput('');
      if (retiradaAtivaInputRef.current) {
        retiradaAtivaInputRef.current.focus();
      }
    }
  };

  const addEmptyRetiradaAtivaTag = () => {
    if (retiradaAtivaTags.some((tag) => tag === '')) return;
    setRetiradaAtivaTags([...retiradaAtivaTags, '']);
    setRetiradaAtivaInput('');
  };

  const handleRetiradaAtivaKeyDown = (e) => {
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      addRetiradaAtivaTag();
    } else if (e.key === 'Backspace' && retiradaAtivaInput === '' && retiradaAtivaTags.length > 0) {
      const newTags = [...retiradaAtivaTags];
      newTags.pop();
      setRetiradaAtivaTags(newTags);
    }
  };

  const removeRetiradaAtivaTag = (indexToRemove) => {
    setRetiradaAtivaTags(retiradaAtivaTags.filter((_, index) => index !== indexToRemove));
  };

  const updateRetiradaAtivaTag = (indexToUpdate, newValue) => {
    const trimmedValue = String(newValue).trim().toUpperCase();
    if (trimmedValue.length !== 2) return;
    if (retiradaAtivaTags.some((tag, index) => index !== indexToUpdate && tag === trimmedValue)) return;
    const next = [...retiradaAtivaTags];
    next[indexToUpdate] = trimmedValue;
    setRetiradaAtivaTags(next);
  };

  // Função para carregar dados de automação
  const loadAutomationData = async () => {
    try {
      setIsLoadingAutomation(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/automation`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        setAutomationData(result.data);
      }
    } catch (error) {
      console.error('❌ [Automation] Erro ao carregar dados:', error);
    } finally {
      setIsLoadingAutomation(false);
    }
  };

  // Função para carregar configuração de busca de equipamento
  const loadEquipmentSearchConfig = async () => {
    try {
      setIsLoadingEquipmentSearch(true);
      setEquipmentSearchMessage('');
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/equipment-search`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        const codstatus = String(result.data.codstatus ?? '00').trim().padStart(2, '0');
        setEquipmentSearchType(codstatus === '01' ? 'patrimonio-only' : 'serie-patrimonio');
      } else {
        // Valor padrão: Série e patrimônio
        setEquipmentSearchType('serie-patrimonio');
      }
    } catch (error) {
      console.error('❌ [EquipmentSearch] Erro ao carregar configuração:', error);
      setEquipmentSearchMessage('Erro ao carregar configuração');
      // Valor padrão em caso de erro
      setEquipmentSearchType('serie-patrimonio');
    } finally {
      setIsLoadingEquipmentSearch(false);
      setEquipmentSearchReady(true);
    }
  };

  // Função para salvar configuração de busca de equipamento
  const saveEquipmentSearchConfig = async () => {
    try {
      setIsSavingEquipmentSearch(true);
      setEquipmentSearchMessage('');
      
      // Converter para codstatus: 'serie-patrimonio' = '00', 'patrimonio-only' = '01'
      const codstatus = equipmentSearchType === 'patrimonio-only' ? '01' : '00';
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/equipment-search`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ codstatus })
      });
      
      const result = await response.json();
      
      if (result.success) {
        setEquipmentSearchMessage('Configuração salva com sucesso!');
      } else {
        setEquipmentSearchMessage('Erro ao salvar configuração');
      }
    } catch (error) {
      console.error('❌ [EquipmentSearch] Erro ao salvar configuração:', error);
      setEquipmentSearchMessage('Erro ao salvar configuração');
    } finally {
      setIsSavingEquipmentSearch(false);
    }
  };

  // Carregar dados ao montar o componente
  useEffect(() => {
    loadData();
    loadAutomationData();
    loadEquipmentSearchConfig();
  }, []);

  // Carregar configuração de busca de equipamento nos submenus que usam o valor
  useEffect(() => {
    if (activeSubmenu === 'config-status-2') {
      loadEquipmentSearchConfig();
    }
  }, [activeSubmenu]);

  useEffect(() => {
    setMessage('');
  }, [activeSubmenu]);

  const processContentAreaClass =
    activeSubmenu === 'config-status-2' || activeSubmenu === 'coluna-em-aberto' || activeSubmenu === 'condicoes-intervencao' || activeSubmenu === 'defeitos-verve' || activeSubmenu === 'oficina' || activeSubmenu === 'cadastros-marcas-subgrupos' || activeSubmenu === 'notificacoes-email'
      ? ' process-content-area-config-status-2'
      : '';

  const reloadConfigStatusData = async () => {
    setMessage('');
    await loadData();
    await loadAutomationData();
    await loadEquipmentSearchConfig();
  };

  const configStatusViewProps = {
    saveData,
    reloadData: reloadConfigStatusData,
    isSaving,
    message,
    statusInservice,
    statusDeslocamento,
    statusRetorno,
    statusForward,
    statusTomorrow,
    statusUptodate,
    statusFinish,
    statusOpenTags,
    statusOpenInput,
    statusOpenInputRef,
    enviarProximoDiaAutomatico,
    setEnviarProximoDiaAutomatico,
    futureTomorrowSchedule,
    futureTomorrowScheduleModalOpen,
    setFutureTomorrowScheduleModalOpen,
    handleFutureTomorrowScheduleChange,
    retornoPorCondicaoIntervencao,
    setRetornoPorCondicaoIntervencao,
    habilitarTrocaStatus,
    setHabilitarTrocaStatus,
    osCorretiva,
    osEstoque,
    osPreventiva,
    osAfericao,
    osDesinstalacao,
    osRecarga,
    osBalcao,
    automationStatusPedidoDisponivel,
    automationStatusOsEncaminhar,
    automationData,
    automationError,
    isLoadingAutomation,
    isGeneratingReport,
    automationRetornoModalOpen,
    setAutomationRetornoModalOpen,
    automationProximoDiaModalOpen,
    setAutomationProximoDiaModalOpen,
    handleInserviceChange,
    handleDeslocamentoChange,
    handleRetornoChange,
    handleForwardChange,
    handleTomorrowChange,
    handleUptodateChange,
    handleFinishChange,
    handleOsCorretivaChange,
    handleOsEstoqueChange,
    handleOsPreventivaChange,
    handleOsAfericaoChange,
    handleOsDesinstalacaoChange,
    handleOsRecargaChange,
    handleOsBalcaoChange,
    handleAutomationDayChange,
    handleAutomationScheduleChange,
    handleAutomationTipoagendChange,
    handleAutomationStatusPedidoDisponivel,
    handleAutomationStatusOsEncaminhar,
    validateSchedule,
    validateFutureTomorrowSchedule,
    generateLogsReport,
    addStatusOpenTag,
    addEmptyStatusOpenTag,
    removeStatusOpenTag,
    updateStatusOpenTag,
    handleStatusOpenInput,
    handleStatusOpenKeyDown,
    retiradaAtivaTags,
    retiradaAtivaInput,
    retiradaAtivaInputRef,
    addRetiradaAtivaTag,
    addEmptyRetiradaAtivaTag,
    removeRetiradaAtivaTag,
    updateRetiradaAtivaTag,
    handleRetiradaAtivaInput,
    handleRetiradaAtivaKeyDown,
    equipmentSearchType,
    setEquipmentSearchType,
    isLoadingEquipmentSearch,
    equipmentSearchReady,
  };

  if (isLoading) {
    const skeletonVariant = PROCESS_SKELETON_BY_SUBMENU[activeSubmenu] || 'status';
    return (
      <div className="process-config-root">
        <ProcessConfigSidebar activeSubmenu={activeSubmenu} onSelectSubmenu={setActiveSubmenu} />
        <div className={`process-content-area${processContentAreaClass}`}>
          <ConfigOryaAssistant
            userDisplayName={userDisplayName}
            configSection="process"
            submenuId={activeSubmenu}
            hideFab
          />
          <ProcessConfigSkeleton variant={skeletonVariant} />
        </div>
      </div>
    );
  }

  return (
    <div className="process-config-root">
      <ProcessConfigSidebar activeSubmenu={activeSubmenu} onSelectSubmenu={setActiveSubmenu} />

      {/* Área de conteúdo à direita da sidebar */}
      <div className={`process-content-area${processContentAreaClass}`}>
        <ConfigOryaAssistant
          userDisplayName={userDisplayName}
          configSection="process"
          submenuId={activeSubmenu}
          hideFab
        />
        {/* {activeSubmenu === 'config-status' && <ConfigStatusView {...configStatusViewProps} />} */}

        {activeSubmenu === 'config-status-2' && <ConfigStatusView2 {...configStatusViewProps} />}

        {/* {activeSubmenu === 'abertura-os' && (
          <div className="database-config" style={{ maxWidth: '350px' }}>
            <h3 className="config-title">Configurações para abertura</h3>
            <p className="config-description">Configure as opções de abertura de ordens de serviço</p>
            
            <div className="config-form">
              <div className="form-group" style={{ transform: 'scale(0.8)', transformOrigin: 'top left' }}>
                <label style={{ marginBottom: '12px', display: 'block', fontWeight: 600, fontSize: '14px' }}>
                  Busca pelo equipamento
                </label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '11.2px', fontWeight: 'normal' }}>
                    <input
                      type="radio"
                      name="equipment-search"
                      value="serie-patrimonio"
                      checked={equipmentSearchType === 'serie-patrimonio'}
                      onChange={(e) => setEquipmentSearchType(e.target.value)}
                      style={{ cursor: 'pointer' }}
                    />
                    <span>Série e patrimônio</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '11.2px', fontWeight: 'normal' }}>
                    <input
                      type="radio"
                      name="equipment-search"
                      value="patrimonio-only"
                      checked={equipmentSearchType === 'patrimonio-only'}
                      onChange={(e) => setEquipmentSearchType(e.target.value)}
                      style={{ cursor: 'pointer' }}
                    />
                    <span>Somente patrimônio</span>
                  </label>
                </div>
              </div>

              <div className="form-actions">
                <button 
                  onClick={saveEquipmentSearchConfig}
                  disabled={isSavingEquipmentSearch || isLoadingEquipmentSearch}
                  style={{
                    background: '#7c4dff',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: isSavingEquipmentSearch || isLoadingEquipmentSearch ? 'not-allowed' : 'pointer',
                    opacity: isSavingEquipmentSearch || isLoadingEquipmentSearch ? 0.6 : 1
                  }}
                >
                  {isSavingEquipmentSearch ? 'Salvando...' : 'Salvar dados'}
                </button>
              </div>

              {equipmentSearchMessage && (
                <div style={{
                  marginTop: '16px',
                  padding: '12px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  background: equipmentSearchMessage.includes('sucesso') ? '#f0fff4' : '#fed7d7',
                  color: equipmentSearchMessage.includes('sucesso') ? '#22543d' : '#742a2a',
                  border: `1px solid ${equipmentSearchMessage.includes('sucesso') ? '#9ae6b4' : '#fc8181'}`
                }}>
                  {equipmentSearchMessage}
                </div>
              )}

              {isLoadingEquipmentSearch && (
                <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
                  Carregando configuração...
                </div>
              )}
            </div>
          </div>
        )} */}

        {activeSubmenu === 'coluna-em-aberto' && <ConfigColunasView apiBaseUrl={API_BASE_URL} />}

        {activeSubmenu === 'oficina' && <OficinaConfig apiBaseUrl={API_BASE_URL} />}

        {activeSubmenu === 'condicoes-intervencao' && <CondicoesIntervencaoConfig />}

        {activeSubmenu === 'defeitos-verve' && <DefeitosVerveConfig />}

        {activeSubmenu === 'cadastros-marcas-subgrupos' && <MarcaSubgruposCadastrosConfig />}

        {activeSubmenu === 'notificacoes-email' && <EmailNotificationsConfigPage />}
      </div>
    </div>
  );
};

// Componente de configuração da empresa
const CompanyConfig = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
  const [logoPendingKey, setLogoPendingKey] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);
  const logoInputRef = useRef(null);
  
  // Usar estado para controlar os valores dos campos
  const [company, setCompany] = useState('');
  const [token, setToken] = useState('');
  
  // Valores originais carregados do banco (para comparação)
  const [originalCompany, setOriginalCompany] = useState('');
  const [originalToken, setOriginalToken] = useState('');
  const [originalLogoKey, setOriginalLogoKey] = useState(null);

  // Função para carregar dados da API
  const loadData = async ({ silent } = {}) => {
    try {
      if (!silent) setIsLoading(true);
      setMessage('');
      
      // CORREÇÃO: Usar nome diferente para o token de autenticação para evitar conflito
      const authToken = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/config/company`, {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        // Carregar valores do banco
        const loadedCompany = result.data.company || '';
        const loadedToken = result.data.token || '';
        const hasLogo = result.data.hasLogo === true || Boolean(result.data.logoViewUrl);
        const loadedLogoMarker = hasLogo ? '__stored__' : null;
        
        setCompany(loadedCompany);
        setToken(loadedToken);
        setLogoPreviewUrl((prev) => {
          revokeBlobPreviewUrl(prev);
          return result.data.logoViewUrl || null;
        });
        setLogoPendingKey(loadedLogoMarker);
        
        // Salvar valores originais para comparação
        setOriginalCompany(loadedCompany);
        setOriginalToken(loadedToken);
        setOriginalLogoKey(loadedLogoMarker);
      } else {
        // Valores padrão
        setCompany('');
        setToken('');
        setOriginalCompany('');
        setOriginalToken('');
        setLogoPreviewUrl((prev) => {
          revokeBlobPreviewUrl(prev);
          return null;
        });
        setLogoPendingKey(null);
        setOriginalLogoKey(null);
      }
    } catch (error) {
      console.error('Erro ao carregar dados da empresa:', error);
      setMessage('Erro ao carregar dados da API');
      setCompany('');
      setToken('');
      setOriginalCompany('');
      setOriginalToken('');
      setLogoPreviewUrl((prev) => {
        revokeBlobPreviewUrl(prev);
        return null;
      });
      setLogoPendingKey(null);
      setOriginalLogoKey(null);
    } finally {
      if (!silent) setIsLoading(false);
    }
  };

  // Função para salvar dados
  const saveData = async () => {
    try {
      setIsSaving(true);
      setMessage('');
      
      // CORREÇÃO: Obter token de autenticação ANTES de criar formData para evitar conflito de nomes
      const authToken = localStorage.getItem('authToken');
      
      // Preparar dados para envio: enviar apenas valores que foram alterados ou todos se ambos foram alterados
      // Se um campo não foi alterado, enviar o valor original do banco
      const formData = {
        company: company.trim() || null,
        // Token é somente leitura na UI — sempre reenvia o valor original do banco
        token: originalToken.trim() || null
      };
      if (logoPendingKey && logoPendingKey !== originalLogoKey && logoPendingKey !== '__stored__') {
        formData.company_logo_s3_key = logoPendingKey;
      }
      const response = await fetch(`${API_BASE_URL}/api/config/company`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      
      if (result.success) {
        setMessage('Configurações da empresa salvas com sucesso!');
        setOriginalCompany(company.trim());
        setOriginalToken(originalToken.trim());
        setOriginalLogoKey(logoPendingKey);
        await loadData({ silent: true });
        window.dispatchEvent(new CustomEvent(COMPANY_BRANDING_UPDATED_EVENT));
      } else {
        setMessage('Erro ao salvar configurações da empresa');
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setMessage('Erro ao salvar configurações da empresa');
    } finally {
      setIsSaving(false);
    }
  };

  // Carregar dados ao montar o componente
  useEffect(() => {
    loadData();
  }, []);

  const handleLogoSelect = async (event) => {
    const input = event.currentTarget;
    const file = input?.files?.[0];
    if (!file || !(file instanceof Blob)) return;
    if (input.files.length > 1) {
      input.value = '';
      alert('Envie apenas uma imagem por vez.');
      return;
    }

    const effectiveClientId = getClientIdFromLocalSession();
    if (effectiveClientId == null || effectiveClientId === '') {
      input.value = '';
      alert('Não foi possível identificar o cliente da sessão. Faça login novamente.');
      return;
    }

    const previousPreview = logoPreviewUrl;
    const previousKey = logoPendingKey;
    const immediatePreview = URL.createObjectURL(file);
    revokeBlobPreviewUrl(logoPreviewUrl);
    setLogoPreviewUrl(immediatePreview);
    setLogoUploading(true);
    setMessage('');

    try {
      const compressed = await compressCompanyLogo(file);
      const authToken = localStorage.getItem('authToken');
      const presignRes = await fetch(`${API_BASE_URL}/api/config/company/logo/presign`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          mimeType: compressed.type,
          sizeBytes: compressed.size,
          fileName: compressed.name
        })
      });
      const presignData = await presignRes.json();
      if (!presignRes.ok || !presignData.success) {
        throw new Error(presignData.message || 'Falha ao preparar upload');
      }
      const uploadRes = await fetch(presignData.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': compressed.type },
        body: compressed
      });
      if (!uploadRes.ok) throw new Error('Falha ao enviar imagem para o servidor');
      setLogoPendingKey(presignData.key);
    } catch (err) {
      revokeBlobPreviewUrl(immediatePreview);
      setLogoPreviewUrl(previousPreview);
      setLogoPendingKey(previousKey);
      setMessage(err.message || 'Erro ao enviar logomarca');
    } finally {
      setLogoUploading(false);
      input.value = '';
    }
  };

  const isDirty =
    company.trim() !== String(originalCompany || '').trim() ||
    logoPendingKey !== originalLogoKey;

  if (isLoading) {
    return (
      <div className="company-config-page">
        <div className="company-config-sections">
          <section className="company-config-section">
            <div className="company-config-section-aside">
              <div className="company-config-section-heading">
                <Building2 size={20} strokeWidth={2} aria-hidden="true" />
                <h3 className="company-config-section-title">Configuração</h3>
              </div>
              <p className="company-config-section-desc">
                Configure nome da empresa a ser exibido, token de acesso e logomarca.
              </p>
            </div>
            <div className="company-config-section-body">
              <p className="company-config-loading">Carregando configurações...</p>
            </div>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="company-config-page">
      <div className="company-config-sections">
        <section className="company-config-section">
          <div className="company-config-section-aside">
            <div className="company-config-section-heading">
              <Building2 size={20} strokeWidth={2} aria-hidden="true" />
              <h3 className="company-config-section-title">Configuração</h3>
            </div>
            <p className="company-config-section-desc">
              Configure nome da empresa a ser exibido, token de acesso e logomarca.
            </p>
          </div>
          <div className="company-config-section-body">
            <div className="company-config-fields">
              <div className="company-config-field">
                <label htmlFor="company" className="company-config-label">Nome da empresa</label>
                <input
                  type="text"
                  id="company"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  placeholder="Digite o nome da empresa"
                  className="company-config-input"
                />
              </div>
              <div className="company-config-field">
                <label htmlFor="token" className="company-config-label">Token</label>
                <input
                  type="text"
                  id="token"
                  value={token}
                  readOnly
                  tabIndex={0}
                  aria-readonly="true"
                  title="Token somente para visualização"
                  placeholder="Token de acesso"
                  className="company-config-input company-config-input--readonly"
                />
              </div>
              <div className="company-config-field">
                <label className="company-config-label">Logomarca</label>
                <div className="company-config-logo-row">
                  <div className="company-config-logo-preview" aria-hidden={!logoPreviewUrl}>
                    {logoPreviewUrl ? (
                      <img src={logoPreviewUrl} alt="" className="company-config-logo-preview-img" />
                    ) : (
                      <ImageIconLucide size={20} strokeWidth={2} aria-hidden="true" />
                    )}
                  </div>
                  <input
                    ref={logoInputRef}
                    type="file"
                    accept={COMPANY_LOGO_ACCEPT}
                    className="company-config-logo-input-hidden"
                    onChange={handleLogoSelect}
                  />
                  <button
                    type="button"
                    className="user-form-link-btn company-config-logo-update-btn"
                    disabled={logoUploading}
                    onClick={() => logoInputRef.current?.click()}
                  >
                    {logoUploading ? 'Enviando...' : 'Atualizar logo'}
                  </button>
                  <div className="company-config-logo-hints">
                    <span>Tamanho recomendado: 192 × 192 pixels</span>
                    <span>Proporção: 1:1</span>
                  </div>
                </div>
              </div>
            </div>
            {message && (
              <div
                className={`company-config-message${message.includes('sucesso') ? ' company-config-message--ok' : ' company-config-message--err'}`}
                role="status"
              >
                {message}
              </div>
            )}
            {(isDirty || isSaving) ? (
              <div className="company-config-actions">
                <button
                  type="button"
                  className="user-form-profile-save-btn company-config-save-btn"
                  onClick={saveData}
                  disabled={isSaving || !isDirty}
                >
                  {isSaving ? 'Salvando...' : 'Salvar dados'}
                </button>
              </div>
            ) : null}
          </div>
        </section>
      </div>
    </div>
  );
};

// Modal de carregamento inicial
const InitialLoadingModal = ({ isOpen, steps, hasError, errorMessage, onContinue }) => {
  if (!isOpen) return null;

  const getStepIcon = (status) => {
    switch (status) {
      case 'completed':
        return <i className="bi bi-check-circle-fill step-icon completed"></i>;
      case 'loading':
        return <i className="bi bi-arrow-repeat step-icon loading spin"></i>;
      case 'error':
        return <i className="bi bi-x-circle-fill step-icon error"></i>;
      case 'skipped':
        return <i className="bi bi-dash-circle step-icon skipped"></i>;
      default:
        return <i className="bi bi-circle step-icon pending"></i>;
    }
  };

  const getStepClass = (status) => {
    switch (status) {
      case 'completed':
        return 'step-completed';
      case 'loading':
        return 'step-loading';
      case 'error':
        return 'step-error';
      case 'skipped':
        return 'step-skipped';
      default:
        return 'step-pending';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'Concluído';
      case 'loading':
        return 'Carregando...';
      case 'error':
        return 'Erro';
      case 'skipped':
        return 'Ignorado';
      default:
        return 'Aguardando';
    }
  };

  const completedSteps = steps.filter(s => s.status === 'completed').length;
  const hasErrors = steps.some(s => s.status === 'error');

  return (
    <div className="initial-loading-overlay">
      <div className="initial-loading-modal">
        <div className={`loading-header ${hasErrors ? 'error' : ''}`}>
          <div className="loading-logo">
            <i className={hasErrors ? "bi bi-exclamation-triangle-fill" : "bi bi-gear-fill"}></i>
          </div>
          <h2>{hasErrors ? 'Problema na Inicialização' : 'Inicializando Sistema'}</h2>
          <p>{hasErrors ? 'Alguns problemas foram encontrados durante o carregamento.' : 'Carregando dados e configurações...'}</p>
        </div>
        
        {hasError && errorMessage && (
          <div className="loading-error-message">
            <div className="error-icon">
              <i className="bi bi-exclamation-circle"></i>
            </div>
            <div className="error-text">{errorMessage}</div>
          </div>
        )}
        
        <div className="loading-steps">
          {steps.map((step, index) => (
            <div key={step.id} className={`loading-step ${getStepClass(step.status)}`}>
              <div className="step-number">{index + 1}</div>
              <div className="step-content">
                <div className="step-title">{step.name}</div>
                <div className="step-status">
                  {getStatusText(step.status)}
                </div>
              </div>
              <div className="step-icon-container">
                {getStepIcon(step.status)}
              </div>
            </div>
          ))}
        </div>
        
        <div className="loading-footer">
          <div className="loading-progress">
            <div className="progress-bar">
              <div 
                className={`progress-fill ${hasErrors ? 'error' : ''}`}
                style={{
                  width: `${(completedSteps / steps.length) * 100}%`
                }}
              ></div>
            </div>
            <div className="progress-text">
              {hasErrors ? 
                `${completedSteps} de ${steps.length} etapas concluídas (com problemas)` :
                `${completedSteps} de ${steps.length} etapas concluídas`
              }
            </div>
          </div>
          
          {onContinue && (
            <div className="loading-actions">
              <button className="btn-continue" onClick={onContinue}>
                <i className="bi bi-arrow-right"></i>
                {hasErrors ? 'Continuar mesmo assim' : 'Entrar no sistema'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const splitUserDisplayName = (full) => {
  const text = String(full || '').trim();
  if (!text) return { firstName: '', lastName: '' };
  const parts = text.split(/\s+/);
  return { firstName: parts[0] || '', lastName: parts.slice(1).join(' ') };
};

const joinUserDisplayName = (firstName, lastName) =>
  `${String(firstName || '').trim()} ${String(lastName || '').trim()}`.trim();

const getClientIdFromLocalSession = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if (userData?.clientId != null && userData.clientId !== '') return userData.clientId;
  } catch (_) { /* ignore */ }
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    const part = token.split('.')[1];
    if (!part) return null;
    const json = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return json.clientId ?? null;
  } catch (_) { /* ignore */ }
  return null;
};

const revokeBlobPreviewUrl = (url) => {
  if (url && String(url).startsWith('blob:')) {
    try { URL.revokeObjectURL(url); } catch (_) { /* ignore */ }
  }
};

const COMPANY_BRANDING_UPDATED_EVENT = 'painelos:company-branding-updated';

const getPostLoginGreeting = (displayName) => {
  const name = String(displayName || 'Usuário').trim() || 'Usuário';
  const totalMinutes = new Date().getHours() * 60 + new Date().getMinutes();
  let suffix;
  if (totalMinutes >= 1 && totalMinutes <= 12 * 60) {
    suffix = 'tenha um bom dia!';
  } else if (totalMinutes <= 17 * 60 + 59) {
    suffix = 'tenha uma boa tarde!';
  } else {
    suffix = 'tenha uma boa noite!';
  }
  return `Bem vindo ${name}, ${suffix}`;
};

const getProfileInitials = (displayName) => {
  const parts = String(displayName || 'U').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
  return (parts[0]?.charAt(0) || 'U').toUpperCase();
};

const getHeaderConnectionStatus = (isLoadingData, dataSource) => {
  if (isLoadingData) {
    return { kind: 'loading', label: 'Carregando...', title: 'Carregando dados...' };
  }
  if (dataSource === 'sql_server') {
    return { kind: 'connected', label: 'On-line', title: 'Dados carregados do SQL Server' };
  }
  if (dataSource === 'mock_fallback') {
    return { kind: 'fallback', label: 'Modo fallback', title: 'Erro SQL Server — usando dados mock' };
  }
  return { kind: 'mock', label: 'Modo mock', title: 'Usando dados mock — configure o banco' };
};

const renderProfileAvatar = (photoUrl, displayName, className = '') => {
  const initial = getProfileInitials(displayName);
  const isTableAvatar = className.includes('profile-avatar-img--table');
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={`profile-avatar-img ${className}`.trim()}
      />
    );
  }
  if (isTableAvatar) {
    return (
      <div className={`avatar-placeholder avatar-placeholder--table ${className}`.trim()}>
        {initial}
      </div>
    );
  }
  return (
    <div className={`avatar-placeholder ${className}`.trim()}>
      {initial}
    </div>
  );
};

const USER_TYPE_OPTIONS = [
  { value: 'Administrador', label: 'Administrador' },
  { value: 'Gerente Técnico', label: 'Gerente Técnico' },
  { value: 'Coordenador', label: 'Coordenador' },
  { value: 'Técnico', label: 'Técnico / App Go' },
  { value: 'Financeiro', label: 'Financeiro' },
];

/** Layout dos chips no formulário (linhas). value permanece o tipo persistido. */
const USER_TYPE_CHIP_ROWS = [
  [
    { value: 'Administrador', label: 'Administrador' },
    { value: 'Gerente Técnico', label: 'Gerente Técnico' },
    { value: 'Coordenador', label: 'Coordenador' },
  ],
  [{ value: 'Técnico', label: 'Técnico / App Go' }],
  [{ value: 'Financeiro', label: 'Financeiro' }],
];

function getUserTypeLabel(user) {
  if (!user) return '—';
  const type = String(user.type ?? '').trim();
  if (type === 'Financeiro' || type === '4') return 'Financeiro';
  if (type === 'Técnico' || type === '3' || Number(type) === 3) return 'Técnico / App Go';
  if (user.coordinator === true || user.coordinator === 1) {
    return 'Coordenador';
  }
  if (type === 'Usuário') return 'Coordenador';
  return type || '—';
}

const USER_OS_TYPE_TOGGLES = [
  { key: 'os_stock', label: 'Estoque', Icon: Package },
  { key: 'os_counter', label: 'Balcão', Icon: Store },
  { key: 'os_reading', label: 'Aferição', Icon: Gauge },
  { key: 'os_return', label: 'Retorno/Recarga', Icon: RotateCcw },
  { key: 'os_uninstall', label: 'Desinstalação', Icon: Unplug },
  { key: 'os_install', label: 'Instalação', Icon: PackagePlus },
  { key: 'os_preventive', label: 'Preventiva', Icon: ShieldCheck },
  { key: 'os_normal', label: 'Normal', Icon: Wrench },
];

const USER_PERMISSION_GROUPS = [
  {
    key: 'os',
    title: 'Ordem de serviço',
    desc: 'Permissões sobre ordens de serviço',
    Icon: Wrench,
    toggles: [
      { field: 'asstec_openos', label: 'Abrir OS' },
      { field: 'asstec_closeos', label: 'Fechar OS' },
      { field: 'asstec_deleteos', label: 'Deletar OS' },
    ],
  },
  {
    key: 'reports',
    title: 'Relatórios',
    desc: 'Criação de relatórios no sistema',
    Icon: FilePen,
    toggles: [
      { field: 'asstec_create_reports', label: 'Criar relatórios' },
    ],
  },
  {
    key: 'reembolsos',
    title: 'Gestão de reembolsos',
    desc: 'Aprovar, pagar e lançar despesas avulsas',
    Icon: Banknote,
    toggles: [
      { field: 'asstec_reembolso_approve', label: 'Aprovar e reprovar' },
      { field: 'asstec_reembolso_pay', label: 'Pagar' },
      { field: 'asstec_reembolso_create', label: 'Criar despesa avulsa' },
    ],
  },
];

const USER_PERMISSION_TOGGLES = USER_PERMISSION_GROUPS.flatMap((group) => group.toggles);

const getUserTablePermissionPills = (user) =>
  USER_PERMISSION_TOGGLES.filter((opt) => user[opt.field]).map((opt) => opt.label);

const USER_BOARD_VIEW_OPTIONS = [
  { value: 0, label: 'Ordem de serviço' },
  { value: 1, label: 'Patrimônio' },
];

const UserManagement = ({
  users,
  setUsers,
  isLoadingUsers,
  setIsLoadingUsers,
  showUserForm,
  setShowUserForm,
  editingUser,
  setEditingUser,
  showPasswordUser,
  setShowPasswordUser,
  userFormData,
  setUserFormData,
  userFormErrors,
  setUserFormErrors,
  userOSTypes,
  setUserOSTypes,
  clientId,
  verveCustomersModule = 0,
  goAppModule = 0,
  onProfilePhotoSaved
}) => {
  // Estado para pesquisa de usuários
  const [searchTerm, setSearchTerm] = useState('');
  const [showInactive, setShowInactive] = useState(false);
  const [userSortConfig, setUserSortConfig] = useState({ key: 'name', direction: 'asc' });
  const userProfilePhotoMap = useUserProfilePhotos(users);
  const { success: toastSuccess, error: toastError, Toaster } = useCxExpToast();

  // Estado para configuração de visão de ordens de serviço
  const [userShowOSConfig, setUserShowOSConfig] = useState(0); // 0 = Ordem de serviço, 1 = Patrimônio
  
  // Estado para controlar a aba ativa no formulário
  const [activeUserTab, setActiveUserTab] = useState('basic'); // 'basic', 'permissions', 'settings', 'customers', 'email'
  const [securitySubTab, setSecuritySubTab] = useState('geral');
  
  // Estados para configuração de email
  const [emailConfig, setEmailConfig] = useState({
    email: '',
    password: '',
    smtpServer: '',
    smtpPort: ''
  });
  const [hasEmailPasswordInDb, setHasEmailPasswordInDb] = useState(false); // Indica se há senha salva no banco
  const [testEmail, setTestEmail] = useState('');
  const [emailTestResult, setEmailTestResult] = useState(null);
  const [isTestingEmail, setIsTestingEmail] = useState(false);
  const [isSendingTestEmail, setIsSendingTestEmail] = useState(false);
  const [emailType, setEmailType] = useState('comum'); // 'comum' ou 'google' - para alternar formulários
  const [emailPreference, setEmailPreference] = useState('auto'); // 'auto', 'comum', 'google' - preferência para envio
  const [googleOAuthConfig, setGoogleOAuthConfig] = useState({
    google_client_id: '',
    google_client_secret: '',
    has_client_secret: false,
    google_redirect_uri: ''
  });
  const [isSavingOAuthConfig, setIsSavingOAuthConfig] = useState(false);
  const [copiedRedirectUri, setCopiedRedirectUri] = useState(false);
  const [showCannySuccessAnimation, setShowCannySuccessAnimation] = useState(false);
  const [showPassPolicyModal, setShowPassPolicyModal] = useState(false);
  const [showAuthHistoryModal, setShowAuthHistoryModal] = useState(false);
  const [passPolicy, setPassPolicy] = useState(null);
  const [passwordValidationRules, setPasswordValidationRules] = useState([]);
  const [isPasswordFieldFocused, setIsPasswordFieldFocused] = useState(false);
  const [coordinatorUnlinkModal, setCoordinatorUnlinkModal] = useState(null);
  const [technicianOsBlockModal, setTechnicianOsBlockModal] = useState(null);
  /** Técnico: 'oficina' exige codtec; 'app_go' sem codtec (aparece em Go → Não habilitados). */
  const [techPurpose, setTechPurpose] = useState('oficina');
  const [profileExpanded, setProfileExpanded] = useState(false);
  const [profileFirstName, setProfileFirstName] = useState('');
  const [profileLastName, setProfileLastName] = useState('');
  const [profilePhotoPreviewUrl, setProfilePhotoPreviewUrl] = useState(null);
  const [profilePhotoPendingKey, setProfilePhotoPendingKey] = useState(null);
  const [profilePhotoDraftId, setProfilePhotoDraftId] = useState(null);
  const [profilePhotoUploading, setProfilePhotoUploading] = useState(false);
  const [profilePanelSnapshot, setProfilePanelSnapshot] = useState(null);
  const [resolvedClientId, setResolvedClientId] = useState(null);
  const profilePhotoInputRef = useRef(null);

  useEffect(() => {
    if (activeUserTab === 'email') {
      setEmailType('comum');
    }
  }, [activeUserTab]);

  const showCustomersUserTab = Number(verveCustomersModule) === 1;
  const showReembolsoPermissionGroup = canShowReembolsoPermissionGroup(goAppModule);
  const isTechnicianType = userFormData.type === 'Técnico';
  const isFinanceiroType = userFormData.type === 'Financeiro';
  const isRestrictedBoardType = isTechnicianType || isFinanceiroType;
  /** Visão OS/Patrimônio liberada para Técnico/App Go; permanece bloqueada para Financeiro. */
  const isShowOsVisionDisabled = isFinanceiroType;

  useEffect(() => {
    if (!showUserForm || showCustomersUserTab) return;
    if (activeUserTab === 'customers') setActiveUserTab('basic');
  }, [showUserForm, showCustomersUserTab, activeUserTab]);

  useEffect(() => {
    if (activeUserTab === 'permissions') setSecuritySubTab('geral');
  }, [activeUserTab]);

  useEffect(() => {
    if (showUserForm) {
      fetchPassPolicy()
        .then((p) => {
          setPassPolicy(p);
          setPasswordValidationRules(validatePasswordForPolicy(userFormData.password, p).rules);
        })
        .catch(() => { setPassPolicy(null); setPasswordValidationRules([]); });

      const fromProp = clientId ?? getClientIdFromLocalSession();
      if (fromProp != null && fromProp !== '') {
        setResolvedClientId(fromProp);
      } else {
        const token = localStorage.getItem('authToken');
        fetch(`${API_BASE_URL}/api/session/database-info`, {
          headers: { Authorization: `Bearer ${token}` }
        })
          .then((r) => r.json())
          .then((data) => {
            if (data?.success && data?.data?.clientId != null) {
              setResolvedClientId(data.data.clientId);
            }
          })
          .catch(() => { /* ignore */ });
      }
    } else {
      setPasswordValidationRules([]);
      setIsPasswordFieldFocused(false);
      setResolvedClientId(null);
    }
  }, [showUserForm, clientId]);

  const resetProfilePanelState = () => {
    setProfileExpanded(false);
    setProfileFirstName('');
    setProfileLastName('');
    revokeBlobPreviewUrl(profilePhotoPreviewUrl);
    setProfilePhotoPreviewUrl(null);
    setProfilePhotoPendingKey(null);
    setProfilePhotoDraftId(null);
    setProfilePhotoUploading(false);
    setProfilePanelSnapshot(null);
  };

  const ensureProfileDraftId = () => {
    if (profilePhotoDraftId) return profilePhotoDraftId;
    const id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `draft-${Date.now()}`;
    setProfilePhotoDraftId(id);
    return id;
  };

  const initProfileFromUsername = (username, photoKey, photoUrl) => {
    const { firstName, lastName } = splitUserDisplayName(username);
    setProfileFirstName(firstName);
    setProfileLastName(lastName);
    setProfilePhotoPendingKey(photoKey || null);
    setProfilePhotoPreviewUrl(photoUrl || null);
    setProfilePhotoDraftId(null);
    setProfileExpanded(false);
    setProfilePanelSnapshot(null);
  };

  const loadProfilePhotoViewUrl = async (userId) => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${API_BASE_URL}/api/users/${userId}/profile-photo/url`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include',
      });
      const data = await res.json();
      if (data.success && data.viewUrl) {
        setProfilePhotoPreviewUrl(data.viewUrl);
        setProfilePhotoPendingKey(null);
      }
    } catch (_) { /* preview opcional */ }
  };

  const handleProfilePhotoSelect = async (event) => {
    const input = event.currentTarget;
    const file = input?.files?.[0];
    if (!file || !(file instanceof Blob)) return;
    if (input.files.length > 1) {
      input.value = '';
      alert('Envie apenas uma imagem por vez.');
      return;
    }

    const effectiveClientId = resolvedClientId ?? clientId ?? getClientIdFromLocalSession();
    if (effectiveClientId == null || effectiveClientId === '') {
      input.value = '';
      alert('Não foi possível identificar o cliente da sessão. Faça login novamente.');
      return;
    }

    const immediatePreview = URL.createObjectURL(file);
    revokeBlobPreviewUrl(profilePhotoPreviewUrl);
    setProfilePhotoPreviewUrl(immediatePreview);

    setProfilePhotoUploading(true);
    try {
      const compressed = await compressProfileImage(file);
      const draftId = ensureProfileDraftId();
      const token = localStorage.getItem('authToken');
      const presignRes = await fetch(`${API_BASE_URL}/api/users/profile-photo/presign`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId: null,
          draftId,
          mimeType: compressed.type,
          sizeBytes: compressed.size,
          fileName: compressed.name
        })
      });
      const presignData = await presignRes.json();
      if (!presignRes.ok || !presignData.success) {
        throw new Error(presignData.message || 'Falha ao preparar upload');
      }
      const uploadRes = await fetch(presignData.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': compressed.type },
        body: compressed
      });
      if (!uploadRes.ok) throw new Error('Falha ao enviar imagem para o servidor');
      setProfilePhotoPendingKey(presignData.key);
      if (compressed instanceof Blob) {
        const finalPreview = URL.createObjectURL(compressed);
        revokeBlobPreviewUrl(immediatePreview);
        setProfilePhotoPreviewUrl(finalPreview);
      }
    } catch (err) {
      alert(err.message || 'Erro ao enviar foto');
    } finally {
      input.value = '';
      setProfilePhotoUploading(false);
    }
  };

  const openProfilePanel = () => {
    setProfilePanelSnapshot({
      firstName: profileFirstName,
      lastName: profileLastName,
      photoUrl: profilePhotoPreviewUrl,
      photoKey: profilePhotoPendingKey
    });
    setProfileExpanded(true);
  };

  const handleProfilePanelCancel = () => {
    if (profilePanelSnapshot) {
      setProfileFirstName(profilePanelSnapshot.firstName);
      setProfileLastName(profilePanelSnapshot.lastName);
      setProfilePhotoPreviewUrl(profilePanelSnapshot.photoUrl);
      setProfilePhotoPendingKey(profilePanelSnapshot.photoKey);
    }
    setProfileExpanded(false);
  };

  const handleProfilePanelSave = () => {
    const merged = joinUserDisplayName(profileFirstName, profileLastName).slice(0, 60);
    if (!merged) {
      setUserFormErrors((prev) => ({ ...prev, username: 'Nome é obrigatório' }));
      return;
    }
    handleFormChange('username', merged);
    setUserFormErrors((prev) => ({ ...prev, username: undefined }));
    setProfileExpanded(false);
  };

  const profileDisplayName =
    joinUserDisplayName(profileFirstName, profileLastName) ||
    String(userFormData.username || '').trim() ||
    'Sem nome';

  const profileInitials = (() => {
    const f = profileFirstName || profileDisplayName.split(/\s+/)[0] || '?';
    const l = profileLastName ? profileLastName.split(/\s+/)[0]?.[0] : profileDisplayName.split(/\s+/)[1]?.[0];
    return `${f[0] || ''}${l || ''}`.toUpperCase() || '?';
  })();

  const validatePasswordField = () => {
    if (!passPolicy) return;
    const result = validatePasswordForPolicy(userFormData.password, passPolicy);
    setPasswordValidationRules(result.rules);
    if (userFormData.password && !result.valid) {
      setUserFormErrors(prev => ({ ...prev, password: result.errors[0] || 'Senha não atende aos requisitos.' }));
    } else if (result.valid) {
      setUserFormErrors(prev => ({ ...prev, password: undefined }));
    }
  };

  // Função para carregar usuários
  const loadUsers = async () => {
    setIsLoadingUsers(true);
    try {
      const token = localStorage.getItem('authToken');
      const url = `${API_BASE_URL}/api/users${showInactive ? '?showInactive=1' : ''}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success) {
        setUsers(result.users);
      } else {
        console.error('Erro ao carregar usuários:', result.message);
      }
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
    } finally {
      setIsLoadingUsers(false);
    }
  };

  // Carregar usuários ao montar e quando showInactive mudar
  useEffect(() => {
    loadUsers();
  }, [showInactive]);

  // Função para abrir formulário de novo usuário
  const handleNewUser = () => {
    setUserFormData({
      user: '',
      password: '',
      type: '',
      coordinator: false,
      blacktheme: false,
      asstec_openos: false,
      asstec_closeos: false,
      asstec_deleteos: false,
      asstec_create_reports: false,
      asstec_reembolso_approve: false,
      asstec_reembolso_pay: false,
      asstec_reembolso_create: false,
      asstec_openos_type_only: false,
      customers_chat_only: false,
      cannyLinked: false,
      codtec: '',
      active: true,
    });
    setUserOSTypes({
      os_stock: false,
      os_counter: false,
      os_reading: false,
      os_return: false,
      os_uninstall: false,
      os_install: false,
      os_preventive: false,
      os_normal: false
    });
    setUserShowOSConfig(0); // Padrão: Ordem de serviço
    setEditingUser(null);
    setUserFormData({
      user: '',
      username: '',
      password: '',
      type: '',
      coordinator: false,
      blacktheme: false,
      asstec_openos: false,
      asstec_closeos: false,
      asstec_deleteos: false,
      asstec_create_reports: false,
      asstec_reembolso_approve: false,
      asstec_reembolso_pay: false,
      asstec_reembolso_create: false,
      asstec_openos_type_only: false,
      customers_chat_only: false,
      codtec: '',
      active: true,
      changePasswordOnNextLogin: false,
    });
    setUserFormErrors({});
    setEmailConfig({
      email: '',
      password: '',
      smtpServer: '',
      smtpPort: ''
    });
    setHasEmailPasswordInDb(false);
    setTestEmail('');
    setEmailTestResult(null);
    setGoogleOAuthConfig({
      google_client_id: '',
      google_client_secret: '',
      has_client_secret: false,
      google_redirect_uri: ''
    });
    setEmailType('comum');
    resetProfilePanelState();
    initProfileFromUsername('');
    setProfilePhotoDraftId(
      (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `draft-${Date.now()}`
    );
    setProfileExpanded(true);
    setActiveUserTab('basic');
    setSecuritySubTab('geral');
    setTechPurpose('oficina');
    setShowUserForm(true);
  };

  // Função para editar usuário
  const handleEditUser = async (user) => {
    setUserFormData({
      user: user.user,
      username: user.username || '',
      password: '',
      type: user.type === 'Usuário' ? 'Coordenador' : user.type,
      coordinator: user.coordinator === true || user.coordinator === 1 || user.type === 'Usuário',
      blacktheme: normalizeBlacktheme(user.blacktheme) === THEME_PREF.DARK,
      asstec_openos: false,
      asstec_closeos: false,
      asstec_deleteos: false,
      asstec_create_reports: false,
      asstec_reembolso_approve: false,
      asstec_reembolso_pay: false,
      asstec_reembolso_create: false,
      asstec_openos_type_only: false,
      customers_chat_only: false,
      cannyLinked: user.canny_linked === 1 || user.canny_linked === true,
      codtec: user.codtec || '',
      active: user.active !== false && user.active !== 0,
      changePasswordOnNextLogin: false,
    });
    const editType = user.type === 'Usuário' ? 'Coordenador' : user.type;
    const editCodtec = String(user.codtec || '').trim();
    setTechPurpose(
      (editType === 'Técnico' || Number(user.type) === 3) && !/^\d{4}$/.test(editCodtec)
        ? 'app_go'
        : 'oficina'
    );
    setEditingUser(user);
    resetProfilePanelState();
    initProfileFromUsername(user.username || '');
    setProfilePhotoDraftId(
      (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `draft-${Date.now()}`
    );
    if (user.profilePhotoUrl) {
      setProfilePhotoPreviewUrl(user.profilePhotoUrl);
      setProfilePhotoPendingKey(null);
    } else if (user.hasProfilePhoto) {
      loadProfilePhotoViewUrl(user.id);
    }
    setUserFormErrors({});

    // Carregar configuração de visão de ordens de serviço
    try {
      const token = localStorage.getItem('authToken');
      const configResponse = await fetch(`${API_BASE_URL}/api/users/${user.id}/config`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const configResult = await configResponse.json();
      if (configResult.success) {
        setUserShowOSConfig(configResult.asstec_showos || 0);
        // Carregar permissão de abrir OS: 1 ou true = true, caso contrário = false
        setUserFormData(prev => ({
          ...prev,
          asstec_openos: configResult.asstec_openos === 1 || configResult.asstec_openos === true || configResult.asstec_openos === '1',
          asstec_closeos: configResult.asstec_closeos === 1 || configResult.asstec_closeos === true || configResult.asstec_closeos === '1',
          asstec_deleteos: configResult.asstec_deleteos === 1 || configResult.asstec_deleteos === true || configResult.asstec_deleteos === '1',
          asstec_create_reports: configResult.asstec_create_reports === 1 || configResult.asstec_create_reports === true || configResult.asstec_create_reports === '1',
          asstec_reembolso_approve: configResult.asstec_reembolso_approve === 1 || configResult.asstec_reembolso_approve === true || configResult.asstec_reembolso_approve === '1',
          asstec_reembolso_pay: configResult.asstec_reembolso_pay === 1 || configResult.asstec_reembolso_pay === true || configResult.asstec_reembolso_pay === '1',
          asstec_reembolso_create: configResult.asstec_reembolso_create === 1 || configResult.asstec_reembolso_create === true || configResult.asstec_reembolso_create === '1',
          asstec_openos_type_only:
            configResult.asstec_openos_type_only === 1 ||
            configResult.asstec_openos_type_only === true ||
            configResult.asstec_openos_type_only === '1',
          customers_chat_only: configResult.customers_chat_only === 1 || configResult.customers_chat_only === true || configResult.customers_chat_only === '1'
        }));
      } else {
        setUserShowOSConfig(0); // Padrão: Ordem de serviço
        setUserFormData(prev => ({
          ...prev,
          asstec_openos: false,
          asstec_closeos: false,
          asstec_deleteos: false,
          asstec_create_reports: false,
          asstec_reembolso_approve: false,
          asstec_reembolso_pay: false,
          asstec_reembolso_create: false,
          asstec_openos_type_only: false,
          customers_chat_only: false
        }));
      }
    } catch (error) {
      console.error('Erro ao carregar configuração de visão:', error);
      setUserShowOSConfig(0); // Padrão: Ordem de serviço
      setUserFormData(prev => ({
        ...prev,
        asstec_openos: false,
        asstec_closeos: false,
        asstec_deleteos: false,
        asstec_create_reports: false,
        asstec_reembolso_approve: false,
        asstec_reembolso_pay: false,
        asstec_reembolso_create: false,
        asstec_openos_type_only: false,
        customers_chat_only: false
      }));
    }
    
    // Carregar tipos de OS do banco de dados (sempre, independente de ser coordenador)
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/users/${user.id}/os-types`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        // Converter valores para boolean (pode vir como 1/0 ou true/false do banco)
        const convertToBoolean = (value) => {
          if (value === true || value === 1 || value === '1') return true;
          if (value === false || value === 0 || value === '0' || value === null || value === undefined) return false;
          return Boolean(value);
        };
        
        const loadedOSTypes = {
          os_stock: convertToBoolean(result.data.os_stock),
          os_counter: convertToBoolean(result.data.os_counter),
          os_reading: convertToBoolean(result.data.os_reading),
          os_return: convertToBoolean(result.data.os_return),
          os_uninstall: convertToBoolean(result.data.os_uninstall),
          os_install: convertToBoolean(result.data.os_install),
          os_preventive: convertToBoolean(result.data.os_preventive),
          os_normal: convertToBoolean(result.data.os_normal)
        };
        setUserOSTypes(loadedOSTypes);
      } else {
        // Se não houver dados no banco, inicializar como false
        setUserOSTypes({
          os_stock: false,
          os_counter: false,
          os_reading: false,
          os_return: false,
          os_uninstall: false,
          os_install: false,
          os_preventive: false,
          os_normal: false
        });
      }
    } catch (error) {
      console.error('❌ Erro ao carregar tipos de OS:', error);
      // Em caso de erro, inicializar como false
      setUserOSTypes({
        os_stock: false,
        os_counter: false,
        os_reading: false,
        os_return: false,
        os_uninstall: false,
        os_install: false,
        os_preventive: false,
        os_normal: false
      });
    }
    
    // Carregar configuração de email
    try {
      const token = localStorage.getItem('authToken');
      const emailResponse = await fetch(`${API_BASE_URL}/api/users/${user.id}/email-config`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const emailResult = await emailResponse.json();
      
      if (emailResult.success && emailResult.data) {
        setEmailConfig({
          email: emailResult.data.email || '',
          password: '', // Não carregar senha por segurança
          smtpServer: emailResult.data.email_smtpsv || '',
          smtpPort: emailResult.data.email_smtpport || ''
        });
        setEmailPreference(emailResult.data.email_preference || 'auto');
        // Verificar se há senha configurada no banco
        setHasEmailPasswordInDb(emailResult.data.hasPassword === true);
      } else {
        setEmailConfig({
          email: '',
          password: '',
          smtpServer: '',
          smtpPort: ''
        });
        setHasEmailPasswordInDb(false);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar configuração de email:', error);
      setEmailConfig({
        email: '',
        password: '',
        smtpServer: '',
        smtpPort: ''
      });
    }
    
    // Carregar configurações OAuth
    try {
      const token = localStorage.getItem('authToken');
      const oauthResponse = await fetch(`${API_BASE_URL}/api/users/${user.id}/email-config/oauth`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const oauthResult = await oauthResponse.json();
      
      if (oauthResult.success && oauthResult.data) {
        setGoogleOAuthConfig({
          google_client_id: oauthResult.data.google_client_id || '',
          google_client_secret: '',
          has_client_secret: Boolean(oauthResult.data.has_client_secret),
          google_redirect_uri: oauthResult.data.google_redirect_uri || ''
        });
      } else {
        setGoogleOAuthConfig({
          google_client_id: '',
          google_client_secret: '',
          has_client_secret: false,
          google_redirect_uri: ''
        });
      }
    } catch (error) {
      console.error('❌ Erro ao carregar configurações OAuth:', error);
      setGoogleOAuthConfig({
        google_client_id: '',
        google_client_secret: '',
        has_client_secret: false,
        google_redirect_uri: ''
      });
    }
    
    setEmailTestResult(null);
    setTestEmail('');
    setActiveUserTab('basic'); // Resetar para aba inicial
    setSecuritySubTab('geral');
    setShowUserForm(true);
  };

  // Função para excluir usuário
  const handleDeleteUser = async (user) => {
    const userId = user?.id;
    if (!userId) return;

    const token = localStorage.getItem('authToken');
    const typeLabel = getUserTypeLabel(user);
    const isCoordinator =
      typeLabel === 'Coordenador' ||
      user.coordinator === true ||
      user.coordinator === 1;
    const isTechnician = user.type === 'Técnico' || Number(user.type) === 3;

    try {
      if (isCoordinator) {
        const res = await fetch(`${API_BASE_URL}/api/users/${userId}/coordinator-links`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        if (json?.success && json?.data?.blocked) {
          setCoordinatorUnlinkModal({
            message: json.data.message || '',
            hasAreaLinks: Boolean(json.data.hasAreaLinks),
            hasTeamLinks: Boolean(json.data.hasTeamLinks),
          });
          return;
        }
        if (!res.ok || !json?.success) {
          setCoordinatorUnlinkModal({
            message:
              json?.message ||
              'Não foi possível verificar os vínculos deste coordenador em Gestão de equipe.',
            hasAreaLinks: false,
            hasTeamLinks: false,
          });
          return;
        }
      }

      if (isTechnician) {
        const techCode = String(user.codtec || '').trim();
        if (techCode) {
          const res = await fetch(
            `${API_BASE_URL}/api/users/technician-orders?codtec=${encodeURIComponent(techCode)}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const json = await res.json();
          if (json?.success && json?.data?.blocked) {
            setTechnicianOsBlockModal({
              message: json.data.message || '',
              orderNumbers: json.data.orderNumbers || [],
              totalCount: json.data.totalCount || 0,
            });
            return;
          }
          if (!res.ok || !json?.success) {
            setTechnicianOsBlockModal({
              message:
                json?.message ||
                'Não foi possível verificar as ordens vinculadas a este técnico.',
              orderNumbers: [],
              totalCount: 0,
            });
            return;
          }
        }
      }
    } catch (err) {
      console.error('Erro ao validar exclusão do usuário:', err);
      alert('Não foi possível validar a exclusão deste usuário.');
      return;
    }

    if (!window.confirm('Deseja realmente excluir este usuário?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        loadUsers(); // Recarregar lista
        alert('Usuário excluído com sucesso!');
      } else if (result.code === 'COORDINATOR_HAS_TEAM_LINKS') {
        setCoordinatorUnlinkModal({
          message: result.message || '',
          hasAreaLinks: Boolean(result.data?.hasAreaLinks),
          hasTeamLinks: Boolean(result.data?.hasTeamLinks),
        });
      } else if (result.code === 'TECHNICIAN_HAS_OPEN_ORDERS') {
        setTechnicianOsBlockModal({
          message: result.message || '',
          orderNumbers: result.data?.orderNumbers || [],
          totalCount: result.data?.totalCount || 0,
        });
      } else {
        alert('Erro ao excluir usuário: ' + result.message);
      }
    } catch (error) {
      console.error('Erro ao excluir usuário:', error);
      alert('Erro ao excluir usuário');
    }
  };

  // Função para alterar campos do formulário
  const handleFormChange = async (field, value) => {
    if (field === 'type') {
      const leavingCoordinator =
        userFormData.type === 'Coordenador' && value !== 'Coordenador';
      if (leavingCoordinator && editingUser?.id) {
        try {
          const token = localStorage.getItem('authToken');
          const res = await fetch(
            `${API_BASE_URL}/api/users/${editingUser.id}/coordinator-links`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const json = await res.json();
          if (json?.success && json?.data?.blocked) {
            setCoordinatorUnlinkModal({
              message: json.data.message || '',
              hasAreaLinks: Boolean(json.data.hasAreaLinks),
              hasTeamLinks: Boolean(json.data.hasTeamLinks),
            });
            return;
          }
          if (!res.ok || !json?.success) {
            setCoordinatorUnlinkModal({
              message:
                json?.message ||
                'Não foi possível verificar os vínculos deste coordenador em Gestão de equipe.',
              hasAreaLinks: false,
              hasTeamLinks: false,
            });
            return;
          }
        } catch (err) {
          setCoordinatorUnlinkModal({
            message:
              'Não foi possível verificar os vínculos deste coordenador em Gestão de equipe.',
            hasAreaLinks: false,
            hasTeamLinks: false,
          });
          return;
        }
      }

      const leavingTechnician =
        userFormData.type === 'Técnico' && value !== 'Técnico';
      if (leavingTechnician && editingUser?.id) {
        const techCode = String(userFormData.codtec || editingUser.codtec || '').trim();
        if (techCode) {
          try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(
              `${API_BASE_URL}/api/users/technician-orders?codtec=${encodeURIComponent(techCode)}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const json = await res.json();
            if (json?.success && json?.data?.blocked) {
              setTechnicianOsBlockModal({
                message: json.data.message || '',
                orderNumbers: json.data.orderNumbers || [],
                totalCount: json.data.totalCount || 0,
              });
              return;
            }
            if (!res.ok || !json?.success) {
              setTechnicianOsBlockModal({
                message:
                  json?.message ||
                  'Não foi possível verificar as ordens vinculadas a este técnico.',
                orderNumbers: [],
                totalCount: 0,
              });
              return;
            }
          } catch (err) {
            setTechnicianOsBlockModal({
              message: 'Não foi possível verificar as ordens vinculadas a este técnico.',
              orderNumbers: [],
              totalCount: 0,
            });
            return;
          }
        }
      }

      // Sempre que o tipo deixar de ser "Coordenador", desmarcar coordenador e limpar tipos de OS
      if (value !== 'Coordenador') {
        const technicianLocks = value === 'Técnico'
          ? {
              ...Object.fromEntries(USER_PERMISSION_TOGGLES.map((opt) => [opt.field, false])),
              cannyLinked: false,
              customers_chat_only: false,
            }
          : {};
        const financeiroLocks = value === 'Financeiro'
          ? {
              asstec_openos: false,
              asstec_closeos: false,
              asstec_deleteos: false,
              asstec_create_reports: false,
              cannyLinked: false,
              customers_chat_only: false,
            }
          : {};
        setUserFormData(prev => ({
          ...prev,
          [field]: value,
          coordinator: false,
          codtec: value === 'Técnico' ? prev.codtec : '',
          asstec_openos_type_only: false,
          ...technicianLocks,
          ...financeiroLocks,
        }));
        setTechPurpose('oficina');
        setUserOSTypes({
          os_stock: false,
          os_counter: false,
          os_reading: false,
          os_return: false,
          os_uninstall: false,
          os_install: false,
          os_preventive: false,
          os_normal: false
        });
        if (value === 'Técnico' || value === 'Financeiro') setUserShowOSConfig(0);
      } else {
        setUserFormData(prev => ({
          ...prev,
          [field]: value,
          codtec: '',
          coordinator: true
        }));
      }
    } else if (field === 'asstec_openos') {
      setUserFormData((prev) => ({
        ...prev,
        asstec_openos: value,
        asstec_openos_type_only: value ? prev.asstec_openos_type_only : false,
      }));
    } else if (field === 'codtec') {
      // Somente dígitos, exatamente até 4
      const limitedValue = String(value || '').replace(/\D/g, '').slice(0, 4);
      setUserFormData(prev => ({
        ...prev,
        [field]: limitedValue,
      }));
    } else {
      setUserFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    
    // Limpar erro do campo
    if (userFormErrors[field]) {
      setUserFormErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  // Função para salvar usuário
  // Função para testar configuração de email
  const handleTestEmailConfig = async () => {
    if (!emailConfig.email || !emailConfig.smtpServer || !emailConfig.smtpPort) {
      setEmailTestResult({
        success: false,
        message: 'Preencha todos os campos obrigatórios (Email, Servidor SMTP e Porta SMTP)'
      });
      return;
    }

    // Verificar se há senha (no formulário ou no banco)
    if (!emailConfig.password && !hasEmailPasswordInDb) {
      setEmailTestResult({
        success: false,
        message: 'Preencha a senha do email ou salve a configuração primeiro'
      });
      return;
    }

    setIsTestingEmail(true);
    setEmailTestResult(null);

    try {
      const token = localStorage.getItem('authToken');
      const userId = editingUser?.id || 'test';
      const response = await fetch(`${API_BASE_URL}/api/users/${userId}/email-config/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailConfig.email,
          password: emailConfig.password || null, // null indica para usar senha do banco
          smtpServer: emailConfig.smtpServer,
          smtpPort: parseInt(emailConfig.smtpPort) || 587
        })
      });

      const result = await response.json();
      
      setEmailTestResult({
        success: result.success,
        message: result.message || (result.success ? 'Configuração de email válida!' : 'Erro ao testar configuração')
      });
    } catch (error) {
      console.error('Erro ao testar configuração de email:', error);
      setEmailTestResult({
        success: false,
        message: 'Erro ao testar configuração: ' + (error.message || 'Erro desconhecido')
      });
    } finally {
      setIsTestingEmail(false);
    }
  };

  // Função para enviar email de teste
  const handleSendTestEmail = async () => {
    if (!testEmail || !emailConfig.email || !emailConfig.smtpServer || !emailConfig.smtpPort) {
      setEmailTestResult({
        success: false,
        message: 'Preencha todos os campos de configuração de email e o email de destino'
      });
      return;
    }

    // Verificar se há senha (no formulário ou no banco)
    if (!emailConfig.password && !hasEmailPasswordInDb) {
      setEmailTestResult({
        success: false,
        message: 'Preencha a senha do email ou salve a configuração primeiro'
      });
      return;
    }

    setIsSendingTestEmail(true);
    setEmailTestResult(null);

    try {
      const token = localStorage.getItem('authToken');
      const userId = editingUser?.id || 'test';
      const response = await fetch(`${API_BASE_URL}/api/users/${userId}/email-config/send-test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailConfig.email,
          password: emailConfig.password || null, // null indica para usar senha do banco
          smtpServer: emailConfig.smtpServer,
          smtpPort: parseInt(emailConfig.smtpPort) || 587,
          testEmail: testEmail
        })
      });

      const result = await response.json();
      
      setEmailTestResult({
        success: result.success,
        message: result.message || (result.success ? 'Email de teste enviado com sucesso!' : 'Erro ao enviar email de teste')
      });
    } catch (error) {
      console.error('Erro ao enviar email de teste:', error);
      setEmailTestResult({
        success: false,
        message: 'Erro ao enviar email de teste: ' + (error.message || 'Erro desconhecido')
      });
    } finally {
      setIsSendingTestEmail(false);
    }
  };

  const handleSaveOAuthConfig = async () => {
    if (!editingUser?.id) {
      alert('Salve o usuário primeiro antes de configurar OAuth');
      return;
    }
    if (
      !googleOAuthConfig.google_client_id ||
      !googleOAuthConfig.google_redirect_uri ||
      (!googleOAuthConfig.google_client_secret && !googleOAuthConfig.has_client_secret)
    ) {
      alert('Preencha Client ID, Redirect URI e Client Secret (na primeira configuração)');
      return;
    }
    setIsSavingOAuthConfig(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/users/${editingUser.id}/email-config/oauth/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          google_client_id: googleOAuthConfig.google_client_id,
          google_client_secret: googleOAuthConfig.google_client_secret,
          google_redirect_uri: googleOAuthConfig.google_redirect_uri
        })
      });
      const result = await response.json();
      if (result.success) {
        setGoogleOAuthConfig((prev) => ({
          ...prev,
          google_client_secret: '',
          has_client_secret: true,
        }));
        alert('Configurações OAuth salvas com sucesso!');
      } else {
        alert('Erro ao salvar configurações OAuth: ' + (result.message || 'Erro desconhecido'));
      }
    } catch (error) {
      console.error('Erro ao salvar OAuth config:', error);
      alert('Erro ao salvar configurações OAuth: ' + error.message);
    } finally {
      setIsSavingOAuthConfig(false);
    }
  };

  const handleSaveUser = async () => {
    const errors = {};
    console.log('[UserForm] handleSaveUser iniciado', {
      editingUserId: editingUser?.id || null,
      cannyLinkedFlag: userFormData.cannyLinked,
      userEmail: userFormData.user,
      username: userFormData.username
    });
    
    // Validações
    const nameToValidate = joinUserDisplayName(profileFirstName, profileLastName) || userFormData.username;
    if (!nameToValidate || !nameToValidate.trim()) {
      errors.username = 'Nome é obrigatório';
    } else if (nameToValidate.trim().length > 60) {
      errors.username = 'Nome deve ter no máximo 60 caracteres';
    } else {
      const usernameRegex = /^[a-zA-Z0-9\s]+$/;
      if (!usernameRegex.test(nameToValidate.trim())) {
        errors.username = 'Nome deve conter apenas letras, números e espaços';
      }
    }
    
    if (!userFormData.user.trim()) {
      errors.user = 'E-mail é obrigatório';
    } else {
      // Validar formato de e-mail
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(userFormData.user.trim())) {
        errors.user = 'E-mail inválido. Por favor, insira um e-mail válido.';
      }
    }

    if (!USER_TYPE_OPTIONS.some((opt) => opt.value === userFormData.type)) {
      errors.type = 'Tipo de usuário é obrigatório';
    }
    
    // Senha: obrigatória para novo usuário; ao editar opcional, mas se preenchida deve respeitar a política
    if (passPolicy) {
      if (!editingUser) {
        if (!userFormData.password || !userFormData.password.trim()) {
          errors.password = 'Senha é obrigatória';
        } else {
          const pwdVal = validatePasswordForPolicy(userFormData.password, passPolicy);
          if (!pwdVal.valid) {
            errors.password = pwdVal.errors[0] || 'Senha não atende aos requisitos';
            setPasswordValidationRules(pwdVal.rules);
          }
        }
      } else if (userFormData.password && userFormData.password.trim()) {
        const pwdVal = validatePasswordForPolicy(userFormData.password, passPolicy);
        if (!pwdVal.valid) {
          errors.password = pwdVal.errors[0] || 'Senha não atende aos requisitos';
          setPasswordValidationRules(pwdVal.rules);
        }
      }
    } else {
      if (!editingUser && (!userFormData.password || userFormData.password.length < 4)) {
        errors.password = 'Senha é obrigatória (mínimo 4 caracteres)';
      } else if (editingUser && userFormData.password && userFormData.password.length < 4) {
        errors.password = 'Senha deve ter no mínimo 4 caracteres';
      }
    }
    
    // Validar que coordenadores devem ter pelo menos um tipo de OS selecionado
    const isCoordinatorType =
      userFormData.type === 'Coordenador' ||
      userFormData.coordinator === true ||
      userFormData.coordinator === 1;
    if (isCoordinatorType) {
      const hasAtLeastOneOS = Object.values(userOSTypes).some(
        (value) => value === true || value === 1 || value === '1'
      );
      if (!hasAtLeastOneOS) {
        errors.os_types = 'Selecione pelo menos um tipo de OS';
      }
    }

    if (userFormData.type === 'Técnico' && techPurpose === 'oficina') {
      if (!/^\d{4}$/.test(String(userFormData.codtec || '').trim())) {
        errors.codtec = 'Código do técnico deve ter exatamente 4 dígitos';
      }
    }

    if (userFormData.type === 'Financeiro') {
      const hasReembolso =
        userFormData.asstec_reembolso_approve ||
        userFormData.asstec_reembolso_pay ||
        userFormData.asstec_reembolso_create;
      if (!hasReembolso) {
        errors.reembolso_perms = 'Selecione pelo menos uma permissão em Gestão de reembolsos';
      }
    }

    if (Object.keys(errors).length > 0) {
      console.warn('[UserForm] Validações falharam ao salvar usuário', errors);
      setUserFormErrors(errors);
      if (errors.reembolso_perms || errors.os_types) {
        setActiveUserTab('permissions');
        setSecuritySubTab(errors.os_types && !errors.reembolso_perms ? 'geral' : 'permissoes');
      }
      return;
    }

    try {
      const method = editingUser ? 'PUT' : 'POST';
      const url = editingUser 
        ? `${API_BASE_URL}/api/users/${editingUser.id}` 
        : `${API_BASE_URL}/api/users`;
      
      // Preparar dados - não enviar senha vazia ao editar
      // Garantir que asstec_openos esteja definido (padrão: false/0)
      const mergedUsername = joinUserDisplayName(profileFirstName, profileLastName) || userFormData.username;
      const dataToSend = { 
        ...userFormData,
        username: mergedUsername,
        coordinator: userFormData.type === 'Coordenador' ? true : userFormData.coordinator === true,
        asstec_openos: userFormData.asstec_openos !== undefined ? (userFormData.asstec_openos ? 1 : 0) : 0,
        asstec_closeos: userFormData.asstec_closeos !== undefined ? (userFormData.asstec_closeos ? 1 : 0) : 0,
        canny_linked: (userFormData.type === 'Técnico' || userFormData.type === 'Financeiro') ? 0 : (userFormData.cannyLinked === true ? 1 : 0),
        active: userFormData.active !== false,
        codtec:
          userFormData.type === 'Técnico' && techPurpose === 'oficina'
            ? String(userFormData.codtec || '').trim()
            : (userFormData.type === 'Técnico' ? '' : (userFormData.codtec || '')),
      };
      if (profilePhotoPendingKey) {
        dataToSend.profile_photo_s3_key = profilePhotoPendingKey;
      }
      delete dataToSend.asstec_deleteos;
      console.log('[UserForm] Enviando requisição de save de usuário', {
        method,
        url,
        canny_linked: dataToSend.canny_linked
      });
      if (editingUser && !userFormData.password) {
        delete dataToSend.password;
      }
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(url, {
        method: method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });
      
      const result = await response.json();
      console.log('[UserForm] Resposta do backend ao salvar usuário', {
        success: result.success,
        cannyLinked: result.cannyLinked,
        message: result.message
      });
      
      if (result.success) {
        const userId = editingUser ? editingUser.id : result.userId || result.id;

        if (profilePhotoPendingKey && userId) {
          await loadProfilePhotoViewUrl(userId);
          if (onProfilePhotoSaved) await onProfilePhotoSaved(userId);
        }
        
        // Salvar configuração de visão de ordens de serviço e permissão de abrir OS
        try {
          const token = localStorage.getItem('authToken');
          const configResponse = await fetch(`${API_BASE_URL}/api/users/${userId}/config`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
              asstec_showos: isFinanceiroType ? 0 : userShowOSConfig,
              asstec_openos: isRestrictedBoardType ? 0 : (userFormData.asstec_openos ? 1 : 0),
              asstec_closeos: isRestrictedBoardType ? 0 : (userFormData.asstec_closeos ? 1 : 0),
              asstec_deleteos: isRestrictedBoardType ? 0 : (userFormData.asstec_deleteos ? 1 : 0),
              asstec_create_reports: isRestrictedBoardType ? 0 : (userFormData.asstec_create_reports ? 1 : 0),
              asstec_reembolso_approve: isTechnicianType ? 0 : (userFormData.asstec_reembolso_approve ? 1 : 0),
              asstec_reembolso_pay: isTechnicianType ? 0 : (userFormData.asstec_reembolso_pay ? 1 : 0),
              asstec_reembolso_create: isTechnicianType ? 0 : (userFormData.asstec_reembolso_create ? 1 : 0),
              asstec_financeiro_only: isFinanceiroType ? 1 : 0,
              asstec_openos_type_only:
                isRestrictedBoardType || !userFormData.asstec_openos
                  ? 0
                  : userFormData.asstec_openos_type_only
                    ? 1
                    : 0,
              customers_chat_only: isRestrictedBoardType ? 0 : (userFormData.customers_chat_only ? 1 : 0)
            })
          });
          const configResult = await configResponse.json();
          if (!configResult.success) {
            console.error('Erro ao salvar configuração:', configResult.message);
          }
        } catch (configError) {
          console.error('Erro ao salvar configuração:', configError);
        }
        
        // Se for coordenador, salvar tipos de OS
        if (userFormData.type === 'Coordenador' || userFormData.coordinator === true) {
          try {
            const token = localStorage.getItem('authToken');
            await fetch(`${API_BASE_URL}/api/users/${userId}/os-types`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(userOSTypes)
            });
          } catch (osError) {
            console.error('Erro ao salvar tipos de OS:', osError);
          }
        }
        
        // Salvar configuração de email (apenas se houver dados preenchidos)
        if (emailConfig.email || emailConfig.smtpServer || emailConfig.smtpPort || emailConfig.password) {
          try {
            const token = localStorage.getItem('authToken');
            const emailResponse = await fetch(`${API_BASE_URL}/api/users/${userId}/email-config`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                email: emailConfig.email,
                password: emailConfig.password, // Será criptografado no backend
                smtpServer: emailConfig.smtpServer,
                smtpPort: parseInt(emailConfig.smtpPort) || null,
                email_preference: 'comum'
              })
            });
            const emailResult = await emailResponse.json();
            if (emailResult.success) {
              // Atualizar flag de senha no banco se todos os campos estão preenchidos
              const hasAllFields = emailConfig.email && emailConfig.smtpServer && emailConfig.smtpPort;
              // Se senha foi fornecida ou já estava no banco, considerar como configurada
              if (hasAllFields && (emailConfig.password || hasEmailPasswordInDb)) {
                setHasEmailPasswordInDb(true);
              }
            } else {
              console.error('Erro ao salvar configuração de email:', emailResult.message);
            }
          } catch (emailError) {
            console.error('Erro ao salvar configuração de email:', emailError);
          }
        }

        if (editingUser && userFormData.cannyLinked && result.cannyLinked === false) {
          setUserFormData(prev => ({ ...prev, cannyLinked: false }));
          toastError('Usuário atualizado, mas não foi possível vincular ao Canny. Tente novamente.');
          return;
        }
        const wasAlreadyCannyLinked = editingUser && (editingUser.canny_linked === true || editingUser.canny_linked === 1);
        if (editingUser && userFormData.cannyLinked && result.cannyLinked === true && !wasAlreadyCannyLinked) {
          setShowCannySuccessAnimation(true);
          setTimeout(() => {
            setShowUserForm(false);
            loadUsers();
            setShowCannySuccessAnimation(false);
          }, 1500);
          return;
        }

        setShowUserForm(false);
        loadUsers(); // Recarregar lista
        toastSuccess(editingUser ? 'Usuário atualizado' : 'Usuário criado');
      } else if (result.code === 'COORDINATOR_HAS_TEAM_LINKS') {
        setCoordinatorUnlinkModal({
          message: result.message || '',
          hasAreaLinks: Boolean(result.data?.hasAreaLinks),
          hasTeamLinks: Boolean(result.data?.hasTeamLinks),
        });
      } else if (result.code === 'TECHNICIAN_HAS_OPEN_ORDERS') {
        setTechnicianOsBlockModal({
          message: result.message || '',
          orderNumbers: result.data?.orderNumbers || [],
          totalCount: result.data?.totalCount || 0,
        });
      } else {
        toastError(result.message || 'Erro ao salvar usuário');
      }
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
      toastError(error.message || 'Erro ao salvar usuário');
    }
  };

  const toggleUserSort = useCallback((key) => {
    setUserSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  }, []);

  const displayedUsers = React.useMemo(() => {
    const search = searchTerm.trim().toLowerCase();
    const filtered = users.filter((user) => {
      if (!search) return true;
      return (
        user.id.toString().includes(search) ||
        (user.username && user.username.toLowerCase().includes(search)) ||
        user.user.toLowerCase().includes(search) ||
        getUserTypeLabel(user).toLowerCase().includes(search) ||
        (user.coordinator ? 'sim' : 'não').includes(search)
      );
    });

    const { key, direction } = userSortConfig;
    const mult = direction === 'asc' ? 1 : -1;
    const sorted = [...filtered];

    sorted.sort((a, b) => {
      let av;
      let bv;

      switch (key) {
        case 'email':
          av = (a.user || '').toLowerCase();
          bv = (b.user || '').toLowerCase();
          break;
        case 'status':
          av = a.active !== false ? 1 : 0;
          bv = b.active !== false ? 1 : 0;
          break;
        case 'type':
          av = getUserTypeLabel(a).toLowerCase();
          bv = getUserTypeLabel(b).toLowerCase();
          break;
        case 'permissions':
          av = getUserTablePermissionPills(a).join(', ').toLowerCase();
          bv = getUserTablePermissionPills(b).join(', ').toLowerCase();
          break;
        case 'name':
        default:
          av = (a.username || a.user || '').toLowerCase();
          bv = (b.username || b.user || '').toLowerCase();
          break;
      }

      if (typeof av === 'number' && typeof bv === 'number') {
        return (av - bv) * mult;
      }
      return String(av).localeCompare(String(bv), 'pt-BR', { numeric: true }) * mult;
    });

    return sorted;
  }, [users, searchTerm, userSortConfig]);

  const handleExportUsers = useCallback(() => {
    exportUsersToXlsx(displayedUsers, {
      getUserTypeLabel,
      getPermissionPills: getUserTablePermissionPills,
    });
  }, [displayedUsers]);

  return (
    <div className="user-management">
      <PassPolicyModal open={showPassPolicyModal} onClose={() => setShowPassPolicyModal(false)} />
      <AuthHistoryModal
        open={showAuthHistoryModal}
        onClose={() => setShowAuthHistoryModal(false)}
        mode="user"
        userId={editingUser?.id}
      />
      <UserManagementList
        users={users}
        displayedUsers={displayedUsers}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onNewUser={handleNewUser}
        showInactive={showInactive}
        onShowInactiveChange={setShowInactive}
        onPassPolicy={() => setShowPassPolicyModal(true)}
        onExport={handleExportUsers}
        exportDisabled={displayedUsers.length === 0}
        isLoading={isLoadingUsers}
        typeOptions={USER_TYPE_OPTIONS}
        sortConfig={userSortConfig}
        onSort={toggleUserSort}
        userProfilePhotoMap={userProfilePhotoMap}
        getUserTypeLabel={getUserTypeLabel}
        getPermissionPills={getUserTablePermissionPills}
        onEditUser={handleEditUser}
        onDeleteUser={handleDeleteUser}
        renderProfileAvatar={renderProfileAvatar}
      />

      {showUserForm && (
        <div className="user-form-overlay">
          <div className="user-form-modern">
            <div className="user-form-modern-body">
              <aside className="user-form-sidebar">
                <div className="user-form-sidebar-header">
                  <h2 className="user-form-sidebar-title">
                    {editingUser ? 'Editar usuário' : 'Novo usuário'}
                  </h2>
                  <p className="user-form-sidebar-subtitle">
                    Gerencie as informações e permissões.
                  </p>
                </div>
                <nav className="user-form-nav" aria-label="Seções do usuário">
                  {[
                    { id: 'basic', Icon: CircleUser, label: 'Perfil' },
                    { id: 'permissions', Icon: ShieldCheck, label: 'Segurança' },
                    { id: 'settings', Icon: Cog, label: 'Configurações' },
                    ...(showCustomersUserTab
                      ? [{ id: 'customers', Icon: CustomersAffiliateIcon, label: 'Customers' }]
                      : []),
                    { id: 'email', Icon: Mail, label: 'Email' },
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      className={`user-form-nav-item${activeUserTab === tab.id ? ' active' : ''}${
                        userFormTabHasError(userFormErrors, tab.id) ? ' has-error' : ''
                      }`}
                      onClick={() => setActiveUserTab(tab.id)}
                    >
                      <span className="user-form-nav-icon">
                        <tab.Icon size={14} strokeWidth={2} aria-hidden="true" />
                      </span>
                      {tab.label}
                    </button>
                  ))}
                </nav>
              </aside>

              <div className="user-form-main">
                <div className={`user-form-main-header${activeUserTab === 'permissions' ? ' user-form-main-header--sec' : ''}`}>
                  {activeUserTab === 'permissions' ? (
                    <UserFormSecurityTabs
                      value={securitySubTab}
                      onChange={setSecuritySubTab}
                      permissionsAttention={Boolean(userFormData.type) && !isTechnicianType}
                    />
                  ) : (
                    <h3 className="user-form-main-title">
                      {activeUserTab === 'basic' && 'Perfil'}
                      {activeUserTab === 'settings' && 'Configurações'}
                      {activeUserTab === 'customers' && 'Customers'}
                      {activeUserTab === 'email' && 'Configuração de email'}
                    </h3>
                  )}
                  <button
                    type="button"
                    className="user-form-modern-close"
                    onClick={() => setShowUserForm(false)}
                    title="Fechar"
                  >
                    ✕
                  </button>
                </div>

                <div className="user-form-main-content">
                <UserFormTabErrorBanner
                  errors={userFormErrors}
                  onGoToTab={(tab) => {
                    setActiveUserTab(tab);
                    if (tab === 'permissions' && userFormErrors.reembolso_perms) {
                      setSecuritySubTab('permissoes');
                    }
                  }}
                />
                {/* Aba: Informações Básicas */}
                {activeUserTab === 'basic' && (
                  <div className="user-form-rows">
                    <div className={`user-form-row user-form-row--profile${profileExpanded ? ' user-form-row--profile-open' : ''}`}>
                      <div className="user-form-row-label">Perfil</div>
                      {!profileExpanded ? (
                        <>
                          <div className="user-form-row-content user-form-profile-summary">
                            <div className="user-form-profile-avatar" aria-hidden="true">
                              {profilePhotoPreviewUrl ? (
                                <img src={profilePhotoPreviewUrl} alt="" className="user-form-profile-avatar-img" />
                              ) : (
                                <span className="user-form-profile-avatar-initials">{profileInitials}</span>
                              )}
                            </div>
                            <span className="user-form-profile-name">{profileDisplayName}</span>
                          </div>
                          <div className="user-form-row-action">
                            <button type="button" className="user-form-link-btn" onClick={openProfilePanel}>
                              Atualizar perfil
                            </button>
                          </div>
                        </>
                      ) : (
                        <div className="user-form-profile-panel">
                          <h4 className="user-form-profile-panel-title">Atualizar perfil</h4>
                          <div className="user-form-profile-panel-avatar-row">
                            <div className="user-form-profile-avatar user-form-profile-avatar--lg">
                              {profilePhotoPreviewUrl ? (
                                <img src={profilePhotoPreviewUrl} alt="" className="user-form-profile-avatar-img" />
                              ) : (
                                <span className="user-form-profile-avatar-initials">{profileInitials}</span>
                              )}
                            </div>
                            <div className="user-form-profile-upload">
                              <input
                                ref={profilePhotoInputRef}
                                type="file"
                                accept={PROFILE_IMAGE_ACCEPT}
                                multiple={false}
                                className="user-form-profile-file-input"
                                onChange={handleProfilePhotoSelect}
                              />
                              <button
                                type="button"
                                className="user-form-profile-upload-btn"
                                disabled={profilePhotoUploading}
                                onClick={() => profilePhotoInputRef.current?.click()}
                              >
                                {profilePhotoUploading ? 'Enviando...' : 'Upload'}
                              </button>
                              <p className="user-form-profile-upload-hint">JPEG, PNG ou WebP. Uma imagem, até 10MB (comprimida automaticamente).</p>
                            </div>
                          </div>
                          <div className="user-form-profile-panel-fields">
                            <div className="form-field">
                              <label className="form-label">Nome</label>
                              <input
                                type="text"
                                value={profileFirstName}
                                onChange={(e) => setProfileFirstName(e.target.value.slice(0, 30))}
                                className="form-input-modern"
                                placeholder="Nome"
                              />
                            </div>
                            <div className="form-field">
                              <label className="form-label">Sobrenome</label>
                              <input
                                type="text"
                                value={profileLastName}
                                onChange={(e) => setProfileLastName(e.target.value.slice(0, 30))}
                                className="form-input-modern"
                                placeholder="Sobrenome"
                              />
                            </div>
                          </div>
                          <div className="user-form-profile-panel-actions">
                            <button type="button" className="user-form-link-btn" onClick={handleProfilePanelCancel}>
                              Cancelar
                            </button>
                            <button type="button" className="user-form-profile-save-btn" onClick={handleProfilePanelSave}>
                              Salvar
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    {userFormErrors.username && !profileExpanded && (
                      <div className="user-form-row user-form-row--error-hint">
                        <div className="user-form-row-label" />
                        <div className="user-form-row-content">
                          <span className="form-error">{userFormErrors.username}</span>
                        </div>
                      </div>
                    )}

                    <div className="user-form-row user-form-row--center">
                      <div className="user-form-row-label">E-mail{!editingUser && <span className="required"> *</span>}</div>
                      {editingUser ? (
                        <div className="user-form-row-content user-form-email-readonly">
                          <span className="user-form-email-value">{userFormData.user || '—'}</span>
                          <span className="user-form-badge">Principal</span>
                        </div>
                      ) : (
                        <div className="user-form-row-content">
                          <input
                            type="email"
                            value={userFormData.user}
                            onChange={(e) => handleFormChange('user', e.target.value)}
                            className={`form-input-modern ${userFormErrors.user ? 'error' : ''}`}
                            placeholder="exemplo@email.com"
                            style={{ width: '100%' }}
                          />
                          {userFormErrors.user && (
                            <span className="form-error">{userFormErrors.user}</span>
                          )}
                        </div>
                      )}
                    </div>

                    {editingUser?.id ? (
                      <UserFormConnectedAccounts
                        userId={editingUser.id}
                        onMessage={(type, text) => {
                          if (type === 'error') {
                            alert(text);
                          }
                        }}
                      />
                    ) : null}

                    <div className="user-form-row user-form-row--center">
                      <div className="user-form-row-label">Usuário ativo</div>
                      <div className="user-form-row-content" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span className="switch-label" style={{ fontSize: '13px' }}>
                          {userFormData.active !== false ? 'Sim' : 'Não'}
                        </span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={userFormData.active !== false}
                            onChange={(e) => handleFormChange('active', e.target.checked)}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {/* Aba: Segurança */}
                {activeUserTab === 'permissions' && (
                  <div className="user-form-rows user-form-rows--wide">
                    {securitySubTab === 'geral' && (
                    <>
                    <div className="user-form-row">
                      <div className="user-form-row-label">
                        Senha{!editingUser && <span className="required"> *</span>}
                      </div>
                      <div className="user-form-row-content">
                        <div className={`user-form-email-input user-form-password-input${userFormErrors.password ? ' user-form-password-input--error' : ''}`}>
                          <KeyRound size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                          <input
                            id="user-form-password"
                            type={showPasswordUser ? 'text' : 'password'}
                            value={userFormData.password}
                            onChange={(e) => {
                              handleFormChange('password', e.target.value);
                              if (passPolicy && userFormData.password !== undefined) {
                                const next = e.target.value;
                                const result = validatePasswordForPolicy(next, passPolicy);
                                setPasswordValidationRules(result.rules);
                              }
                            }}
                            onFocus={() => setIsPasswordFieldFocused(true)}
                            onBlur={() => { setIsPasswordFieldFocused(false); validatePasswordField(); }}
                            className="user-form-password-field"
                            placeholder={editingUser ? 'Deixe em branco para manter' : 'Defina uma senha'}
                            autoComplete="new-password"
                          />
                          <button
                            type="button"
                            className="user-form-password-toggle"
                            onClick={() => setShowPasswordUser(!showPasswordUser)}
                            title={showPasswordUser ? 'Ocultar senha' : 'Mostrar senha'}
                            aria-label={showPasswordUser ? 'Ocultar senha' : 'Mostrar senha'}
                          >
                            {showPasswordUser ? (
                              <EyeOff size={15} strokeWidth={2} aria-hidden="true" />
                            ) : (
                              <Eye size={15} strokeWidth={2} aria-hidden="true" />
                            )}
                          </button>
                        </div>
                        {isPasswordFieldFocused && passwordValidationRules.length > 0 && (
                          <ul className="password-policy-rules" aria-live="polite">
                            {passwordValidationRules.map((r, i) => (
                              <li key={i} className={r.ok ? 'password-rule-ok' : 'password-rule-fail'}>
                                <span className="password-rule-icon">{r.ok ? '✓' : '✗'}</span>
                                <span>{r.label}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                        {userFormErrors.password && (
                          <span className="form-error">{userFormErrors.password}</span>
                        )}
                      </div>
                    </div>

                    {editingUser && (
                      <div className="user-form-row user-form-row--center">
                        <div className="user-form-row-label">Histórico</div>
                        <div className="user-form-row-content">
                          <button
                            type="button"
                            className="user-form-link-btn"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
                            onClick={() => setShowAuthHistoryModal(true)}
                          >
                            <History size={15} strokeWidth={2} aria-hidden="true" />
                            Histórico de acesso
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="user-form-row">
                      <div className="user-form-row-label">
                        Tipo de usuário<span className="required"> *</span>
                      </div>
                      <div className="user-form-row-content user-form-row-content--full">
                        <div className="user-form-type-chips" role="radiogroup" aria-label="Tipo de usuário">
                          {USER_TYPE_CHIP_ROWS.map((row, rowIdx) => (
                            <div key={`type-row-${rowIdx}`} className="user-form-type-chip-row">
                              {row.map((opt) => {
                                const on = userFormData.type === opt.value;
                                return (
                                  <button
                                    key={opt.value}
                                    type="button"
                                    role="radio"
                                    aria-checked={on}
                                    className={`user-form-type-chip${on ? ' is-on' : ''}`}
                                    onClick={() => {
                                      if (on) return;
                                      handleFormChange('type', opt.value);
                                    }}
                                  >
                                    <span className={`user-form-type-chip-mark${on ? ' is-on' : ''}`} aria-hidden />
                                    {opt.label}
                                  </button>
                                );
                              })}
                            </div>
                          ))}
                        </div>
                        {userFormErrors.type ? (
                          <span className="form-error">{userFormErrors.type}</span>
                        ) : null}
                        {userFormData.type === 'Técnico' && (
                          <div className="user-form-technician-fields">
                            <div className="user-form-technician-field user-form-technician-field--purpose">
                              <span className="user-form-technician-label">Uso</span>
                              <div className="user-form-tech-purpose" role="radiogroup" aria-label="Uso do técnico">
                              <button
                                type="button"
                                role="radio"
                                aria-checked={techPurpose === 'oficina'}
                                className={`user-form-tech-purpose-opt${techPurpose === 'oficina' ? ' is-on' : ''}`}
                                onClick={async () => {
                                  if (techPurpose === 'oficina') return;
                                  setTechPurpose('oficina');
                                }}
                              >
                                Módulo Oficina
                              </button>
                              <button
                                type="button"
                                role="radio"
                                aria-checked={techPurpose === 'app_go'}
                                className={`user-form-tech-purpose-opt${techPurpose === 'app_go' ? ' is-on' : ''}`}
                                title="Sem código de técnico — aparece em Go → Usuários (Não habilitados)"
                                onClick={async () => {
                                  if (techPurpose === 'app_go') return;
                                  const techCode = String(userFormData.codtec || editingUser?.codtec || '').trim();
                                  if (editingUser?.id && /^\d{4}$/.test(techCode)) {
                                    try {
                                      const token = localStorage.getItem('authToken');
                                      const res = await fetch(
                                        `${API_BASE_URL}/api/users/technician-orders?codtec=${encodeURIComponent(techCode)}`,
                                        { headers: { Authorization: `Bearer ${token}` } }
                                      );
                                      const json = await res.json();
                                      if (json?.success && json?.data?.blocked) {
                                        setTechnicianOsBlockModal({
                                          message: json.data.message || '',
                                          orderNumbers: json.data.orderNumbers || [],
                                          totalCount: json.data.totalCount || 0,
                                        });
                                        return;
                                      }
                                      if (!res.ok || !json?.success) {
                                        setTechnicianOsBlockModal({
                                          message:
                                            json?.message ||
                                            'Não foi possível verificar as ordens vinculadas a este técnico.',
                                          orderNumbers: [],
                                          totalCount: 0,
                                        });
                                        return;
                                      }
                                    } catch (_err) {
                                      setTechnicianOsBlockModal({
                                        message: 'Não foi possível verificar as ordens vinculadas a este técnico.',
                                        orderNumbers: [],
                                        totalCount: 0,
                                      });
                                      return;
                                    }
                                  }
                                  setTechPurpose('app_go');
                                  setUserFormData((prev) => ({ ...prev, codtec: '' }));
                                  setUserFormErrors((prev) => {
                                    if (!prev?.codtec) return prev;
                                    const next = { ...prev };
                                    delete next.codtec;
                                    return next;
                                  });
                                }}
                              >
                                Usuário App Go
                              </button>
                              </div>
                            </div>
                            {techPurpose === 'oficina' ? (
                              <div className="user-form-technician-field">
                                <label className="user-form-technician-label" htmlFor="user-codtec">
                                  Código do técnico
                                </label>
                                <input
                                  id="user-codtec"
                                  type="text"
                                  inputMode="numeric"
                                  pattern="\d{4}"
                                  value={userFormData.codtec}
                                  onChange={(e) => handleFormChange('codtec', e.target.value)}
                                  className={`form-input-modern${userFormErrors.codtec ? ' error' : ''}`}
                                  maxLength={4}
                                  placeholder="4 dígitos"
                                  aria-invalid={Boolean(userFormErrors.codtec)}
                                />
                                {userFormErrors.codtec ? (
                                  <span className="form-error">{userFormErrors.codtec}</span>
                                ) : null}
                              </div>
                            ) : (
                              <p className="user-form-tech-purpose-hint">
                                Sem código de técnico. Após salvar, o usuário aparece em Go → Usuários → Não habilitados.
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {(userFormData.type === 'Coordenador' || isTechnicianType) && (
                      <div className="user-form-row">
                        <div className="user-form-row-label">
                          Tipos de OS{isTechnicianType ? null : <span className="required"> *</span>}
                        </div>
                        <div className="user-form-row-content user-form-row-content--full">
                          <p className="user-form-toggle-hint">
                            {isTechnicianType
                              ? 'Tipos de ordem de serviço não se aplicam a técnicos'
                              : 'Tipos de ordem de serviço que este coordenador poderá visualizar'}
                          </p>
                          <div
                            className={`user-form-toggle-wrap${isTechnicianType ? ' is-disabled' : ''}`}
                            role="group"
                            aria-label="Tipos de ordem de serviço"
                            aria-disabled={isTechnicianType}
                          >
                            {USER_OS_TYPE_TOGGLES.map((opt) => {
                              const active = !!userOSTypes[opt.key];
                              const OsIcon = opt.Icon;
                              return (
                                <button
                                  key={opt.key}
                                  type="button"
                                  aria-pressed={active}
                                  disabled={isTechnicianType}
                                  className={`user-form-toggle-pill${active ? ' active' : ''}`}
                                  onClick={() => {
                                    if (isTechnicianType) return;
                                    setUserOSTypes((prev) => {
                                      const next = { ...prev, [opt.key]: !prev[opt.key] };
                                      const anyOn = Object.values(next).some(Boolean);
                                      if (!anyOn) {
                                        setUserFormData((formPrev) => ({
                                          ...formPrev,
                                          asstec_openos_type_only: false,
                                        }));
                                      }
                                      return next;
                                    });
                                    if (userFormErrors.os_types) {
                                      setUserFormErrors((prev) => ({ ...prev, os_types: '' }));
                                    }
                                  }}
                                >
                                  <OsIcon size={14} strokeWidth={2} aria-hidden="true" />
                                  <span>{opt.label}</span>
                                </button>
                              );
                            })}
                          </div>
                          {userFormErrors.os_types && (
                            <span className="form-error">{userFormErrors.os_types}</span>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="user-form-row user-form-row--center">
                      <div className="user-form-row-label">Próximo logon</div>
                      <div className="user-form-row-content">
                        <label className="uc-upf-check user-form-uc-check">
                          <input
                            type="checkbox"
                            className="uc-upf-check-native"
                            checked={userFormData.changePasswordOnNextLogin === true}
                            onChange={(e) => handleFormChange('changePasswordOnNextLogin', e.target.checked)}
                          />
                          <span className="uc-upf-check-faux" aria-hidden="true" />
                          <span className="uc-upf-check-txt">Alterar senha no próximo logon</span>
                        </label>
                      </div>
                    </div>
                    </>
                    )}

                    {securitySubTab === 'permissoes' && (
                    <div className={`user-form-row user-form-row--permissions${isTechnicianType ? ' is-disabled' : ''}`}>
                      <div className="user-form-row-label">Permissões</div>
                      <div className="user-form-row-content user-form-row-content--full">
                        <div className="user-permission-groups" aria-disabled={isTechnicianType}>
                          {USER_PERMISSION_GROUPS.filter(
                            (group) => group.key !== 'reembolsos' || showReembolsoPermissionGroup || isFinanceiroType
                          ).map((group) => {
                            const GroupIcon = group.Icon;
                            const groupLocked = isTechnicianType || (isFinanceiroType && group.key !== 'reembolsos');
                            const showOpenOsTypeOnly =
                              group.key === 'os' &&
                              !groupLocked &&
                              !!userFormData.asstec_openos &&
                              Object.values(userOSTypes).some(Boolean);
                            return (
                              <section key={group.key} className="user-permission-group">
                                <div className="user-permission-group-aside">
                                  <div className="user-permission-group-heading">
                                    <GroupIcon size={14} strokeWidth={2} aria-hidden="true" />
                                    <h4 className="user-permission-group-title">{group.title}</h4>
                                  </div>
                                  {group.desc ? (
                                    <p className="user-permission-group-desc">{group.desc}</p>
                                  ) : null}
                                </div>
                                <div className="user-permission-group-body">
                                  <div
                                    className={`user-form-toggle-wrap${groupLocked ? ' is-disabled' : ''}`}
                                    role="group"
                                    aria-label={`Permissões: ${group.title}`}
                                    aria-disabled={groupLocked}
                                  >
                                    {group.toggles.map((opt) => {
                                      const active = !!userFormData[opt.field];
                                      return (
                                        <button
                                          key={opt.field}
                                          type="button"
                                          aria-pressed={active}
                                          disabled={groupLocked}
                                          className={`user-form-toggle-pill user-form-toggle-pill--permission${active ? ' active' : ''}`}
                                          onClick={() => {
                                            if (groupLocked) return;
                                            handleFormChange(opt.field, !active);
                                          }}
                                        >
                                          {active && <BadgeCheck size={14} strokeWidth={2} aria-hidden="true" />}
                                          <span>{opt.label}</span>
                                        </button>
                                      );
                                    })}
                                  </div>
                                  {showOpenOsTypeOnly ? (
                                    <label className="uc-upf-check user-form-uc-check user-form-openos-type-only">
                                      <input
                                        type="checkbox"
                                        className="uc-upf-check-native"
                                        checked={userFormData.asstec_openos_type_only === true}
                                        onChange={(e) =>
                                          handleFormChange('asstec_openos_type_only', e.target.checked)
                                        }
                                      />
                                      <span
                                        className={`user-form-type-chip-mark${
                                          userFormData.asstec_openos_type_only ? ' is-on' : ''
                                        }`}
                                        aria-hidden="true"
                                      />
                                      <span className="uc-upf-check-txt">
                                        Usuário só pode abrir OS os Tipos selecionados
                                      </span>
                                    </label>
                                  ) : null}
                                  {group.key === 'reembolsos' && userFormErrors.reembolso_perms ? (
                                    <span className="form-error">{userFormErrors.reembolso_perms}</span>
                                  ) : null}
                                </div>
                              </section>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    )}
                  </div>
                )}

                {/* Aba: Configurações */}
                {activeUserTab === 'settings' && (
                  <div className="user-form-rows user-form-rows--wide">
                    <div className="user-form-row">
                      <div className="user-form-row-label">Visão de ordens de serviço</div>
                      <div className="user-form-row-content user-form-row-content--full">
                        <div
                          className={`user-form-segmented${isShowOsVisionDisabled ? ' is-disabled' : ''}`}
                          role="tablist"
                          aria-label="Visão de ordens de serviço"
                          aria-disabled={isShowOsVisionDisabled}
                        >
                          {USER_BOARD_VIEW_OPTIONS.map((opt) => (
                            <button
                              key={opt.value}
                              type="button"
                              role="tab"
                              aria-selected={userShowOSConfig === opt.value}
                              disabled={isShowOsVisionDisabled}
                              className={`user-form-segmented-item${userShowOSConfig === opt.value ? ' active' : ''}`}
                              onClick={() => {
                                if (isShowOsVisionDisabled) return;
                                setUserShowOSConfig(opt.value);
                              }}
                            >
                              {opt.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="user-form-row user-form-row--center">
                      <div className="user-form-row-label">Sugestões de melhoria</div>
                      <div className="user-form-row-content">
                        <CannyUserSection
                          checked={userFormData.cannyLinked === true}
                          disabled={isRestrictedBoardType}
                          onChange={(checked) => {
                            if (isRestrictedBoardType) return;
                            setUserFormData(prev => ({ ...prev, cannyLinked: checked }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Aba: Customers */}
                {activeUserTab === 'customers' && (
                  <div className="user-form-rows user-form-rows--wide">
                    <div className="user-form-row user-form-row--center">
                      <div className="user-form-row-label">Chat</div>
                      <div className="user-form-row-content user-form-chat-only-content">
                        <label className={`uc-upf-check user-form-uc-check${isRestrictedBoardType ? ' is-disabled' : ''}`}>
                          <input
                            type="checkbox"
                            className="uc-upf-check-native"
                            checked={userFormData.customers_chat_only === true}
                            disabled={isRestrictedBoardType}
                            onChange={(e) => {
                              if (isRestrictedBoardType) return;
                              handleFormChange('customers_chat_only', e.target.checked);
                            }}
                          />
                          <span className="uc-upf-check-faux" aria-hidden="true" />
                          <span className="uc-upf-check-txt">Só usa função de chat</span>
                        </label>
                        <span
                          className="user-form-info-tip-host"
                          data-tooltip="Ao marcar esta opção, o usuário visualiza apenas o Chat quando faz login no sistema."
                          onClick={(e) => e.preventDefault()}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          <IconHelpHexagon
                            size={12}
                            stroke={1.75}
                            className="user-form-info-tip-icon"
                            aria-label="Mais informações"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Aba: Email */}
                {activeUserTab === 'email' && (
                  <div className="user-form-rows user-form-rows--wide">
                    <div className="user-form-email-future" hidden aria-hidden="true">
                      <div className="form-field">
                        <label className="form-label">TIPO DE EMAIL (Configuração)</label>
                        <select
                          value={emailType}
                          onChange={(e) => setEmailType(e.target.value)}
                          className="form-select-modern"
                        >
                          <option value="comum">Email comum</option>
                          <option value="google">Email Google</option>
                        </select>
                      </div>
                      <div className="form-field">
                        <label className="form-label">PREFERÊNCIA PARA ENVIO</label>
                        <select
                          value={emailPreference}
                          onChange={(e) => setEmailPreference(e.target.value)}
                          className="form-select-modern"
                        >
                          <option value="auto">Automático (OAuth se disponível, senão comum)</option>
                          <option value="comum">Sempre usar Email comum</option>
                          <option value="google">Sempre usar Email Google (OAuth)</option>
                        </select>
                      </div>
                    </div>

                    <div className="user-form-row user-form-row--email-config">
                      <div className="user-form-row-label" />
                      <div className="user-form-row-content user-form-row-content--full">
                        <div className="user-form-email-fields">
                          <label className="user-form-email-input" htmlFor="user-email-config-email">
                            <Mail size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                            <input
                              id="user-email-config-email"
                              type="email"
                              value={emailConfig.email}
                              onChange={(e) => setEmailConfig(prev => ({ ...prev, email: e.target.value }))}
                              placeholder="Email"
                              autoComplete="email"
                            />
                          </label>
                          <label className="user-form-email-input" htmlFor="user-email-config-password">
                            <KeyRound size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                            <input
                              id="user-email-config-password"
                              type="password"
                              value={emailConfig.password}
                              onChange={(e) => setEmailConfig(prev => ({ ...prev, password: e.target.value }))}
                              placeholder={editingUser ? 'Senha (em branco mantém a atual)' : 'Senha'}
                              autoComplete="new-password"
                            />
                          </label>
                          <label className="user-form-email-input" htmlFor="user-email-config-smtp">
                            <Server size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                            <input
                              id="user-email-config-smtp"
                              type="text"
                              value={emailConfig.smtpServer}
                              onChange={(e) => setEmailConfig(prev => ({ ...prev, smtpServer: e.target.value }))}
                              placeholder="Servidor SMTP"
                              autoComplete="off"
                            />
                          </label>
                          <label className="user-form-email-input" htmlFor="user-email-config-port">
                            <Hash size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                            <input
                              id="user-email-config-port"
                              type="number"
                              value={emailConfig.smtpPort}
                              onChange={(e) => setEmailConfig(prev => ({ ...prev, smtpPort: e.target.value }))}
                              placeholder="Porta SMTP"
                              autoComplete="off"
                            />
                          </label>
                        </div>
                        <button
                          type="button"
                          className="user-form-profile-save-btn user-form-email-test-btn"
                          onClick={handleTestEmailConfig}
                          disabled={isTestingEmail || !emailConfig.email || !emailConfig.smtpServer || !emailConfig.smtpPort}
                        >
                          {isTestingEmail ? 'Testando...' : 'Testar Configurações'}
                        </button>
                        {emailTestResult && (
                          <div
                            className={`user-form-email-result${emailTestResult.success ? ' user-form-email-result--ok' : ' user-form-email-result--err'}`}
                            role="status"
                          >
                            <i className={`bi ${emailTestResult.success ? 'bi-check-circle' : 'bi-x-circle'}`} aria-hidden="true" />
                            <span>{emailTestResult.message}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="user-form-row user-form-row--email-send">
                      <div className="user-form-row-label" />
                      <div className="user-form-row-content user-form-row-content--full">
                        <p className="user-form-email-section-title">Enviar teste</p>
                        <label className="user-form-email-input user-form-email-input--compact" htmlFor="user-email-test-to">
                          <Send size={15} strokeWidth={2} className="user-form-email-input-icon" aria-hidden="true" />
                          <input
                            id="user-email-test-to"
                            type="email"
                            value={testEmail}
                            onChange={(e) => setTestEmail(e.target.value)}
                            placeholder="Destinatário"
                            autoComplete="email"
                          />
                        </label>
                        <button
                          type="button"
                          className="user-form-profile-save-btn user-form-email-test-btn"
                          onClick={handleSendTestEmail}
                          disabled={
                            isSendingTestEmail
                            || !testEmail
                            || !emailConfig.email
                            || !emailConfig.smtpServer
                            || !emailConfig.smtpPort
                            || (!emailConfig.password && !hasEmailPasswordInDb)
                          }
                        >
                          {isSendingTestEmail ? 'Enviando...' : 'Enviar Teste'}
                        </button>
                      </div>
                    </div>

                    <div className="user-form-email-future" hidden aria-hidden="true">
                    {emailType === 'google' && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                          <div className="form-field" style={{ flex: 1 }}>
                            <label className="form-label">GOOGLE_CLIENT_ID</label>
                            <input
                              type="text"
                              value={googleOAuthConfig.google_client_id}
                              onChange={(e) => setGoogleOAuthConfig(prev => ({ ...prev, google_client_id: e.target.value }))}
                              className="form-input-modern"
                              placeholder="Seu Google Client ID"
                              style={{ width: '100%', maxWidth: '400px' }}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                          <div className="form-field" style={{ flex: 1 }}>
                            <label className="form-label">GOOGLE_CLIENT_SECRET</label>
                            <input
                              type="password"
                              value={googleOAuthConfig.google_client_secret}
                              onChange={(e) => setGoogleOAuthConfig(prev => ({ ...prev, google_client_secret: e.target.value }))}
                              className="form-input-modern"
                              placeholder={
                                googleOAuthConfig.has_client_secret
                                  ? 'Deixe em branco para manter o secret atual'
                                  : 'Seu Google Client Secret'
                              }
                              autoComplete="new-password"
                              style={{ width: '100%', maxWidth: '400px' }}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                          <div className="form-field" style={{ flex: 1 }}>
                            <label className="form-label">GOOGLE_REDIRECT_URI</label>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', maxWidth: '400px' }}>
                              <input
                                type="text"
                                value={googleOAuthConfig.google_redirect_uri}
                                onChange={(e) => setGoogleOAuthConfig(prev => ({ ...prev, google_redirect_uri: e.target.value }))}
                                className="form-input-modern"
                                placeholder="https://seu-dominio.com/api/users/:id/email-config/oauth/google/callback"
                                style={{ width: '100%', maxWidth: '400px', paddingRight: '40px' }}
                              />
                              <button
                                type="button"
                                onClick={async () => {
                                  if (!editingUser?.id) return;
                                  const currentOrigin = window.location.origin;
                                  const redirectUri = `${currentOrigin}/api/users/${editingUser.id}/email-config/oauth/google/callback`;
                                  try {
                                    await navigator.clipboard.writeText(redirectUri);
                                    setCopiedRedirectUri(true);
                                    setTimeout(() => setCopiedRedirectUri(false), 2000);
                                  } catch (error) {
                                    console.error('Erro ao copiar:', error);
                                  }
                                }}
                                disabled={!editingUser?.id}
                                title="Copiar URI de redirecionamento autorizados"
                                style={{
                                  position: 'absolute',
                                  right: '8px',
                                  background: 'none',
                                  border: 'none',
                                  cursor: !editingUser?.id ? 'not-allowed' : 'pointer',
                                  padding: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  opacity: !editingUser?.id ? 0.5 : 1,
                                  transition: 'transform 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  if (editingUser?.id) {
                                    e.currentTarget.style.transform = 'scale(1.1)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i 
                                  className={copiedRedirectUri ? "bi bi-check-circle-fill" : "bi bi-clipboard"} 
                                  style={{ 
                                    fontSize: '18px', 
                                    color: copiedRedirectUri ? '#10b981' : '#64748b',
                                    transition: 'all 0.3s ease'
                                  }}
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', marginTop: '8px', flexWrap: 'wrap' }}>
                          <button
                            type="button"
                            onClick={handleSaveOAuthConfig}
                            disabled={
                              isSavingOAuthConfig ||
                              !editingUser?.id ||
                              !googleOAuthConfig.google_client_id ||
                              !googleOAuthConfig.google_redirect_uri ||
                              (!googleOAuthConfig.google_client_secret && !googleOAuthConfig.has_client_secret)
                            }
                            style={{
                              padding: '10px 20px',
                              fontSize: '14px',
                              fontWeight: 600,
                              backgroundColor: '#10b981',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: (
                                isSavingOAuthConfig ||
                                !editingUser?.id ||
                                !googleOAuthConfig.google_client_id ||
                                !googleOAuthConfig.google_redirect_uri ||
                                (!googleOAuthConfig.google_client_secret && !googleOAuthConfig.has_client_secret)
                              ) ? 'not-allowed' : 'pointer',
                              opacity: (
                                isSavingOAuthConfig ||
                                !editingUser?.id ||
                                !googleOAuthConfig.google_client_id ||
                                !googleOAuthConfig.google_redirect_uri ||
                                (!googleOAuthConfig.google_client_secret && !googleOAuthConfig.has_client_secret)
                              ) ? 0.6 : 1,
                              transition: 'all 0.2s ease'
                            }}
                          >
                            {isSavingOAuthConfig ? 'Salvando...' : 'Salvar Configurações OAuth'}
                          </button>
                          <button
                            type="button"
                            onClick={async () => {
                              if (!editingUser?.id) {
                                alert('Salve o usuário primeiro antes de configurar OAuth');
                                return;
                              }
                              try {
                                const token = localStorage.getItem('authToken');
                                const response = await fetch(`${API_BASE_URL}/api/users/${editingUser.id}/email-config/oauth/google/init`, {
                                  method: 'GET',
                                  headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json',
                                  }
                                });
                                const result = await response.json();
                                if (result.success && result.authUrl) {
                                  console.log('🔵 [OAuth Frontend] Abrindo popup com URL:', result.authUrl.substring(0, 100) + '...');
                                  console.log('🔵 [OAuth Frontend] URL completa do OAuth:', result.authUrl);
                                  
                                  // Monitorar mudanças na URL do popup
                                  const popup = window.open(result.authUrl, 'google-oauth', 'width=600,height=700,left=' + (window.screen.width/2 - 300) + ',top=' + (window.screen.height/2 - 350));
                                  
                                  // Monitorar URL do popup (se possível)
                                  const urlCheckInterval = setInterval(() => {
                                    try {
                                      if (popup && !popup.closed) {
                                        const popupUrl = popup.location.href;
                                        if (popupUrl && popupUrl.includes('/callback')) {
                                          console.log('🔵 [OAuth Frontend] Popup redirecionado para:', popupUrl);
                                          clearInterval(urlCheckInterval);
                                        }
                                      } else {
                                        clearInterval(urlCheckInterval);
                                      }
                                    } catch (e) {
                                      // Cross-origin, não é possível acessar
                                    }
                                  }, 500);
                                  
                                  if (!popup) {
                                    alert('Popup bloqueado. Por favor, permita popups para este site.');
                                    return;
                                  }
                                  
                                  // Listener para postMessage do OAuth
                                  const messageListener = (event) => {
                                    console.log('🔵 [OAuth Frontend] Mensagem recebida:', event.data);
                                    if (event.data && event.data.type === 'oauth-success') {
                                      console.log('🔵 [OAuth Frontend] OAuth sucesso!');
                                      window.removeEventListener('message', messageListener);
                                      if (popup) popup.close();
                                      if (editingUser?.id) {
                                        loadUsers();
                                        alert('OAuth autorizado com sucesso! Tokens salvos.');
                                      }
                                    } else if (event.data && event.data.type === 'oauth-error') {
                                      console.error('❌ [OAuth Frontend] Erro OAuth:', event.data.error);
                                      window.removeEventListener('message', messageListener);
                                      if (popup) popup.close();
                                      alert('Erro na autorização OAuth: ' + (event.data.error || 'Erro desconhecido'));
                                    }
                                  };
                                  window.addEventListener('message', messageListener);
                                  
                                  // Fallback: verificar se popup foi fechado
                                  const checkClosed = setInterval(() => {
                                    try {
                                      if (popup.closed) {
                                        console.log('🔵 [OAuth Frontend] Popup fechado');
                                        clearInterval(checkClosed);
                                        window.removeEventListener('message', messageListener);
                                        if (editingUser?.id) {
                                          loadUsers();
                                        }
                                      }
                                    } catch (e) {
                                      // Cross-Origin-Opener-Policy pode bloquear, mas não é crítico
                                      console.warn('⚠️ [OAuth Frontend] Não é possível verificar se popup está fechado:', e.message);
                                    }
                                  }, 500);
                                } else {
                                  alert('Erro ao iniciar OAuth: ' + (result.message || 'Erro desconhecido'));
                                }
                              } catch (error) {
                                console.error('Erro ao iniciar OAuth:', error);
                                alert('Erro ao iniciar OAuth: ' + error.message);
                              }
                            }}
                            disabled={!editingUser?.id}
                            style={{
                              padding: '10px 20px',
                              fontSize: '14px',
                              fontWeight: 600,
                              backgroundColor: '#ea4335',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: editingUser?.id ? 'pointer' : 'not-allowed',
                              opacity: editingUser?.id ? 1 : 0.6,
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              height: '36px'
                            }}
                          >
                            <i className="bi bi-google" style={{ fontSize: '16px' }}></i>
                            Google OAuth
                          </button>
                        </div>
                      </div>
                    )}
                    </div>
                  </div>
                )}
                </div>

                <div className="user-form-modern-footer">
                  <button
                    type="button"
                    className="user-form-link-btn user-form-footer-btn"
                    onClick={() => setShowUserForm(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="user-form-profile-save-btn user-form-footer-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleSaveUser();
                    }}
                  >
                    {editingUser ? 'Atualizar Usuário' : 'Criar Usuário'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CannySuccessOverlay show={showCannySuccessAnimation} />
        </div>
      )}
      {coordinatorUnlinkModal ? (
        <UserFormCoordinatorUnlinkModal
          message={coordinatorUnlinkModal.message}
          hasAreaLinks={coordinatorUnlinkModal.hasAreaLinks}
          hasTeamLinks={coordinatorUnlinkModal.hasTeamLinks}
          onClose={() => setCoordinatorUnlinkModal(null)}
        />
      ) : null}
      {Toaster}
      {technicianOsBlockModal ? (
        <UserFormTechnicianOsBlockModal
          message={technicianOsBlockModal.message}
          orderNumbers={technicianOsBlockModal.orderNumbers}
          totalCount={technicianOsBlockModal.totalCount}
          onClose={() => setTechnicianOsBlockModal(null)}
        />
      ) : null}
    </div>
  );
};

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  // Estados de autenticação
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Gate de UI: com marcador de sessão, aguarda verify antes de mostrar login (não autentica por si só)
  const [authChecking, setAuthChecking] = useState(() => hasAuthSession());
  const [currentUser, setCurrentUser] = useState(null);
  const { logDragDrop } = useAuditLog();
  const [theme, setTheme] = useState('light');
  const [userShowOSConfig, setUserShowOSConfig] = useState(0); // 0 = Ordem de serviço, 1 = Patrimônio
  const [showLogoutMenu, setShowLogoutMenu] = useState(false);
  const [showChangelogMenu, setShowChangelogMenu] = useState(false);
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

  const [activeSection, setActiveSection] = useState('Board');
  const [activeFilters, setActiveFilters] = useState({
    coordenador: null,
    area: null,
    tecnico: null
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [openModal, setOpenModal] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  useClearMultiOrderSelectionOnOutsideClick(selectedOrders, setSelectedOrders);
  const [techniqueColumns, setTechniqueColumns] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [minimizedTechnicianColumns, setMinimizedTechnicianColumns] = useState([]);
  /** Teste: host tech → tech empilhado abaixo (meia coluna + meia coluna). */
  const [technicianColumnStacks, setTechnicianColumnStacks] = useState({});
  const [openColumnCollapsed, setOpenColumnCollapsed] = useOpenColumnCollapsedPreference(
    normalizeOpenColumnMinimized(currentUser?.open_column_minimized)
  );
  const boardStackPrefAppliedUserRef = React.useRef(null);
  const [pendingFuturaBellColumnFocus, setPendingFuturaBellColumnFocus] = useState(null);
  const lastTechniciansRef = React.useRef([]); // Ref para rastrear última lista de técnicos
  const [isDragOverOpen, setIsDragOverOpen] = useState(false);
  const [showConfigMenu, setShowConfigMenu] = useState(() =>
    typeof window !== 'undefined' && isConfigAreaPath(window.location.pathname)
  );
  const [analisesNavOpen, setAnalisesNavOpen] = useState(false);
  const [cadastrosNavOpen, setCadastrosNavOpen] = useState(false);
  const [financeiroNavOpen, setFinanceiroNavOpen] = useState(false);
  const [estoqueNavOpen, setEstoqueNavOpen] = useState(false);
  const [fechamentoCount, setFechamentoCount] = useState(0);
  
  // Estados para loading de atualização de colunas
  const [isRefreshingOpenColumn, setIsRefreshingOpenColumn] = useState(false);
  const [refreshingTechnicianColumns, setRefreshingTechnicianColumns] = useState(new Set());
  // Codstatus "OS de retorno" para destacar linhas na coluna Em aberto
  const [codstatusRetornoEmAberto, setCodstatusRetornoEmAberto] = useState('');
  // Lista adicional de status de retorno (LCMY_REG_CONDITION), quando configurados
  const [extraRetornoStatusesEmAberto, setExtraRetornoStatusesEmAberto] = useState([]);
  // Codstatus "Status de pedido vinculado a OS de retorno" (pedido liberado) para sino animado nas colunas de técnicos
  const [codstatusPedidoVinculadoDisponivel, setCodstatusPedidoVinculadoDisponivel] = useState('');
  /** status_* (LCMY_SYS_CONFIG) para UI do board / relocate Liberado aceito */
  const [boardStatusForward, setBoardStatusForward] = useState('');
  const [boardStatusTomorrow, setBoardStatusTomorrow] = useState('');
  const [boardStatusUptodate, setBoardStatusUptodate] = useState('');
  /** Abas Pendente/Liberado na coluna FUTURA: só com [Config] Retornos por condição de intervenção = 01 (lido no login). */
  const { futuraRetornoTabsEnabled, loadFuturaRetornoTabsConfig, resetFuturaRetornoTabsEnabled } =
    useFuturaRetornoTabsEnabled(API_BASE_URL);
  /** Estado do tab Pendente/Liberado por técnico (fora de TechnicianServiceGroup para não resetar a cada render do App). */
  const [futuraRetornoHeaderTabByTechnician, setFuturaRetornoHeaderTabByTechnician] = useState({});
  const setFuturaRetornoTabForTechnician = React.useCallback((techName, valueOrUpdater) => {
    setFuturaRetornoHeaderTabByTechnician((prev) => {
      const cur = prev[techName] ?? null;
      const next = typeof valueOrUpdater === 'function' ? valueOrUpdater(cur) : valueOrUpdater;
      const out = { ...prev };
      if (next == null || next === undefined) {
        delete out[techName];
      } else {
        out[techName] = next;
      }
      return out;
    });
  }, []);

  React.useEffect(() => {
    if (!futuraRetornoTabsEnabled) {
      setFuturaRetornoHeaderTabByTechnician({});
    }
  }, [futuraRetornoTabsEnabled]);

  React.useEffect(() => {
    if (!isAuthenticated) {
      setBoardStatusForward('');
      setBoardStatusTomorrow('');
      setBoardStatusUptodate('');
      return;
    }
    const token = localStorage.getItem('authToken');
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/config/process`, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const json = await res.json();
        if (!cancelled && json.success && json.data) {
          setBoardStatusForward(String(json.data.status_forward || '').trim());
          setBoardStatusTomorrow(String(json.data.status_tomorrow || '').trim());
          setBoardStatusUptodate(String(json.data.status_uptodate || '').trim());
        }
      } catch {
        if (!cancelled) {
          setBoardStatusForward('');
          setBoardStatusTomorrow('');
          setBoardStatusUptodate('');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  const [futuraRetornoBellApi, setFuturaRetornoBellApi] = useState({
    rows: [],
    mode: null,
    loaded: false
  });

  const initialColumnFiltersState = {
    retorno: null,
    cidade: [],
    bairro: [],
    cliente: [],
    tipoOS: [],
    sla: [],
    equipamento: [],
    status: [],
    tecnicoInicial: [],
    defeitoDescricao: [],
    defeitoAlert: [],
    defeitoClassification: [],
    defeitoSeverity: [],
  };

  // Estados para filtros da coluna Em Aberto (via BoardSearchWithFilters)
  const [selectedColumnFilters, setSelectedColumnFilters] = useState({
    ...initialColumnFiltersState,
    tipoOS: [], // Será preenchido automaticamente com 'C' (Corretiva/Normal) após carregar dados
  });
  
  // Estado para controlar se o filtro inicial foi aplicado (REMOVIDO - agora a filtragem é no backend)
  // const [initialFilterApplied, setInitialFilterApplied] = useState(false);

  // Estados para filtros das colunas de técnicos
  const [technicianFilters, setTechnicianFilters] = useState({});
  const [showTechnicianFilter, setShowTechnicianFilter] = useState({});
  const [technicianFilterPositions, setTechnicianFilterPositions] = useState({});
  
  const initialTechnicianColumnFiltersState = {
    previsao: [],
    retorno: null,
    cidade: [],
    bairro: [],
    cliente: [],
    tipoOS: [],
    sla: [],
    equipamento: [],
    osFuturaRange: null,
    defeitoDescricao: [],
    defeitoAlert: [],
    defeitoClassification: [],
    defeitoSeverity: [],
  };

  // Estados para filtros globais das colunas de técnicos (via BoardSearchWithFilters)
  const [selectedTechnicianColumnFilters, setSelectedTechnicianColumnFilters] = useState(
    initialTechnicianColumnFiltersState
  );
  /** Conjunto de opções de Previsão disponíveis na última sincronização (auto-apply subtrativo). */
  const prevAvailablePrevisaoRef = React.useRef([]);
  
  // Estados para menu das colunas de técnicos
  const {
    showTechnicianMenu,
    setShowTechnicianMenu,
    technicianMenuPrevisaoOpen,
    setTechnicianMenuPrevisaoOpen,
    technicianMenuPositions,
    closeAllTechnicianMenus,
    toggleTechnicianMenu,
    updateTechnicianMenuPosition,
  } = useTechnicianMenu();
  
  // Estados para modal de Abrir OS
  // NOTA: Apenas showOpenOSModal é necessário aqui. Todos os outros estados foram migrados para OpenOSModal.js
  const [showOpenOSModal, setShowOpenOSModal] = useState(false);
  /** Temporário: mock visual Abrir OS v2 (stepper flutuante) até adaptação completa */
  const [showOpenOsV2Mock, setShowOpenOsV2Mock] = useState(false);

  const [showEquipmentConsultSearchModal, setShowEquipmentConsultSearchModal] = useState(false);
  const [equipmentConsultSearchMountKey, setEquipmentConsultSearchMountKey] = useState(0);
  const [showEquipmentConsultDetailModal, setShowEquipmentConsultDetailModal] = useState(false);
  const [equipmentConsultSelection, setEquipmentConsultSelection] = useState(null);

  // Variáveis dummy para evitar erros de referência no código comentado do modal antigo
  // Estas variáveis não são usadas, apenas definidas para evitar erros de compilação
  // eslint-disable-next-line no-unused-vars
  const setShowScheduleSidebar = () => {};
  // eslint-disable-next-line no-unused-vars
  const setScheduleType = () => {};
  // eslint-disable-next-line no-unused-vars
  const setSelectedScheduleDate = () => {};
  // eslint-disable-next-line no-unused-vars
  const setSelectedTechnician = () => {};
  // eslint-disable-next-line no-unused-vars
  const setExpandedAreas = () => {};
  // eslint-disable-next-line no-unused-vars
  const loadScheduleData = () => {};
  // eslint-disable-next-line no-unused-vars
  const setScheduleData = () => {};
  // eslint-disable-next-line no-unused-vars
  const setIsScheduled = () => {};
  // eslint-disable-next-line no-unused-vars
  const setShowScheduleDropdown = () => {};
  // eslint-disable-next-line no-unused-vars
  const isLoadingScheduleData = false;
  // eslint-disable-next-line no-unused-vars
  const scheduleAreasData = [];
  // eslint-disable-next-line no-unused-vars
  const expandedAreas = new Set();
  // eslint-disable-next-line no-unused-vars
  const selectedTechnician = null;
  // eslint-disable-next-line no-unused-vars
  const scheduleType = null;
  // eslint-disable-next-line no-unused-vars
  const selectedScheduleDate = null;
  // NOTA: getNextBusinessDay, getLocalDateString, getTodayLocal e getDayAfterNextBusinessDay
  // já existem como funções reais abaixo, então não precisam de variáveis dummy

  // NOTA: validateRequiredFields foi removido.
  // A função agora está em utils/validators.js e é usada pelo OpenOSModal.js

  // Funções auxiliares para datas em PT-BR (evitar problemas de timezone)
  const getLocalDateString = (date) => {
    if (!date) return '';
    // Se for string no formato YYYY-MM-DD, usar diretamente
    if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return date;
    }
    // Se for Date object, converter para string local sem timezone
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getTodayLocal = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatDateToPTBR = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  // Funções para formatação de números com máscara de milhar
  const formatNumberWithMask = (value) => {
    if (!value && value !== 0) return '';
    const numStr = String(value).replace(/[^0-9]/g, '');
    if (!numStr) return '';
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const removeMask = (value) => {
    if (!value) return '';
    return String(value).replace(/[^0-9]/g, '');
  };

  // Função para calcular próximo dia útil
  const getNextBusinessDay = (date = new Date()) => {
    const currentDate = new Date(date);
    let nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + 1);
    const dayOfWeek = nextDay.getDay();
    if (dayOfWeek === 0) {
      nextDay.setDate(nextDay.getDate() + 1);
    } else if (dayOfWeek === 6) {
      nextDay.setDate(nextDay.getDate() + 2);
    }
    return nextDay;
  };

  // Função para calcular o dia após o próximo dia útil (para agendamento futuro)
  const getDayAfterNextBusinessDay = () => {
    const nextBusinessDay = getNextBusinessDay();
    let dayAfter = new Date(nextBusinessDay);
    dayAfter.setDate(dayAfter.getDate() + 1);
    const dayOfWeek = dayAfter.getDay();
    if (dayOfWeek === 0) {
      dayAfter.setDate(dayAfter.getDate() + 1);
    } else if (dayOfWeek === 6) {
      dayAfter.setDate(dayAfter.getDate() + 2);
    }
    return dayAfter;
  };

  // Função para organizar áreas e técnicos em formato de árvore
  const organizeAreasAndTechnicians = useCallback((areas, technicians, areaTeamLinks) => {
    if (!areas || !technicians || !areaTeamLinks) return [];
    
    const organized = areas.map(area => {
      const areaTechnicians = areaTeamLinks
        .filter(link => link.id_area === area.id)
        .map(link => {
          const technician = technicians.find(tech => tech.id === link.id_tech || tech.codigo === link.id_tech);
          return technician ? { ...technician, areaId: area.id } : null;
        })
        .filter(tech => tech !== null);
      
      return {
        ...area,
        tecnicos: areaTechnicians
      };
    }).filter(area => area.tecnicos && area.tecnicos.length > 0);
    
    return organized;
  }, []);

  // NOTA: loadScheduleData foi removido.
  // A função agora está em scheduleService.loadScheduleData() e é usada pelo OpenOSModal.js
  // Código antigo comentado abaixo (linhas ~3522-3568):
  /*
  const loadScheduleData = useCallback(async () => {
    setIsLoadingScheduleData(true);
    try {
      const token = localStorage.getItem('authToken');
      
      const [areasRes, techniciansRes, areaTeamRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/team/areas`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }),
        fetch(`${API_BASE_URL}/api/team/technicians`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }),
        fetch(`${API_BASE_URL}/api/team/areateam`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
      ]);

      const [areasData, techniciansData, areaTeamData] = await Promise.all([
        areasRes.json(),
        techniciansRes.json(),
        areaTeamRes.json()
      ]);

      if (areasData.success && techniciansData.success && areaTeamData.success) {
        const organized = organizeAreasAndTechnicians(
          areasData.data,
          techniciansData.data,
          areaTeamData.data
        );
        setScheduleAreasData(organized);
      }
    } catch (error) {
      console.error('Erro ao carregar dados para programação:', error);
      setScheduleAreasData([]);
    } finally {
      setIsLoadingScheduleData(false);
    }
  }, [organizeAreasAndTechnicians]);
  */
  
  // Estados para modal do roteiro de hoje
  const [showTodayRouteModal, setShowTodayRouteModal] = useState({});
  const [technicianPanelMock, setTechnicianPanelMock] = useState({ open: false, technician: null });

  // Deep-link /app/roteiro (painel do técnico) — Board permanece montado (não é full-page).
  useEffect(() => {
    if (location.pathname === TECHNICIAN_PANEL_ROUTE) {
      if (!technicianPanelMock.open) {
        const tech = getRememberedTechnicianPanelTechnician();
        if (tech) setTechnicianPanelMock({ open: true, technician: tech });
      }
      return;
    }
    if (technicianPanelMock.open) {
      clearRememberedTechnicianPanelTechnician();
      setTechnicianPanelMock({ open: false, technician: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- só reage à URL (espelha Board Chat)
  }, [location.pathname]);
  
  // Estados para o modal de rota
  const [showRouteModal, setShowRouteModal] = useState(false);
  const [routeModalData, setRouteModalData] = useState(null);
  const [routeModalLoading, setRouteModalLoading] = useState(false);
  const [routeModalError, setRouteModalError] = useState(null);
  const handleCloseRouteModal = React.useCallback(() => {
    setShowRouteModal(false);
    setRouteModalData(null);
    setRouteModalError(null);
    if (window.mapInstance) {
      window.mapInstance.remove();
      window.mapInstance = null;
    }
  }, []);
  
  // Estados para operações de drag & drop
  const [isDragDropProcessing, setIsDragDropProcessing] = useState(false);
  const [dragDropProgress, setDragDropProgress] = useState({ current: 0, total: 0 });
  const [dragDropMessage, setDragDropMessage] = useState('');
  const beginDragDropProcessing = (total, message) => {
    flushSync(() => {
      setIsDragDropProcessing(true);
      setDragDropProgress({ current: 0, total: Number(total) || 0 });
      setDragDropMessage(message || 'Processando...');
    });
  };
  
  // Ref e estado para preservar posição do scroll da coluna Em Aberto
  const openColumnScrollRef = useRef(null);
  const lastScrollPosition = useRef(0);
  const cityScrollPositions = useRef({});
  const [openCityDropdown, setOpenCityDropdown] = useState(null);
  const [selectedOrderForDetails, setSelectedOrderForDetails] = useState(null);
  const [selectedOrderForDetailsV2, setSelectedOrderForDetailsV2] = useState(null);
  /** Mock visual "Detalhe 2" (iframe) — sem API ainda */
  const [selectedOrderForDetailsMock, setSelectedOrderForDetailsMock] = useState(null);
  const clickTimeoutRef = useRef(null);
  const clickOrderIdRef = useRef(null);
  // Ref para armazenar refs diretos dos elementos de scroll das colunas de técnicos
  const technicianColumnScrollRefs = useRef({});
  
  // Estados para a barra lateral do pedido
  const [showOrderSidebar, setShowOrderSidebar] = useState(false);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [selectedPedidoCodigo, setSelectedPedidoCodigo] = useState(null);
  const [pedidoDetails, setPedidoDetails] = useState(null);
  const [loadingPedido, setLoadingPedido] = useState(false);
  const [pedidoError, setPedidoError] = useState(null);
  const [showTimeline, setShowTimeline] = useState(false);
  const [timelineData, setTimelineData] = useState(null);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  const [timelineError, setTimelineError] = useState(null);
  
  // Estados para a barra lateral do equipamento
  const [showEquipmentSidebar, setShowEquipmentSidebar] = useState(false);
  const [selectedEquipmentData, setSelectedEquipmentData] = useState(null);

  // Estados para área Equipe
  const [teamData, setTeamData] = useState({
    coordenadores: [],
    areas: [],
    tecnicos: []
  });
  
  // Estados para carregar técnicos da API
  const [isLoadingTechnicians, setIsLoadingTechnicians] = useState(false);
  const [techniciansError, setTechniciansError] = useState(null);
  
  // Estados para defeitos das ordens de serviço (quando há apenas uma coluna)
  const [defeitosData, setDefeitosData] = useState({}); // { orderNumber: { defeito, observacao, solucao } }
  const [loadingDefeitos, setLoadingDefeitos] = useState(false);
  
  // Estados para carregar áreas da API
  const [isLoadingAreas, setIsLoadingAreas] = useState(false);
  const [areasError, setAreasError] = useState(null);
  
  // Estados para carregar coordenadores da API
  const [isLoadingCoordinators, setIsLoadingCoordinators] = useState(false);
  const [coordinatorsError, setCoordinatorsError] = useState(null);
  
  // Estados para carregar vínculos técnico-área da API
  const [isLoadingAreaTeam, setIsLoadingAreaTeam] = useState(false);
  const [areaTeamError, setAreaTeamError] = useState(null);
  
  // Estados para carregar vínculos área-coordenador da API
  const [isLoadingAreaCoord, setIsLoadingAreaCoord] = useState(false);
  const [areaCoordError, setAreaCoordError] = useState(null);
  
  // Estados para modal de status das ordens
  const [showOrderStatusModal, setShowOrderStatusModal] = useState(false);
  const [showBoardDragValidationModal, setShowBoardDragValidationModal] = useState(false);
  const [boardDragValidationMessages, setBoardDragValidationMessages] = useState([]);
  /** 'alert' = só Entendi; 'confirm' = Cancelar/Confirmar (App Go offline em Previsto). */
  const [boardDragValidationMode, setBoardDragValidationMode] = useState('alert');
  const boardDragConfirmResumeRef = React.useRef(null);
  /** Após Confirmar no aviso App Go offline — permite o update-status uma vez. */
  const previstoGoSyncAckRef = React.useRef(false);
  const [orderStatusResults, setOrderStatusResults] = useState([]);
  const orderStatusVencEnrichKeyRef = React.useRef(null);
  const [orderStatusSummary, setOrderStatusSummary] = useState(null);
  
  // Estados para modal de seleção de data para área Futura
  const [showFutureDateModal, setShowFutureDateModal] = useState(false);
  const [futureDateModalData, setFutureDateModalData] = useState(null);
  const futureDateConfirmRef = React.useRef(null);
  const [selectedFutureDate, setSelectedFutureDate] = useState(null);
  const [noDateSelected, setNoDateSelected] = useState(false);
  
  // Estado para filtro de período na seção FUTURA (por técnico)
  const [futuraDateFilter, setFuturaDateFilter] = useState({}); // { technicianName: { startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' } }
  const [showFuturaDateFilter, setShowFuturaDateFilter] = useState({}); // { technicianName: true/false }
  
  // Estados para menu de contexto (Em aberto e colunas de técnicos)
  const [contextMenu, setContextMenu] = useState(null); // { x, y, orderId, technician?, groupName?, source: 'open'|'technician' }
  /** Preserva scroll das colunas de técnico antes de re-renders que remontam TechnicianColumn (definido no corpo do App). */
  const captureTechnicianColumnScrollPositions = React.useCallback(() => {
    Object.keys(technicianColumnScrollRefs.current).forEach((techName) => {
      if (techName === '_savedPositions') return;
      const scrollRef = technicianColumnScrollRefs.current[techName];
      if (scrollRef && scrollRef.current) {
        if (!technicianColumnScrollRefs.current._savedPositions) {
          technicianColumnScrollRefs.current._savedPositions = {};
        }
        technicianColumnScrollRefs.current._savedPositions[techName] = scrollRef.current.scrollTop;
      }
    });
  }, []);
  const openBoardOrderContextMenu = React.useCallback(
    (payload) => {
      captureTechnicianColumnScrollPositions();
      setContextMenu(payload);
    },
    [captureTechnicianColumnScrollPositions]
  );
  const closeBoardOrderContextMenu = React.useCallback(() => {
    captureTechnicianColumnScrollPositions();
    setContextMenu(null);
  }, [captureTechnicianColumnScrollPositions]);
  /** Menu "Encaminhar chamado" aberto a partir do rodapé do OrderDetailsModal (área → técnico → sessão). */
  const [orderDetailsEncaminharMenu, setOrderDetailsEncaminharMenu] = useState(null); // { x, y } | null
  /** Painel Encaminhar chamado no modal V2 (áreas + técnicos). */
  const [orderDetailsEncaminharV2Panel, setOrderDetailsEncaminharV2Panel] = useState(null);
  /**
   * Encaminhar chamado (botão direito Em aberto): overlay agenda Open OS v2.
   */
  const [boardEncaminharFlow, setBoardEncaminharFlow] = useState(null);
  // { orderIds, source, fromTechnician, fromGroup }
  const [boardCellTooltip, setBoardCellTooltip] = useState(null); // { text, x, y, triggerRect? } — tooltip portal; triggerRect para fechar ao sair
  useEffect(() => {
    if (!boardCellTooltip?.triggerRect) return;
    const { left, top, width, height } = boardCellTooltip.triggerRect;
    const onMove = (e) => {
      if (e.clientX < left || e.clientX > left + width || e.clientY < top || e.clientY > top + height) {
        setBoardCellTooltip(null);
      }
    };
    document.addEventListener('mousemove', onMove, { passive: true });
    return () => document.removeEventListener('mousemove', onMove);
  }, [boardCellTooltip]);
  // Overlay de exclusão de OS (Board)
  const [deleteOverlay, setDeleteOverlay] = useState({ visible: false, status: 'loading', message: '' });
  // Filtro: somente colunas de técnicos que possuem ao menos uma OS (Board)
  const [onlyTechniciansWithOS, setOnlyTechniciansWithOS] = useOnlyTechniciansWithOSFilter();
  // Filtro: Filtrar SLA (data + horário limite em CALC_PREVISAO)
  const [slaFiltrarConfig, setSlaFiltrarConfig] = useState(null); // { date, time, deadlineMs }
  const [slaFiltrarLoading, setSlaFiltrarLoading] = useState(false);
  const [showFiltrarSLAModal, setShowFiltrarSLAModal] = useState(false);
  const [showTechnicianViewModal, setShowTechnicianViewModal] = useState(false);

  React.useEffect(() => {
    if (!slaFiltrarConfig || !slaFiltrarLoading) return;
    const id = setTimeout(() => setSlaFiltrarLoading(false), 200);
    return () => clearTimeout(id);
  }, [slaFiltrarConfig, slaFiltrarLoading]);

  // Fechar menu de contexto: tratado em BoardOrderContextMenu (pointerdown/Escape/scroll).
  // Mantém fallback se o estado existir sem o portal montado.
  React.useEffect(() => {
    if (!contextMenu) return undefined;
    const handlePointerDownOutside = (e) => {
      if (e.target?.closest?.('.context-menu') || e.target?.closest?.('.board-order-context-menu')) return;
      closeBoardOrderContextMenu();
    };
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeBoardOrderContextMenu();
    };
    document.addEventListener('pointerdown', handlePointerDownOutside, true);
    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDownOutside, true);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [contextMenu, closeBoardOrderContextMenu]);

  React.useEffect(() => {
    if (!orderDetailsEncaminharMenu) return undefined;
    const handlePointerDownOutside = (e) => {
      if (e.target.closest?.('.context-menu')) return;
      setOrderDetailsEncaminharMenu(null);
    };
    document.addEventListener('pointerdown', handlePointerDownOutside, true);
    return () => document.removeEventListener('pointerdown', handlePointerDownOutside, true);
  }, [orderDetailsEncaminharMenu]);

  React.useEffect(() => {
    if (!selectedOrderForDetails) setOrderDetailsEncaminharMenu(null);
  }, [selectedOrderForDetails]);

  React.useEffect(() => {
    if (!selectedOrderForDetailsV2) setOrderDetailsEncaminharV2Panel(null);
  }, [selectedOrderForDetailsV2]);

  // Detalhe OS 2 aberto: limpa marcação da OS no Board (só neste caso)
  React.useEffect(() => {
    if (!selectedOrderForDetailsMock) return;
    setSelectedOrders((prev) => (Array.isArray(prev) && prev.length > 0 ? [] : prev));
  }, [selectedOrderForDetailsMock]);

  // Função para abrir modal de reprogramação de previsão
  const handleReprogramarPrevisao = (orderId, technician, groupName) => {
    if (groupName !== 'FUTURA') return;
    
    const technicianId = getTechnicianIdByName(technician);
    setFutureDateModalData({
      technicianName: technician,
      technicianId: technicianId,
      orderIds: [orderId],
      fromGroup: 'FUTURA',
      isReprogramacao: true // Flag para indicar que é reprogramação
    });
    setSelectedFutureDate(null);
    setNoDateSelected(false);
    setShowFutureDateModal(true);
    closeBoardOrderContextMenu(); // Fechar menu de contexto
  };

  // Listener para capturar mudanças de scroll
  React.useEffect(() => {
    const scrollElement = openColumnScrollRef.current;
    if (scrollElement) {
      const handleScroll = () => {
        lastScrollPosition.current = scrollElement.scrollTop;
      };
      
      scrollElement.addEventListener('scroll', handleScroll);
      
      // Configurar listeners para os scrolls dos grupos de cidade
      const setupCityScrollListeners = () => {
        const cityContainers = scrollElement.querySelectorAll('.city-orders-container');
        cityContainers.forEach((container, index) => {
          const cityElement = container.closest('.city-group');
          const cityTitle = cityElement?.querySelector('.city-title')?.textContent;
          
          if (cityTitle) {
            const handleCityScroll = () => {
              cityScrollPositions.current[cityTitle] = container.scrollTop;
            };
            
            container.addEventListener('scroll', handleCityScroll);
          }
        });
      };
      
      // Configurar listeners inicialmente
      setupCityScrollListeners();
      
      // Reconfigurar quando o DOM muda
      const observer = new MutationObserver(() => {
        setTimeout(setupCityScrollListeners, 100);
      });
      
      observer.observe(scrollElement, {
        childList: true,
        subtree: true
      });
      
      return () => {
        scrollElement.removeEventListener('scroll', handleScroll);
        observer.disconnect();
      };
    }
  }, []);

  // Coluna "Em aberto": OpenColumnCityGroup estável preserva scroll interno dos grupos.
  // Só restaurar scroll do container externo quando o navegador zerar sem intenção (ex.: remount raro).
  React.useLayoutEffect(() => {
    const scrollElement = openColumnScrollRef.current;
    if (!scrollElement || lastScrollPosition.current <= 0) return;
    if (scrollElement.scrollTop !== 0) return;
    scrollElement.scrollTop = lastScrollPosition.current;
  }, [selectedOrders]);
  

  


  // Fechar filtro da coluna quando clicar fora
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      // Fechar menus de filtro (Coordenador, Área, Técnicos)
      if (
        openModal &&
        !event.target.closest('.filter-modal-content') &&
        !event.target.closest('.filter-btn') &&
        !event.target.closest('.board-search-filters-chip-anchor') &&
        !event.target.closest('.board-clickup-filter-chip-anchor') &&
        !event.target.closest('.board-search-filters-popover')
      ) {
        setOpenModal(null);
      }

      // Fechar menus das colunas de técnicos
      if (shouldCloseTechnicianMenuOnOutsideClick(event, showTechnicianMenu)) {
        closeAllTechnicianMenus();
      }

      // Fechar dropdown de cidade
      if (openCityDropdown && 
          !event.target.closest('.city-dropdown') && 
          !event.target.closest('.city-header')) {
        setOpenCityDropdown(null);
      }

      // Fechar barra lateral do pedido
      if (showOrderSidebar && 
          !event.target.closest('.order-sidebar') && 
          !event.target.closest('.order-detail-maps-btn')) {
        setShowOrderSidebar(false);
        setSelectedPedidoCodigo(null);
        setPedidoDetails(null);
        setPedidoError(null);
        setLoadingPedido(false);
        setShowTimeline(false);
        setTimelineData(null);
        setTimelineError(null);
        setLoadingTimeline(false);
      }

      // Fechar barra lateral do equipamento
      if (showEquipmentSidebar && 
          !event.target.closest('.equipment-sidebar') && 
          !event.target.closest('.equipment-detail-btn')) {
        setShowEquipmentSidebar(false);
        setSelectedEquipmentData(null);
      }

      // Fechar modal de rota
      if (showRouteModal && 
          !event.target.closest('.route-modal-content') && 
          event.target.classList.contains('modal-overlay')) {
        handleCloseRouteModal();
      }

      // Fechar menu de logout
      if (showLogoutMenu && 
          !event.target.closest('.user-info')) {
        setShowLogoutMenu(false);
      }
      // Fechar menu de changelog
      if (showChangelogMenu &&
          !event.target.closest('.changelog-dropdown-wrap') &&
          !event.target.closest('.changelog-sidebar') &&
          !event.target.closest('.changelog-sidebar-backdrop')) {
        setShowChangelogMenu(false);
      }

      // Fechar menu Análises (dropdown)
      if (analisesNavOpen && !event.target.closest('.analises-nav-dropdown')) {
        setAnalisesNavOpen(false);
      }
      if (cadastrosNavOpen && !event.target.closest('.cadastros-nav-dropdown')) {
        setCadastrosNavOpen(false);
      }
      if (financeiroNavOpen && !event.target.closest('.financeiro-nav-dropdown')) {
        setFinanceiroNavOpen(false);
      }
      if (estoqueNavOpen && !event.target.closest('.estoque-nav-dropdown')) {
        setEstoqueNavOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [
    openModal,
    showTechnicianMenu,
    closeAllTechnicianMenus,
    openCityDropdown,
    showOrderSidebar,
    showEquipmentSidebar,
    showRouteModal,
    handleCloseRouteModal,
    showLogoutMenu,
    showChangelogMenu,
    analisesNavOpen,
    cadastrosNavOpen,
    financeiroNavOpen,
    estoqueNavOpen
  ]);

  const [activeConfigSection, setActiveConfigSection] = useState(() => {
    if (typeof window === 'undefined') return null;
    if (isConfigHomePath(window.location.pathname)) return null;
    return CONFIG_PATH_TO_SECTION[window.location.pathname] || null;
  });

  useEffect(() => {
    if (!currentUser || String(currentUser.type) !== '1') {
      return;
    }
    const hasCustomers = Number(currentUser.verve_customers_module) === 1;
    const hasGo = hasGoAppLicense(currentUser);
    const leaveCustomers =
      !hasCustomers &&
      (activeConfigSection === 'usersCustomers' || activeConfigSection === 'integrations');
    const leaveGo = !hasGo && activeConfigSection === 'go';
    if (!leaveCustomers && !leaveGo) {
      return;
    }
    setActiveConfigSection(null);
    if (CONFIG_ROUTES.includes(location.pathname) || INTEGRACOES_ROUTES.includes(location.pathname)) {
      navigate(CONFIG_ROUTE_HOME, { replace: true });
    } else if (
      leaveCustomers &&
      (INTEGRACOES_ROUTES.includes(location.pathname) ||
        location.pathname.startsWith('/configuracoes/integracoes') ||
        location.pathname.startsWith('/integracoes'))
    ) {
      navigate(CONFIG_ROUTE_HOME, { replace: true });
    }
  }, [currentUser, activeConfigSection, location.pathname, navigate]);

  useEffect(() => {
    if (isConfigHomePath(location.pathname)) {
      if (!isAuthenticated || !currentUser || String(currentUser.type) !== '1') {
        navigate('/app', { replace: true });
        return;
      }
      setShowConfigMenu(true);
      setActiveConfigSection(null);
      return;
    }
    if (location.pathname === '/integracoes' || location.pathname === '/integracoes/') {
      navigate(INTEGRACOES_ROUTE_BASE, { replace: true });
      return;
    }
    if (location.pathname === '/integracoes/1' || location.pathname === '/integracoes/2') {
      navigate(
        location.pathname === '/integracoes/2' ? INTEGRACOES_ROUTE_AREA_TECNICA : INTEGRACOES_ROUTE_LOGISTICA,
        { replace: true }
      );
      return;
    }
    if (
      location.pathname.startsWith(`${INTEGRACOES_ROUTE_BASE}/`) &&
      !INTEGRACOES_ROUTES.includes(location.pathname)
    ) {
      navigate(INTEGRACOES_ROUTE_LOGISTICA, { replace: true });
      return;
    }
    if (CONFIG_PATH_TO_SECTION[location.pathname]) {
      if (!isAuthenticated || !currentUser || String(currentUser.type) !== '1') {
        navigate('/app', { replace: true });
        return;
      }
      setShowConfigMenu(true);
      setActiveConfigSection(CONFIG_PATH_TO_SECTION[location.pathname]);
      return;
    }
    if (location.pathname.startsWith('/configuracoes')) {
      navigate(CONFIG_ROUTE_HOME, { replace: true });
      return;
    }
    setShowConfigMenu(false);
  }, [location.pathname, isAuthenticated, currentUser, navigate]);
  
  // Estado para controlar ordens disponíveis (removidas quando movidas)
  const [availableOrdersState, setAvailableOrdersState] = useState(availableOrders);
  
  // Log para debug do estado
  useEffect(() => {
    if (availableOrdersState.length > 0) {
    }
  }, [availableOrdersState]);

  // Estado para exibir TB02115_STATUS na coluna "Em aberto" (asstec_osopen_shstatus = 1)
  const [showStatusColumnEmAberto, setShowStatusColumnEmAberto] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    const token = localStorage.getItem('authToken');
    if (!token) return;
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/config/visualizacao-coluna-status`, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    })
      .then(r => r.json())
      .then(res => {
        if (cancelled) return;
        setShowStatusColumnEmAberto(!!(res.success && res.data && (res.data.asstec_osopen_shstatus === 1 || res.data.asstec_osopen_shstatus === '1')));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  // Sincronizar Router com window.location ao carregar em rotas standalone (evita primeiro render com pathname /app)
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const winPath = window.location.pathname;
    const routerPath = location.pathname;
    if (
      winPath !== routerPath &&
      APP_FULL_PAGE_ROUTES.includes(winPath)
    ) {
      navigate(winPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  // Redirecionar raiz (/) para a home do perfil (Financeiro → reembolsos; demais → Board)
  useEffect(() => {
    if (location.pathname !== '/' || !isAuthenticated) return;
    if (isFinanceiroOnlyMode(currentUser)) {
      navigate(FINANCEIRO_REEMBOLSOS_ROUTE, { replace: true });
      return;
    }
    navigate('/app', { replace: true });
  }, [location.pathname, isAuthenticated, currentUser, navigate]);

  useEffect(() => {
    if (!isAuthenticated || !currentUser) return;
    if (!isFinanceiroOnlyMode(currentUser)) return;
    if (
      location.pathname === FINANCEIRO_REEMBOLSOS_ROUTE ||
      location.pathname === `${FINANCEIRO_REEMBOLSOS_ROUTE}/`
    ) return;
    navigate(FINANCEIRO_REEMBOLSOS_ROUTE, { replace: true });
  }, [isAuthenticated, currentUser, location.pathname, navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      setShowSessionExpiredModal(false);
      return undefined;
    }
    const onSessionExpired = () => setShowSessionExpiredModal(true);
    window.addEventListener('painelos:session-expired', onSessionExpired);
    return () => window.removeEventListener('painelos:session-expired', onSessionExpired);
  }, [isAuthenticated]);

  const handleSessionExpiredDismiss = useCallback(() => {
    setShowSessionExpiredModal(false);
    clearAuthSession();
    setIsAuthenticated(false);
    setCurrentUser(null);
    navigate('/', { replace: true });
  }, [navigate]);

  const handleOryaTourOpenDocumentation = useCallback(() => {
    const { tourVersion } = getOryaTourSettings();
    if (tourVersion) setAprenderVersionNavIntent(tourVersion);
    setShowConfigMenu(false);
    navigate('/aprender');
  }, [navigate]);

  useEffect(() => {
    if (!isAuthenticated || !currentUser) return undefined;
    if (APP_FULL_PAGE_ROUTES.includes(location.pathname)) return undefined;
    const typingTarget = (target) => {
      if (!target || !target.tagName) return false;
      const t = target.tagName.toLowerCase();
      if (t === 'input' || t === 'textarea' || t === 'select') return true;
      if (target.isContentEditable) return true;
      return false;
    };
    const onKey = (e) => {
      if (!e.ctrlKey || e.shiftKey || e.altKey) return;
      const k = typeof e.key === 'string' ? e.key.toLowerCase() : '';
      if (k !== 'o' && k !== 'e') return;
      if (typingTarget(e.target)) return;
      if (k === 'o') {
        if (Number(currentUser.asstec_openos) !== 1) return;
        e.preventDefault();
        setShowRefreshContextMenu(false);
        // Abrir OS v1 (backup): setShowOpenOSModal(true);
        setShowOpenOsV2Mock(true);
      } else if (k === 'e') {
        e.preventDefault();
        setShowRefreshContextMenu(false);
        setEquipmentConsultSearchMountKey((x) => x + 1);
        setShowEquipmentConsultSearchModal(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isAuthenticated, currentUser, location.pathname]);

  // Estados para dados da API
  const [apiData, setApiData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [dataSource, setDataSource] = useState('mock');
  const [companyName, setCompanyName] = useState('Empresa teste');
  const [companyLogoUrl, setCompanyLogoUrl] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshProgress, setRefreshProgress] = useState({ current: 0, total: 0, message: '' });
  const [isAutoRefreshEnabled, setIsAutoRefreshEnabled] = useState(false);
  const [showRefreshContextMenu, setShowRefreshContextMenu] = useState(false);
  const [showFuturaBellMenu, setShowFuturaBellMenu] = useState(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const [autoRefreshRemaining, setAutoRefreshRemaining] = useState(4 * 60); // segundos
  
  // Usar refs para evitar re-renderizações desnecessárias
  const autoRefreshRemainingRef = React.useRef(4 * 60);
  const refreshDataRef = React.useRef(null);
  const isRefreshingRef = React.useRef(false);
  
  // Estrutura para agrupamentos de técnicos
  const [technicianGroups, setTechnicianGroups] = useState({});
  /** Debug sync condt (resposta API batch/GET): consulta PEDIDO_VINCULADO_LIBERADO + resultado */
  const [condtBoardDebugSync, setCondtBoardDebugSync] = useState([]);
  const condtBoardDebugSyncRef = React.useRef([]);
  const mergeCondtBoardDebug = React.useCallback((incoming) => {
    if (!incoming || !Array.isArray(incoming) || incoming.length === 0) return;
    setCondtBoardDebugSync((prev) => {
      const map = new Map((prev || []).map((d) => [String(d.os).trim(), d]));
      incoming.forEach((d) => {
        if (d && d.os != null && String(d.os).trim() !== '') {
          map.set(String(d.os).trim(), d);
        }
      });
      const next = Array.from(map.values());
      condtBoardDebugSyncRef.current = next;
      return next;
    });
  }, []);
  const technicianGroupsRef = React.useRef(technicianGroups);
  const columnOrderRef = React.useRef(columnOrder);
  React.useEffect(() => {
    if (technicianGroups && Object.keys(technicianGroups).length > 0) {
      technicianGroupsRef.current = technicianGroups;
    }
  }, [technicianGroups]);
  React.useEffect(() => {
    if (columnOrder && columnOrder.length > 0) {
      columnOrderRef.current = columnOrder;
    }
  }, [columnOrder]);

  const prevOnlyTechniciansWithOSRef = React.useRef(onlyTechniciansWithOS);
  // Técnicos removidos do filtro ao marcar "Somente técnicos com OS" — restaurados ao desmarcar.
  // Não usar columnOrder no restore: ao marcar, o efeito de colunas já remove esses techs de columnOrder.
  const techsRemovedByOnlyWithOSRef = React.useRef([]);
  // Ao marcar "Somente técnicos com OS", desmarcar no filtro de técnicos os que têm 0 ordens. Ao desmarcar, restaurar seleção dos técnicos com 0 ordens.
  useEffect(() => {
    if (onlyTechniciansWithOS) {
      if (technicianGroups && typeof technicianGroups === 'object') {
        setSelectedFilterItems((prev) => {
          const current = prev.tecnico || [];
          const removed = current.filter((tech) => getTechnicianOrderCount(technicianGroups, tech) === 0);
          if (removed.length > 0) {
            techsRemovedByOnlyWithOSRef.current = [
              ...new Set([...techsRemovedByOnlyWithOSRef.current, ...removed]),
            ];
          }
          return {
            ...prev,
            tecnico: current.filter((tech) => getTechnicianOrderCount(technicianGroups, tech) > 0),
          };
        });
      }
    } else if (prevOnlyTechniciansWithOSRef.current) {
      const toRestore = techsRemovedByOnlyWithOSRef.current;
      if (toRestore.length > 0) {
        setSelectedFilterItems((prev) => {
          const current = new Set(prev.tecnico || []);
          toRestore.forEach((t) => current.add(t));
          return { ...prev, tecnico: [...current] };
        });
        techsRemovedByOnlyWithOSRef.current = [];
      }
    }
    prevOnlyTechniciansWithOSRef.current = onlyTechniciansWithOS;
  }, [onlyTechniciansWithOS, technicianGroups]);
  // Cache para dados de técnicos já carregados
  const [technicianDataCache, setTechnicianDataCache] = useState({});
  const technicianDataCacheRef = React.useRef(technicianDataCache);
  React.useEffect(() => {
    technicianDataCacheRef.current = technicianDataCache;
  }, [technicianDataCache]);
  const boardFilterItemsRef = React.useRef({ coordenador: [], area: [], tecnico: [] });
  // Mapeamento nome->ID para técnicos com ordens
  const [technicianNameToIdMap, setTechnicianNameToIdMap] = useState({});
  // Contagem de ordens concluídas no dia por técnico
  const [technicianCompletedCounts, setTechnicianCompletedCounts] = useState({});
  const [technicianCompletedDetails, setTechnicianCompletedDetails] = useState({}); // { technicianName: { concluidas: {}, checkout: {}, total: 0 } }
  const [technicianFinishedCounts, setTechnicianFinishedCounts] = useState({});

  // NOTA: filterFromCache foi removido - migrado para useEquipmentSearch hook
  // A função agora está em features/new-os/hooks/useEquipmentSearch.js
  // Código antigo comentado abaixo:
  // Funções de equipamento/defeito/OS: useEquipmentSearch, equipmentService, defeitoService (features/new-os).
  
  // Função para aplicar máscara de telefone (XX)XXXXX-XXXX
  const applyPhoneMask = useCallback((value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)})${numbers.slice(2)}`;
    } else {
      return `(${numbers.slice(0, 2)})${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  }, []);

  // NOTA: validateEmail foi removido (usava setEmailError que não existe mais).
  // A função agora está em utils/validators.js e é usada pelo OpenOSModal.js

  // Função para traduzir tipo de preventiva
  const translatePreventivaType = useCallback((type) => {
    const types = {
      'E': 'ESTOQUE',
      'B': 'BALCÃO',
      'A': 'AFERIÇÃO',
      'R': 'RETORNO-RECARGA',
      'D': 'DESINSTALAÇÃO',
      'I': 'INSTALAÇÃO',
      'S': 'PREVENTIVA',
      'N': 'NORMAL'
    };
    return types[type] || type || 'N/A';
  }, []);

  // Função para calcular tempo de atendimento
  const calculateTimeDifference = useCallback((horaIni, horaFim) => {
    if (!horaIni || !horaFim) return 'N/A';
    
    try {
      // Formato esperado: "HH:mm" ou "HH:mm:ss"
      const [hIni, mIni] = horaIni.split(':').map(Number);
      const [hFim, mFim] = horaFim.split(':').map(Number);
      
      const totalIni = hIni * 60 + mIni;
      const totalFim = hFim * 60 + mFim;
      
      let diff = totalFim - totalIni;
      
      // Se a diferença for negativa, assumir que passou meia-noite
      if (diff < 0) {
        diff += 24 * 60; // Adicionar 24 horas em minutos
      }
      
      const hours = Math.floor(diff / 60);
      const minutes = diff % 60;
      
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    } catch (error) {
      return 'N/A';
    }
  }, []);

  // Função para formatar números com máscara de milhar (preservando sinal)
  const formatNumber = useCallback((num) => {
    if (num == null || num === '') return '0';
    const n = Number(num);
    if (isNaN(n)) return '0';
    const isNegative = n < 0;
    const absStr = Math.abs(n).toString();
    const formatted = absStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return isNegative ? `-${formatted}` : formatted;
  }, []);

  // Função auxiliar para formatar endereço (logradouro, número, bairro, cidade, CEP)
  const formatAddress = useCallback((item, userQuery) => {
    const addr = item.address || {};
    
    // Extrair componentes do endereço
    const road = addr.road || addr.street || addr.pedestrian || '';
    const houseNumber = addr.house_number || addr.house_name || '';
    
    // Buscar bairro com prioridade: suburb > neighbourhood > quarter
    // Ignorar city_district, pois geralmente contém informações administrativas (ex: "2º Subdistrito")
    let suburb = '';
    if (addr.suburb) {
      suburb = addr.suburb;
    } else if (addr.neighbourhood) {
      suburb = addr.neighbourhood;
    } else if (addr.quarter) {
      suburb = addr.quarter;
    }
    // Filtrar campos que contenham termos administrativos indesejados
    if (suburb && (suburb.toLowerCase().includes('subdistrito') || 
                   suburb.toLowerCase().includes('distrito administrativo') ||
                   suburb.match(/^\d+º/))) {
      suburb = '';
    }
    
    const city = addr.city || addr.town || addr.village || addr.municipality || '';
    const postcode = addr.postcode || '';
    
    // Tentar extrair número do query do usuário se não estiver no endereço
    let extractedNumber = houseNumber;
    if (!extractedNumber && userQuery) {
      // Procurar por padrões comuns de número: "123", "123A", "S/N", etc.
      const numberPatterns = [
        /\b(\d+[A-Za-z]?)\b/,  // Número com possível letra (ex: 123A)
        /\b(S\/N|s\/n)\b/,     // Sem número
        /\b(\d+)\b/            // Apenas número
      ];
      
      for (const pattern of numberPatterns) {
        const match = userQuery.match(pattern);
        if (match) {
          extractedNumber = match[1];
          break;
        }
      }
    }
    
    // Montar endereço formatado
    const parts = [];
    if (road) {
      parts.push(road);
      if (extractedNumber) {
        parts[parts.length - 1] = `${road}, ${extractedNumber}`;
      }
    } else if (extractedNumber) {
      parts.push(extractedNumber);
    }
    if (suburb) parts.push(suburb);
    if (city) parts.push(city);
    if (postcode) parts.push(`CEP ${postcode}`);
    
    return parts.length > 0 ? parts.join(', ') : item.display_name;
  }, []);

  // NOTA: searchAddress foi removido - migrado para addressService
  // A função agora está em features/new-os/services/addressService.js (searchAddress)
  // Código antigo comentado abaixo:

  // NOTA: useEffect para busca de endereços foi removido.
  // A lógica agora está gerenciada pelo hook useAddressSearch no OpenOSModal.js
  
  // Normaliza nome para comparação (remove acentos, colapsa espaços, trim, maiúsculas)
  const normalizeTechnicianName = React.useCallback((str) => {
    if (str == null || typeof str !== 'string') return '';
    return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
  }, []);

  // Funções auxiliares para conversão entre nome e ID de técnicos
  const getTechnicianIdByName = React.useCallback((technicianName) => {
    if (!technicianName) return null;
    const n = normalizeTechnicianName(technicianName);

    // Primeiro, tentar encontrar na tabela de técnicos cadastrados (exato e normalizado)
    let tecnico = teamData.tecnicos.find(t => t.nome === technicianName);
    if (!tecnico && n) {
      tecnico = teamData.tecnicos.find(t => normalizeTechnicianName(t.nome) === n);
    }
    if (tecnico) {
      return tecnico.id;
    }

    // Verificar no mapeamento de técnicos com ordens (exato e normalizado)
    if (technicianNameToIdMap[technicianName]) {
      return technicianNameToIdMap[technicianName];
    }
    const mapKey = Object.keys(technicianNameToIdMap || {}).find(k => normalizeTechnicianName(k) === n);
    if (mapKey) {
      return technicianNameToIdMap[mapKey];
    }

    console.warn(`⚠️ Técnico "${technicianName}" não encontrado em lugar nenhum`);
    return null;
  }, [teamData, technicianNameToIdMap, normalizeTechnicianName]);

  // Mover OS(s) para outro técnico/seção via menu "Alterar técnico" (suporta múltiplas selecionadas na mesma coluna)
  const handleMoveOrderContextMenu = useCallback((orderIds, fromTech, fromGroup, toTech, toGroupName) => {
    closeBoardOrderContextMenu();
    const ids = Array.isArray(orderIds) && orderIds.length > 0 ? orderIds : [];
    if (fromTech === toTech) {
      handleDropBetweenTechnicianSections(fromTech, fromGroup, toGroupName, ids);
    } else {
      handleDropBetweenTechnicians(fromTech, toTech, toGroupName, ids);
    }
  }, [closeBoardOrderContextMenu]);

  // Abrir modal de data futura via menu "Alterar técnico" → técnico → FUTURA
  const handleOpenFutureModalContextMenu = useCallback((data) => {
    closeBoardOrderContextMenu();
    setFutureDateModalData({
      ...data,
      technicianId: getTechnicianIdByName(data.technicianName),
    });
    setSelectedFutureDate(null);
    setNoDateSelected(false);
    setShowFutureDateModal(true);
  }, [getTechnicianIdByName, closeBoardOrderContextMenu]);

  // Fluxo "Alterar técnico": apenas logar no console (técnico origem, destino, OS) sem movimentar — para validar dados
  const handleAlterarTecnicoLogOnly = useCallback((orderId, fromTech, fromGroup, toTech, toGroupName) => {
    closeBoardOrderContextMenu();
    const n = (str) => (str == null || typeof str !== 'string' ? '' : String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toUpperCase());
    const resolveKey = (name) => {
      const norm = n(name);
      const fromGroups = Object.keys(technicianGroups || {}).find(k => n(k) === norm);
      if (fromGroups) return fromGroups;
      const fromCol = (columnOrder || []).find(t => n(t) === norm);
      return fromCol || name;
    };
    const fromKey = resolveKey(fromTech);
    const toKey = resolveKey(toTech);
    const fromCode = getTechnicianIdByName(fromKey);
    const toCode = getTechnicianIdByName(toKey);
    console.log('--- Alterar técnico (dados do fluxo) ---');
    console.log('1) Técnico de origem:', { nome: fromKey, codigo: fromCode });
    console.log('2) Técnico de destino:', { nome: toKey, codigo: toCode });
    console.log('3) Número da OS:', orderId);
    console.log('4) Seção escolhida:', toGroupName);
    console.log('----------------------------------------');
  }, [technicianGroups, columnOrder, getTechnicianIdByName, closeBoardOrderContextMenu]);

  const handleAlterarTecnicoLogOnlyFuture = useCallback((data) => {
    closeBoardOrderContextMenu();
    const fromKey = data.fromTechnicianName;
    const toKey = data.technicianName;
    const orderId = data.orderIds && data.orderIds[0];
    const fromCode = getTechnicianIdByName(fromKey);
    const toCode = getTechnicianIdByName(toKey);
    console.log('--- Alterar técnico → FUTURA (dados do fluxo) ---');
    console.log('1) Técnico de origem:', { nome: fromKey, codigo: fromCode });
    console.log('2) Técnico de destino:', { nome: toKey, codigo: toCode });
    console.log('3) Número da OS:', orderId);
    console.log('4) Seção escolhida:', 'FUTURA');
    console.log('------------------------------------------------');
  }, [getTechnicianIdByName, closeBoardOrderContextMenu]);

  const getTechnicianNameById = React.useCallback((technicianId) => {
    if (!technicianId) return null;
    
    const tecnico = teamData.tecnicos.find(t => t.id === technicianId);
    if (tecnico) {
      return tecnico.nome;
    }
    
    // Se não encontrar na tabela de técnicos, retornar null
    // Os nomes reais agora vêm da API /api/orders/technicians/available
    console.log(`⚠️ Técnico ID "${technicianId}" não encontrado na tabela TB01024`);
    return null;
  }, [teamData]);

  // Função para buscar contagem de ordens concluídas no dia para um técnico
  const fetchCompletedCountForTechnician = React.useCallback(async (technicianName) => {
    try {
      const technicianId = getTechnicianIdByName(technicianName);
      if (!technicianId) {
        console.log(`⚠️ Técnico "${technicianName}" não tem ID válido para buscar ordens concluídas`);
        setTechnicianCompletedCounts(prev => ({ ...prev, [technicianName]: 0 }));
        setTechnicianCompletedDetails(prev => ({ ...prev, [technicianName]: { concluidas: {}, checkout: {}, total: 0 } }));
        return;
      }

      const token = localStorage.getItem('authToken');
      
      // Usar a nova API que retorna dados agrupados
      const response = await fetch(`${API_BASE_URL}/api/orders/completed-count/${technicianId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        console.warn(`⚠️ Erro ao buscar contagem de ordens concluídas para ${technicianName}: ${response.status}`);
        setTechnicianCompletedCounts(prev => ({ ...prev, [technicianName]: 0 }));
        setTechnicianCompletedDetails(prev => ({ ...prev, [technicianName]: { concluidas: {}, checkout: {}, total: 0 } }));
        return;
      }

      const result = await response.json();
      if (result.success && result.data) {
        const count = result.data.total || 0;
        setTechnicianCompletedCounts(prev => ({ ...prev, [technicianName]: count }));
        setTechnicianCompletedDetails(prev => ({ 
          ...prev, 
          [technicianName]: {
            concluidas: result.data.concluidas || {},
            checkout: result.data.checkout || {},
            total: count
          }
        }));
      } else {
        setTechnicianCompletedCounts(prev => ({ ...prev, [technicianName]: 0 }));
        setTechnicianCompletedDetails(prev => ({ ...prev, [technicianName]: { concluidas: {}, checkout: {}, total: 0 } }));
      }
    } catch (error) {
      console.error(`❌ Erro ao buscar contagem de ordens concluídas para ${technicianName}:`, error);
      setTechnicianCompletedCounts(prev => ({ ...prev, [technicianName]: 0 }));
      setTechnicianCompletedDetails(prev => ({ ...prev, [technicianName]: { concluidas: {}, checkout: {}, total: 0 } }));
    }
  }, [getTechnicianIdByName]);

  const applyTechnicianCountsPayload = React.useCallback((technicianNames, byTechnicianId) => {
    const data = byTechnicianId && typeof byTechnicianId === 'object' ? byTechnicianId : {};
    setTechnicianCompletedCounts((prev) => {
      const next = { ...prev };
      technicianNames.forEach((name) => {
        const id = getTechnicianIdByName(name);
        next[name] = id && data[id] ? Number(data[id].completed?.total) || 0 : 0;
      });
      return next;
    });
    setTechnicianCompletedDetails((prev) => {
      const next = { ...prev };
      technicianNames.forEach((name) => {
        const id = getTechnicianIdByName(name);
        const completed = id && data[id] ? data[id].completed : null;
        next[name] = {
          concluidas: completed?.concluidas || {},
          checkout: completed?.checkout || {},
          total: completed ? Number(completed.total) || 0 : 0,
        };
      });
      return next;
    });
    setTechnicianFinishedCounts((prev) => {
      const next = { ...prev };
      technicianNames.forEach((name) => {
        const id = getTechnicianIdByName(name);
        next[name] = id && data[id] ? Number(data[id].finished) || 0 : 0;
      });
      return next;
    });
  }, [getTechnicianIdByName]);

  const fetchFinishedCountForTechnician = React.useCallback(async (technicianName) => {
    try {
      const technicianId = getTechnicianIdByName(technicianName);
      if (!technicianId) {
        setTechnicianFinishedCounts((prev) => ({ ...prev, [technicianName]: 0 }));
        return;
      }

      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${API_BASE_URL}/api/orders/technicians/counts?ids=${encodeURIComponent(technicianId)}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        setTechnicianFinishedCounts((prev) => ({ ...prev, [technicianName]: 0 }));
        return;
      }

      const result = await response.json();
      const finished = result.success && result.data?.[technicianId]
        ? Number(result.data[technicianId].finished) || 0
        : 0;
      setTechnicianFinishedCounts((prev) => ({ ...prev, [technicianName]: finished }));
    } catch (error) {
      console.error(`❌ Erro ao buscar contagem de ordens finalizadas para ${technicianName}:`, error);
      setTechnicianFinishedCounts((prev) => ({ ...prev, [technicianName]: 0 }));
    }
  }, [getTechnicianIdByName]);

  const fetchAllTechnicianCounts = React.useCallback(async (technicianNamesOverride) => {
    const visibleTechnicians =
      Array.isArray(technicianNamesOverride) && technicianNamesOverride.length > 0
        ? technicianNamesOverride
        : Object.keys(technicianGroups);
    if (visibleTechnicians.length === 0) return;

    const ids = [...new Set(
      visibleTechnicians.map((name) => getTechnicianIdByName(name)).filter(Boolean)
    )];
    if (ids.length === 0) {
      applyTechnicianCountsPayload(visibleTechnicians, {});
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${API_BASE_URL}/api/orders/technicians/counts?ids=${ids.map(encodeURIComponent).join(',')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.success) {
        applyTechnicianCountsPayload(visibleTechnicians, {});
        return;
      }
      applyTechnicianCountsPayload(visibleTechnicians, result.data);
    } catch (error) {
      console.error('❌ Erro ao buscar contagens dos técnicos:', error);
      applyTechnicianCountsPayload(visibleTechnicians, {});
    }
  }, [technicianGroups, getTechnicianIdByName, applyTechnicianCountsPayload]);


  // Fechar menu de contexto ao clicar fora
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showRefreshContextMenu &&
        !event.target.closest('.refresh-context-menu') &&
        !event.target.closest('.refresh-btn') &&
        !event.target.closest('.board-clickup-toolbar-menu-btn')
      ) {
        setShowRefreshContextMenu(false);
      }
    };

    if (showRefreshContextMenu) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showRefreshContextMenu]);

  // Limpar estado de drag over quando o drag termina globalmente
  React.useEffect(() => {
    const handleDragEnd = (event) => {
      // Pequeno delay para garantir que o drop foi processado primeiro
      setTimeout(() => {
        setIsDragOverOpen(false);
      }, 100);
    };

    document.addEventListener('dragend', handleDragEnd);
    return () => document.removeEventListener('dragend', handleDragEnd);
  }, []);

  // Formatar timer de atualização automática (MM:SS)
  const formatAutoRefreshTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const mm = String(mins).padStart(2, '0');
    const ss = String(secs).padStart(2, '0');
    return `${mm}:${ss}`;
  };

  // Resumo Pendente/Liberado (condt_*) via LCMY_ASSTEC02 — alinhado às abas FUTURA; requer sessão.
  const loadFuturaRetornoCondtBellSummary = React.useCallback(async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setFuturaRetornoBellApi({ rows: [], mode: null, loaded: false });
        return;
      }
      const res = await fetch(`${API_BASE_URL}/api/orders/futura-retorno-condt-summary`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
      });
      if (res.status === 401) {
        setFuturaRetornoBellApi({ rows: [], mode: null, loaded: false });
        return;
      }
      const json = await res.json();
      if (!json.success || !json.data) {
        setFuturaRetornoBellApi({ rows: [], mode: null, loaded: false });
        return;
      }
      const rows = (json.data.rows || []).map((r) => ({
        technician: String(r.technician || '').trim(),
        pendente: Number(r.pendente) || 0,
        liberado: Number(r.liberado) || 0
      }));
      const mode = json.data.mode === 'liberado' || json.data.mode === 'pendente' ? json.data.mode : null;
      setFuturaRetornoBellApi({ rows, mode, loaded: true });
    } catch {
      setFuturaRetornoBellApi({ rows: [], mode: null, loaded: false });
    }
  }, [API_BASE_URL]);

  // Função OTIMIZADA para pré-carregar dados apenas dos técnicos com ordens de serviço
  // Ref para evitar execuções simultâneas
  const isPreloadingRef = React.useRef(false);
  const pendingPreloadNamesRef = React.useRef(null);
  const pendingPreloadForceRef = React.useRef(false);
  
  const preloadAllTechnicianData = React.useCallback(async (options = {}) => {
    const requestedNames = Array.isArray(options.names)
      ? options.names
      : getVisibleBoardTechnicianNames(boardFilterItemsRef.current, teamData);
    const names = [...new Set((requestedNames || []).map((n) => String(n || '').trim()).filter(Boolean))];
    const force = options.force === true;

    if (isPreloadingRef.current) {
      pendingPreloadNamesRef.current = names;
      pendingPreloadForceRef.current = force || pendingPreloadForceRef.current;
      return {};
    }

    if (!names.length) {
      void loadFuturaRetornoCondtBellSummary();
      return {};
    }

    const cacheNow = technicianDataCacheRef.current || {};
    const namesToFetch = force ? names : names.filter((n) => !cacheNow[n]);
    if (!namesToFetch.length) {
      const hit = {};
      names.forEach((n) => {
        if (cacheNow[n]) hit[n] = cacheNow[n];
      });
      return hit;
    }

    isPreloadingRef.current = true;

    try {
      const token = localStorage.getItem('authToken');
      const nameToIdMapping = {};
      const technicianIds = [];
      namesToFetch.forEach((technicianName) => {
        const technicianId = getTechnicianIdByName(technicianName);
        if (!technicianId) return;
        technicianIds.push(technicianId);
        nameToIdMapping[technicianName] = technicianId;
      });

      const emptyGroups = () => createEmptyTechnicianBoardGroups();
      const technicianCache = {};

      if (technicianIds.length === 0) {
        namesToFetch.forEach((technicianName) => {
          technicianCache[technicianName] = emptyGroups();
        });
      } else {
        const batchResponse = await fetch(`${API_BASE_URL}/api/orders/technicians/batch`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            technicianIds,
            view: BOARD_ORDERS_LIST_VIEW,
            boardRefresh: 'manual',
          })
        });
        const batchResult = await batchResponse.json();

        if (!batchResult.success) {
          console.error('❌ Erro ao carregar dados em lote:', batchResult.message);
          return {};
        }

        namesToFetch.forEach((technicianName) => {
          const technicianId = nameToIdMapping[technicianName];
          const techData = technicianId ? batchResult.data?.[technicianId] : null;
          technicianCache[technicianName] = hydrateTechnicianCondtAuxGroups(
            techData || emptyGroups()
          );
        });

        if (Array.isArray(batchResult.debugCondtSync)) {
          condtBoardDebugSyncRef.current = batchResult.debugCondtSync;
          setCondtBoardDebugSync(batchResult.debugCondtSync);
        }
      }

      setTechnicianDataCache((prev) => ({ ...prev, ...technicianCache }));
      setTechnicianGroups((prev) => mergeCacheIntoEmptyTechnicianGroups(prev, technicianCache, names));
      setTechnicianNameToIdMap((prev) => ({ ...prev, ...nameToIdMapping }));

      const merged = { ...(technicianDataCacheRef.current || {}), ...technicianCache };
      const requestedSlice = {};
      names.forEach((n) => {
        if (merged[n]) requestedSlice[n] = merged[n];
      });
      return requestedSlice;

    } catch (error) {
      console.error('❌ Erro no pré-carregamento otimizado dos técnicos:', error);
      return {};
    } finally {
      isPreloadingRef.current = false;
      void loadFuturaRetornoCondtBellSummary();
      const pending = pendingPreloadNamesRef.current;
      const pendingForce = pendingPreloadForceRef.current;
      pendingPreloadNamesRef.current = null;
      pendingPreloadForceRef.current = false;
      if (pending && pending.length) {
        void preloadAllTechnicianData({ names: pending, force: pendingForce });
      }
    }
  }, [teamData, getTechnicianIdByName, loadFuturaRetornoCondtBellSummary]);

  // Estado para indicar se está carregando colunas de técnicos
  const [isLoadingTechnicianColumns, setIsLoadingTechnicianColumns] = useState(false);
  const [filterSearchTerms, setFilterSearchTerms] = useState({
    coordenador: '',
    area: '',
    tecnico: ''
  });
  const [selectedFilterItems, setSelectedFilterItems] = useState({
    coordenador: [],
    area: [],
    tecnico: []
  });
  React.useEffect(() => {
    boardFilterItemsRef.current = selectedFilterItems;
  }, [selectedFilterItems]);

  // Estados para configuração do banco de dados
  const [dbConfig, setDbConfig] = useState({
    host: '',
    database: '',
    username: '',
    password: ''
  });
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [isTestingConnection, setIsTestingConnection] = useState(false);
  const [connectionTested, setConnectionTested] = useState(false);

  // Estados para gerenciamento de usuários
  const [users, setUsers] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [showUserForm, setShowUserForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [showPasswordUser, setShowPasswordUser] = useState(null);
  const [userFormData, setUserFormData] = useState({
    user: '',
    username: '',
    password: '',
    type: '',
    coordinator: false,
    blacktheme: false,
    asstec_openos: false,
    asstec_closeos: false,
    asstec_deleteos: false,
    asstec_create_reports: false,
    asstec_reembolso_approve: false,
    asstec_reembolso_pay: false,
    asstec_reembolso_create: false,
    asstec_openos_type_only: false,
    customers_chat_only: false,
    codtec: '',
    active: true,
    changePasswordOnNextLogin: false,
  });
  const [userFormErrors, setUserFormErrors] = useState({});
  
  // Estados para tipos de OS permitidos para coordenadores
  const [userOSTypes, setUserOSTypes] = useState({
    os_stock: false,
    os_counter: false,
    os_reading: false,
    os_return: false,
    os_uninstall: false,
    os_install: false,
    os_preventive: false,
    os_normal: false
  });

  // Estados para o modal de carregamento inicial
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isBoardColumnsHydrating, setIsBoardColumnsHydrating] = useState(true);
  const [showPostLoginWelcome, setShowPostLoginWelcome] = useState(false);

  useEffect(() => {
    if (!isInitialLoading) setShowPostLoginWelcome(false);
  }, [isInitialLoading]);

  const [loadingSteps, setLoadingSteps] = useState([
    { id: 'config', name: 'Carregar configuração', status: 'pending' },
    { id: 'orders', name: 'Carregar ordens de serviço', status: 'pending' },
    { id: 'team', name: 'Carregar dados da equipe', status: 'pending' },
    { id: 'filters', name: 'Pré-carregar técnicos com ordens', status: 'pending' },
    { id: 'complete', name: 'Finalizar carregamento', status: 'pending' }
  ]);
  const [loadingHasError, setLoadingHasError] = useState(false);
  const [loadingErrorMessage, setLoadingErrorMessage] = useState('');
  const initialLoadRef = useRef(false);

  // Funções de autenticação serão definidas após loadOrdersFromAPI
  
  // Função helper para limpar todos os estados e filtros
  const clearAllStatesAndFilters = () => {
    console.log('🧹 Limpando todos os estados e filtros...');
    
    // Filtros da faixa de opções (Coordenador, Área, Técnicos)
    setSelectedFilterItems({
      coordenador: [],
      area: [],
      tecnico: []
    });
    
    // Filtros de coluna (Em Aberto)
    setSelectedColumnFilters({
      retorno: null,
      cidade: [],
      bairro: [],
      cliente: [],
      tipoOS: [],
      sla: [],
      equipamento: [],
      status: [],
      tecnicoInicial: [],
      defeitoDescricao: [],
      defeitoAlert: [],
      defeitoClassification: [],
      defeitoSeverity: [],
    });
    
    // Filtros de técnico
    setTechnicianFilters({});
    setShowTechnicianFilter({});
    
    // Ordens selecionadas
    setSelectedOrders([]);
    
    // Dados do aplicativo
    setApiData([]);
    setAvailableOrdersState([]);
    setTechniqueColumns({});
    setTechnicianGroups({});
    condtBoardDebugSyncRef.current = [];
    setCondtBoardDebugSync([]);
    
    // Fechar menus abertos
    closeAllTechnicianMenus();
    setSelectedTechnicianColumnFilters(initialTechnicianColumnFiltersState);
    setTechnicianColumnStacks({});
    boardStackPrefAppliedUserRef.current = null;
    
    // Resetar checkbox "Somente técnicos com OS" ao limpar sessão
    techsRemovedByOnlyWithOSRef.current = [];
    prevOnlyTechniciansWithOSRef.current = false;
    setOnlyTechniciansWithOS(false);

    resetFuturaRetornoTabsEnabled();
    setFuturaRetornoHeaderTabByTechnician({});
    setFuturaRetornoBellApi({ rows: [], mode: null, loaded: false });

    console.log('✅ Todos os estados e filtros limpos');
  };

  const handleLogout = async () => {
    console.log('🚪 Iniciando logout...');
    try {
      if (hasAuthSession()) {
        await fetch(`${API_BASE_URL}/api/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
      }
    } catch (_) { /* ignora erro de rede */ }
    clearAuthSession();
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userData');
    setCurrentUser(null);
    setIsAuthenticated(false);
    setShowLogoutMenu(false);
    clearAllStatesAndFilters();
    console.log('✅ Logout completo realizado');
  };

  // Função para carregar nome e logomarca da empresa (header)
  const loadCompanyBranding = useCallback(async () => {
    try {
      const token = localStorage.getItem('authToken');
      
      if (!token) {
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/api/config/company`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.status === 401) {
        return;
      }
      
      const result = await response.json();
      
      if (result.success && result.data) {
        if (result.data.company) {
          setCompanyName(result.data.company);
        }
        setCompanyLogoUrl(result.data.logoViewUrl || null);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar branding da empresa:', error);
    }
  }, []);

  const loadCompanyName = loadCompanyBranding;

  const applyBoardRetornoConfigs = useCallback(async (token) => {
    const headers = token
      ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
      : { 'Content-Type': 'application/json' };
    try {
      const [retornoRes, autoRetornoRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/config/retorno`, { headers }),
        fetch(`${API_BASE_URL}/api/config/automation-retorno`, { headers }),
      ]);
      const retornoJson = await retornoRes.json().catch(() => null);
      if (retornoJson && retornoJson.success && retornoJson.data) {
        setCodstatusRetornoEmAberto(String(retornoJson.data.codstatus || '').trim());
      }
      const autoRetornoJson = await autoRetornoRes.json().catch(() => null);
      if (autoRetornoJson && autoRetornoJson.success && autoRetornoJson.data) {
        setCodstatusPedidoVinculadoDisponivel(String(autoRetornoJson.data.statusPedidoDisponivel || '').trim());
      }
    } catch (_) {
      /* silencioso */
    }
  }, []);

  useEffect(() => {
    const onBrandingUpdated = () => { loadCompanyBranding(); };
    window.addEventListener(COMPANY_BRANDING_UPDATED_EVENT, onBrandingUpdated);
    return () => window.removeEventListener(COMPANY_BRANDING_UPDATED_EVENT, onBrandingUpdated);
  }, [loadCompanyBranding]);

  // Função para atualizar dados (refresh)
  // Função para atualizar apenas a coluna "Em aberto"
  const refreshOpenOrders = useCallback(async () => {
    setIsRefreshingOpenColumn(true);
    try {
      const token = localStorage.getItem('authToken');
      const headers = {};
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const ordersResponse = await fetch(withBoardOrdersListView(`${API_BASE_URL}/api/orders/open`), {
        headers: headers
      });
      
      if (!ordersResponse.ok) {
        if (ordersResponse.status === 401) {
          const errorData = await ordersResponse.json().catch(() => ({ message: 'Sessão expirada' }));
          throw new Error(errorData.message || 'Sessão expirada. Por favor, faça login novamente.');
        }
        throw new Error(`Erro ao carregar ordens: ${ordersResponse.status} ${ordersResponse.statusText}`);
      }
      
      const ordersResult = await ordersResponse.json();
      
      if (ordersResult.success) {
        setApiData(ordersResult.data);
        setDataSource(ordersResult.dataSource);
        setAvailableOrdersState(ordersResult.data);
        console.log('✅ Coluna "Em aberto" atualizada:', ordersResult.data.length, 'cidades');
      }
      // Carregar codstatus "OS de retorno" e "Status de pedido vinculado" para ícones nas colunas
      try {
        const retornoRes = await fetch(`${API_BASE_URL}/api/config/retorno`, {
          headers: token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }
        });
        const retornoJson = await retornoRes.json();
        if (retornoJson.success && retornoJson.data) {
          setCodstatusRetornoEmAberto(String(retornoJson.data.codstatus || '').trim());
          const extra = Array.isArray(retornoJson.data.extraStatuses)
            ? retornoJson.data.extraStatuses
                .filter((v) => v != null && v !== '')
                .map((v) => String(v).trim())
                .filter((v) => v !== '')
            : [];
          setExtraRetornoStatusesEmAberto(extra);
        }
      } catch (err) { /* ignora */ }
      try {
        const autoRetornoRes = await fetch(`${API_BASE_URL}/api/config/automation-retorno`, {
          headers: token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }
        });
        const autoRetornoJson = await autoRetornoRes.json();
        if (autoRetornoJson.success && autoRetornoJson.data) {
          setCodstatusPedidoVinculadoDisponivel(String(autoRetornoJson.data.statusPedidoDisponivel || '').trim());
        }
      } catch (err) { /* ignora */ }
    } catch (error) {
      console.error('❌ Erro ao atualizar coluna "Em aberto":', error);
    } finally {
      setIsRefreshingOpenColumn(false);
    }
  }, []);

  // Função para atualizar apenas a coluna de um técnico específico
  const refreshTechnicianColumn = useCallback(async (technicianId) => {
    if (!technicianId) {
      console.warn('⚠️ ID do técnico não fornecido para atualização');
      return;
    }

    // Obter nome do técnico pelo ID
    const technicianName = getTechnicianNameById(technicianId);
    if (!technicianName) {
      console.warn(`⚠️ Técnico com ID "${technicianId}" não encontrado`);
      return;
    }

    // Adicionar ao Set de colunas sendo atualizadas
    setRefreshingTechnicianColumns(prev => new Set(prev).add(technicianName));

    try {
      const token = localStorage.getItem('authToken');
      const url = `${API_BASE_URL}/api/orders/technicians?technicianId=${encodeURIComponent(technicianId)}&boardRefresh=manual`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          const errorData = await response.json().catch(() => ({ message: 'Sessão expirada' }));
          throw new Error(errorData.message || 'Sessão expirada. Por favor, faça login novamente.');
        }
        throw new Error(`Erro ao carregar dados do técnico: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (result.success) {
        const prepared = hydrateTechnicianCondtAuxGroups(result.data);
        // Atualizar cache com dados frescos
        setTechnicianDataCache(prev => ({
          ...prev,
          [technicianName]: prepared
        }));
        
        // Atualizar grupos de técnicos diretamente
        setTechnicianGroups(prev => ({
          ...prev,
          [technicianName]: prepared
        }));
        mergeCondtBoardDebug(result.debugCondtSync);

        await fetchCompletedCountForTechnician(technicianName);
        await fetchFinishedCountForTechnician(technicianName);
        
        console.log(`✅ Coluna do técnico "${technicianName}" atualizada`);
      }
    } catch (error) {
      console.error('❌ Erro ao atualizar coluna do técnico:', error);
    } finally {
      // Remover do Set de colunas sendo atualizadas
      setRefreshingTechnicianColumns(prev => {
        const newSet = new Set(prev);
        newSet.delete(technicianName);
        return newSet;
      });
    }
  }, [getTechnicianNameById, mergeCondtBoardDebug, fetchCompletedCountForTechnician, fetchFinishedCountForTechnician]);

  // Função para Excluir OS (menu de contexto Board) - chama API e atualiza coluna
  const handleExcluirOS = useCallback(async (orderId, source, technician, groupName) => {
    if (Number(currentUser?.asstec_deleteos) !== 1) {
      closeBoardOrderContextMenu();
      return;
    }
    closeBoardOrderContextMenu();
    setDeleteOverlay({ visible: true, status: 'loading', message: '' });
    try {
      const result = await boardDeleteOrder(orderId);
      if (result.success) {
        setDeleteOverlay({ visible: true, status: 'success', message: '' });
        if (source === 'open') {
          refreshOpenOrders();
        } else if (source === 'technician' && technician) {
          const techId = getTechnicianIdByName(technician);
          if (techId) refreshTechnicianColumn(techId);
        }
      } else {
        setDeleteOverlay({
          visible: true,
          status: 'error',
          message: result.message || 'Erro ao excluir OS.',
        });
      }
    } catch (err) {
      setDeleteOverlay({ visible: true, status: 'error', message: err.message || 'Erro ao excluir OS.' });
    }
  }, [currentUser, refreshOpenOrders, refreshTechnicianColumn, getTechnicianIdByName, preloadAllTechnicianData, closeBoardOrderContextMenu]);

  const refreshData = useCallback(async (isAutoRefresh = false) => {
    if (isRefreshingRef.current) return; // Evita múltiplas atualizações simultâneas
    
    isRefreshingRef.current = true;
    
    if (isAutoRefresh) {
      setIsAutoRefreshing(true);
      setIsRefreshing(false);
    } else {
      setIsAutoRefreshing(false);
      setIsRefreshing(true);
      setRefreshProgress({ current: 0, total: 4, message: 'Iniciando atualização...' });
    }
    
    try {
      const token = localStorage.getItem('authToken');
      const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
      
      // Carregar ordens em aberto e técnicos em paralelo
      if (!isAutoRefresh) {
        setRefreshProgress({ current: 1, total: 4, message: 'Carregando ordens e técnicos...' });
      }
      
      const [ordersResponse, techniciansResponse] = await Promise.all([
        fetch(withBoardOrdersListView(`${API_BASE_URL}/api/orders/open`), { headers: authHeaders }),
        fetch(`${API_BASE_URL}/api/team/technicians`, {
          headers: token
            ? { ...authHeaders, 'Content-Type': 'application/json' }
            : { 'Content-Type': 'application/json' }
        }),
        applyBoardRetornoConfigs(token),
      ]);
      
      // Tratar resposta de ordens
      if (!ordersResponse.ok) {
        if (ordersResponse.status === 401) {
          const errorData = await ordersResponse.json().catch(() => ({ message: 'Sessão expirada' }));
          throw new Error(errorData.message || 'Sessão expirada. Por favor, faça login novamente.');
        }
        throw new Error(`Erro ao carregar ordens: ${ordersResponse.status} ${ordersResponse.statusText}`);
      }
      
      const ordersResult = await ordersResponse.json();
      
      if (ordersResult.success) {
        setApiData(ordersResult.data);
        setDataSource(ordersResult.dataSource);
        setAvailableOrdersState(ordersResult.data);
        if (!isAutoRefresh) {
          console.log('✅ Ordens atualizadas:', ordersResult.data.length, 'cidades');
          const pvl = ordersResult.pedidoVinculadoLiberado;
          if (pvl) {
            /* Gatilho Pedido Vinculado: dados disponíveis em pvl (applied, step1Count, etc.) */
          }
        }
      }
      
      // Tratar resposta de técnicos
      if (!techniciansResponse.ok) {
        if (techniciansResponse.status === 401) {
          const errorData = await techniciansResponse.json().catch(() => ({ message: 'Sessão expirada' }));
          throw new Error(errorData.message || 'Sessão expirada. Por favor, faça login novamente.');
        }
        throw new Error(`Erro ao carregar técnicos: ${techniciansResponse.status} ${techniciansResponse.statusText}`);
      }
      
      const techniciansResult = await techniciansResponse.json();
      
      if (techniciansResult.success) {
        const technicianMap = {};
        const nameToIdMap = {};
        
        techniciansResult.data.forEach(tech => {
          const cleanName = tech.NOME_TECNICO?.trim() || 'Sem nome';
          technicianMap[cleanName] = tech;
          nameToIdMap[cleanName] = tech.id || cleanName;
        });
        
        // Atualizar mapeamento de nomes para IDs sem limpar caches
        setTechnicianNameToIdMap(nameToIdMap);
        if (!isAutoRefresh) {
          console.log('✅ Técnicos atualizados:', techniciansResult.data.length, 'técnicos');
        }
      }
      
      const visibleTechs = columnOrder.length > 0 ? columnOrder : [];
      let batchCache = null;

      if (!isAutoRefresh) {
        setRefreshProgress({ current: 2, total: 4, message: 'Atualizando colunas de técnicos...' });
        try {
          batchCache = await preloadAllTechnicianData({ force: true });
        } catch (error) {
          console.error('❌ Erro ao recarregar colunas de técnicos durante atualização:', error);
        }

        setRefreshProgress({ current: 3, total: 4, message: 'Recarregando dados dos técnicos visíveis...' });
        if (visibleTechs.length > 0) {
          const cache = batchCache && typeof batchCache === 'object' ? batchCache : {};
          setTechnicianGroups((prev) => {
            const next = { ...prev };
            visibleTechs.forEach((techName) => {
              next[techName] = cache[techName] || createEmptyTechnicianBoardGroups();
            });
            return next;
          });
        }
      } else if (visibleTechs.length > 0) {
        const reloadPromises = visibleTechs.map(async (techName) => {
          try {
            const technicianId = getTechnicianIdByName(techName);
            if (!technicianId) {
              return;
            }

            const url = `${API_BASE_URL}/api/orders/technicians?technicianId=${encodeURIComponent(technicianId)}&boardRefresh=auto`;
            const response = await fetch(url, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            const result = await response.json();

            if (result.success) {
              const hydrated = hydrateTechnicianCondtAuxGroups(result.data);
              setTechnicianDataCache(prev => ({
                ...prev,
                [techName]: hydrated
              }));

              setTechnicianGroups(prev => ({
                ...prev,
                [techName]: hydrated
              }));
              mergeCondtBoardDebug(result.debugCondtSync);
            }
          } catch (_) {
            /* silencioso no auto-refresh */
          }
        });

        await Promise.all(reloadPromises);
      }

      // Contagens e sino em background — não bloqueiam pintura das OS / fechamento do refresh
      void loadFuturaRetornoCondtBellSummary();
      const countsKeys =
        visibleTechs && visibleTechs.length > 0 ? visibleTechs : undefined;
      void fetchAllTechnicianCounts(countsKeys);

      if (!isAutoRefresh) {
        console.log('✅ Atualização de dados concluída com sucesso!');
      }
      
    } catch (error) {
      if (!isAutoRefresh) {
        console.error('❌ Erro durante atualização:', error);
        setRefreshProgress({ current: 0, total: 0, message: 'Erro na atualização' });
        
        const errorMessage = error.message || 'Erro desconhecido ao atualizar dados';
        
        if (errorMessage.includes('Sessão expirada') || errorMessage.includes('401')) {
          alert('⚠️ Sua sessão expirou. Por favor, faça login novamente.');
        } else {
          alert(`❌ Erro ao atualizar dados: ${errorMessage}`);
        }
      }
    } finally {
      isRefreshingRef.current = false;
      try {
        window.dispatchEvent(new CustomEvent('painel-board-data-refresh'));
      } catch (_) {
        /* ignore */
      }
      if (!isAutoRefresh) {
        setIsRefreshing(false);
        setIsAutoRefreshing(false);
        setRefreshProgress({ current: 0, total: 0, message: '' });
      } else {
        setIsAutoRefreshing(false);
      }
    }
  }, [getTechnicianIdByName, columnOrder, fetchAllTechnicianCounts, preloadAllTechnicianData, mergeCondtBoardDebug, loadFuturaRetornoCondtBellSummary, applyBoardRetornoConfigs]);

  // Função para atualizar dados de um técnico específico
  const refreshTechnicianData = useCallback(async (technicianName) => {
    if (isRefreshingRef.current) return; // Evita múltiplas atualizações simultâneas
    
    isRefreshingRef.current = true;
    setIsRefreshing(true);
    setRefreshProgress({ current: 0, total: 3, message: `Iniciando atualização do técnico ${technicianName}...` });
    
    try {
      const technicianId = getTechnicianIdByName(technicianName);
      if (!technicianId) {
        throw new Error(`Técnico "${technicianName}" não encontrado`);
      }
      
      // Passo 1: Recarregar dados do técnico
      setRefreshProgress({ current: 1, total: 3, message: `Carregando dados do técnico ${technicianName}...` });
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const token = localStorage.getItem('authToken');
      const url = `${API_BASE_URL}/api/orders/technicians?technicianId=${encodeURIComponent(technicianId)}&boardRefresh=manual`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Erro ao carregar dados: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success) {
        const prepared = hydrateTechnicianCondtAuxGroups(result.data);
        // Atualizar cache com dados frescos
        setTechnicianDataCache(prev => ({
          ...prev,
          [technicianName]: prepared
        }));
        
        // Atualizar grupos de técnicos diretamente
        setTechnicianGroups(prev => ({
          ...prev,
          [technicianName]: prepared
        }));
        mergeCondtBoardDebug(result.debugCondtSync);
        
        console.log(`✅ Dados do técnico "${technicianName}" atualizados com sucesso`);
      }
      
      // Passo 2: Atualizar contagens de ordens concluídas
      setRefreshProgress({ current: 2, total: 3, message: `Atualizando contagens de ordens concluídas...` });
      await new Promise(resolve => setTimeout(resolve, 300));
      await fetchCompletedCountForTechnician(technicianName);
      
      // Passo 3: Atualizar contagens de ordens finalizadas
      setRefreshProgress({ current: 3, total: 3, message: `Atualizando contagens de ordens finalizadas...` });
      await new Promise(resolve => setTimeout(resolve, 300));
      await fetchFinishedCountForTechnician(technicianName);
      
      // Finalizar
      setRefreshProgress({ current: 3, total: 3, message: 'Atualização concluída!' });
      await new Promise(resolve => setTimeout(resolve, 500));
      
    } catch (error) {
      console.error(`❌ Erro ao atualizar dados do técnico "${technicianName}":`, error);
      setRefreshProgress({ current: 0, total: 0, message: `Erro na atualização: ${error.message}` });
      await new Promise(resolve => setTimeout(resolve, 2000));
    } finally {
      setIsRefreshing(false);
      setRefreshProgress({ current: 0, total: 0, message: '' });
      setTimeout(() => {
        isRefreshingRef.current = false;
      }, 1000);
    }
  }, [getTechnicianIdByName, fetchCompletedCountForTechnician, fetchFinishedCountForTechnician, mergeCondtBoardDebug]);

  // Atualização automática a cada 4 minutos (com timer visual)
  // Usar refs para evitar re-renderizações constantes
  React.useEffect(() => {
    // Atualizar refs quando os valores mudarem
    refreshDataRef.current = refreshData;
    isRefreshingRef.current = isRefreshing;
  }, [refreshData, isRefreshing]);

  // Ref para o elemento do timer (para atualizar diretamente sem re-render)
  const timerElementRef = React.useRef(null);

  React.useEffect(() => {
    if (!isAutoRefreshEnabled) {
      // Resetar contador quando desativar (SEM usar setState para evitar re-render)
      autoRefreshRemainingRef.current = 4 * 60;
      if (timerElementRef.current) {
        timerElementRef.current.textContent = '04:00';
      }
      return;
    }

    // Inicializar o timer APENAS no ref e no DOM (SEM usar setState)
    autoRefreshRemainingRef.current = 4 * 60;
    if (timerElementRef.current) {
      timerElementRef.current.textContent = '04:00';
    }

    // Usar um intervalo que atualiza APENAS o texto do timer diretamente no DOM
    // SEM causar re-renderizações do componente React
    // NADA é executado até o timer chegar a zero
    const interval = setInterval(() => {
      // Se estiver atualizando, não decrementar o timer
      if (isRefreshingRef.current) return;

      // Decrementar o timer no ref (sem causar re-render)
      autoRefreshRemainingRef.current = Math.max(0, autoRefreshRemainingRef.current - 1);

      // Atualizar APENAS o texto do timer diretamente no DOM (sem re-render do componente)
      // Isso evita qualquer re-renderização do React
      if (timerElementRef.current) {
        const mins = Math.floor(autoRefreshRemainingRef.current / 60);
        const secs = autoRefreshRemainingRef.current % 60;
        const mm = String(mins).padStart(2, '0');
        const ss = String(secs).padStart(2, '0');
        timerElementRef.current.textContent = `${mm}:${ss}`;
      }

      // Quando o timer chegar a zero, executar atualização automática TOTALMENTE SILENCIOSA
      // Esta é a ÚNICA vez que algo é executado durante o ciclo do timer
      if (autoRefreshRemainingRef.current <= 0) {
        // Resetar timer antes de atualizar
        autoRefreshRemainingRef.current = 4 * 60;
        if (timerElementRef.current) {
          timerElementRef.current.textContent = '04:00';
        }
        
        // Executar atualização automática em background (TOTALMENTE SILENCIOSA)
        // Usar setTimeout com delay mínimo para não bloquear a UI
        setTimeout(() => {
          if (refreshDataRef.current) {
            // Atualização automática: sem logs, sem UI updates, sem re-renders
            refreshDataRef.current(true); // true = atualização automática silenciosa
          }
        }, 50); // Delay mínimo para não bloquear
      }
    }, 1000); // Atualizar a cada segundo (apenas o texto do timer)

    return () => clearInterval(interval);
  }, [isAutoRefreshEnabled]); // Apenas recriar quando isAutoRefreshEnabled mudar

  // Verificar autenticação ao carregar (cookie HttpOnly)
  useEffect(() => {
    const verifyAuthOnLoad = async () => {
      if (!hasAuthSession()) {
        setCurrentUser(null);
        setIsAuthenticated(false);
        setAuthChecking(false);
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/verify`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });

        let result = await response.json();

        if (!result.success) {
          const refreshRes = await fetch(`${API_BASE_URL}/api/auth/refresh`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
          });
          const refreshData = await refreshRes.json();
          if (refreshData.success) {
            markAuthSession();
            const verifyRes = await fetch(`${API_BASE_URL}/api/auth/verify`, {
              method: 'GET',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
            });
            result = await verifyRes.json();
          }
        }

        if (result.success) {
          let user = result.user;
          try {
            if (user?.profilePhotoUrl) {
              /* já veio no verify */
            } else if (user?.id && user.hasProfilePhoto) {
              const photoUrl = await fetchUserProfilePhotoUrl(user.id);
              user = { ...user, profilePhotoUrl: photoUrl };
            } else {
              user = { ...user, profilePhotoUrl: null };
            }
          } catch {
            user = { ...user, profilePhotoUrl: user?.profilePhotoUrl || null };
          }

          markAuthSession();
          localStorage.setItem('userData', JSON.stringify(user));

          setCurrentUser(user);
          setIsAuthenticated(true);
          techsRemovedByOnlyWithOSRef.current = [];
          prevOnlyTechniciansWithOSRef.current = false;
          setOnlyTechniciansWithOS(false);
          setSelectedTechnicianColumnFilters(initialTechnicianColumnFiltersState);

          if (
            Number(user.customers_chat_only) === 1 ||
            Number(user.customers_users_reg_only) === 1
          ) {
            setDataSource('sql_server');
          }

          if (isFinanceiroOnlyMode(user)) {
            setDataSource('sql_server');
            setShowConfigMenu(false);
            navigate(FINANCEIRO_REEMBOLSOS_ROUTE, { replace: true });
          } else if (user.type === '3' || user.type === 3) {
            setActiveSection('Oficina');
          }

          loadCompanyName();
          loadFuturaRetornoTabsConfig();

          if (user.type !== '1') {
            setShowConfigMenu(false);
          }

          if (user.coordinator) {
            setSelectedFilterItems(prev => ({
              ...prev,
              coordenador: [user.name || user.username]
            }));
          }
        } else {
          clearAuthSession();
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('userData');
          setCurrentUser(null);
          setIsAuthenticated(false);
          clearAllStatesAndFilters();
        }
      } catch (error) {
        console.error('❌ Erro ao verificar token (conexão ou timeout):', error);
        console.log('🔓 Erro na verificação - forçando logout por segurança');
        clearAuthSession();
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userData');
        setCurrentUser(null);
        setIsAuthenticated(false);
        clearAllStatesAndFilters();
        console.log('✅ Logout de segurança realizado - usuário será redirecionado para login');
      } finally {
        setAuthChecking(false);
      }
    };

    verifyAuthOnLoad();
  }, [loadCompanyName, loadFuturaRetornoTabsConfig]);

  // Expor função global para verificar banco de dados (para uso no console)
  useEffect(() => {
    window.checkDatabaseInfo = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          console.log('❌ Token não encontrado. Faça login primeiro.');
          return;
        }
        
        const response = await fetch(`${API_BASE_URL}/api/session/database-info`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          console.error('❌ Erro ao obter informações do banco:', response.status, response.statusText);
          return;
        }
        
        const result = await response.json();
        if (result.success) {
          console.log('🗄️ INFORMAÇÕES DO BANCO DE DADOS DA SESSÃO:');
          console.log('   📊 Database:', result.data.database.name);
          console.log('   🖥️  Server:', result.data.database.server);
          console.log('   🔗 Session ID:', result.data.sessionId);
          console.log('   👤 Client ID:', result.data.clientId);
          if (result.data.database.configured) {
            console.log('   ⚙️  Configuração:');
            console.log('      - Servidor:', result.data.database.configured.servidor);
            console.log('      - Database:', result.data.database.configured.db_name);
            console.log('      - Username:', result.data.database.configured.username_db);
          }
          if (result.data.poolStatus) {
            console.log('   🔌 Pool Status:');
            console.log('      - Conectado:', result.data.poolStatus.connected);
            console.log('      - Total:', result.data.poolStatus.total);
            console.log('      - Idle:', result.data.poolStatus.idle);
            console.log('      - In Use:', result.data.poolStatus.inUse);
          }
          return result.data;
        } else {
          console.error('❌ Erro:', result.message);
        }
      } catch (error) {
        console.error('❌ Erro ao verificar banco de dados:', error);
      }
    };
    
  }, []);

  // Função para atualizar status de uma etapa
  const updateLoadingStep = useCallback((stepId, status) => {
    setLoadingSteps(prev => prev.map(step => 
      step.id === stepId ? { ...step, status } : step
    ));
  }, []);

  // Função para carregar dados da API
  const loadOrdersFromAPI = useCallback(async (prefetchedResult = null, options = {}) => {
    const skipRetornoConfigs = Boolean(options.skipRetornoConfigs);
    setIsLoadingData(true);
    try {
      const token = localStorage.getItem('authToken');
      const configsPromise = skipRetornoConfigs ? Promise.resolve() : applyBoardRetornoConfigs(token);
      let result = prefetchedResult;

      if (!result) {
        const headers = {};
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await fetch(withBoardOrdersListView(`${API_BASE_URL}/api/orders/open`), {
          headers: headers
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        result = await response.json();
      }

      if (result.success) {
        setApiData(result.data);
        setDataSource(result.dataSource);
        setAvailableOrdersState(result.data);
        await configsPromise;
      } else {
        console.error('❌ Erro ao carregar dados da API:', result.message);
        console.error('❌ Resultado completo:', result);
        setAvailableOrdersState(availableOrders);
        setDataSource('mock');
        await configsPromise;
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API:', error);
      console.error('❌ Tipo do erro:', error.constructor.name);
      console.error('❌ Stack trace:', error.stack);
      setAvailableOrdersState(availableOrders);
      setDataSource('mock');
    } finally {
      setIsLoadingData(false);
    }
  }, [currentUser, applyBoardRetornoConfigs]);

  // Função de autenticação - definida após loadOrdersFromAPI para evitar erro de inicialização
  const handleLoginSuccess = useCallback(async (user) => {
    let nextUser = user;
    try {
      if (user?.profilePhotoUrl) {
        nextUser = user;
      } else if (user?.id && user.hasProfilePhoto) {
        const photoUrl = await fetchUserProfilePhotoUrl(user.id);
        nextUser = { ...user, profilePhotoUrl: photoUrl };
        localStorage.setItem('userData', JSON.stringify(nextUser));
      } else {
        nextUser = { ...user, profilePhotoUrl: null };
      }
    } catch {
      nextUser = { ...user, profilePhotoUrl: user?.profilePhotoUrl || null };
    }

    setCurrentUser(nextUser);
    try {
      setTheme(resolveThemeFromPreference(user?.blacktheme));
    } catch {
      setTheme('light');
    }
    setIsAuthenticated(true);
    initialLoadRef.current = true;
    techsRemovedByOnlyWithOSRef.current = [];
    prevOnlyTechniciansWithOSRef.current = false;
    setOnlyTechniciansWithOS(false); // Reset ao fazer login

    if (Number(user.customers_chat_only) === 1 || Number(user.customers_users_reg_only) === 1) {
      // Sem Board: dataSource não vem do /orders — marca on-line (sessão real no SQL).
      setDataSource('sql_server');
      setShowConfigMenu(false);
      setIsInitialLoading(false);
      setIsBoardColumnsHydrating(false);
      if (Number(user.customers_chat_only) === 1) {
        navigate('/app/chat', { replace: true });
      } else {
        navigate(BOARD_CADASTRO_ROUTE, { replace: true });
      }
      return;
    }

    if (isFinanceiroOnlyMode(user)) {
      setDataSource('sql_server');
      setShowConfigMenu(false);
      setIsInitialLoading(false);
      setIsBoardColumnsHydrating(false);
      navigate(FINANCEIRO_REEMBOLSOS_ROUTE, { replace: true });
      return;
    }
    
    // Se for Técnico (type = 3), redirecionar para Oficina
    if (user.type === '3' || user.type === 3) {
      setActiveSection('Oficina');
    }
    
    // Carregar configuração de visão de ordens de serviço
    if (user.asstec_showos !== undefined) {
      setUserShowOSConfig(user.asstec_showos);
    } else {
      setUserShowOSConfig(0); // Padrão: Ordem de serviço
    }
    
    // Carregar nome da empresa após login bem-sucedido
    loadCompanyName();
    loadFuturaRetornoTabsConfig();

    // Mesmo critério de verifyAuthOnLoad: coordenador vê escopo de equipe no board/sino sem depender só do F5.
    if (user.coordinator) {
      setSelectedFilterItems((prev) => ({
        ...prev,
        coordenador: [user.name || user.username]
      }));
    }

    // Técnico (type = 3): não carrega dados do Board; só Oficina
    if (user.type === '3' || user.type === 3) {
      if (user.type !== '1') {
        setShowConfigMenu(false);
      }
      setIsInitialLoading(false);
      setIsBoardColumnsHydrating(false);
      return;
    }
    
    // Ativar flag de loading enquanto carrega as ordens (saudação só no login)
    setShowPostLoginWelcome(true);
    setIsInitialLoading(true);
    updateLoadingStep('orders', 'loading');
    
    // Carregar ordens com os filtros do usuário
    
    try {
      await loadOrdersFromAPI();
      updateLoadingStep('orders', 'completed');
      updateLoadingStep('complete', 'completed');
      setIsInitialLoading(false);
      
    } catch (error) {
      console.error('❌ Erro ao carregar dados após login:', error);
      updateLoadingStep('orders', 'error');
      setLoadingHasError(true);
      setLoadingErrorMessage('Erro ao carregar dados. Tente novamente.');
      
      // Fechar loading mesmo com erro após breve atraso
      setTimeout(() => {
        setIsInitialLoading(false);
        setIsBoardColumnsHydrating(false);
      }, 1500);
    }
    
    // Fechar menu de configurações se o usuário não for administrador
    if (user.type !== '1') {
      setShowConfigMenu(false);
    }
  }, [loadOrdersFromAPI, updateLoadingStep, loadCompanyName, loadFuturaRetornoTabsConfig, navigate]);

  // Função para carregar técnicos da API
  const loadTechniciansFromAPI = useCallback(async () => {
    const startTime = performance.now();
    const startTimestamp = new Date().toLocaleTimeString();
    
    setIsLoadingTechnicians(true);
    setTechniciansError(null);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/team/technicians`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Atualizar apenas os técnicos no teamData
        setTeamData(prev => ({
          ...prev,
          tecnicos: result.data
        }));
      } else {
        console.error('❌ Erro ao carregar técnicos da API:', result.message);
        setTechniciansError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API de técnicos:', error);
      setTechniciansError(`Erro de conexão: ${error.message}`);
    } finally {
      setIsLoadingTechnicians(false);
    }
  }, []);

  // Função para carregar áreas da API
  const loadAreasFromAPI = useCallback(async () => {
    setIsLoadingAreas(true);
    setAreasError(null);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/team/areas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Atualizar apenas as áreas no teamData
        setTeamData(prev => ({
          ...prev,
          areas: result.data
        }));
      } else {
        console.error('❌ Erro ao carregar áreas da API:', result.message);
        setAreasError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API de áreas:', error);
      setAreasError(`Erro de conexão: ${error.message}`);
    } finally {
      setIsLoadingAreas(false);
    }
  }, []);

  // Função para carregar coordenadores da API
  const loadCoordinatorsFromAPI = useCallback(async () => {
    setIsLoadingCoordinators(true);
    setCoordinatorsError(null);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/team/coordinators`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Atualizar apenas os coordenadores no teamData
        setTeamData(prev => ({
          ...prev,
          coordenadores: result.data
        }));
      } else {
        console.error('❌ Erro ao carregar coordenadores da API:', result.message);
        setCoordinatorsError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API de coordenadores:', error);
      setCoordinatorsError(`Erro de conexão: ${error.message}`);
    } finally {
      setIsLoadingCoordinators(false);
    }
  }, []);

  // Função para carregar vínculos técnico-área da API
  const loadAreaTeamFromAPI = useCallback(async () => {
    setIsLoadingAreaTeam(true);
    setAreaTeamError(null);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/team/areateam`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Aplicar os vínculos aos técnicos
        setTeamData(prev => {
          // Verificar se os técnicos já foram carregados
          if (prev.tecnicos.length === 0) {
            return prev;
          }
          
          const updatedTeamData = {
            ...prev,
            tecnicos: prev.tecnicos.map(tecnico => {
              const vinculo = result.data.find(v => v.id_tech === tecnico.id);
              return {
                ...tecnico,
                areaId: vinculo ? vinculo.id_area : null
              };
            })
          };
          
          return updatedTeamData;
        });
      } else {
        console.error('❌ Erro ao carregar vínculos técnico-área da API:', result.message);
        setAreaTeamError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API de vínculos técnico-área:', error);
      setAreaTeamError(`Erro de conexão: ${error.message}`);
    } finally {
      setIsLoadingAreaTeam(false);
    }
  }, []);

  // Função para carregar vínculos área-coordenador da API
  const loadAreaCoordFromAPI = useCallback(async () => {
    setIsLoadingAreaCoord(true);
    setAreaCoordError(null);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/team/areacoord`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Aplicar os vínculos às áreas
        setTeamData(prev => {
          // Verificar se as áreas já foram carregadas
          if (prev.areas.length === 0) {
            return prev;
          }
          
          const updatedTeamData = {
            ...prev,
            areas: prev.areas.map(area => {
              const vinculo = result.data.find(v => v.id_area === area.id);
              return {
                ...area,
                coordenadorId: vinculo ? vinculo.id_coordinator : null
              };
            })
          };
          
          return updatedTeamData;
        });
      } else {
        console.error('❌ Erro ao carregar vínculos área-coordenador da API:', result.message);
        setAreaCoordError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da API de vínculos área-coordenador:', error);
      setAreaCoordError(`Erro de conexão: ${error.message}`);
    } finally {
      setIsLoadingAreaCoord(false);
    }
  }, []);

  // Uma única função que carrega todos os dados de equipe (evita múltiplas requisições em paralelo)
  const loadAllTeamDataFromAPI = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/team/board-bootstrap`, { headers });
      const result = await response.json();
      if (result.success && result.data) {
        const assembled = assembleBoardTeamData(result.data);
        setTeamData(assembled);
        setTechniciansError(null);
        setAreasError(null);
        setCoordinatorsError(null);
        setAreaTeamError(null);
        setAreaCoordError(null);
        return assembled;
      }
    } catch {
      /* fallback nas 5 rotas existentes */
    }

    await Promise.all([
      loadTechniciansFromAPI(),
      loadAreasFromAPI(),
      loadCoordinatorsFromAPI()
    ]);
    await Promise.all([
      loadAreaTeamFromAPI(),
      loadAreaCoordFromAPI()
    ]);
    return null;
  }, [loadTechniciansFromAPI, loadAreasFromAPI, loadCoordinatorsFromAPI, loadAreaTeamFromAPI, loadAreaCoordFromAPI]);

  // Carregar dados iniciais com modal de progresso
  useEffect(() => {
    // Só inicializar se o usuário estiver autenticado
    if (!isAuthenticated) {
      return;
    }
    if (initialLoadRef.current) {
      return;
    }
    const initializeApp = async () => {
      try {
        // Etapa 1: Carregar configuração
        updateLoadingStep('config', 'loading');
        // Não carregar dbConfig do localStorage (credenciais somente no backend)
        localStorage.removeItem('dbConfig');
        updateLoadingStep('config', 'completed');
        
        // Etapa 2: Carregar ordens do banco (detectar erro de conexão)
        updateLoadingStep('orders', 'loading');
        let connectionFailed = false;
        let sqlServerFailed = false;
        let teamPromise = null;
        
        try {
          // Obter token do localStorage (nome correto: 'authToken')
          const token = localStorage.getItem('authToken');
          
          if (!token) {
            // SEM TOKEN = usuário ainda não fez login
            // Não carregar ordens agora, deixar para o login fazer isso
            updateLoadingStep('orders', 'pending');
            
            // Pular para as próximas etapas (elas não precisam de ordens)
            updateLoadingStep('team', 'loading');
            await loadAllTeamDataFromAPI();
            updateLoadingStep('team', 'completed');
            
            // Marcar como concluído e sair
            updateLoadingStep('complete', 'completed');
            return; // Parar aqui, aguardar login
          }
          
          // Usuário exclusivo do chat e/ou cadastro: não carrega dados do Board
          if (
            Number(currentUser?.customers_chat_only) === 1 ||
            Number(currentUser?.customers_users_reg_only) === 1
          ) {
            setDataSource('sql_server');
            updateLoadingStep('orders', 'pending');
            updateLoadingStep('complete', 'completed');
            setIsInitialLoading(false);
            setIsBoardColumnsHydrating(false);
            return;
          }

          if (isFinanceiroOnlyMode(currentUser)) {
            setDataSource('sql_server');
            updateLoadingStep('orders', 'pending');
            updateLoadingStep('complete', 'completed');
            setIsInitialLoading(false);
            setIsBoardColumnsHydrating(false);
            return;
          }

          // Técnico (type = 3): não carrega Board; só Oficina
          if (currentUser?.type === '3' || currentUser?.type === 3) {
            updateLoadingStep('orders', 'pending');
            updateLoadingStep('complete', 'completed');
            setIsInitialLoading(false);
            setIsBoardColumnsHydrating(false);
            return;
          }
          
          // Token encontrado - usuário já estava logado (reload da página)
          updateLoadingStep('team', 'loading');
          const boot = await fetchBoardBootstrap({ token });
          const openResult = boot?.data?.open;
          if (!openResult?.success) {
            throw new Error(boot?.data?.meta?.errors?.open || 'Erro desconhecido na API');
          }

          applyBoardBootstrapConfigs(boot.data, {
            setCodstatusRetornoEmAberto,
            setExtraRetornoStatusesEmAberto,
            setCodstatusPedidoVinculadoDisponivel,
          });
          applyBoardBootstrapBell(boot.data, setFuturaRetornoBellApi);

          const assembledTeam = applyBoardBootstrapTeam(boot.data, setTeamData);
          if (assembledTeam) {
            setTechniciansError(null);
            setAreasError(null);
            setCoordinatorsError(null);
            setAreaTeamError(null);
            setAreaCoordError(null);
            teamPromise = Promise.resolve(assembledTeam);
          } else {
            teamPromise = loadAllTeamDataFromAPI();
          }

          if (openResult.dataSource === 'mock_fallback') {
            sqlServerFailed = true;
            setLoadingHasError(true);
            setLoadingErrorMessage(`Erro na conexão com o SQL Server: ${openResult.message || 'Conexão falhou'}. Sistema iniciado com dados de demonstração.`);
          } else if (openResult.dataSource !== 'sql_server') {
            setLoadingHasError(true);
            setLoadingErrorMessage('Banco de dados não configurado. Sistema iniciado com dados de demonstração. Configure o banco em Configurações > Banco de Dados.');
          }
          await loadOrdersFromAPI(openResult, { skipRetornoConfigs: true });
          updateLoadingStep('orders', 'completed');
        } catch (error) {
          // Verificar se é erro de token inválido
          if (error?.status === 401 || error.message.includes('401') || error.message.includes('Token') || error.message.includes('Sessão')) {
            console.log('❌ Erro de autenticação detectado - forçando logout');
            
            // Limpar localStorage
            clearAuthSession();
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('userData');
            
            // Resetar estados
            setCurrentUser(null);
            setIsAuthenticated(false);
            
            // Limpar todos os estados e filtros
            clearAllStatesAndFilters();
            
            updateLoadingStep('orders', 'error');
            setLoadingHasError(true);
            setLoadingErrorMessage('Sua sessão expirou. Por favor, faça login novamente.');
            
            return; // Parar aqui
          }
          
          // Erro de conexão com backend
          console.error('❌ Erro de conexão com backend:', error);
          connectionFailed = true;
          updateLoadingStep('orders', 'error');
          setLoadingHasError(true);
          setLoadingErrorMessage(`Não foi possível conectar ao servidor backend (${error.message}). Verifique se o servidor está rodando na porta 3002.`);
          
          // NÃO carregar dados mock para coordenadores por questões de segurança
          const userData = localStorage.getItem('userData');
          if (userData) {
            try {
              const user = JSON.parse(userData);
              if (user.coordinator) {
                console.log('🚫 Usuário é coordenador - NÃO carregando dados mock por segurança');
                console.log('🔓 Forçando logout para coordenador sem conexão');
                
                // Limpar localStorage
                clearAuthSession();
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('userData');
                
                // Resetar estados
                setCurrentUser(null);
                setIsAuthenticated(false);
                
                // Limpar todos os estados e filtros
                clearAllStatesAndFilters();
                
                setLoadingErrorMessage('Não foi possível verificar suas permissões. Por favor, faça login novamente.');
                return;
              }
            } catch (e) {
              console.error('Erro ao verificar tipo de usuário:', e);
            }
          }
          
          // Apenas para usuários não-coordenadores, permitir fallback
          console.log('⚠️ Usuário não-coordenador - tentando carregar dados mock');
          await loadOrdersFromAPI();
        }
        
        // Se houver erro de conexão, não continuar automaticamente
        if (connectionFailed) {
          // Marcar etapas restantes como pendentes mas não executar
          setLoadingSteps(prev => prev.map(step => {
            if (['team', 'filters', 'complete'].includes(step.id)) {
              return { ...step, status: 'skipped' };
            }
            return step;
          }));
          setIsBoardColumnsHydrating(false);
          return; // Parar aqui e aguardar confirmação do usuário
        }
        
        updateLoadingStep('complete', 'completed');
        setIsInitialLoading(false);

        const hydrateBoardColumns = async () => {
          try {
            updateLoadingStep('team', 'loading');
            let loadedTeam = null;
            if (teamPromise) {
              loadedTeam = await teamPromise;
            } else {
              loadedTeam = await loadAllTeamDataFromAPI();
            }
            updateLoadingStep('team', 'completed');
            updateLoadingStep('filters', 'loading');
            try {
              // Sem filtro de equipe: colunas não renderizam — não preloadar todos no boot
              const filters = boardFilterItemsRef.current;
              if (hasActiveBoardTeamFilters(filters)) {
                const names = getVisibleBoardTechnicianNames(filters, loadedTeam);
                if (names.length) {
                  await preloadAllTechnicianData({ names });
                } else {
                  void loadFuturaRetornoCondtBellSummary();
                }
              } else {
                void loadFuturaRetornoCondtBellSummary();
              }
            } catch (error) {
              console.error('❌ Erro no pré-carregamento de técnicos durante inicialização:', error);
            }
            updateLoadingStep('filters', 'completed');
          } finally {
            setIsBoardColumnsHydrating(false);
          }
        };
        void hydrateBoardColumns();
    
  } catch (error) {
    console.error('❌ Erro durante inicialização:', error);
    updateLoadingStep('orders', 'error');
    setLoadingHasError(true);
    setLoadingErrorMessage('Erro inesperado durante a inicialização do sistema.');
    setIsBoardColumnsHydrating(false);
  }
};

    initialLoadRef.current = true;
    initializeApp();
}, [loadOrdersFromAPI, loadAllTeamDataFromAPI, applyBoardRetornoConfigs, updateLoadingStep, isAuthenticated, currentUser]);

  // Recarregar dados quando a configuração for salva
  useEffect(() => {
    if (connectionStatus?.success && connectionStatus.message.includes('salva com sucesso')) {
      setTimeout(() => {
        loadOrdersFromAPI();
      }, 1000); // Aguardar 1 segundo para o backend processar
    }
  }, [connectionStatus, loadOrdersFromAPI]);

  // Ref para carregar equipe apenas uma vez após login (evita loop por dependência em teamData)
  const teamLoadedAfterLoginRef = useRef(false);
  useEffect(() => {
    if (!isAuthenticated) {
      teamLoadedAfterLoginRef.current = false;
      return;
    }
    const token = localStorage.getItem('authToken');
    if (!currentUser || !token) return;
    if (teamLoadedAfterLoginRef.current) return;
    teamLoadedAfterLoginRef.current = true;
    loadAllTeamDataFromAPI().catch(() => {});
  }, [isAuthenticated, currentUser, loadAllTeamDataFromAPI]);

  // NOTA: useEffect para fechar dropdown de programação foi removido.
  // A lógica agora está gerenciada pelo OpenOSModal.js
  /*
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showScheduleDropdown && !event.target.closest('[data-schedule-dropdown]')) {
        setShowScheduleDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showScheduleDropdown]);
  */

  // Atualizar dados ao sair de /cadastros/equipe para outra rota
  const prevPathnameForEquipeRef = useRef(location.pathname);
  useEffect(() => {
    const wasEquipeRoute = prevPathnameForEquipeRef.current === '/cadastros/equipe';
    const isEquipeRoute = location.pathname === '/cadastros/equipe';
    if (wasEquipeRoute && !isEquipeRoute) {
      loadAllTeamDataFromAPI().catch(() => {});
    }
    prevPathnameForEquipeRef.current = location.pathname;
  }, [location.pathname, loadAllTeamDataFromAPI]);

  // Coordenador/área marcado antes da equipe: preencher tecnico quando teamData chegar
  useEffect(() => {
    const names = getHydratedBoardFilterTechnicians(selectedFilterItems, teamData);
    if (!names) return;
    setSelectedFilterItems((prev) => {
      const next = getHydratedBoardFilterTechnicians(prev, teamData);
      if (!next) return prev;
      return { ...prev, tecnico: next };
    });
  }, [teamData, selectedFilterItems]);

  // Pré-carregar só técnicos do filtro ativo (sem filtro de equipe = sem colunas = sem batch)
  useEffect(() => {
    if (isInitialLoading) return;
    if (!hasActiveBoardTeamFilters(selectedFilterItems)) {
      setIsBoardColumnsHydrating(false);
      return;
    }
    if (!teamData?.tecnicos?.length) return;
    const names = getVisibleBoardTechnicianNames(selectedFilterItems, teamData);
    if (!names.length) {
      setIsBoardColumnsHydrating(false);
      return;
    }
    const missing = names.filter((n) => !technicianDataCache[n]);
    if (!missing.length) {
      setIsBoardColumnsHydrating(false);
      return;
    }
    preloadAllTechnicianData({ names: missing })
      .then(() => {
        setIsBoardColumnsHydrating(false);
      })
      .catch(error => {
        console.error('❌ Erro no pré-carregamento de técnicos:', error);
        setIsBoardColumnsHydrating(false);
      });
  }, [
    teamData,
    technicianDataCache,
    isInitialLoading,
    selectedFilterItems.tecnico,
    selectedFilterItems.coordenador,
    selectedFilterItems.area,
    preloadAllTechnicianData,
  ]);

  const themeCoverSkipSyncRef = useRef(false);
  const themeCoverGenRef = useRef(0);

  // Atualizar tema quando dados do usuário atual mudarem (0=Claro, 1=Escuro, 2=Sistema)
  useEffect(() => {
    if (!currentUser) {
      setTheme('light');
      return undefined;
    }
    if (!themeCoverSkipSyncRef.current) {
      setTheme(resolveThemeFromPreference(currentUser.blacktheme));
    }

    if (normalizeBlacktheme(currentUser.blacktheme) !== THEME_PREF.SYSTEM) {
      return undefined;
    }
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => setTheme(resolveThemeFromPreference(THEME_PREF.SYSTEM));
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, [currentUser]);

  // Sync em <html> para modais/popovers com createPortal(document.body)
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('theme-dark');
    } else {
      root.classList.remove('theme-dark');
    }
    return () => {
      root.classList.remove('theme-dark');
    };
  }, [theme]);

  const handleSetThemePreference = useCallback(async (nextPrefRaw, event) => {
    if (!currentUser) return;
    const nextPref = normalizeBlacktheme(nextPrefRaw);
    const prevPref = normalizeBlacktheme(currentUser.blacktheme);
    if (nextPref === prevPref) return;
    const nextTheme = resolveThemeFromPreference(nextPref);
    const prevTheme = resolveThemeFromPreference(prevPref);
    if (nextTheme !== prevTheme && isThemeCoverRunning()) return;
    const coverGen = ++themeCoverGenRef.current;
    const applyVisualTheme = () => {
      if (themeCoverGenRef.current !== coverGen) return;
      setTheme(nextTheme);
      if (nextTheme === 'dark') document.documentElement.classList.add('theme-dark');
      else document.documentElement.classList.remove('theme-dark');
      themeCoverSkipSyncRef.current = false;
    };

    if (nextTheme !== prevTheme) {
      themeCoverSkipSyncRef.current = true;
      playThemeCoverTransition({
        toDark: nextTheme === 'dark',
        event,
        apply: applyVisualTheme,
      });
    } else {
      applyVisualTheme();
    }

    const nextUser = { ...currentUser, blacktheme: nextPref };
    setCurrentUser(nextUser);
    try {
      localStorage.setItem('userData', JSON.stringify(nextUser));
    } catch (_) { /* ignore */ }

    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${API_BASE_URL}/api/users/me`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ blacktheme: nextPref })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        themeCoverGenRef.current += 1;
        themeCoverSkipSyncRef.current = false;
        const revertUser = { ...currentUser, blacktheme: prevPref };
        setTheme(resolveThemeFromPreference(prevPref));
        setCurrentUser(revertUser);
        try {
          localStorage.setItem('userData', JSON.stringify(revertUser));
        } catch (_) { /* ignore */ }
        return;
      }
      if (data.blacktheme !== undefined && data.blacktheme !== null) {
        const savedPref = normalizeBlacktheme(data.blacktheme);
        const savedUser = { ...nextUser, blacktheme: savedPref };
        setCurrentUser(savedUser);
        if (!themeCoverSkipSyncRef.current) {
          setTheme(resolveThemeFromPreference(savedPref));
        }
        try {
          localStorage.setItem('userData', JSON.stringify(savedUser));
        } catch (_) { /* ignore */ }
      }
    } catch (_) {
      themeCoverGenRef.current += 1;
      themeCoverSkipSyncRef.current = false;
      const revertUser = { ...currentUser, blacktheme: prevPref };
      setTheme(resolveThemeFromPreference(prevPref));
      setCurrentUser(revertUser);
      try {
        localStorage.setItem('userData', JSON.stringify(revertUser));
      } catch (__) { /* ignore */ }
    }
  }, [currentUser]);

  // SSE contador fechamento (cookie HttpOnly subtoken curto) - type 0/1/2 e asstec_closeos=1
  useEffect(() => {
    if (!isAuthenticated || !currentUser) return;
    const type = currentUser.type;
    const typeOk = type === '0' || type === 0 || type === '1' || type === 1 || type === '2' || type === 2;
    if (!typeOk || currentUser.asstec_closeos !== 1) return;

    if (!hasAuthSession()) return;

    const baseUrl = getApiBaseUrl();

    const ensureValidToken = async () => {
      // Access JWT no cookie HttpOnly; interceptor renova em 401 no stream-token.
      return hasAuthSession() ? 'cookie' : null;
    };

    let cancelled = false;
    let es = null;

    const connect = async () => {
      if (cancelled) return;

      const validToken = await ensureValidToken();
      if (!validToken) return;

      // Gera cookie HttpOnly (subtoken curto) para o SSE.
      try {
        await fetch(`${baseUrl}/api/checkout-view/contador-stream-token`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch (_) { /* ignora erro */ }

      if (cancelled) return;

      // Monta EventSource sem token na query string.
      es = new EventSource(`${baseUrl}/api/checkout-view/contador-stream`, { withCredentials: true });
      es.onmessage = (e) => {
        try {
          const next = JSON.parse(e.data);
          if (next && typeof next.qtde === 'number') {
            setFechamentoCount((prev) => (prev === next.qtde ? prev : next.qtde));
          } else if (next && next.qtde != null) {
            const n = Number(next.qtde) || 0;
            setFechamentoCount((prev) => (prev === n ? prev : n));
          }
        } catch (_) {}
      };

      es.onerror = () => {
        try { es && es.close(); } catch (_) {}
        es = null;
        if (cancelled) return;
        setTimeout(connect, 4000);
      };
    };

    connect();

    return () => {
      cancelled = true;
      try { es && es.close(); } catch (_) {}
      es = null;
    };
  }, [isAuthenticated, currentUser]);

  // Função para mapear tipo de serviço baseado em TB02115_PREVENTIVA
  const getServiceTypeFromPreventiva = (preventiva) => {
    const typeMap = {
      'E': 'E', // ESTOQUE
      'B': 'B', // BALCÃO
      'A': 'A', // AFERIÇÃO
      'R': 'R', // RETORNO-RECARGA
      'D': 'D', // DESINSTALAÇÃO
      'I': 'I', // INSTALAÇÃO
      'S': 'S', // PREVENTIVA
      'N': 'C'  // NORMAL/CORRETIVA - mapear para 'C' visualmente
    };
    return typeMap[preventiva] || 'C'; // Padrão para corretiva (C visualmente)
  };

  const boardAllowedTipoLetters = React.useMemo(() => {
    if (Number(currentUser?.asstec_openos_type_only) !== 1) return null;
    return userOsLoadFlagsToBoardLetters(currentUser?.os_types);
  }, [currentUser?.asstec_openos_type_only, currentUser?.os_types]);

  React.useEffect(() => {
    if (!boardAllowedTipoLetters) return;
    setSelectedColumnFilters((prev) => {
      const nextTipo = (prev.tipoOS || []).filter((t) => boardAllowedTipoLetters.includes(t));
      if (nextTipo.length === (prev.tipoOS || []).length) return prev;
      return { ...prev, tipoOS: nextTipo };
    });
  }, [boardAllowedTipoLetters]);

  // Função para determinar SLA baseado em CALC_RESTANTE e CALC_PREVISAO
  const getSLAFromCalcRestante = (calcRestante, calcPrevisao) => {
    const restanteNum = Number(calcRestante ?? 0);
    const nowMs = Date.now();

    // Regra principal: decide por datetime para considerar hora e minuto na virada.
    if (calcPrevisao) {
      const previsaoDate = new Date(calcPrevisao);
      const previsaoMs = previsaoDate.getTime();

      if (!Number.isNaN(previsaoMs)) {
        if (previsaoMs <= nowMs) {
          return 'Vencido';
        }

        const now = new Date(nowMs);
        const sameDay =
          previsaoDate.getFullYear() === now.getFullYear() &&
          previsaoDate.getMonth() === now.getMonth() &&
          previsaoDate.getDate() === now.getDate();

        if (sameDay && nowMs < previsaoMs) {
          return 'Vencendo';
        }
      }
    }

    // Fallback: se não houver CALC_PREVISAO válida, mantém aproximação por CALC_RESTANTE (horas).
    if (!Number.isNaN(restanteNum) && restanteNum < 0) {
      return 'Vencido';
    }

    return 'Em dia';
  };

  const getBoardSlaForOrder = (ordem, existingSla) => {
    if (String(ordem?.TB02115_PREVENTIVA ?? '').trim().toUpperCase() === 'S') {
      return 'Em dia';
    }
    if (existingSla != null && existingSla !== '') return existingSla;
    return getSLAFromCalcRestante(ordem.CALC_RESTANTE, ordem.CALC_PREVISAO);
  };

  // Normaliza SLA para o formato canônico usado pelos filtros da coluna "Em aberto"
  // (o backend pode retornar minúsculo: vencido/vencendo/ok, enquanto alguns trechos usam maiúsculo)
  const normalizeSlaForFilter = (sla) => {
    const raw = String(sla ?? '').trim();
    const s = raw.toLowerCase();

    if (s === 'vencido') return 'vencido';
    if (s === 'vencendo') return 'vencendo';
    if (s === 'em dia' || s === 'ok') return 'ok';

    return 'ok';
  };

  // Texto exibido no filtro (sempre com os termos pedidos)
  const getSlaLabelForFilter = (sla) => {
    const normalized = normalizeSlaForFilter(sla);
    if (normalized === 'vencido') return 'Vencido';
    if (normalized === 'vencendo') return 'Vencendo';
    return 'A vencer';
  };

  // Função para mapear ordem para formato legado (compatibilidade)
  const mapOrderToLegacyFormat = (ordem) => {
    if (isBoardReadyOrder(ordem)) return ordem;
    // Se a ordem já vem com campos mapeados do backend, preservar TUDO mas garantir campos essenciais
    if (ordem.dataAbertura !== undefined || ordem.contrato !== undefined || ordem.numeroSerie !== undefined) {
      
      return {
        ...ordem, // Preservar TODOS os campos que vêm do backend (incluindo schedule)
        // Garantir campos essenciais para o frontend
        cliente: getBoardClienteExibicao(ordem),
        tipo: ordem.tipo || getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA),
        // SLA calculado a partir de CALC_RESTANTE e CALC_PREVISAO (preventiva: sempre "Em dia" / filtro A vencer)
        sla: getBoardSlaForOrder(ordem, ordem.sla),
        // Garantir que TB02112_PAT esteja disponível
        TB02112_PAT: ordem.TB02112_PAT || ordem.patrimonio,
        patrimonio: ordem.patrimonio || ordem.TB02112_PAT,
        // Garantir que TB02115_NUMSERIE esteja disponível
        TB02115_NUMSERIE: ordem.TB02115_NUMSERIE || ordem.numeroSerie,
        // Garantir que TB02115_CODIGO esteja disponível
        TB02115_CODIGO: ordem.TB02115_CODIGO || ordem.id,
        TB02115_OS: ordem.TB02115_OS ?? null,
        // Garantir que CALC_PREVISAO esteja disponível
        CALC_PREVISAO: ordem.CALC_PREVISAO || ordem.previsao || null,
        // Preservar schedule se vier do backend
        schedule: ordem.schedule || null,
        // Empresa para reimpressão PDF/Imprimir (header)
        TB01007_NOME: ordem.TB01007_NOME || null,
        TB01007_CNPJ: ordem.TB01007_CNPJ || null,
        TB01007_ENDERECO: ordem.TB01007_ENDERECO || null
      };
    }
    
    // Para dados mock ou legados sem mapeamento, usar transformação local
    console.log('🔍 Frontend - Aplicando mapeamento local para ordem:', ordem.TB02115_CODIGO);
    return {
      id: ordem.TB02115_CODIGO,
      cliente: getBoardClienteExibicao(ordem),
      equipamento: ordem.TB01010_RESUMIDO || ordem.TB01010_NOME,
      tipo: getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA),
      sla: getBoardSlaForOrder(ordem),
      atrasada: ordem.CALC_RESTANTE <= 24,
      pedidoVinculado: ordem.pedidoVinculado,
      pedidos_vinculados: ordem.pedidos_vinculados != null ? Number(ordem.pedidos_vinculados) : null,

      // Campos necessários para os modais e sidebars
      numeroSerie: ordem.numeroSerie,
      serie: ordem.serie,
      patrimonio: ordem.patrimonio || ordem.TB02112_PAT,
      TB02112_PAT: ordem.TB02112_PAT || ordem.patrimonio,
      TB02115_NUMSERIE: ordem.TB02115_NUMSERIE || ordem.numeroSerie,
      dataAbertura: ordem.dataAbertura,
      tecnico: ordem.tecnico,
      coordenador: ordem.coordenador,
      area: ordem.area,
      bairro: ordem.bairro,
      estado: ordem.estado,
      contrato: ordem.contrato,
      
      // Campos para o modal de detalhes
      endereco: ordem.ENDERECO || ordem.endereco || null,
      TB02112_LOCAL: ordem.TB02112_LOCAL || null,
      TB02115_LOCAL: ordem.TB02115_LOCAL || null,
      TB02115_CIDADE: ordem.TB02115_CIDADE || ordem.cidade,
      TB02115_ESTADO: ordem.TB02115_ESTADO || ordem.estado,
      
      // Campos originais mantidos para referência
      TB02115_CODIGO: ordem.TB02115_CODIGO,
      TB01008_NOME: ordem.TB01008_NOME,
      TB01008_FANTASIA: ordem.TB01008_FANTASIA ?? null,
      TB01010_NOME: ordem.TB01010_NOME,
      TB01010_RESUMIDO: ordem.TB01010_RESUMIDO,
      TB02115_PREVENTIVA: ordem.TB02115_PREVENTIVA,
      TB02115_BAIRRO: ordem.TB02115_BAIRRO, // Campo adicionado para filtros
      TB02115_OS: ordem.TB02115_OS ?? null,
      CALC_RESTANTE: ordem.CALC_RESTANTE,
      CALC_PREVISAO: ordem.CALC_PREVISAO, // Campo de previsão
      TB01047_NOME: ordem.TB01047_NOME, // Marca
      TB01018_NOME: ordem.TB01018_NOME, // Subgrupo
      TB01073_NOME: ordem.TB01073_NOME, // Status
      TB01024_NOME: ordem.TB01024_NOME, // Técnico inicial
      TECMAQ: ordem.TECMAQ || null, // Técnico máquina
      TB01024_TERRITORIO: ordem.TB01024_TERRITORIO || null, // Território do técnico máquina
      RoteiroHoje: ordem.RoteiroHoje,    // Campo para cor do roteiro de hoje
      // Empresa para reimpressão PDF/Imprimir (header)
      TB01007_NOME: ordem.TB01007_NOME || null,
      TB01007_CNPJ: ordem.TB01007_CNPJ || null,
      TB01007_ENDERECO: ordem.TB01007_ENDERECO || null
    };
  };

  // Abordagem simples sem estados complexos


  // Função para aplicar filtros automáticos quando um filtro é selecionado
  const applyAutomaticFilters = (type, newSelection) => {
    
    let updatedFilters = {};
    
    // Quando um coordenador é selecionado/desmarcado, sincronizar técnicos automaticamente
    if (type === 'coordenador') {
      const technicosToAdd = [];
      
      // Para cada coordenador selecionado, obter todos os técnicos vinculados
      newSelection.forEach(coordenadorNome => {
        const coord = teamData.coordenadores.find(c => c.nome === coordenadorNome);
        if (coord) {
          // Encontrar áreas deste coordenador
          const coordAreas = teamData.areas.filter(area => area.coordenadorId === coord.id);
          
          // Para cada área, encontrar técnicos
          coordAreas.forEach(area => {
            const tecnicosFromArea = teamData.tecnicos.filter(tec => tec.areaId === area.id);
            tecnicosFromArea.forEach(tec => {
              if (!technicosToAdd.includes(tec.nome)) {
                technicosToAdd.push(tec.nome);
              }
            });
          });
        }
      });
      
      // Manter técnicos já selecionados manualmente (que não pertencem aos coordenadores desmarcados)
      const coordenadorRemovidos = selectedFilterItems.coordenador.filter(c => !newSelection.includes(c));
      let technicosToRemove = [];
      
      coordenadorRemovidos.forEach(coordenadorNome => {
        const coord = teamData.coordenadores.find(c => c.nome === coordenadorNome);
        if (coord) {
          const coordAreas = teamData.areas.filter(area => area.coordenadorId === coord.id);
          coordAreas.forEach(area => {
            const tecnicosFromArea = teamData.tecnicos.filter(tec => tec.areaId === area.id);
            tecnicosFromArea.forEach(tec => {
              if (!technicosToRemove.includes(tec.nome)) {
                technicosToRemove.push(tec.nome);
              }
            });
          });
        }
      });
      
      // Criar nova lista de técnicos: manter os atuais, adicionar os novos, remover os que não pertencem mais
      const currentTechnicians = selectedFilterItems.tecnico || [];
      const newTechnicians = [
        ...currentTechnicians.filter(t => !technicosToRemove.includes(t)),
        ...technicosToAdd.filter(t => !currentTechnicians.includes(t))
      ];
      
      updatedFilters.tecnico = newTechnicians;
      
    }
    
    // Quando uma área é selecionada/desmarcada, sincronizar técnicos automaticamente
    if (type === 'area') {
      const technicosToAdd = [];
      
      // Para cada área selecionada, obter todos os técnicos vinculados
      newSelection.forEach(areaNome => {
        const area = teamData.areas.find(a => a.nome === areaNome);
        if (area) {
          const tecnicosFromArea = teamData.tecnicos.filter(tec => tec.areaId === area.id);
          tecnicosFromArea.forEach(tec => {
            if (!technicosToAdd.includes(tec.nome)) {
              technicosToAdd.push(tec.nome);
            }
          });
        }
      });
      
      // NOVA LÓGICA SIMPLIFICADA: 
      // Quando áreas são selecionadas, mostrar APENAS técnicos das áreas selecionadas
      // Ignorar técnicos de coordenadores previamente selecionados
      
      // Se há coordenador selecionado E área selecionada: intersecção (técnicos da área que pertencem ao coordenador)
      if (selectedFilterItems.coordenador.length > 0) {
        const coordenadorNomes = selectedFilterItems.coordenador;
        const coordenadorIds = teamData.coordenadores
          .filter(coord => coordenadorNomes.includes(coord.nome))
          .map(coord => coord.id);
        
        // Filtrar técnicos que estão nas áreas selecionadas E pertencem aos coordenadores selecionados
        const newTechnicians = technicosToAdd.filter(tecnicoNome => {
          const tecnico = teamData.tecnicos.find(t => t.nome === tecnicoNome);
          if (!tecnico) return false;
          
          const areaDoTecnico = teamData.areas.find(a => a.id === tecnico.areaId);
          return areaDoTecnico && coordenadorIds.includes(areaDoTecnico.coordenadorId);
        });
        
      updatedFilters.tecnico = newTechnicians;
      } else {
        // Se só há área selecionada: mostrar APENAS técnicos das áreas
        updatedFilters.tecnico = technicosToAdd;
      }
      
    }
    
    // Quando um técnico é selecionado/desmarcado diretamente, manter essa preferência
    // (não fazer nada adicional, apenas manter a seleção manual)
    return updatedFilters;
  };

  const SimpleFilterModal = ({ type, options, onClose, onTechnicianSelected }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const currentSelected = selectedFilterItems[type] || [];
    const scrollContainerRef = useRef(null);
    // Usar um objeto global para persistir entre remontagens do componente
    const scrollStateKey = `filter-scroll-${type}`;
    if (!window[scrollStateKey]) {
      window[scrollStateKey] = { savedPosition: null, shouldRestore: false };
    }
    const scrollState = window[scrollStateKey];
    
    const filteredOptions = options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const isSelected = (item) => currentSelected.includes(item);

    // Verificar se o usuário é coordenador e se estamos no filtro de coordenador
    const isUserCoordinator = currentUser?.coordinator;
    const isCoordinatorFilter = type === 'coordenador';
    const userCoordinatorName = currentUser?.name || currentUser?.username;
    const selectableFilteredOptions = filteredOptions.filter((option) => {
      if (!(isUserCoordinator && isCoordinatorFilter)) return true;
      return option === userCoordinatorName;
    });
    const allSelectableMarked =
      selectableFilteredOptions.length > 0 &&
      selectableFilteredOptions.every((option) => currentSelected.includes(option));

    // Preservar scroll durante atualizações
    useLayoutEffect(() => {
      const container = scrollContainerRef.current;
      if (!container || scrollState.savedPosition === null) return;
      
      const savedPos = scrollState.savedPosition;
      if (container.scrollTop !== savedPos) {
        container.scrollTop = savedPos;
      }
    });

    // Monitoramento persistente para restaurar scroll quando resetado
    useEffect(() => {
      if (!scrollContainerRef.current || type !== 'tecnico') return;
      
      const container = scrollContainerRef.current;
      let isUserScrolling = false;
      let scrollTimeout = null;
      
      // Detectar quando usuário está fazendo scroll manual
      const handleScroll = () => {
        isUserScrolling = true;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          isUserScrolling = false;
        }, 150);
      };
      
      container.addEventListener('scroll', handleScroll, { passive: true });
      
      // Monitorar e restaurar scroll quando necessário
      const restoreInterval = setInterval(() => {
        if (!scrollState.shouldRestore || scrollState.savedPosition === null) {
          return;
        }
        
        const savedPos = scrollState.savedPosition;
        const currentScroll = container.scrollTop;
        
        // Se não é scroll do usuário e o scroll foi resetado
        if (!isUserScrolling && currentScroll === 0 && savedPos > 0) {
          container.scrollTop = savedPos;
        } else if (!isUserScrolling && Math.abs(currentScroll - savedPos) > 10) {
          container.scrollTop = savedPos;
        }
      }, 10);
      
      // Limpar estado após 500ms de estabilidade
      const cleanupTimeout = setTimeout(() => {
        if (scrollState.shouldRestore) {
          scrollState.shouldRestore = false;
          scrollState.savedPosition = null;
        }
      }, 500);
      
      return () => {
        container.removeEventListener('scroll', handleScroll);
        clearInterval(restoreInterval);
        clearTimeout(cleanupTimeout);
        clearTimeout(scrollTimeout);
      };
    }, [type, currentSelected]);

    const toggleItem = (item) => {
      // Salvar posição do scroll antes de atualizar o estado
      if (scrollContainerRef.current) {
        const currentScroll = scrollContainerRef.current.scrollTop;
        scrollState.savedPosition = currentScroll;
        scrollState.shouldRestore = true;
      }
      
      // Se o usuário é coordenador e estamos no filtro de coordenador
      if (isUserCoordinator && isCoordinatorFilter) {
        // Coordenador só pode selecionar/desmarcar a si mesmo
        if (item !== (currentUser.name || currentUser.username)) {
          return;
        }
      }
      
      const newSelection = isSelected(item)
        ? currentSelected.filter(i => i !== item)
        : [...currentSelected, item];
      const isAdding = type === 'tecnico' && !isSelected(item);
      if (isAdding && typeof onTechnicianSelected === 'function') {
        onTechnicianSelected(item, true);
      }
      // Aplicar filtros automáticos baseados na seleção
      const updatedFilters = applyAutomaticFilters(type, newSelection);
      
      const finalUpdate = {
        ...selectedFilterItems,
        [type]: newSelection,
        ...updatedFilters
      };
      
      setSelectedFilterItems(finalUpdate);
    };

    const toggleMarkAll = () => {
      const selectableSet = new Set(selectableFilteredOptions);
      const nextSelection = allSelectableMarked
        ? currentSelected.filter((item) => !selectableSet.has(item))
        : Array.from(new Set([...currentSelected, ...selectableFilteredOptions]));
      const updatedFilters = applyAutomaticFilters(type, nextSelection);
      const finalUpdate = {
        ...selectedFilterItems,
        [type]: nextSelection,
        ...updatedFilters,
      };
      setSelectedFilterItems(finalUpdate);
    };

    return (
      <div className="filter-modal filter-modal--main">
        <div className={`filter-modal-content ${type === 'tecnico' ? 'technician-filter' : ''}`}>
          {isUserCoordinator && isCoordinatorFilter && (
            <div className="filter-modal-coord-msg">
              <strong>👨‍💼 Modo Coordenador:</strong> Você só pode selecionar a si mesmo neste filtro.
            </div>
          )}
          <div className="filter-search">
            <input
              type="text"
              placeholder={`Pesquisar ${type}...`}
              className="filter-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div
            ref={scrollContainerRef}
            className={`filter-options ${type === 'tecnico' ? 'technician-filter' : ''}`}
          >
            <button
              type="button"
              className={`filter-option-row filter-option-row--toggle-all${allSelectableMarked ? ' is-selected' : ''}`}
              disabled={selectableFilteredOptions.length === 0}
              onMouseDown={(e) => {
                e.preventDefault();
                if (selectableFilteredOptions.length > 0) toggleMarkAll();
              }}
            >
              <span className="filter-option-row-check" aria-hidden>
                {allSelectableMarked ? '✔' : ''}
              </span>
              <span className="filter-option-row-label">
                {allSelectableMarked ? 'Desmarcar todos' : 'Marcar todos'}
              </span>
            </button>
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => {
                const isDisabled = isUserCoordinator && isCoordinatorFilter &&
                                 option !== userCoordinatorName;
                const selected = isSelected(option);
                return (
                  <button
                    key={option}
                    type="button"
                    className={`filter-option-row${selected ? ' is-selected' : ''}${isDisabled ? ' is-disabled' : ''}`}
                    disabled={isDisabled}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      if (!isDisabled) toggleItem(option);
                    }}
                  >
                    <span className={`filter-option-row-check${selected ? ' is-selected' : ''}`} aria-hidden>
                      {selected ? '●' : ''}
                    </span>
                    <span className="filter-option-row-label" title={option}>
                      {option}
                      {isDisabled ? ' (Não disponível para coordenadores)' : ''}
                    </span>
                  </button>
                );
              })
            ) : (
              <div className="filter-no-results">
                {options.length === 0 ? `Nenhum ${type} disponível` : 'Nenhum resultado encontrado'}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };



  // Função para obter opções de filtros interligados (estrutura hierárquica completa) - memoizada
  const getFilterOptions = React.useCallback((type) => {
    switch(type) {
      case 'coordenador':
        // Mostrar apenas coordenadores que têm áreas vinculadas (com técnicos)
        const coordenadoresComAreas = teamData.coordenadores.filter(coord => {
          // Verificar se este coordenador tem áreas vinculadas
          const areasDoCoord = teamData.areas.filter(area => area.coordenadorId === coord.id);
          
          // Verificar se pelo menos uma área tem técnicos vinculados
          const temTecnicosVinculados = areasDoCoord.some(area => 
            teamData.tecnicos.some(tec => tec.areaId === area.id)
          );
          
          return areasDoCoord.length > 0 && temTecnicosVinculados;
        });
        
        const coordOptions = coordenadoresComAreas.map(coord => coord.nome);
        return coordOptions;
      
      case 'area':
        // Se há coordenador selecionado, mostrar apenas suas áreas que têm técnicos
        if (selectedFilterItems.coordenador.length > 0) {
          const coordenadorNomes = selectedFilterItems.coordenador;
          const coordenadorIds = teamData.coordenadores
            .filter(coord => coordenadorNomes.includes(coord.nome))
            .map(coord => coord.id);
          
          const areaOptions = teamData.areas
            .filter(area => {
              // Área deve pertencer ao coordenador selecionado
              const pertenceAoCoord = coordenadorIds.includes(area.coordenadorId);
              // Área deve ter pelo menos um técnico vinculado
              const temTecnicos = teamData.tecnicos.some(tec => tec.areaId === area.id);
              return pertenceAoCoord && temTecnicos;
            })
            .map(area => area.nome);
          return areaOptions;
        }
        
        // Se há técnico selecionado, mostrar apenas a área do técnico
        if (selectedFilterItems.tecnico.length > 0) {
          const tecnicoNomes = selectedFilterItems.tecnico;
          const tecnicoIds = teamData.tecnicos
            .filter(tec => tecnicoNomes.includes(tec.nome))
            .map(tec => tec.id);
          
          const areaIds = teamData.tecnicos
            .filter(tec => tecnicoIds.includes(tec.id) && tec.areaId)
            .map(tec => tec.areaId);
          
          const areaOptions = teamData.areas
            .filter(area => areaIds.includes(area.id) && area.coordenadorId)
            .map(area => area.nome);
          return areaOptions;
        }
        
        // Caso contrário, mostrar apenas áreas que têm coordenador E técnicos
        const allAreaOptions = teamData.areas
          .filter(area => {
            // Área deve ter coordenador vinculado
            const temCoord = area.coordenadorId;
            // Área deve ter pelo menos um técnico vinculado
            const temTecnicos = teamData.tecnicos.some(tec => tec.areaId === area.id);
            return temCoord && temTecnicos;
          })
                      .map(area => area.nome);
        return allAreaOptions;
      
      case 'tecnico':
        // Se há coordenador selecionado, mostrar técnicos das áreas do coordenador
        if (selectedFilterItems.coordenador.length > 0) {
          const coordenadorNomes = selectedFilterItems.coordenador;
          const coordenadorIds = teamData.coordenadores
            .filter(coord => coordenadorNomes.includes(coord.nome))
            .map(coord => coord.id);
          
          const areaIds = teamData.areas
            .filter(area => coordenadorIds.includes(area.coordenadorId))
            .map(area => area.id);
          
          let tecnicoOptions = teamData.tecnicos
            .filter(tec => areaIds.includes(tec.areaId))
            .map(tec => tec.nome);
          
          // Adicionar técnicos com ordens mas não cadastrados (usando nomes reais)
          // IMPORTANTE: Só adicionar se o técnico pertencer ao coordenador selecionado
          const technicianCacheKeys = Object.keys(technicianDataCache);
          technicianCacheKeys.forEach(techName => {
            if (!tecnicoOptions.includes(techName) && technicianDataCache[techName]) {
              const hasOrders = Object.values(technicianDataCache[techName]).some(group => group.length > 0);
              if (hasOrders) {
                // Verificar se o técnico pertence ao coordenador através do mapeamento
                const technicianId = technicianNameToIdMap[techName];
                if (technicianId) {
                  // Verificar se o técnico está vinculado a alguma área do coordenador
                  const belongsToCoordinator = teamData.tecnicos.some(tec => 
                    tec.id === technicianId && areaIds.includes(tec.areaId)
                  );
                  
                  if (belongsToCoordinator) {
                    tecnicoOptions.push(techName);
                  }
                }
              }
            }
          });
          
          return tecnicoOptions;
        }
        
        // Se há área selecionada, mostrar técnicos da área
        if (selectedFilterItems.area.length > 0) {
          console.log('🎯 getFilterOptions(tecnico): Área selecionada, filtrando técnicos');
          const areaNomes = selectedFilterItems.area;
          console.log('🔍 Áreas selecionadas:', areaNomes);
          const areaIds = teamData.areas
            .filter(area => areaNomes.includes(area.nome))
            .map(area => area.id);
          console.log('🔍 IDs das áreas:', areaIds);
          
          let tecnicoOptions = teamData.tecnicos
            .filter(tec => areaIds.includes(tec.areaId))
            .map(tec => tec.nome);
          console.log('🔍 Técnicos das áreas:', tecnicoOptions);
          
          // Adicionar técnicos com ordens mas não cadastrados (usando nomes reais)
          // IMPORTANTE: Só adicionar se o técnico pertencer à área selecionada
          const technicianCacheKeys = Object.keys(technicianDataCache);
          technicianCacheKeys.forEach(techName => {
            if (!tecnicoOptions.includes(techName) && technicianDataCache[techName]) {
              const hasOrders = Object.values(technicianDataCache[techName]).some(group => group.length > 0);
              if (hasOrders) {
                // Verificar se o técnico pertence à área através do mapeamento
                const technicianId = technicianNameToIdMap[techName];
                if (technicianId) {
                  // Verificar se o técnico está vinculado a alguma área selecionada
                  const belongsToArea = teamData.tecnicos.some(tec => 
                    tec.id === technicianId && areaIds.includes(tec.areaId)
                  );
                  
                  if (belongsToArea) {
                    console.log(`➕ Adicionando técnico "${techName}" aos filtros da área (pertence à área)`);
                    tecnicoOptions.push(techName);
                  } else {
                    console.log(`❌ Técnico "${techName}" tem ordens mas não pertence à área selecionada`);
                  }
                } else {
                  console.log(`❌ Técnico "${techName}" não tem ID mapeado, não pode verificar vinculação`);
                }
              }
            }
          });
          
          console.log('🔍 Resultado final tecnicoOptions para área:', tecnicoOptions);
          return tecnicoOptions;
        }
        
                // Caso contrário, mostrar apenas técnicos com estrutura hierárquica completa
        let allTecnicoOptions = teamData.tecnicos
          .filter(tec => {
            // Técnico deve ter área vinculada
            if (!tec.areaId) return false;
            
            // A área do técnico deve ter coordenador vinculado
            const areaDoTecnico = teamData.areas.find(area => area.id === tec.areaId);
            return areaDoTecnico && areaDoTecnico.coordenadorId;
          })
          .map(tec => tec.nome);
        
        // NOVIDADE: Adicionar técnicos que têm ordens mas não estão cadastrados (usando nomes reais)
        // IMPORTANTE: Só adicionar se tiver estrutura hierárquica completa
        const technicianCacheKeys = Object.keys(technicianDataCache);
        technicianCacheKeys.forEach(techName => {
          // Se o técnico não está na lista de cadastrados, mas tem dados em cache
          if (!allTecnicoOptions.includes(techName) && technicianDataCache[techName]) {
            // Verificar se o técnico realmente tem ordens
            const hasOrders = Object.values(technicianDataCache[techName]).some(group => group.length > 0);
            if (hasOrders) {
              // Verificar se o técnico tem estrutura hierárquica completa através do mapeamento
              const technicianId = technicianNameToIdMap[techName];
              if (technicianId) {
                // Verificar se o técnico está vinculado a uma área com coordenador
                const hasCompleteHierarchy = teamData.tecnicos.some(tec => {
                  if (tec.id === technicianId && tec.areaId) {
                    const areaDoTecnico = teamData.areas.find(area => area.id === tec.areaId);
                    return areaDoTecnico && areaDoTecnico.coordenadorId;
                  }
                  return false;
                });
                
                if (hasCompleteHierarchy) {
                  allTecnicoOptions.push(techName);
                } else {
                }
              } else {
                console.log(`❌ Técnico "${techName}" não tem ID mapeado, não pode verificar hierarquia`);
              }
            }
          }
        });
        
        return allTecnicoOptions;
      
      default:
        return [];
    }
  }, [selectedFilterItems.coordenador, selectedFilterItems.area, selectedFilterItems.tecnico, teamData, technicianDataCache, technicianNameToIdMap]);

  // Função para verificar se uma ordem corresponde ao termo de busca
  const orderMatchesSearch = (order, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') return true;
    
    const term = searchTerm.toLowerCase().trim();
    
    // Campos para buscar na ordem
    const searchFields = [
      order.id || '',
      order.TB02115_OS || '',
      order.cliente || order.TB01008_NOME || '',
      order.TB02115_BAIRRO || '',
      order.TB02115_EQUIPAMENTO || order.TB01010_RESUMIDO || order.TB01010_NOME || '',
      order.TB02115_SERIE || '',
      order.TB02115_PATRIMONIO || '',
      // Adicionar número de série (TB02115_NUMSERIE) e patrimônio (TB02112_PAT)
      order.TB02115_NUMSERIE || order.numeroSerie || '',
      order.TB02112_PAT || order.patrimonio || '',
      order.TB02115_MOTIVO || '',
      order.tipo || getServiceTypeFromPreventiva(order.TB02115_PREVENTIVA) || '',
      order.sla || ''
    ];
    
    return searchFields.some(field => 
      field.toString().toLowerCase().includes(term)
    );
  };

  // Função para filtrar ordens por busca (aplicável tanto para "Em Aberto" quanto para técnicos)
  const filterOrdersBySearch = (orders, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') return orders;
    
    return orders.filter(order => orderMatchesSearch(order, searchTerm));
  };

  const boardCondtMatcher = React.useCallback(
    (ordem) => {
      if (slaFiltrarConfig?.deadlineMs != null && !isOrderWithinSlaFiltrarDeadline(ordem, slaFiltrarConfig.deadlineMs)) {
        return false;
      }
      return orderMatchesSearch(ordem, searchTerm);
    },
    [searchTerm, slaFiltrarConfig]
  );


  const getFilteredOrders = React.useMemo(() => {
    
    const filtered = availableOrdersState
      .filter(item => item.cidade && item.cidade.trim() !== '') // Garantir que tem cidade
      .map(item => ({
        ...item,
        ordens: item.ordens.filter((ordem) => {
          if (!orderMatchesSearch(ordem, searchTerm)) return false;
          if (boardAllowedTipoLetters) {
            return orderMatchesUserOsTypeRestriction(
              ordem,
              boardAllowedTipoLetters,
              getServiceTypeFromPreventiva
            );
          }
          return true;
        })
      }))
      .filter(item => item.ordens.length > 0);
    
    return filtered;
  }, [availableOrdersState, searchTerm, boardAllowedTipoLetters]);

  const getGroupedByCity = React.useMemo(() => {
    const filtered = getFilteredOrders;
    let result = [];
    
    // Se os dados vêm da API, usar a ordenação que já vem do backend
    if (dataSource === 'sql_server' && filtered.length > 0) {
      result = filtered.map(item => ({
        cidade: item.cidade,
        ordens: reuseBoardOrders(item.ordens, mapOrderToLegacyFormat)
      }));
    } else {
      // Caso contrário, usar agrupamento local (dados mock)
      const grouped = {};
      
      filtered.forEach(item => {
        if (item.cidade && item.cidade.trim() !== '') {
          if (!grouped[item.cidade]) {
            grouped[item.cidade] = [];
          }
          const mappedOrders = reuseBoardOrders(item.ordens, mapOrderToLegacyFormat);
          grouped[item.cidade].push(...mappedOrders);
        }
      });

      // Para dados mock, ordenar alfabeticamente
      result = Object.keys(grouped)
        .sort()
        .map(cidade => ({
          cidade,
          ordens: grouped[cidade]
        }));
    }

    // Aplicar filtros da coluna Em Aberto (retorno: 1ª regra TB02115_STATUS, 2ª regra os_request_status)
    if (selectedColumnFilters.retorno === 'sim' && codstatusRetornoEmAberto !== '') {
      const ref = String(codstatusRetornoEmAberto).trim();
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const byStatus = String(ordem.TB02115_STATUS || '').trim() === ref;
          const byRequestStatus = String(ordem.os_request_status || ordem.OS_REQUEST_STATUS || '').trim() === ref;
          return byStatus || byRequestStatus;
        })
      })).filter(group => group.ordens.length > 0);
    } else if (selectedColumnFilters.retorno === 'nao') {
      const ref = String(codstatusRetornoEmAberto).trim();
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const byStatus = String(ordem.TB02115_STATUS || '').trim() === ref;
          const byRequestStatus = String(ordem.os_request_status || ordem.OS_REQUEST_STATUS || '').trim() === ref;
          return !byStatus && !byRequestStatus;
        })
      })).filter(group => group.ordens.length > 0);
    }

    if (selectedColumnFilters.cidade.length > 0) {
      result = result.filter(group => 
        selectedColumnFilters.cidade.includes(group.cidade)
      );
    }

    // Aplicar filtros por bairro
    if (selectedColumnFilters.bairro.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const bairro = ordem.TB02115_BAIRRO || '';
          return selectedColumnFilters.bairro.includes(bairro);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    // Aplicar filtros por cliente
    if (selectedColumnFilters.cliente.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
          return selectedColumnFilters.cliente.includes(cliente);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    // Aplicar filtros por tipo de OS
    if (selectedColumnFilters.tipoOS.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem =>
          orderMatchesTipoOSFilter(ordem, selectedColumnFilters.tipoOS, getServiceTypeFromPreventiva)
        )
      })).filter(group => group.ordens.length > 0);
    }

    // Aplicar filtros por SLA
    if (selectedColumnFilters.sla.length > 0) {
      const normalizedSelectedSLAs = selectedColumnFilters.sla.map(normalizeSlaForFilter);
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const sla = normalizeSlaForFilter(ordem.sla || 'Em dia');
          return normalizedSelectedSLAs.includes(sla);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    // Aplicar filtros por equipamento
    if (selectedColumnFilters.equipamento.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
          return selectedColumnFilters.equipamento.includes(equipamento);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    // Aplicar filtros por status
    if (selectedColumnFilters.status.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const status = ordem.TB01073_NOME || '';
          return selectedColumnFilters.status.includes(status);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    // Aplicar filtros por técnico inicial
    if (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length > 0) {
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter(ordem => {
          const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
          return selectedColumnFilters.tecnicoInicial.includes(tecnicoInicial);
        })
      })).filter(group => group.ordens.length > 0); // Remover grupos sem ordens
    }

    const normDef = (v) => String(v ?? '').trim();
    if (selectedColumnFilters.defeitoDescricao.length > 0) {
      result = result
        .map((group) => ({
          ...group,
          ordens: group.ordens.filter((ordem) =>
            selectedColumnFilters.defeitoDescricao.includes(normDef(ordem.defeito_descricao))
          ),
        }))
        .filter((group) => group.ordens.length > 0);
    }
    if (selectedColumnFilters.defeitoAlert.length > 0) {
      result = result
        .map((group) => ({
          ...group,
          ordens: group.ordens.filter((ordem) =>
            selectedColumnFilters.defeitoAlert.includes(normDef(ordem.defeito_alert))
          ),
        }))
        .filter((group) => group.ordens.length > 0);
    }
    if (selectedColumnFilters.defeitoClassification.length > 0) {
      result = result
        .map((group) => ({
          ...group,
          ordens: group.ordens.filter((ordem) =>
            selectedColumnFilters.defeitoClassification.includes(normDef(ordem.defeito_classification))
          ),
        }))
        .filter((group) => group.ordens.length > 0);
    }
    if (selectedColumnFilters.defeitoSeverity.length > 0) {
      result = result
        .map((group) => ({
          ...group,
          ordens: group.ordens.filter((ordem) =>
            selectedColumnFilters.defeitoSeverity.includes(normDef(ordem.defeito_severity_level))
          ),
        }))
        .filter((group) => group.ordens.length > 0);
    }

    if (slaFiltrarConfig?.deadlineMs != null) {
      const d = slaFiltrarConfig.deadlineMs;
      result = result.map(group => ({
        ...group,
        ordens: group.ordens.filter((o) => isOrderWithinSlaFiltrarDeadline(o, d))
      })).filter(group => group.ordens.length > 0);
    }

    return result;
  }, [getFilteredOrders, dataSource, selectedColumnFilters, codstatusRetornoEmAberto, slaFiltrarConfig]);

  const [osStatusInicialCustomers, setOsStatusInicialCustomers] = useState('');
  useEffect(() => {
    const enabled =
      currentUser &&
      String(currentUser.type) === '1' &&
      Number(currentUser.verve_customers_module) === 1;
    if (!enabled) {
      setOsStatusInicialCustomers('');
      return undefined;
    }
    let cancelled = false;
    fetchOsStatusInicial().then((cod) => {
      if (!cancelled && cod != null) setOsStatusInicialCustomers(cod);
    });
    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  /** Poll Em aberto (Customers / Novos chamados): só Board + módulo customers, sem full refresh. */
  const customersOpenOrdersPollPauseRef = React.useRef(false);
  customersOpenOrdersPollPauseRef.current =
    Boolean(isRefreshingRef.current) ||
    isRefreshing ||
    isAutoRefreshing ||
    isRefreshingOpenColumn ||
    isInitialLoading ||
    Boolean(showRouteModal) ||
    Object.values(showTodayRouteModal || {}).some(Boolean);

  const customersOpenOrdersPollEnabled = Boolean(
    isAuthenticated &&
      currentUser &&
      String(currentUser.type) === '1' &&
      Number(currentUser.verve_customers_module) === 1 &&
      Number(currentUser.customers_chat_only) !== 1 &&
      Number(currentUser.customers_users_reg_only) !== 1 &&
      activeSection === 'Board' &&
      !APP_FULL_PAGE_ROUTES.includes(location.pathname)
  );

  const handleCustomersOpenOrdersPoll = React.useCallback((data, nextDataSource) => {
    if (!Array.isArray(data)) return;
    setApiData(data);
    if (nextDataSource != null) setDataSource(nextDataSource);
    setAvailableOrdersState(data);
  }, []);

  useCustomersOpenOrdersPoll({
    enabled: customersOpenOrdersPollEnabled,
    openOrderGroups: availableOrdersState,
    onOpenOrdersChange: handleCustomersOpenOrdersPoll,
    pauseRef: customersOpenOrdersPollPauseRef,
  });

  const openColumnOrderCount = React.useMemo(
    () => getGroupedByCity.reduce((total, group) => total + group.ordens.length, 0),
    [getGroupedByCity]
  );

  const openColumnCustomersCount = React.useMemo(
    () => countOpenOrdersByStatus(getGroupedByCity, osStatusInicialCustomers),
    [getGroupedByCity, osStatusInicialCustomers]
  );

  const getAllTechniques = () => {
    // Retorna lista vazia - técnicos agora vêm dos dados reais do banco
    return [];
  };

  // Função para verificar se há filtros ativos (coordenador, área ou técnico) - memoizada
  // Colunas de técnico só com filtro de equipe ativo — não inverter por performance
  const hasActiveTeamFilters = React.useMemo(() => {
    return selectedFilterItems.coordenador.length > 0 || 
           selectedFilterItems.area.length > 0 || 
           selectedFilterItems.tecnico.length > 0;
  }, [selectedFilterItems.coordenador, selectedFilterItems.area, selectedFilterItems.tecnico]);

  const getFilteredTechnicians = React.useMemo(() => {
    if (!hasActiveTeamFilters) return [];
    return getVisibleBoardTechnicianNames(selectedFilterItems, teamData);
  }, [hasActiveTeamFilters, selectedFilterItems, teamData]);

  // Alias para manter compatibilidade
  const getVisibleTechniques = getFilteredTechnicians;

  // Função OTIMIZADA para carregar dados dos técnicos com carregamento inteligente
  const loadTechnicianData = async (technicianName) => {
    try {
      // Verificar se já temos dados em cache
      if (technicianDataCache[technicianName]) {
        console.log(`⚡ Usando dados em cache para técnico "${technicianName}"`);
        return technicianDataCache[technicianName];
      }
      
      // Converter nome para ID antes da chamada da API
      const technicianId = technicianName ? getTechnicianIdByName(technicianName) : null;
      
      if (!technicianId) {
        console.warn(`⚠️ Técnico "${technicianName}" não tem ID válido, usando dados vazios`);
        const defaultData = {
          'Em deslocamento': [],
          'Em serviço': [],
          'Previsto para hoje': [],
          'Previstas para amanhã': [],
          'FUTURA': []
        };
        
        // Salvar dados vazios no cache
        setTechnicianDataCache(prev => ({
          ...prev,
          [technicianName]: defaultData
        }));
        
        return defaultData;
      }
      
      console.log(`🔄 Carregamento sob demanda para técnico "${technicianName}" (ID: ${technicianId})`);
      
      // Primeiro verificar se este técnico tem ordens de serviço
      const token = localStorage.getItem('authToken');
      const availableResponse = await fetch(`${API_BASE_URL}/api/orders/technicians/available`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const availableResult = await availableResponse.json();
      
      if (availableResult.success) {
        const technicianHasOrders = availableResult.data.some(t => t.technicianId === technicianId);
        
        if (!technicianHasOrders) {
          console.log(`💡 Técnico "${technicianName}" não possui ordens de serviço, usando dados vazios`);
          const defaultData = {
            'Em deslocamento': [],
            'Em serviço': [],
            'Previsto para hoje': [],
            'Previstas para amanhã': [],
            'FUTURA': []
          };
          
          // Salvar dados vazios no cache
          setTechnicianDataCache(prev => ({
            ...prev,
            [technicianName]: defaultData
          }));
          
          return defaultData;
        }
      }
      
      // Carregar dados para o técnico
      const url = `${API_BASE_URL}/api/orders/technicians?technicianId=${encodeURIComponent(technicianId)}&boardRefresh=manual`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success) {
        // Salvar dados no cache
        setTechnicianDataCache(prev => ({
          ...prev,
          [technicianName]: result.data
        }));
        mergeCondtBoardDebug(result.debugCondtSync);
        
        return result.data;
      } else {
        console.error(`❌ Erro ao carregar dados do técnico "${technicianName}":`, result.message);
        const defaultData = {
          'Em deslocamento': [],
          'Em serviço': [],
          'Previsto para hoje': [],
          'Previstas para amanhã': [],
          'FUTURA': []
        };
        
        // Salvar dados vazios no cache para evitar tentativas repetidas
        setTechnicianDataCache(prev => ({
          ...prev,
          [technicianName]: defaultData
        }));
        
        return defaultData;
      }
    } catch (error) {
      console.error(`❌ Erro na requisição para técnico "${technicianName}":`, error);
      const defaultData = {
        'Em deslocamento': [],
        'Em serviço': [],
        'Previsto para hoje': [],
        'Previstas para amanhã': [],
        'FUTURA': []
      };
      
      // Salvar dados vazios no cache para evitar tentativas repetidas
      setTechnicianDataCache(prev => ({
        ...prev,
        [technicianName]: defaultData
      }));
      
      return defaultData;
    }
  };

  // Inicializar colunas de técnicos quando os filtros mudarem (com debounce)
  React.useEffect(() => {
    const visibleTechs = getVisibleTechniques;
    
    // Verificar se a lista de técnicos realmente mudou (comparando sets, não ordem)
    const lastTechsSet = new Set(lastTechniciansRef.current);
    const newTechsSet = new Set(visibleTechs);
    const techsChanged = lastTechsSet.size !== newTechsSet.size || 
                        ![...newTechsSet].every(tech => lastTechsSet.has(tech));
    
    if (techsChanged) {
      // Debounce para evitar múltiplas execuções
      const timeoutId = setTimeout(() => {
        lastTechniciansRef.current = [...visibleTechs];
        const initializeTechnicians = async () => {
          try {
            setIsLoadingTechnicianColumns(true);
            
            const newTechniqueColumns = {};
            const newTechnicianGroups = {};
            
            // Identificar quais técnicos são novos e precisam carregar dados
            const newTechnicians = [];
            const existingTechnicians = [];
            
            // Preservar ordem existente quando possível, adicionando novos técnicos no final
            // Usar columnOrder atual para preservar ordem manual
            const preservedOrder = columnOrder.filter(tech => visibleTechs.includes(tech));
            const newTechsInOrder = visibleTechs.filter(tech => !columnOrder.includes(tech));
            const finalOrder = [...preservedOrder, ...newTechsInOrder];
            
            for (const techName of finalOrder) {
              // Preservar dados existentes se o técnico já tinha uma coluna
              if (techniqueColumns[techName]) {
                newTechniqueColumns[techName] = techniqueColumns[techName];
              } else {
                newTechniqueColumns[techName] = [];
              }
              
              // Separar técnicos novos dos existentes
              if (technicianGroups[techName]) {
                const existing = technicianGroups[techName];
                const cached = technicianDataCache[techName];
                newTechnicianGroups[techName] =
                  isTechnicianBoardGroupsEmpty(existing) && !isTechnicianBoardGroupsEmpty(cached)
                    ? cached
                    : existing;
                existingTechnicians.push(techName);
              } else {
                newTechnicians.push(techName);
              }
            }
            
            // Usar dados pré-carregados (instantâneo)
            if (newTechnicians.length > 0) {
              newTechnicians.forEach(techName => {
                // Verificar se existe no cache
                if (technicianDataCache[techName]) {
                  newTechnicianGroups[techName] = technicianDataCache[techName];
                } else {
                  newTechnicianGroups[techName] = {
                    'Em deslocamento': [],
                    'Em serviço': [],
                    'Previsto para hoje': [],
                    'Previstas para amanhã': [],
                    'FUTURA': []
                  };
                }
              });
            }

            // Atualizar estados
            setTechniqueColumns(newTechniqueColumns);
            setTechnicianGroups(newTechnicianGroups);
            // Preservar ordem manual quando os técnicos são os mesmos
            setColumnOrder(prevOrder => {
              // Se a ordem atual tem os mesmos técnicos (apenas reordenados), preservar a ordem manual
              const prevSet = new Set(prevOrder);
              const newSet = new Set(finalOrder);
              const sameTechs = prevSet.size === newSet.size && 
                               [...newSet].every(tech => prevSet.has(tech));
              
              if (sameTechs && prevOrder.length > 0) {
                // Mesmos técnicos - preservar ordem manual do usuário
                return prevOrder;
              } else {
                // Técnicos mudaram - usar nova ordem
                return finalOrder;
              }
            });

            const techKeysForCounts = Object.keys(newTechnicianGroups);
            if (techKeysForCounts.length > 0) {
              void fetchAllTechnicianCounts(techKeysForCounts);
            }
            
          } finally {
            setIsLoadingTechnicianColumns(false);
          }
        };
        
        initializeTechnicians();
      }, 100); // Debounce de 100ms
      
      return () => clearTimeout(timeoutId);
    }
    // Remover columnOrder das dependências para não resetar ordem manual
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getVisibleTechniques, technicianDataCache, techniqueColumns, technicianGroups, fetchAllTechnicianCounts]);

  // Buscar defeitos quando há apenas uma coluna de técnico
  React.useEffect(() => {
    // Só buscar defeitos se houver exatamente uma coluna
    if (columnOrder.length !== 1) {
      // Limpar defeitos se não há apenas uma coluna (mas não durante o carregamento)
      if (!loadingDefeitos) {
        setDefeitosData({});
      }
      return;
    }

    const technician = columnOrder[0];
    
    // Coletar todas as ordens de todos os grupos do técnico
    const allOrders = [];
    if (technicianGroups[technician]) {
      Object.values(technicianGroups[technician]).forEach(groupOrders => {
        if (Array.isArray(groupOrders)) {
          allOrders.push(...groupOrders);
        }
      });
    }
    
    // Se não há ordens, limpar defeitos (mas não durante o carregamento)
    if (allOrders.length === 0) {
      if (!loadingDefeitos) {
        setDefeitosData({});
      }
      return;
    }

    // Função para buscar defeitos em lote
    const fetchDefeitosForOrders = async () => {
      setLoadingDefeitos(true);
      const defeitosMap = {};
      
      try {
        const token = localStorage.getItem('authToken');
        
        // Buscar defeitos para todas as ordens em paralelo
        const defeitoPromises = allOrders.map(async (ordem) => {
          // Garantir que orderNumber seja sempre string para consistência
          const orderNumber = String(ordem.TB02115_CODIGO || ordem.id || '');
          if (!orderNumber || orderNumber === 'undefined' || orderNumber === 'null') {
            console.warn('⚠️ Ordem sem número válido:', ordem);
            return null;
          }
          
          try {
            const response = await fetch(`${API_BASE_URL}/api/orders/${orderNumber}/defeito`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            const result = await response.json();
            
            if (result.success && result.data) {
              // Armazenar apenas o defeito (não precisamos de observação e solução)
              return {
                orderNumber,
                defeito: result.data.defeito || 'Não informado'
              };
            }
            return null;
          } catch (error) {
            console.error(`❌ Erro ao buscar defeito para ordem ${orderNumber}:`, error);
            return null;
          }
        });
        
        const results = await Promise.all(defeitoPromises);
        
        // Mapear resultados (apenas defeito)
        results.forEach((result) => {
          if (result) {
            defeitosMap[result.orderNumber] = {
              defeito: result.defeito
            };
          }
        });
        
        setDefeitosData(defeitosMap);
      } catch (error) {
        console.error('❌ Erro ao buscar defeitos:', error);
      } finally {
        setLoadingDefeitos(false);
      }
    };

    // Debounce para evitar múltiplas chamadas, mas garantir que execute
    const timeoutId = setTimeout(() => {
      fetchDefeitosForOrders();
    }, 100); // Reduzido para 100ms para carregar mais rápido

    return () => clearTimeout(timeoutId);
  }, [columnOrder, technicianGroups]);

  // Filtro inicial removido - agora a filtragem é feita no backend baseada nas permissões do usuário
  // React.useEffect(() => {
  //   if (!initialFilterApplied && availableOrdersState.length > 0) {
  //     setSelectedColumnFilters(prev => ({
  //       ...prev,
  //       tipoOS: ['C'] // Aplicar filtro de Corretiva (C) após dados carregarem
  //     }));
  //     setInitialFilterApplied(true);
  //   }
  // }, [availableOrdersState, initialFilterApplied]);

  /** Informativo: anexa vencimento de contrato nos resultados do OrderStatusModal. */
  React.useEffect(() => {
    if (!showOrderStatusModal) {
      orderStatusVencEnrichKeyRef.current = null;
      return undefined;
    }
    const list = Array.isArray(orderStatusResults) ? orderStatusResults : [];
    if (!list.length) return undefined;
    const key = list.map((r) => String(r?.orderId || '')).join('|');
    if (!key || orderStatusVencEnrichKeyRef.current === key) return undefined;
    if (list.every((r) => r && Object.prototype.hasOwnProperty.call(r, 'contratoVenc'))) {
      orderStatusVencEnrichKeyRef.current = key;
      return undefined;
    }
    orderStatusVencEnrichKeyRef.current = key;
    let cancelled = false;
    (async () => {
      const enriched = await enrichOrderResultsWithContratoVenc(list);
      if (cancelled) return;
      setOrderStatusResults(enriched);
    })();
    return () => {
      cancelled = true;
    };
  }, [showOrderStatusModal, orderStatusResults]);

  const closeBoardDragValidationModal = React.useCallback(() => {
    setShowBoardDragValidationModal(false);
    setBoardDragValidationMessages([]);
    setBoardDragValidationMode('alert');
    boardDragConfirmResumeRef.current = null;
  }, []);

  const openPrevistoGoSyncConfirm = React.useCallback((messages, resumeFn) => {
    const list =
      Array.isArray(messages) && messages.length
        ? messages
        : [BOARD_DRAG_MSG_PREVISTO_GO_OFFLINE];
    setBoardDragValidationMessages(list);
    setBoardDragValidationMode('confirm');
    boardDragConfirmResumeRef.current = typeof resumeFn === 'function' ? resumeFn : null;
    setShowBoardDragValidationModal(true);
  }, []);

  const attachPrevistoGoSyncAck = React.useCallback((payload) => {
    if (!payload || typeof payload !== 'object') return payload;
    if (!previstoGoSyncAckRef.current) return payload;
    previstoGoSyncAckRef.current = false;
    return { ...payload, ackPrevistoGoOffline: true };
  }, []);

  const handleDropBetweenTechnicianSections = async (technicianName, fromGroup, toGroup, orderIdsOverride) => {
    const ordersToProcess = (orderIdsOverride && orderIdsOverride.length) ? orderIdsOverride : selectedOrders;
    console.log('🔍 handleDropBetweenTechnicianSections chamado:', { technicianName, fromGroup, toGroup, selectedOrdersCount: ordersToProcess.length });
    
    // Limpar estado de drag over da coluna "Em aberto" imediatamente
    setIsDragOverOpen(false);
    
    // Não permitir drop em "Em deslocamento" / "Em serviço"
    if (isBoardLiveServiceGroup(toGroup)) {
      console.log('❌ Não é permitido arrastar para seções ativas (deslocamento/serviço)');
      return;
    }
    
    // Se não há ordens selecionadas, não fazer nada
    if (ordersToProcess.length === 0) {
      console.log('⚠️ Nenhuma ordem selecionada para arrastar');
      return;
    }

    beginDragDropProcessing(
      ordersToProcess.length,
      `Movendo ${ordersToProcess.length} ordens de "${fromGroup}" para "${toGroup}"...`
    );

    // App Go: dia iniciado + sem sync > 20 min → confirmação TO/FROM Previsto para hoje
    if (fromGroup === 'Previsto para hoje' || toGroup === 'Previsto para hoje') {
      if (!previstoGoSyncAckRef.current) {
        try {
          const gateTechId = getTechnicianIdByName(technicianName);
          const goSync = await validateBoardDragPrevistoGoSync({
            orderIds: ordersToProcess,
            targetSection: toGroup,
            technicianId: gateTechId,
          });
          if (goSync.blocked) {
            setIsDragDropProcessing(false);
            openPrevistoGoSyncConfirm(goSync.messages, () =>
              handleDropBetweenTechnicianSections(
                technicianName,
                fromGroup,
                toGroup,
                ordersToProcess
              )
            );
            return;
          }
        } catch (_goErr) {
          /* segue — backend reforça no update-status */
        }
      }
    }

    ordersToProcess.forEach((orderId) => {
      logDragDrop({
        userId: currentUser?.id,
        userName: currentUser?.name || currentUser?.username,
        tenantId: currentUser?.clientId ?? 1,
        ordemId: orderId,
        origem: technicianName,
        destino: technicianName,
        sessaoOrigem: fromGroup,
        sessaoDestino: toGroup,
        tecnicoCurrent: technicianName,
        tecnicoNovo: technicianName,
      });
    });
    // Se o destino é "FUTURA", abrir modal de seleção de data
    // Isso deve acontecer independente de onde a ordem vem (Em aberto, Previsto para hoje, Previstas para amanhã, etc.)
    if (toGroup === 'FUTURA') {
      console.log('📅 Abrindo modal de seleção de data para área FUTURA');
      console.log('🔍 toGroup recebido:', toGroup);
      console.log('🔍 fromGroup recebido:', fromGroup);
      console.log('🔍 technicianName:', technicianName);
      console.log('🔍 ordersToProcess:', ordersToProcess);
      console.log('🔍 ordersToProcess.length:', ordersToProcess.length);
      
      const technicianId = getTechnicianIdByName(technicianName);
      console.log('🔍 technicianId:', technicianId);
      
      if (ordersToProcess.length === 0) {
        console.warn('⚠️ Nenhuma ordem selecionada, não é possível abrir modal');
        setIsDragDropProcessing(false);
        return;
      }
      
      console.log('✅ Configurando modal de data com:', {
        technicianName,
        technicianId,
        orderIds: ordersToProcess,
        fromGroup
      });
      
      setFutureDateModalData({
        technicianName,
        technicianId,
        orderIds: [...ordersToProcess],
        fromGroup: fromGroup || 'Previsto para hoje' // Garantir que fromGroup sempre tenha um valor
      });
      setSelectedFutureDate(null);
      setNoDateSelected(false);
      setShowFutureDateModal(true);
      setIsDragDropProcessing(false);
      // Limpar seleção após abrir o modal
      setSelectedOrders([]);
      
      console.log('✅ Modal de data configurado, showFutureDateModal deve ser true');
      return;
    }
    
    // Ativar feedback visual imediato
    setIsDragDropProcessing(true);
    setDragDropProgress({ current: 0, total: ordersToProcess.length });
    setDragDropMessage(`Movendo ${ordersToProcess.length} ordens de "${fromGroup}" para "${toGroup}"...`);
    
    try {
      // Obter ID do técnico
      const technicianId = getTechnicianIdByName(technicianName);
      
      // Saindo de FUTURA ou inbox Liberado: remover LCMY_REG_OS_STANDBY (com ou sem data de previsão / só observações)
      if (fromGroup === 'FUTURA' || fromGroup === 'LIBERADO') {
        const token = localStorage.getItem('authToken');
        
        console.log(`🔍 Removendo standby ao sair de FUTURA - technicianName: ${technicianName}`);
        console.log(`🔍 ordersToProcess:`, ordersToProcess);
        
        const ordersToRemoveStandby = ordersToProcess;
        
        if (ordersToRemoveStandby.length > 0) {
          console.log(`🗑️ Removendo ${ordersToRemoveStandby.length} ordem(ns) de LCMY_REG_OS_STANDBY`);
          setDragDropMessage(`Removendo standby de ${ordersToRemoveStandby.length} ordem(ns)...`);
          
          const removeStandbyPromises = ordersToRemoveStandby.map(async (orderId) => {
            try {
              console.log(`🗑️ Chamando API para remover standby: os=${orderId}, id_tech=${technicianId}`);
              const response = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
                method: 'DELETE',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  os: orderId,
                  id_tech: technicianId
                })
              });
              
              const result = await response.json();
              console.log(`📋 Resposta da API para ordem ${orderId}:`, result);
              
              if (!result.success) {
                console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, result.message);
              } else {
                console.log(`✅ Standby removido para ordem ${orderId}, linhas afetadas: ${result.rowsAffected}`);
              }
              return result;
            } catch (error) {
              console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, error);
              return { success: false, error: error.message };
            }
          });
          
          await Promise.all(removeStandbyPromises);
        }
      } else {
        console.log(`ℹ️ Ordem não está saindo de FUTURA/LIBERADO (fromGroup: ${fromGroup}), não precisa remover standby`);
      }
      
      // Roteirizada em "Previsto para hoje" ou "Previstas para amanhã":
      // ao mudar entre esses grupos ou para FUTURA, limpar LCMY_REG_ROADMAP.
      const roadmapGroups = new Set(['Previsto para hoje', 'Previstas para amanhã']);
      const shouldClearRoadmap =
        roadmapGroups.has(fromGroup) &&
        fromGroup !== toGroup &&
        (roadmapGroups.has(toGroup) || toGroup === 'FUTURA');
      if (shouldClearRoadmap) {
        const token = localStorage.getItem('authToken');
        console.log(`🗑️ Removendo ordens de LCMY_REG_ROADMAP (de "${fromGroup}" para "${toGroup}")`);
        setDragDropMessage(`Removendo roteirização de ${ordersToProcess.length} ordem(ns)...`);
        
        const removeRoadmapPromises = ordersToProcess.map(async (orderId) => {
          try {
            console.log(`🗑️ Chamando API para remover roteirização: os=${orderId}`);
            const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                orderNumber: orderId
              })
            });
            
            const result = await response.json();
            console.log(`📋 Resposta da API para ordem ${orderId}:`, result);
            
            if (!result.success) {
              console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
            } else {
              console.log(`✅ Roteirização removida para ordem ${orderId}, linhas afetadas: ${result.data.rowsAffected}`);
            }
            return result;
          } catch (error) {
            console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
            return { success: false, error: error.message };
          }
        });
        
        await Promise.all(removeRoadmapPromises);
      }
      
      // Objeto que será enviado para o backend
      const requestPayload = attachPrevistoGoSyncAck({
        orderIds: ordersToProcess,
        targetSection: toGroup,
        technicianId: technicianId
      });
      
      // Atualizar progresso
      setDragDropProgress({ current: 1, total: ordersToProcess.length });
      setDragDropMessage('Atualizando status no banco de dados...');
      
      // AbortController para timeout de 60 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 segundos
      
      // Fazer chamada da API para atualizar status no banco de dados
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      const result = await response.json();
      
      // Preparar dados para o modal
      const orderResults = [];
      const matchOrderIdMap = (order, id) => String(order.id) === String(id) || String(order.TB02115_CODIGO || '') === String(id);
      const orderInfoMap = new Map();
      Object.keys(technicianGroups).forEach(tech => {
        Object.keys(technicianGroups[tech] || {}).forEach(group => {
          (technicianGroups[tech][group] || []).forEach(order => {
            const matched = ordersToProcess.some(id => matchOrderIdMap(order, id));
            if (matched) {
              orderInfoMap.set(String(order.id), { cliente: order.cliente || order.TB01008_NOME || 'N/A', tecnico: tech, targetSection: toGroup });
              if (order.TB02115_CODIGO != null) orderInfoMap.set(String(order.TB02115_CODIGO), orderInfoMap.get(String(order.id)));
            }
          });
        });
      });
      
      if (
        (response.status === 422 || !result.success) &&
        result.blocked &&
        Array.isArray(result.messages) &&
        result.messages.length > 0
      ) {
        setBoardDragValidationMessages(result.messages);
        setShowBoardDragValidationModal(true);
        return;
      }

      if (!result.success) {
        console.error('❌ Erro ao atualizar status no banco:', result.message);
        
        // Criar resultados de erro para o modal
        ordersToProcess.forEach(orderId => {
          const orderInfo = orderInfoMap.get(orderId) || {};
          orderResults.push({
            orderId: orderId,
            status: 'error',
            errorMessage: result.message,
            cliente: orderInfo.cliente || 'N/A',
            tecnico: orderInfo.tecnico || 'N/A',
            targetSection: orderInfo.targetSection || toGroup
          });
        });
        
        // Mostrar modal com erro
        setOrderStatusResults(orderResults);
        setOrderStatusSummary({
          targetSection: toGroup,
          technicianName: technicianName
        });
        setShowOrderStatusModal(true);
        return;
      }
      
      // Disparar email "Será atendida amanhã" se aplicável
      if (result.success && toGroup === 'Previstas para amanhã' && ordersToProcess.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaAmanha(t, [...ordersToProcess]);
            }
          } catch (e) { console.warn('[Email Será atendida amanhã]', e.message); }
        })();
      }
      if (result.success && toGroup === 'Previsto para hoje' && ordersToProcess.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaHoje(t, [...ordersToProcess]);
            }
          } catch (e) { console.warn('[Email Será atendida hoje]', e.message); }
        })();
      }
      
      const getOrderInfo = (id) => orderInfoMap.get(String(id)) || {};
      // Processar resultados do backend
      if (result.data && result.data.results && Array.isArray(result.data.results)) {
        result.data.results.forEach(item => {
          const orderInfo = getOrderInfo(item.orderId);
          orderResults.push({
            orderId: item.orderId,
            status: 'success',
            errorMessage: null,
            cliente: item.cliente || orderInfo.cliente || 'N/A',
            tecnico: orderInfo.tecnico || 'N/A',
            targetSection: orderInfo.targetSection || toGroup
          });
        });
      }

      // Processar erros do backend
      if (result.data && result.data.errors && Array.isArray(result.data.errors)) {
        result.data.errors.forEach(item => {
          const orderInfo = getOrderInfo(item.orderId);
          orderResults.push({
            orderId: item.orderId,
            status: 'error',
            errorMessage: item.error,
            cliente: orderInfo.cliente || 'N/A',
            tecnico: orderInfo.tecnico || 'N/A',
            targetSection: orderInfo.targetSection || toGroup
          });
        });
      }

      // Se não há resultados estruturados, criar baseado no sucesso geral (usar ordersToProcess, ex.: menu Alterar técnico)
      if (orderResults.length === 0) {
        if (result.success) {
          ordersToProcess.forEach(orderId => {
            const orderInfo = getOrderInfo(orderId);
            orderResults.push({
              orderId: orderId,
              status: 'success',
              errorMessage: null,
              cliente: orderInfo.cliente || 'N/A',
              tecnico: orderInfo.tecnico || 'N/A',
              targetSection: orderInfo.targetSection || toGroup
            });
          });
        } else {
          ordersToProcess.forEach(orderId => {
            const orderInfo = getOrderInfo(orderId);
            orderResults.push({
              orderId: orderId,
              status: 'error',
              errorMessage: result.message,
              cliente: orderInfo.cliente || 'N/A',
              tecnico: orderInfo.tecnico || 'N/A',
              targetSection: orderInfo.targetSection || toGroup
            });
          });
        }
      }

      console.log('📊 Resultados processados:', orderResults);
      console.log('📊 Total de resultados:', orderResults.length);
      
      // Mostrar modal com resultados
      setOrderStatusResults(orderResults);
      setOrderStatusSummary({
        targetSection: toGroup,
        technicianName: technicianName
      });
      setShowOrderStatusModal(true);
      
      // Se a atualização no banco foi bem-sucedida, atualizar o estado local (cópia imutável)
      const newTechnicianGroups = { ...technicianGroups };
      const matchOrderIdSection = (order, id) => {
        if (order == null) return false;
        if (typeof order === 'string' || typeof order === 'number') {
          return String(order) === String(id);
        }
        return String(order.id) === String(id) || String(order.TB02115_CODIGO || '') === String(id);
      };
      if (newTechnicianGroups[technicianName]) {
        newTechnicianGroups[technicianName] = { ...newTechnicianGroups[technicianName] };
      }

      // Encontrar e mover as ordens entre as seções
      console.log('🔍 Movendo ordens entre seções...');
      console.log('🔍 Ordens a mover:', ordersToProcess);
      console.log('🔍 De:', fromGroup, 'Para:', toGroup);

      ordersToProcess.forEach(orderId => {
        console.log(`🔍 Procurando ordem ${orderId}...`);
        let found = false;

        if (newTechnicianGroups[technicianName] && newTechnicianGroups[technicianName][fromGroup]) {
          const orderIndex = newTechnicianGroups[technicianName][fromGroup].findIndex(order => matchOrderIdSection(order, orderId));
          if (orderIndex !== -1) {
            console.log(`✅ Encontrada ordem ${orderId} na seção ${fromGroup}`);
            let orderToMove = newTechnicianGroups[technicianName][fromGroup][orderIndex];
            if (typeof orderToMove === 'string' || typeof orderToMove === 'number') {
              orderToMove = { id: String(orderToMove) };
            } else {
              orderToMove = { ...orderToMove };
            }

            newTechnicianGroups[technicianName][fromGroup] = newTechnicianGroups[technicianName][fromGroup].filter(
              order => !matchOrderIdSection(order, orderId)
            );

            if (!newTechnicianGroups[technicianName][toGroup]) {
              newTechnicianGroups[technicianName][toGroup] = [];
            }
            // Evita duplicar se a OS ainda existia no destino (legado dual)
            newTechnicianGroups[technicianName][toGroup] = newTechnicianGroups[technicianName][toGroup].filter(
              order => !matchOrderIdSection(order, orderId)
            );
            newTechnicianGroups[technicianName][toGroup].push(orderToMove);

            found = true;
          }
        }

        if (!found) {
          console.log(`⚠️ Ordem ${orderId} não encontrada na seção ${fromGroup}`);
        }
      });

      setTechnicianGroups(newTechnicianGroups);
      setSelectedOrders([]); // Clear selection after success
      
    } catch (error) {
      console.error('❌ Erro na requisição de movimentação entre seções:', error);
      
      // Verificar se é erro de timeout
      const isTimeoutError = error.name === 'AbortError' || error.message.includes('timeout');
      const errorMessage = isTimeoutError 
        ? 'Timeout na operação - a operação está demorando mais que o esperado. Tente novamente em alguns segundos.'
        : error.message;
      
      // Criar resultados de erro para o modal
      const errorResults = ordersToProcess.map(orderId => ({
        orderId,
        status: 'error',
        errorMessage: errorMessage,
        cliente: 'N/A',
        tecnico: technicianName,
        targetSection: toGroup
      }));
      
      setOrderStatusResults(errorResults);
      setOrderStatusSummary({
        targetSection: toGroup,
        technicianName: technicianName
      });
      setShowOrderStatusModal(true);
    } finally {
      // Sempre desativar o loading independente do resultado
      setIsDragDropProcessing(false);
      setDragDropProgress({ current: 0, total: 0 });
      setDragDropMessage('');
    }
  };

  // Nova função para lidar com drops entre técnicos diferentes
  const handleDropBetweenTechnicians = async (fromTechnicianName, toTechnicianName, toGroupName, orderIdsOverride) => {
    let ordersToProcess = (orderIdsOverride && orderIdsOverride.length) ? orderIdsOverride : selectedOrders;
    let specialtyRejectedForModal = [];
    // Usar refs para ter sempre o estado atual (evita closure obsoleta quando technicianGroups fica vazio após "técnicos mudaram")
    const groups = technicianGroupsRef.current ?? technicianGroups;
    const order = columnOrderRef.current ?? columnOrder;
    const resolveKey = (name) => {
      const n = normalizeTechnicianName(name);
      const fromGroups = Object.keys(groups || {}).find(k => normalizeTechnicianName(k) === n);
      if (fromGroups) return fromGroups;
      const fromColumn = (order || []).find(t => normalizeTechnicianName(t) === n);
      return fromColumn || name;
    };
    const fromKey = resolveKey(fromTechnicianName);
    const toKey = resolveKey(toTechnicianName);

    if (!groups[fromKey]) {
      console.warn('Técnico de origem não encontrado no estado. Chaves em technicianGroups:', Object.keys(groups || {}));
      setOrderStatusResults(ordersToProcess.map(orderId => ({
        orderId,
        status: 'error',
        errorMessage: 'Técnico de origem não encontrado no painel. Atualize a página (F5) e tente novamente.',
        cliente: 'N/A',
        tecnico: fromKey,
        targetSection: toGroupName
      })));
      setOrderStatusSummary({ targetSection: toGroupName, technicianName: toKey });
      setShowOrderStatusModal(true);
      return;
    }
    // Destino pode não ter coluna ainda (sem OS / filtro "só com OS") — o update local cria a estrutura.

    // Não permitir drop em "Em deslocamento" / "Em serviço"
    if (isBoardLiveServiceGroup(toGroupName)) {
      console.log('❌ Não é permitido arrastar para seções ativas (deslocamento/serviço)');
      return;
    }

    // Se não há ordens selecionadas, não fazer nada
    if (ordersToProcess.length === 0) {
      console.log('⚠️ Nenhuma ordem selecionada para arrastar');
      return;
    }

    beginDragDropProcessing(
      ordersToProcess.length,
      `Movendo ${ordersToProcess.length} ordens do técnico "${fromKey}" para "${toGroupName}" do técnico "${toKey}"...`
    );

    const toTechnicianIdForSpec = getTechnicianIdByName(toKey);
    if (toTechnicianIdForSpec) {
      try {
        const spec = await validateBoardDragSpecialty(toTechnicianIdForSpec, ordersToProcess);
        specialtyRejectedForModal = spec.rejectedOrderIds || [];
        if (Array.isArray(spec.allowedOrderIds)) {
          ordersToProcess = spec.allowedOrderIds;
        }
      } catch (_e) {
        specialtyRejectedForModal = [];
      }
    }
    if (ordersToProcess.length === 0) {
      setIsDragDropProcessing(false);
      if (specialtyRejectedForModal.length > 0) {
        setOrderStatusResults(specialtyRejectedForModal.map((orderId) => ({
          orderId,
          status: 'error',
          errorMessage: BOARD_SPECIALTY_DRAG_MSG,
          cliente: 'N/A',
          tecnico: toKey,
          targetSection: toGroupName
        })));
        setOrderStatusSummary({ targetSection: toGroupName, technicianName: toKey });
        setShowOrderStatusModal(true);
      }
      return;
    }

    let fromGroupForGoSync = 'Previsto para hoje';
    ordersToProcess.forEach((orderId) => {
      Object.keys(groups[fromKey] || {}).forEach((sectionName) => {
        const order = groups[fromKey]?.[sectionName]?.find(
          (o) => String(o.id) === String(orderId) || String(o.TB02115_CODIGO || '') === String(orderId)
        );
        if (order) fromGroupForGoSync = sectionName;
      });
    });
    if (fromGroupForGoSync === 'Previsto para hoje' || toGroupName === 'Previsto para hoje') {
      if (!previstoGoSyncAckRef.current) {
        try {
          const goSync = await validateBoardDragPrevistoGoSync({
            orderIds: ordersToProcess,
            targetSection: toGroupName,
            technicianId: toTechnicianIdForSpec,
          });
          if (goSync.blocked) {
            setIsDragDropProcessing(false);
            openPrevistoGoSyncConfirm(goSync.messages, () =>
              handleDropBetweenTechnicians(
                fromTechnicianName,
                toTechnicianName,
                toGroupName,
                ordersToProcess
              )
            );
            return;
          }
        } catch (_goErr) {
          /* segue — backend reforça no update-status */
        }
      }
    }

    ordersToProcess.forEach((orderId) => {
      let fromGroup = 'Previsto para hoje';
      Object.keys(groups[fromKey] || {}).forEach((sectionName) => {
        const order = groups[fromKey]?.[sectionName]?.find((o) => String(o.id) === String(orderId) || String(o.TB02115_CODIGO || '') === String(orderId));
        if (order) fromGroup = sectionName;
      });
      logDragDrop({
        userId: currentUser?.id,
        userName: currentUser?.name || currentUser?.username,
        tenantId: currentUser?.clientId ?? 1,
        ordemId: orderId,
        origem: fromKey,
        destino: toKey,
        sessaoOrigem: fromGroup,
        sessaoDestino: toGroupName,
        tecnicoCurrent: fromKey,
        tecnicoNovo: toKey,
      });
    });
    // Se o destino é "FUTURA", abrir modal de seleção de data
    // Isso deve acontecer independente de onde a ordem vem (outro técnico, Em aberto, etc.)
    if (toGroupName === 'FUTURA' || toGroupName === 'Futura') {
      const toTechnicianId = getTechnicianIdByName(toKey);
      const fromTechnicianId = getTechnicianIdByName(fromKey);
      
      if (ordersToProcess.length === 0) {
        console.warn('⚠️ Nenhuma ordem selecionada, não é possível abrir modal');
        setIsDragDropProcessing(false);
        return;
      }
      
      // Determinar o fromGroup baseado na origem
      // Se a ordem vem de outro técnico, precisamos descobrir de qual seção
      let fromGroup = 'Previsto para hoje'; // Valor padrão
      
      // Tentar descobrir de qual seção a ordem vem
      ordersToProcess.forEach(orderId => {
        Object.keys(groups[fromKey] || {}).forEach(sectionName => {
          const order = groups[fromKey]?.[sectionName]?.find(o => String(o.id) === String(orderId) || String(o.TB02115_CODIGO || '') === String(orderId));
          if (order) {
            fromGroup = sectionName;
          }
        });
      });

      setFutureDateModalData({
        technicianName: toKey,
        technicianId: toTechnicianId,
        orderIds: [...ordersToProcess],
        fromGroup: fromGroup || 'Previsto para hoje',
        fromTechnicianName: fromKey
      });
      setSelectedFutureDate(null);
      setNoDateSelected(false);
      setShowFutureDateModal(true);
      setIsDragDropProcessing(false);
      // Limpar seleção após abrir o modal
      setSelectedOrders([]);
      
      return;
    }
    
    // Ativar feedback visual imediato
    setIsDragDropProcessing(true);
    setDragDropProgress({ current: 0, total: ordersToProcess.length });
    setDragDropMessage(`Movendo ${ordersToProcess.length} ordens do técnico "${fromKey}" para "${toGroupName}" do técnico "${toKey}"...`);
    
    try {
      // Obter ID do técnico de destino e origem (usando chaves resolvidas)
      const toTechnicianId = getTechnicianIdByName(toKey);
      const fromTechnicianId = getTechnicianIdByName(fromKey);
      // Quando move para outro técnico, deletar da LCMY_REG_ROADMAP
      const token = localStorage.getItem('authToken');
      setDragDropMessage(`Removendo roteirização de ${ordersToProcess.length} ordem(ns)...`);
      
      const removeRoadmapPromises = ordersToProcess.map(async (orderId) => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              orderNumber: orderId
            })
          });
          
          const result = await response.json();
          
          if (!result.success) {
            console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
          }
          return result;
        } catch (error) {
          console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
          return { success: false, error: error.message };
        }
      });
      
      await Promise.all(removeRoadmapPromises);
      
      // Saindo de FUTURA (outro técnico): remover standby com ou sem previsão
      const matchOrderIdStandby = (o, id) => String(o.id) === String(id) || String(o.TB02115_CODIGO || '') === String(id);
      const ordersLeavingFuturaStandby = ordersToProcess.filter(orderId => {
        const order = groups[fromKey]?.['FUTURA']?.find(o => matchOrderIdStandby(o, orderId));
        return !!order;
      });
      
      if (ordersLeavingFuturaStandby.length > 0) {
        setDragDropMessage(`Removendo standby de ${ordersLeavingFuturaStandby.length} ordem(ns)...`);
        
        const removeStandbyPromises = ordersLeavingFuturaStandby.map(async (orderId) => {
          try {
            const response = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                os: orderId,
                id_tech: fromTechnicianId
              })
            });
            
            const result = await response.json();
            
            if (!result.success) {
              console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, result.message);
            }
            return result;
          } catch (error) {
            console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, error);
            return { success: false, error: error.message };
          }
        });
        
        await Promise.all(removeStandbyPromises);
      }
      
      // Objeto que será enviado para o backend
      const requestPayload = attachPrevistoGoSyncAck({
        orderIds: ordersToProcess,
        targetSection: toGroupName,
        technicianId: toTechnicianId
      });
      
      // Atualizar progresso
      setDragDropProgress({ current: 1, total: ordersToProcess.length });
      setDragDropMessage('Atualizando status no banco de dados...');
      
      // AbortController para timeout de 60 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 segundos
      
      // Fazer chamada da API para atualizar status no banco de dados
      const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      const result = await response.json();
      
      // Preparar dados para o modal
      const orderResults = [];
      
      if (
        (response.status === 422 || !result.success) &&
        result.blocked &&
        Array.isArray(result.messages) &&
        result.messages.length > 0
      ) {
        setBoardDragValidationMessages(result.messages);
        setShowBoardDragValidationModal(true);
        return;
      }

      if (!result.success) {
        console.error('❌ Erro ao atualizar status no banco:', result.message);
        const matchOrderIdErr = (order, id) => String(order.id) === String(id) || String(order.TB02115_CODIGO || '') === String(id);
        // Buscar dados das ordens para o modal de erro
        ordersToProcess.forEach(orderId => {
          let orderData = { orderId, status: 'error', errorMessage: result.message };
          Object.keys(groups || {}).forEach(techName => {
            Object.keys(groups[techName] || {}).forEach(groupName => {
              (groups[techName][groupName] || []).forEach(ordem => {
                if (matchOrderIdErr(ordem, orderId)) {
                  orderData.cliente = ordem.cliente || ordem.TB01008_NOME;
                }
              });
            });
          });
          orderResults.push(orderData);
        });

        // Mostrar modal com erro
        setOrderStatusResults(orderResults);
        setOrderStatusSummary({
          targetSection: toGroupName,
          technicianName: toKey
        });
        setShowOrderStatusModal(true);
        return;
      }

      // Disparar email "Será atendida amanhã" se aplicável
      if (result.success && toGroupName === 'Previstas para amanhã' && ordersToProcess.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaAmanha(t, [...ordersToProcess]);
            }
          } catch (e) { console.warn('[Email Será atendida amanhã]', e.message); }
        })();
      }
      if (result.success && toGroupName === 'Previsto para hoje' && ordersToProcess.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaHoje(t, [...ordersToProcess]);
            }
          } catch (e) { console.warn('[Email Será atendida hoje]', e.message); }
        })();
      }
      
      // Atualizar estado local - remover das seções do técnico origem e adicionar ao técnico destino (cópia imutável; usar groups do ref)
      const newTechnicianGroups = { ...groups };
      const ordersToMove = [];
      const matchOrderId = (order, id) => String(order.id) === String(id) || String(order.TB02115_CODIGO || '') === String(id);

      // Copiar objetos dos técnicos que serão alterados para não mutar o state (usar chaves resolvidas)
      if (newTechnicianGroups[fromKey]) {
        newTechnicianGroups[fromKey] = { ...newTechnicianGroups[fromKey] };
      }
      if (newTechnicianGroups[toKey]) {
        newTechnicianGroups[toKey] = { ...newTechnicianGroups[toKey] };
      } else {
        newTechnicianGroups[toKey] = createEmptyTechnicianBoardGroups();
      }

      // Encontrar e remover ordens do técnico de origem
      ordersToProcess.forEach(orderId => {
        let found = false;

        Object.keys(newTechnicianGroups[fromKey] || {}).forEach(groupName => {
          const orderIndex = newTechnicianGroups[fromKey][groupName].findIndex(order => matchOrderId(order, orderId));
          if (orderIndex !== -1) {
            const orderToMove = newTechnicianGroups[fromKey][groupName][orderIndex];

            newTechnicianGroups[fromKey][groupName] = newTechnicianGroups[fromKey][groupName].filter(
              order => !matchOrderId(order, orderId)
            );

            ordersToMove.push(orderToMove);
            found = true;
            orderResults.push({
              orderId: orderToMove.id,
              cliente: orderToMove.cliente || orderToMove.TB01008_NOME,
              status: 'success',
              targetSection: toGroupName
            });
          }
        });

        if (!found) {
          // ordem não encontrada no técnico de origem
        }
      });

      if (!newTechnicianGroups[toKey][toGroupName]) {
        newTechnicianGroups[toKey][toGroupName] = [];
      }

      newTechnicianGroups[toKey][toGroupName] = [
        ...newTechnicianGroups[toKey][toGroupName],
        ...ordersToMove
      ];

      setTechnicianGroups(newTechnicianGroups);
      setTechniqueColumns((prev) => (prev[toKey] ? prev : { ...prev, [toKey]: [] }));
      setColumnOrder((prev) => {
        if ((prev || []).some((t) => normalizeTechnicianName(t) === normalizeTechnicianName(toKey))) {
          return prev;
        }
        return [...(prev || []), toKey];
      });
      setSelectedOrders([]);

      const specialtyRows = specialtyRejectedForModal.map((orderId) => ({
        orderId,
        status: 'error',
        errorMessage: BOARD_SPECIALTY_DRAG_MSG,
        cliente: 'N/A',
        tecnico: toKey,
        targetSection: toGroupName
      }));
      setOrderStatusResults([...orderResults, ...specialtyRows]);
      setOrderStatusSummary({
        targetSection: toGroupName,
        technicianName: toKey
      });
      setShowOrderStatusModal(true);
      
    } catch (error) {
      console.error('❌ Erro na requisição de movimentação entre técnicos:', error);
      
      // Verificar se é erro de timeout
      const isTimeoutError = error.name === 'AbortError' || error.message.includes('timeout');
      const errorMessage = isTimeoutError 
        ? 'Timeout na operação - a operação está demorando mais que o esperado. Tente novamente em alguns segundos.'
        : error.message;
      
      // Criar resultados de erro para o modal
      const errorResults = ordersToProcess.map(orderId => ({
        orderId,
        status: 'error',
        errorMessage: errorMessage,
        cliente: 'N/A',
        tecnico: fromKey,
        targetSection: toGroupName
      }));

      setOrderStatusResults(errorResults);
      setOrderStatusSummary({
        targetSection: toGroupName,
        technicianName: toKey
      });
      setShowOrderStatusModal(true);
    } finally {
      setIsDragDropProcessing(false);
      setDragDropProgress({ current: 0, total: 0 });
      setDragDropMessage('');
    }
  };

  const handleDropToTechnique = async (technicianName, groupName = 'Previsto para hoje', orderIdsOverride) => {
    // Limpar estado de drag over da coluna "Em aberto" imediatamente
    setIsDragOverOpen(false);
    
    // Não permitir drop em "Em deslocamento" / "Em serviço"
    if (isBoardLiveServiceGroup(groupName)) {
      return;
    }
    
    const newTechnicianGroups = { ...technicianGroups };
    // Técnico sem coluna ainda (todos do filtro): cria seções vazias para receber a OS
    if (!newTechnicianGroups[technicianName]) {
      newTechnicianGroups[technicianName] = createEmptyTechnicianBoardGroups();
    } else {
      newTechnicianGroups[technicianName] = { ...newTechnicianGroups[technicianName] };
    }
    if (!newTechnicianGroups[technicianName][groupName] && groupName !== 'Em Aberto') {
      newTechnicianGroups[technicianName][groupName] = [];
    }
    
    const ordersToMoveInput = (Array.isArray(orderIdsOverride) && orderIdsOverride.length > 0)
      ? orderIdsOverride
      : selectedOrders;

    // Se não há ordens selecionadas, não fazer nada
    if (ordersToMoveInput.length === 0) {
      console.log('⚠️ Nenhuma ordem selecionada para arrastar');
      return;
    }

    beginDragDropProcessing(
      ordersToMoveInput.length,
      `Movendo ${ordersToMoveInput.length} ordens para "${groupName}" do técnico "${technicianName}"...`
    );

    let specialtyRejectedForOpen = [];
    let ordersToMove = [...ordersToMoveInput];
    const technicianIdForSpecOpen = getTechnicianIdByName(technicianName);
    if (technicianIdForSpecOpen) {
      try {
        const specOpen = await validateBoardDragSpecialty(technicianIdForSpecOpen, ordersToMove);
        specialtyRejectedForOpen = specOpen.rejectedOrderIds || [];
        if (Array.isArray(specOpen.allowedOrderIds)) {
          ordersToMove = specOpen.allowedOrderIds;
        }
      } catch (_e) {
        specialtyRejectedForOpen = [];
      }
    }
    if (ordersToMove.length === 0) {
      setIsDragDropProcessing(false);
      if (specialtyRejectedForOpen.length > 0) {
        setOrderStatusResults(specialtyRejectedForOpen.map((orderId) => ({
          orderId,
          status: 'error',
          errorMessage: BOARD_SPECIALTY_DRAG_MSG,
          cliente: 'N/A',
          tecnico: technicianName,
          targetSection: groupName
        })));
        setOrderStatusSummary({ targetSection: groupName, technicianName });
        setShowOrderStatusModal(true);
      }
      return;
    }

    try {
      const clienteContrato = await validateBoardDragClienteContrato(ordersToMove);
      if (clienteContrato.blocked && clienteContrato.messages?.length) {
        setIsDragDropProcessing(false);
        setBoardDragValidationMessages(clienteContrato.messages);
        setShowBoardDragValidationModal(true);
        return;
      }
    } catch (_ccErr) {
      /* segue sem bloquear se a validação falhar por rede */
    }

    if (groupName === 'Previsto para hoje') {
      if (!previstoGoSyncAckRef.current) {
        try {
          const goSync = await validateBoardDragPrevistoGoSync({
            orderIds: ordersToMove,
            targetSection: groupName,
            technicianId: technicianIdForSpecOpen,
          });
          if (goSync.blocked) {
            setIsDragDropProcessing(false);
            openPrevistoGoSyncConfirm(goSync.messages, () =>
              handleDropToTechnique(technicianName, groupName, ordersToMove)
            );
            return;
          }
        } catch (_goErr) {
          /* segue — backend reforça no update-status */
        }
      }
    }

    ordersToMove.forEach((orderId) => {
      logDragDrop({
        userId: currentUser?.id,
        userName: currentUser?.name || currentUser?.username,
        tenantId: currentUser?.clientId ?? 1,
        ordemId: orderId,
        origem: 'Em aberto',
        destino: technicianName,
        sessaoOrigem: null,
        sessaoDestino: groupName,
        tecnicoCurrent: null,
        tecnicoNovo: technicianName,
      });
    });
    // Se o destino é "FUTURA", abrir modal de seleção de data
    if (groupName === 'FUTURA') {
      console.log('📅 Abrindo modal de seleção de data para área FUTURA (de Em aberto)');
      const technicianId = getTechnicianIdByName(technicianName);
      setFutureDateModalData({
        technicianName,
        technicianId,
        orderIds: [...ordersToMove],
        fromGroup: 'Em Aberto'
      });
      setSelectedFutureDate(null);
      setNoDateSelected(false);
      setShowFutureDateModal(true);
      setIsDragDropProcessing(false);
      // Limpar seleção após abrir o modal
      setSelectedOrders([]);
      return;
    }
    
    // Ativar feedback visual imediato
    setIsDragDropProcessing(true);
    setDragDropProgress({ current: 0, total: ordersToMove.length });
    setDragDropMessage(`Movendo ${ordersToMove.length} ordens para "${groupName}" do técnico "${technicianName}"...`);
    
    try {
      // Obter ID do técnico
      const technicianId = getTechnicianIdByName(technicianName);
      
      // Objeto que será enviado para o backend
      const requestPayload = attachPrevistoGoSyncAck({
        orderIds: ordersToMove,
        targetSection: groupName,
        technicianId: technicianId,
        validateClienteContrato: true,
      });
      
      // Atualizar progresso
      setDragDropProgress({ current: 1, total: ordersToMove.length });
      setDragDropMessage('Atualizando status no banco de dados...');
      
      // AbortController para timeout de 60 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 segundos
      
      // Fazer chamada da API para atualizar status no banco de dados
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      const result = await response.json();
      
      // Preparar dados para o modal
      const orderResults = [];
      
      // Buscar dados das ordens selecionadas para o modal
      const currentData = availableOrdersState;
      const realOrdersData = [];
      
      if (
        (response.status === 422 || !result.success) &&
        result.blocked &&
        Array.isArray(result.messages) &&
        result.messages.length > 0
      ) {
        setIsDragDropProcessing(false);
        setBoardDragValidationMessages(result.messages);
        setShowBoardDragValidationModal(true);
        return;
      }

      const successfulIds = (result.data?.results || [])
        .filter((item) => item && item.success !== false)
        .map((item) => item.orderId);
      const idsToPlace = successfulIds.length ? successfulIds : (result.success ? ordersToMove : []);

      if (!idsToPlace.length) {
        console.error('❌ Erro ao atualizar status no banco:', result.message);
        ordersToMove.forEach(orderId => {
          let orderData = { orderId, status: 'error', errorMessage: result.message };
          currentData.forEach(cityGroup => {
            cityGroup.ordens.forEach(ordem => {
              if (sameBoardOrderId(ordem, orderId)) {
                orderData.cliente = ordem.cliente || ordem.TB01008_NOME;
              }
            });
          });
          orderResults.push(orderData);
        });
        setOrderStatusResults(orderResults);
        setOrderStatusSummary({
          targetSection: groupName,
          technicianName: technicianName
        });
        setShowOrderStatusModal(true);
        return;
      }
      
      if (groupName === 'Previstas para amanhã' && idsToPlace.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaAmanha(t, [...idsToPlace]);
            }
          } catch (e) { console.warn('[Email Será atendida amanhã]', e.message); }
        })();
      }
      if (groupName === 'Previsto para hoje' && idsToPlace.length > 0) {
        (async () => {
          try {
            const t = localStorage.getItem('authToken');
            if (t) {
              await sendSeraAtendidaHoje(t, [...idsToPlace]);
            }
          } catch (e) { console.warn('[Email Será atendida hoje]', e.message); }
        })();
      }
      
      idsToPlace.forEach(orderId => {
        availableOrdersState.forEach(cityGroup => {
          cityGroup.ordens.forEach(ordem => {
            if (sameBoardOrderId(ordem, orderId)) {
              const realOrder = {
                ...ordem,
                id: ordem.id || ordem.TB02115_CODIGO,
                cliente: ordem.cliente || ordem.TB01008_NOME,
                equipamento: ordem.equipamento || ordem.TB01010_NOME,
                tipo: ordem.tipo || getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA),
                sla: ordem.sla || getSLAFromCalcRestante(ordem.CALC_RESTANTE, ordem.CALC_PREVISAO),
                cidade: cityGroup.cidade,
                pedidoVinculado: ordem.pedidoVinculado,
                numeroSerie: ordem.numeroSerie,
                serie: ordem.serie,
                patrimonio: ordem.patrimonio,
                endereco: ordem.endereco,
                dataAbertura: ordem.dataAbertura,
                tecnico: ordem.tecnico,
                coordenador: ordem.coordenador,
                area: ordem.area,
                bairro: ordem.bairro,
                estado: ordem.estado,
                contrato: ordem.contrato,
                TB02115_CODIGO: ordem.TB02115_CODIGO,
                TB01008_NOME: ordem.TB01008_NOME,
                TB01010_NOME: ordem.TB01010_NOME,
                TB02115_PREVENTIVA: ordem.TB02115_PREVENTIVA,
                TB02115_BAIRRO: ordem.TB02115_BAIRRO,
                CALC_RESTANTE: ordem.CALC_RESTANTE,
                TB01047_NOME: ordem.TB01047_NOME,
                TB01018_NOME: ordem.TB01018_NOME,
                TB01073_NOME: ordem.TB01073_NOME
              };
              realOrdersData.push(realOrder);
              orderResults.push({
                orderId: realOrder.id,
                cliente: realOrder.cliente,
                status: 'success',
                targetSection: groupName
              });
            }
          });
        });
      });

      (result.data?.errors || []).forEach((item) => {
        orderResults.push({
          orderId: item.orderId,
          status: 'error',
          errorMessage: item.error,
          cliente: 'N/A',
          tecnico: technicianName,
          targetSection: groupName
        });
      });
      
      // Adicionar ordens reais ao grupo do técnico (exceto "Em Aberto"/apenas técnico)
      if (groupName !== 'Em Aberto') {
        if (!newTechnicianGroups[technicianName][groupName]) {
          newTechnicianGroups[technicianName][groupName] = [];
        }
        newTechnicianGroups[technicianName][groupName] = [
          ...newTechnicianGroups[technicianName][groupName],
          ...realOrdersData
        ];
      }
      
      // Remover ordens de availableOrdersState
      const newAvailableOrders = availableOrdersState.map(item => ({
        ...item,
        ordens: item.ordens.filter(ordem => 
          !idsToPlace.some((mid) => sameBoardOrderId(ordem, mid))
        )
      })).filter(item => item.ordens.length > 0);
      
      setAvailableOrdersState(newAvailableOrders);
      setTechnicianGroups(newTechnicianGroups);
      setSelectedOrders([]);
      
      // Mostrar modal com resultados de sucesso
      const specialtyRowsOpen = specialtyRejectedForOpen.map((orderId) => ({
        orderId,
        status: 'error',
        errorMessage: BOARD_SPECIALTY_DRAG_MSG,
        cliente: 'N/A',
        tecnico: technicianName,
        targetSection: groupName
      }));
      setOrderStatusResults([...orderResults, ...specialtyRowsOpen]);
      setOrderStatusSummary({
        targetSection: groupName,
        technicianName: technicianName
      });
      setShowOrderStatusModal(true);
      
    } catch (error) {
      console.error('❌ Erro na chamada da API de atualização:', error);
      
      // Verificar se é erro de timeout
      const isTimeoutError = error.name === 'AbortError' || error.message.includes('timeout');
      const errorMessage = isTimeoutError 
        ? 'Timeout na operação - a operação está demorando mais que o esperado. Tente novamente em alguns segundos.'
        : `Erro de conexão: ${error.message}`;
      
      // Criar resultados de erro para o modal
      const errorResults = ordersToMove.map(orderId => {
        let orderData = { orderId, status: 'error', errorMessage: errorMessage };
        
        // Buscar dados da ordem para o modal
        availableOrdersState.forEach(cityGroup => {
          cityGroup.ordens.forEach(ordem => {
            if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
              orderData.cliente = ordem.cliente || ordem.TB01008_NOME;
            }
          });
        });
        
        return orderData;
      });
      
      // Mostrar modal com erro
      setOrderStatusResults(errorResults);
      setOrderStatusSummary({
        targetSection: groupName,
        technicianName: technicianName
      });
      setShowOrderStatusModal(true);
    } finally {
      // Sempre desativar o loading independente do resultado
      setIsDragDropProcessing(false);
      setDragDropProgress({ current: 0, total: 0 });
      setDragDropMessage('');
    }
  };

  // Nova função para retornar ordens para "Em aberto"
  const handleReturnToOpen = async (orderIds) => {
    // Garantir que orderIds seja sempre um array
    const orderIdsArray = Array.isArray(orderIds) ? orderIds : [orderIds];
    console.log(`🔄 handleReturnToOpen chamado para ${orderIdsArray.length} ordens:`, orderIdsArray);
    if (orderIdsArray.length === 0) return;

    beginDragDropProcessing(
      orderIdsArray.length,
      `Retornando ${orderIdsArray.length} ordens para "Em Aberto"...`
    );

    const leavingPrevisto = orderIdsArray.some((orderId) => {
      return Object.keys(technicianGroups || {}).some((techName) => {
        const list = technicianGroups[techName]?.['Previsto para hoje'] || [];
        return list.some(
          (o) => String(o.id) === String(orderId) || String(o.TB02115_CODIGO || '') === String(orderId)
        );
      });
    });
    if (leavingPrevisto) {
      if (!previstoGoSyncAckRef.current) {
        try {
          const goSync = await validateBoardDragPrevistoGoSync({
            orderIds: orderIdsArray,
            targetSection: 'Em Aberto',
            technicianId: null,
          });
          if (goSync.blocked) {
            setIsDragDropProcessing(false);
            openPrevistoGoSyncConfirm(goSync.messages, () => handleReturnToOpen(orderIdsArray));
            return;
          }
        } catch (_goErr) {
          /* segue — backend reforça no update-status */
        }
      }
    }

    // Ativar feedback visual imediato
    setIsDragDropProcessing(true);
    setDragDropProgress({ current: 0, total: orderIdsArray.length });
    setDragDropMessage(`Retornando ${orderIdsArray.length} ordens para "Em Aberto"...`);
    
    try {
      console.log(`🎯 Atualizando ${orderIdsArray.length} ordens para status "Em Aberto"`);
      
      // Ordens em FUTURA (com ou sem previsão): remover LCMY_REG_OS_STANDBY ao voltar para Em aberto
      const token = localStorage.getItem('authToken');
      const ordersToRemoveStandby = [];
      
      orderIdsArray.forEach(orderId => {
        Object.keys(technicianGroups).forEach(technicianName => {
          const order = technicianGroups[technicianName]?.['FUTURA']?.find(o => o.id === orderId);
          if (order) {
            const technicianId = getTechnicianIdByName(technicianName);
            ordersToRemoveStandby.push({ orderId, technicianId, technicianName });
          }
        });
      });
      
      console.log(`🔍 Ordens em FUTURA para remover standby: ${ordersToRemoveStandby.length}`, ordersToRemoveStandby);
      
      if (ordersToRemoveStandby.length > 0) {
        console.log(`🗑️ Removendo ${ordersToRemoveStandby.length} ordem(ns) de LCMY_REG_OS_STANDBY`);
        setDragDropMessage(`Removendo previsões de ${ordersToRemoveStandby.length} ordem(ns)...`);
        
        const removeStandbyPromises = ordersToRemoveStandby.map(async ({ orderId, technicianId }) => {
          try {
            console.log(`🗑️ Chamando API para remover standby (retorno para Em aberto): os=${orderId}, id_tech=${technicianId}`);
            const response = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                os: orderId,
                id_tech: technicianId
              })
            });
            
            const result = await response.json();
            console.log(`📋 Resposta da API para ordem ${orderId} (retorno para Em aberto):`, result);
            
            if (!result.success) {
              console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, result.message);
            } else {
              console.log(`✅ Standby removido para ordem ${orderId}, linhas afetadas: ${result.rowsAffected}`);
            }
            return result;
          } catch (error) {
            console.error(`❌ Erro ao remover standby para ordem ${orderId}:`, error);
            return { success: false, error: error.message };
          }
        });
        
        await Promise.all(removeStandbyPromises);
      } else {
        console.log(`⚠️ Nenhuma ordem em FUTURA para remover standby (retorno para Em aberto)`);
      }
      
      // Objeto que será enviado para o backend
      const requestPayload = attachPrevistoGoSyncAck({
        orderIds: orderIdsArray,
        targetSection: 'Em Aberto',
        technicianId: null // Não há técnico para "Em Aberto"
      });
      
      // Atualizar progresso
      setDragDropProgress({ current: 1, total: orderIdsArray.length });
      setDragDropMessage('Atualizando status no banco de dados...');
      
      // AbortController para timeout de 60 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 segundos
      
      // Fazer chamada da API para atualizar status no banco de dados
      const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      const result = await response.json();
      
      // Preparar dados para o modal
      const orderResults = [];
      
      if (
        (response.status === 422 || !result.success) &&
        result.blocked &&
        Array.isArray(result.messages) &&
        result.messages.length > 0
      ) {
        setBoardDragValidationMessages(result.messages);
        setShowBoardDragValidationModal(true);
        return;
      }

      if (!result.success) {
        console.error('❌ Erro ao atualizar status no banco:', result.message);
        
        // Criar resultados de erro para o modal
        orderIdsArray.forEach(orderId => {
          let orderData = { orderId, status: 'error', errorMessage: result.message };
          
          // Buscar dados da ordem para o modal
          availableOrdersState.forEach(cityGroup => {
            cityGroup.ordens.forEach(ordem => {
              if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                orderData.cliente = ordem.cliente || ordem.TB01008_NOME;
              }
            });
          });
          
          orderResults.push(orderData);
        });
        
        // Mostrar modal com erro
        setOrderStatusResults(orderResults);
        setOrderStatusSummary({
          targetSection: 'Em Aberto',
          technicianName: null
        });
        setShowOrderStatusModal(true);
        return;
      }
      
      // Encontrar informações das ordens antes de processar resultados
      const orderInfoMap = new Map();
      
      // Buscar informações das ordens nos grupos de técnicos
      Object.keys(technicianGroups).forEach(technician => {
        Object.keys(technicianGroups[technician]).forEach(groupName => {
          technicianGroups[technician][groupName].forEach(order => {
            if (orderIdsArray.includes(order.id)) {
              orderInfoMap.set(order.id, {
                cliente: order.cliente || order.TB01008_NOME || 'N/A',
                tecnico: technician,
                targetSection: 'Em Aberto'
              });
            }
          });
        });
      });
      
      // Processar resultados do backend
      if (result.data && result.data.results && Array.isArray(result.data.results)) {
        // Processar resultados de sucesso
        result.data.results.forEach(item => {
          const orderInfo = orderInfoMap.get(item.orderId) || {};
          orderResults.push({
            orderId: item.orderId,
            status: 'success',
            errorMessage: null,
            cliente: item.cliente || orderInfo.cliente || 'N/A',
            tecnico: orderInfo.tecnico || 'N/A',
            targetSection: orderInfo.targetSection || 'Em Aberto'
          });
        });
      }
      
      // Processar erros do backend
      if (result.data && result.data.errors && Array.isArray(result.data.errors)) {
        result.data.errors.forEach(item => {
          const orderInfo = orderInfoMap.get(item.orderId) || {};
          orderResults.push({
            orderId: item.orderId,
            status: 'error',
            errorMessage: item.error,
            cliente: orderInfo.cliente || 'N/A',
            tecnico: orderInfo.tecnico || 'N/A',
            targetSection: orderInfo.targetSection || 'Em Aberto'
          });
        });
      }
      
      // Se não há resultados estruturados, criar baseado no sucesso geral
      if (orderResults.length === 0) {
        if (result.success) {
          // Se foi sucesso geral, criar resultados para todas as ordens
          orderIdsArray.forEach(orderId => {
            const orderInfo = orderInfoMap.get(orderId) || {};
            orderResults.push({
              orderId: orderId,
              status: 'success',
              errorMessage: null,
              cliente: orderInfo.cliente || 'N/A',
              tecnico: orderInfo.tecnico || 'N/A',
              targetSection: orderInfo.targetSection || 'Em Aberto'
            });
          });
        } else {
          // Se foi erro geral, criar resultados de erro para todas as ordens
          orderIdsArray.forEach(orderId => {
            const orderInfo = orderInfoMap.get(orderId) || {};
            orderResults.push({
              orderId: orderId,
              status: 'error',
              errorMessage: result.message,
              cliente: orderInfo.cliente || 'N/A',
              tecnico: orderInfo.tecnico || 'N/A',
              targetSection: orderInfo.targetSection || 'Em Aberto'
            });
          });
        }
      }
      
      console.log('📊 Resultados processados:', orderResults);
      console.log('📊 Total de resultados:', orderResults.length);
      
      // Mostrar modal com resultados
      setOrderStatusResults(orderResults);
      setOrderStatusSummary({
        targetSection: 'Em Aberto',
        technicianName: null
      });
      setShowOrderStatusModal(true);
      
      // Se a atualização no banco foi bem-sucedida, atualizar o estado local
      const newTechnicianGroups = { ...technicianGroups };
      const ordersToReturn = [];
      
      // Encontrar e remover as ordens dos grupos de técnicos
      console.log('🔍 Procurando ordens nos grupos de técnicos...');
      console.log('🔍 Ordens a procurar:', orderIdsArray);
      console.log('🔍 Grupos de técnicos disponíveis:', Object.keys(newTechnicianGroups));
      
      orderIdsArray.forEach(orderId => {
        console.log(`🔍 Procurando ordem ${orderId}...`);
        let found = false;
        
        Object.keys(newTechnicianGroups).forEach(technician => {
          Object.keys(newTechnicianGroups[technician]).forEach(groupName => {
            const orderIndex = newTechnicianGroups[technician][groupName].findIndex(order => order.id === orderId);
            if (orderIndex !== -1) {
              console.log(`✅ Encontrada ordem ${orderId} no técnico ${technician}, grupo ${groupName}`);
              const orderToReturn = newTechnicianGroups[technician][groupName][orderIndex];
              ordersToReturn.push(orderToReturn);
              newTechnicianGroups[technician][groupName] = newTechnicianGroups[technician][groupName].filter(
                order => order.id !== orderId
              );
              found = true;
            }
          });
        });
        
        if (!found) {
          console.log(`⚠️ Ordem ${orderId} não encontrada nos grupos de técnicos`);
        }
      });
      
      console.log('📊 Ordens encontradas para retorno:', ordersToReturn.length);
      console.log('📊 IDs das ordens encontradas:', ordersToReturn.map(o => o.id));
      
      // Se encontrou ordens, adicionar de volta aos dados disponíveis
      if (ordersToReturn.length > 0) {
        const newAvailableOrders = [...availableOrdersState];
        
        // Processar cada ordem retornada
        ordersToReturn.forEach(orderToReturn => {
          let groupFound = false;
          
          // Procurar grupo existente da cidade para adicionar a ordem
          for (let item of newAvailableOrders) {
            if (item.cidade === orderToReturn.cidade) {
              item.ordens.push({
                ...orderToReturn,
                atrasada: (orderToReturn.sla === 'vencido' || orderToReturn.sla === 'Vencido'),
              });
              groupFound = true;
              break;
            }
          }
          
          // Se não encontrou grupo existente da cidade, criar novo
          if (!groupFound) {
            newAvailableOrders.push({
              cidade: orderToReturn.cidade,
              ordens: [{
                ...orderToReturn,
                atrasada: orderToReturn.sla === 'vencido' || orderToReturn.sla === 'Vencido',
              }],
            });
          }
        });
        
        setAvailableOrdersState(newAvailableOrders);
      }
      
      setTechnicianGroups(newTechnicianGroups);
      
      // Limpar seleção após o sucesso
      setSelectedOrders([]);
      
    } catch (error) {
      console.error('❌ Erro na requisição de retorno para "Em Aberto":', error);
      
      // Verificar se é erro de timeout
      const isTimeoutError = error.name === 'AbortError' || error.message.includes('timeout');
      const errorMessage = isTimeoutError 
        ? 'Timeout na operação - a operação está demorando mais que o esperado. Tente novamente em alguns segundos.'
        : error.message;
      
      // Criar resultados de erro para o modal
      const errorResults = orderIdsArray.map(orderId => ({
        orderId,
        status: 'error',
        errorMessage: errorMessage,
        cliente: 'N/A'
      }));
      
      setOrderStatusResults(errorResults);
      setOrderStatusSummary({
        targetSection: 'Em Aberto',
        technicianName: null
      });
      setShowOrderStatusModal(true);
    } finally {
      // Sempre desativar o loading independente do resultado
      setIsDragDropProcessing(false);
      setDragDropProgress({ current: 0, total: 0 });
      setDragDropMessage('');
    }
  };

  const handleColumnReorder = React.useCallback((dragIndex, hoverIndex, visibleList = columnOrder) => {
    if (dragIndex === hoverIndex || dragIndex < 0 || hoverIndex < 0) return;
    const dragTech = visibleList[dragIndex];
    const hoverTech = visibleList[hoverIndex];
    if (!dragTech || !hoverTech) return;
    const next = [...columnOrder];
    const from = next.indexOf(dragTech);
    if (from < 0) return;
    next.splice(from, 1);
    const to = next.indexOf(hoverTech);
    if (to < 0) return;
    next.splice(to, 0, dragTech);
    setColumnOrder(next);
  }, [columnOrder]);

  /** Empilha coluna arrastada abaixo (corpo) / host fica em cima. */
  const handleTechnicianColumnStack = React.useCallback((hostTechnician, draggedTechnician) => {
    const host = String(hostTechnician || '').trim();
    const drag = String(draggedTechnician || '').trim();
    if (!host || !drag || host === drag) return;
    setTechnicianColumnStacks((prev) => applyTechnicianColumnStack(prev, host, drag));
  }, []);

  const handleTechnicianColumnUnstack = React.useCallback((hostTechnician) => {
    setTechnicianColumnStacks((prev) => unstackTechnicianColumn(prev, hostTechnician));
  }, []);

  // Obtém technicianId de outras colunas do técnico (ex.: "Para hoje", "Em serviço") quando "Para amanhã" está vazio
  const getTechnicianIdFromGroups = (name) => {
    const groups = technicianGroups[name];
    if (!groups) return null;
    const cols = ['Previsto para hoje', 'Em deslocamento', 'Em serviço', 'FUTURA'];
    for (const col of cols) {
      const arr = groups[col];
      if (Array.isArray(arr) && arr.length > 0 && arr[0]) {
        const id = arr[0].TB02115_CODTEC;
        if (id) return id;
      }
    }
    return null;
  };

  // Função para visualizar rota do técnico (versão simplificada - sem geocodificação)
  const handleViewTechnicianRoute = async (technicianName) => {
    try {
      setRouteModalLoading(true);
      setRouteModalError(null);
      setShowRouteModal(true); // Mostrar modal com loading
      
      const getRouteForecastDate = (date = new Date()) => {
        const currentDay = date.getDay();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        if (currentDay >= 1 && currentDay <= 4) {
          return new Date(year, month, day + 1);
        }
        const daysUntilMonday = currentDay === 0 ? 1 : (8 - currentDay);
        return new Date(year, month, day + daysUntilMonday);
      };

      // Buscar ordens do técnico para amanhã
      const tomorrowOrders = technicianGroups[technicianName]?.['Previstas para amanhã'] || [];
      
      if (tomorrowOrders.length === 0) {
        const technicianId = getTechnicianIdFromGroups(technicianName);
        if (!technicianId) {
          setRouteModalError(`Nenhuma ordem de serviço encontrada para amanhã para o técnico ${technicianName}`);
          setRouteModalLoading(false);
          setRouteModalData({ technicianName, orders: [] });
          return;
        }
        const forecastDateObj = getRouteForecastDate();
        const forecastDate = `${forecastDateObj.getFullYear()}-${String(forecastDateObj.getMonth() + 1).padStart(2, '0')}-${String(forecastDateObj.getDate()).padStart(2, '0')}`;
        setRouteModalError(null);
        setRouteModalData({ technicianName, orders: [], technicianId, forecastDate });
        setRouteModalLoading(false);
        return;
      }

      // Filtrar ordens que têm cidade válida (excluir "Sem cidade")
      const validOrders = tomorrowOrders.filter(order => {
        const cidade = order.cidade || order.TB02115_CIDADE;
        return cidade && cidade.trim() !== '' && cidade !== 'Sem cidade';
      });

      if (validOrders.length === 0) {
        const technicianId = tomorrowOrders[0]?.TB02115_CODTEC || getTechnicianIdFromGroups(technicianName);
        if (!technicianId) {
          setRouteModalError(`Nenhuma ordem com cidade válida encontrada para o técnico ${technicianName}. Todas as ordens estão sem cidade definida.`);
          setRouteModalLoading(false);
          setRouteModalData({ technicianName, orders: [] });
          return;
        }
        const forecastDateObj = getRouteForecastDate();
        const forecastDate = `${forecastDateObj.getFullYear()}-${String(forecastDateObj.getMonth() + 1).padStart(2, '0')}-${String(forecastDateObj.getDate()).padStart(2, '0')}`;
        setRouteModalError(null);
        setRouteModalData({ technicianName, orders: [], technicianId, forecastDate });
        setRouteModalLoading(false);
        return;
      }

      const technicianId = validOrders[0]?.TB02115_CODTEC;
      const forecastDateObj = getRouteForecastDate();
      const forecastDate = `${forecastDateObj.getFullYear()}-${String(forecastDateObj.getMonth() + 1).padStart(2, '0')}-${String(forecastDateObj.getDate()).padStart(2, '0')}`;

      let routedOrders = [];
      if (technicianId) {
        try {
          const apiUrl = `${API_BASE_URL}/api/route/technician-orders/${technicianId}?forecast=${forecastDate}`;
          
          const token = localStorage.getItem('authToken');
          const response = await fetch(apiUrl, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          const result = await response.json();
          
        
          
          if (result.success) {
            routedOrders = result.data.orders;
          } else {
            console.warn('⚠️ Erro ao carregar ordens roteirizadas:', result.message);
          }
        } catch (error) {
          console.warn('⚠️ Erro ao conectar com API de roteirização:', error);
        }
      }
      
      // Preparar ordens com endereço
      const ordersWithAddress = validOrders.map(order => {
        const cidade = order.cidade || order.TB02115_CIDADE;
        const endereco = order.endereco || order.TB02115_ENDERECO;
        
        // Verificar se o endereço já contém a cidade (para evitar duplicação)
        // O endereço do banco já vem completo com cidade, então não precisamos adicionar novamente
        let enderecoCompleto = endereco;
        
        // Se não houver endereço, usar apenas a cidade
        if (!endereco) {
          enderecoCompleto = cidade;
        }
        // Se o endereço não termina com a cidade, adicionar (caso raro onde o endereço está incompleto)
        else if (cidade && !endereco.toUpperCase().includes(cidade.toUpperCase())) {
          enderecoCompleto = `${endereco}, ${cidade}`;
        }
        // Caso contrário, usar o endereço original do banco (já completo)
        
        // Verificar se a ordem está roteirizada
        // Converter ambos para string para garantir comparação correta
        const orderNumber = String(order.id || order.TB02115_CODIGO);
        const routedOrder = routedOrders.find(ro => String(ro.os) === orderNumber);
        
        
        
        return {
          ...order,
          endereco: enderecoCompleto,
          isRouted: !!routedOrder,
          routeSequence: routedOrder?.sequence || null,
          // Garantir que os campos do banco sejam preservados explicitamente
          TB02115_NUMSERIE: order.TB02115_NUMSERIE || order.numeroSerie || order.serie || null,
          CALC_PREVISAO: order.CALC_PREVISAO || order.previsao || null,
          // Preservar também campos alternativos
          serie: order.serie || order.TB02115_NUMSERIE || order.numeroSerie || null,
          previsao: order.previsao || order.CALC_PREVISAO || null
        };
      });

      
      
      setRouteModalData({
        technicianName,
        orders: ordersWithAddress,
        technicianId,
        forecastDate
      });
      setRouteModalLoading(false);
      
    } catch (error) {
      console.error('Erro ao buscar rota:', error);
      setRouteModalError('Erro ao buscar rota: ' + error.message);
      setRouteModalLoading(false);
    }
  };

  // Função para selecionar/desselecionar todas as ordens de uma cidade (só Em aberto)
  const selectAllOrdersFromCity = (cityOrders) => {
    const cityOrderIds = cityOrders.map((ordem) => ordem.id);
    const openScope = collectOrderIdsFromCityGroups(availableOrdersState);
    setSelectedOrders((prevSelected) =>
      toggleCityOrdersSelectionInOpenScope(prevSelected, cityOrderIds, openScope)
    );
    setOpenCityDropdown(null); // Fechar dropdown após ação
  };

  // Função para lidar com cliques simples vs duplos. technicianName: quando clicado em coluna de técnico, limpa seleções de outras colunas.
  const handleOrderClick = (ordem, technicianName, groupName) => {
    captureTechnicianColumnScrollPositions();

    // Salvar posições dos scrolls dos containers de cidade
    if (openColumnScrollRef.current) {
      const cityContainers = openColumnScrollRef.current.querySelectorAll('.city-orders-container');
      cityContainers.forEach((container) => {
        const cityElement = container.closest('.city-group');
        const cityTitle = cityElement?.querySelector('.city-title')?.textContent;
        if (cityTitle) {
          cityScrollPositions.current[cityTitle] = container.scrollTop;
        }
      });
    }

    const orderId = String(ordem?.id ?? ordem?.TB02115_CODIGO ?? '').trim();
    const isDoubleOnSame =
      !!clickTimeoutRef.current &&
      !!orderId &&
      String(clickOrderIdRef.current) === orderId;

    if (isDoubleOnSame) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
      clickOrderIdRef.current = null;

      // Definir contexto de seção para o modal/PDF
      let contextGroup = groupName || null;
      if (!contextGroup) {
        // Se não há grupo informado:
        // - sem técnico => coluna "Em aberto"
        // - com técnico mas sem grupo => manter grupo já existente na ordem, se houver
        if (!technicianName) {
          contextGroup = 'Em Aberto';
        } else if (ordem && ordem.forecastGroup) {
          contextGroup = ordem.forecastGroup;
        }
      }

      if (orderId) {
        handleOpenOrderDetailsV2FromContext(orderId, {
          source: technicianName ? 'technician' : 'open',
          technician: technicianName || null,
          groupName: contextGroup,
          futuraRetornoTab: ordem?.fromFuturaRetornoLiberado ? 'liberado' : null,
        }, setSelectedOrderForDetailsMock);
      }

      /* Modal v1 — rollback: restaurar bloco abaixo e remover chamada V2 acima
      let detailModalBoardTechnician = null;
      if (technicianName) {
        const groups = technicianGroupsRef.current ?? technicianGroups;
        const colOrder = columnOrderRef.current ?? columnOrder;
        const resolveKey = (name) => {
          const n = normalizeTechnicianName(name);
          const k = Object.keys(groups || {}).find((key) => normalizeTechnicianName(key) === n);
          if (k) return k;
          const col = colOrder.find((t) => normalizeTechnicianName(t) === n);
          return col || name;
        };
        detailModalBoardTechnician = resolveKey(technicianName);
      }

      const orderWithContext = {
        ...ordem,
        forecastGroup: !technicianName
          ? (contextGroup || 'Em Aberto')
          : ordem && ordem.forecastGroup
            ? ordem.forecastGroup
            : contextGroup,
        detailModalBoardTechnician,
      };

      setSelectedOrderForDetails(orderWithContext);
      */
    } else {
      // Clique simples (ou outra OS dentro da janela): marca na hora.
      // Duplo só conta se for a mesma OS — senão multi-seleção rápida abre o detalhe.
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
      clickOrderIdRef.current = orderId || ordem.id;
      setSelectedOrders((prev) => {
        // Seleção exclusiva: Em aberto XOR coluna de um técnico (não misturar).
        if (!technicianName) {
          const openScope = collectOrderIdsFromCityGroups(availableOrdersState);
          openScope.add(String(ordem.id));
          return toggleOrderSelectionInColumnScope(prev, ordem.id, openScope);
        }
        const groups = technicianGroupsRef.current ?? {};
        const order = columnOrderRef.current ?? [];
        const resolveKey = (name) => {
          const n = normalizeTechnicianName(name);
          const k = Object.keys(groups).find(key => normalizeTechnicianName(key) === n);
          if (k) return k;
          const col = order.find(t => normalizeTechnicianName(t) === n);
          return col || name;
        };
        const techKey = resolveKey(technicianName);
        const techData = groups[techKey];
        const orderIdsInThisColumn = collectOrderIdsFromTechnicianGroups(techData);
        orderIdsInThisColumn.add(String(ordem.id));
        return toggleOrderSelectionInColumnScope(prev, ordem.id, orderIdsInThisColumn);
      });
      clickTimeoutRef.current = setTimeout(() => {
        clickTimeoutRef.current = null;
        clickOrderIdRef.current = null;
      }, 250);
    }
  };

  const resolveOrderDetailFromBoardCaches = React.useCallback(
    (orderId) => {
      const id = String(orderId ?? '').trim();
      if (!id) return null;
      const matchId = (o) =>
        o != null && (String(o.id) === id || String(o.TB02115_CODIGO) === id);

      const toDetailOrder = (o) => (isBoardReadyOrder(o) ? o : mapOrderToLegacyFormat(o));

      const groupsObj = technicianGroups || {};
      for (const tech of Object.keys(groupsObj)) {
        const g = groupsObj[tech];
        if (!g || typeof g !== 'object') continue;
        for (const section of Object.keys(g)) {
          const arr = g[section];
          if (!Array.isArray(arr)) continue;
          const o = arr.find(matchId);
          if (o) return { order: toDetailOrder(o), forecastGroup: section, boardTechnician: tech };
        }
      }

      const cache = technicianDataCache || {};
      for (const tech of Object.keys(cache)) {
        const g = cache[tech];
        if (!g || typeof g !== 'object') continue;
        for (const section of Object.keys(g)) {
          const arr = g[section];
          if (!Array.isArray(arr)) continue;
          const o = arr.find(matchId);
          if (o) return { order: toDetailOrder(o), forecastGroup: section, boardTechnician: tech };
        }
      }

      for (const cityGroup of availableOrdersState || []) {
        const ordens = cityGroup?.ordens || [];
        for (const raw of ordens) {
          if (!matchId(raw)) continue;
          return { order: toDetailOrder(raw), forecastGroup: 'Em Aberto' };
        }
      }

      return null;
    },
    [technicianGroups, technicianDataCache, availableOrdersState]
  );

  const boardEncaminharRouteOrigin = React.useMemo(() => {
    if (!boardEncaminharFlow?.orderIds?.length) {
      return { address: '', city: '' };
    }
    return resolveBoardEncaminharRouteOrigin(
      boardEncaminharFlow.orderIds,
      resolveOrderDetailFromBoardCaches
    );
  }, [boardEncaminharFlow, resolveOrderDetailFromBoardCaches]);

  const buildOrderDetailStateFromFound = React.useCallback((found) => {
    if (!found?.order) return null;
    return {
      ...found.order,
      forecastGroup:
        found.boardTechnician != null && String(found.boardTechnician).trim() !== ''
          ? found.order.forecastGroup || found.forecastGroup
          : found.forecastGroup || found.order.forecastGroup || 'Em Aberto',
      detailModalBoardTechnician: found.boardTechnician || found.order.detailModalBoardTechnician || null,
    };
  }, []);

  const handleViewOrderDetailsFromOpenOsModal = React.useCallback(
    async (orderCodigo) => {
      const id = String(orderCodigo ?? '').trim();
      if (!id) return;
      const found = resolveOrderDetailFromBoardCaches(id);
      const built = buildOrderDetailStateFromFound(found);
      if (built) {
        const optimistic = mergeBoardOrderDetailPayload({
          cacheOrder: built,
          fullOrder: null,
          ctx: { source: 'open' },
        });
        if (optimistic) setSelectedOrderForDetails(optimistic);
        if (!needsBoardOrderFullLookup(built)) return;
      }
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(
          `${API_BASE_URL}/api/orders/lookup-for-modal/${encodeURIComponent(id)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        const json = await res.json();
        if (json.success && json.data) {
          setSelectedOrderForDetails(
            mergeBoardOrderDetailPayload({
              cacheOrder: built,
              fullOrder: json.data,
              ctx: { source: 'open' },
            })
          );
        }
      } catch {
        /* silencioso */
      }
    },
    [resolveOrderDetailFromBoardCaches, buildOrderDetailStateFromFound, API_BASE_URL]
  );
  useOpenOsDetailsFromNav(handleViewOrderDetailsFromOpenOsModal);

  const handleOpenOrderDetailsV2FromContext = React.useCallback(
    async (orderId, ctx, setOrderState) => {
      closeBoardOrderContextMenu();
      const commitOrder = typeof setOrderState === 'function' ? setOrderState : setSelectedOrderForDetailsV2;
      const id = String(orderId ?? '').trim();
      if (!id) return;
      let detailModalBoardTechnician = null;
      if (ctx?.source === 'technician' && ctx?.technician) {
        const groups = technicianGroupsRef.current ?? technicianGroups;
        const order = columnOrderRef.current ?? columnOrder;
        const resolveKey = (name) => {
          const n = normalizeTechnicianName(name);
          const k = Object.keys(groups || {}).find((key) => normalizeTechnicianName(key) === n);
          if (k) return k;
          const col = order.find((t) => normalizeTechnicianName(t) === n);
          return col || name;
        };
        detailModalBoardTechnician = resolveKey(ctx.technician);
      }
      const found = resolveOrderDetailFromBoardCaches(id);
      const built = buildOrderDetailStateFromFound(found);
      const mergeCtx = {
        source: ctx?.source,
        groupName: ctx?.groupName,
        forecastGroup: ctx?.source === 'open' ? 'Em Aberto' : ctx?.groupName,
        detailModalBoardTechnician:
          detailModalBoardTechnician || built?.detailModalBoardTechnician || null,
        futuraRetornoTab: ctx?.futuraRetornoTab,
        isPreAtendimento: ctx?.isPreAtendimento === true,
      };

      // Abre na hora (stub se não estiver no cache) — evita "clicou e nada" no chat.
      const stubOrder = { id, TB02115_CODIGO: id };
      const optimistic = mergeBoardOrderDetailPayload({
        cacheOrder: built || stubOrder,
        fullOrder: null,
        ctx: mergeCtx,
      });
      if (optimistic) commitOrder(optimistic);
      if (built && !needsBoardOrderFullLookup(built)) return;

      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(
          `${API_BASE_URL}/api/orders/lookup-for-modal/${encodeURIComponent(id)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        const json = await res.json();
        if (json.success && json.data) {
          commitOrder(
            mergeBoardOrderDetailPayload({
              cacheOrder: built || stubOrder,
              fullOrder: json.data,
              ctx: mergeCtx,
            })
          );
        }
      } catch {
        /* silencioso — mantém optimistic/stub se houver */
      }
    },
    [
      closeBoardOrderContextMenu,
      resolveOrderDetailFromBoardCaches,
      buildOrderDetailStateFromFound,
      technicianGroups,
      columnOrder,
      API_BASE_URL,
      setSelectedOrderForDetailsV2,
    ]
  );

  /* Sync modal v1 com cache do board — rollback junto com OrderDetailsModal
  React.useEffect(() => {
    const id = String(selectedOrderForDetails?.id ?? selectedOrderForDetails?.TB02115_CODIGO ?? '').trim();
    if (!id) return;
    const found = resolveOrderDetailFromBoardCaches(id);
    if (!found) return;
    setSelectedOrderForDetails((prev) => {
      if (!prev) return prev;
      const prevId = String(prev.id ?? prev.TB02115_CODIGO ?? '').trim();
      if (prevId !== id) return prev;
      const next = {
        ...prev,
        ...found.order,
        forecastGroup:
          found.boardTechnician != null && String(found.boardTechnician).trim() !== ''
            ? found.order.forecastGroup || found.forecastGroup
            : found.forecastGroup || found.order.forecastGroup || 'Em Aberto',
        detailModalBoardTechnician: found.boardTechnician ?? prev.detailModalBoardTechnician,
      };
      const same =
        String(prev.TB01024_NOME || '') === String(next.TB01024_NOME || '') &&
        String(prev.TB01073_NOME || '') === String(next.TB01073_NOME || '') &&
        String(prev.forecastGroup || '') === String(next.forecastGroup || '') &&
        String(prev.detailModalBoardTechnician || '') === String(next.detailModalBoardTechnician || '');
      return same ? prev : next;
    });
  }, [
    technicianGroups,
    technicianDataCache,
    availableOrdersState,
    selectedOrderForDetails?.id,
    selectedOrderForDetails?.TB02115_CODIGO,
    resolveOrderDetailFromBoardCaches,
  ]);
  */

  // Cleanup do timeout quando o componente for desmontado
  React.useEffect(() => {
    return () => {
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
    };
  }, []);

  // Função para buscar detalhes do pedido vinculado
  const fetchPedidoDetails = async (codigoPedido) => {
    setLoadingPedido(true);
    setPedidoError(null);
    setPedidoDetails(null);
    
    try {
      console.log(`🔍 Buscando detalhes do pedido: ${codigoPedido}`);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/pedido/${codigoPedido}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success) {
        console.log('✅ Detalhes do pedido carregados:', result.data);
        setPedidoDetails(result.data);
      } else {
        console.error('❌ Erro ao buscar pedido:', result.message);
        setPedidoError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição do pedido:', error);
      setPedidoError('Erro ao conectar com o servidor');
    } finally {
      setLoadingPedido(false);
    }
  };

  // Função para buscar linha do tempo do pedido
  const fetchTimelineData = async (codigoPedido) => {
    setLoadingTimeline(true);
    setTimelineError(null);
    
    try {
      console.log(`🕐 Buscando linha do tempo do pedido: ${codigoPedido}`);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/pedido/${codigoPedido}/timeline`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json();
      
      if (result.success) {
        console.log('✅ Linha do tempo carregada:', result.data);
        setTimelineData(result.data);
      } else {
        console.error('❌ Erro ao buscar linha do tempo:', result.message);
        setTimelineError(result.message);
      }
    } catch (error) {
      console.error('❌ Erro na requisição da linha do tempo:', error);
      setTimelineError('Erro ao conectar com o servidor');
    } finally {
      setLoadingTimeline(false);
    }
  };

  // Função para alternar exibição da linha do tempo
  const toggleTimeline = (codigoPedido) => {
    if (showTimeline) {
      // Se já está aberto, fechar
      setShowTimeline(false);
      setTimelineData(null);
      setTimelineError(null);
    } else {
      // Se está fechado, abrir e buscar dados
      setShowTimeline(true);
      fetchTimelineData(codigoPedido);
    }
  };

  // Função para formatar data em PT-BR
  const formatDateTimeBR = (dateString) => {
    if (!dateString) return 'Data não disponível';
    
    try {
      // Se for objeto Date, extrair valores UTC para evitar conversão de timezone
      if (dateString instanceof Date) {
        // Converter para ISO string e parsear diretamente (mantém valores originais)
        const isoString = dateString.toISOString();
        // ISO format: YYYY-MM-DDTHH:mm:ss.sssZ
        const match = isoString.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
        if (match) {
          const [, year, month, day, hours, minutes] = match;
          return `${day}/${month}/${year} ${hours}:${minutes}`;
        }
        // Fallback: usar métodos UTC
        const year = dateString.getUTCFullYear();
        const month = String(dateString.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dateString.getUTCDate()).padStart(2, '0');
        const hours = String(dateString.getUTCHours()).padStart(2, '0');
        const minutes = String(dateString.getUTCMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      }
      
      // Se for string, parsear diretamente
      let dateStr = String(dateString).trim();
      
      // Remover timezone (Z, +00:00, etc) e normalizar separador
      dateStr = dateStr.replace(/T/g, ' ').replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '');
      
      // Extrair componentes diretamente da string (aceita milissegundos)
      // Regex: YYYY-MM-DD HH:MM:SS.mmm ou YYYY-MM-DD HH:MM:SS
      const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?/);
      if (match) {
        const [, year, month, day, hours, minutes] = match;
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      }
      
      // Fallback para formato sem segundos: YYYY-MM-DD HH:MM
      const matchShort = dateStr.match(/(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})/);
      if (matchShort) {
        const [, year, month, day, hours, minutes] = matchShort;
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      }
      
      // Se não conseguir parsear, retornar original
      return dateString;
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return 'Data inválida';
    }
  };

  // Função para formatar data no formato dd/MM/yyyy
  const formatDateDDMMYYYY = (dateString) => {
    if (!dateString) return null;
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (e) {
      return null;
    }
  };

  const handleBoardOrderDragStart = React.useCallback(() => {
    // Não setar estado do App aqui: re-render do App ainda recria TechnicianServiceGroup
    // (interno) e pode interromper o HTML5 drag da OS.
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }
  }, []);
  const handleBoardOrderDragEnd = React.useCallback(() => {}, []);

  // Componente para agrupamento por previsão (usado apenas na seção FUTURA)
  const TechnicianForecastGroup = ({
    forecastDate,
    orders,
    technician,
    groupName,
    isDroppable,
    setIsDraggingOrder,
    onBoardOrderDragStart,
    onBoardOrderDragEnd,
  }) => {
    // Agrupar ordens por cidade dentro da previsão; enriquecer com grupo e data para reimpressão (PDF/Imprimir)
    const groupedByCity = React.useMemo(() => {
      const groups = {};
      orders.forEach(ordem => {
        const cidade = ordem.cidade || 'Sem Cidade';
        if (!groups[cidade]) {
          groups[cidade] = [];
        }
        groups[cidade].push({
          ...ordem,
          forecastGroup: groupName,
          groupForecastDate: forecastDate && typeof forecastDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(forecastDate) ? forecastDate.split('T')[0] : null
        });
      });
      return groups;
    }, [orders, groupName, forecastDate]);

    // Formatar data: se forecastDate for null ou string vazia, mostrar "Sem previsão"
    // forecastDate já vem no formato YYYY-MM-DD da chave do agrupamento
    let formattedDate = 'Sem previsão';
    if (forecastDate) {
      // Se já está no formato YYYY-MM-DD, formatar diretamente
      if (typeof forecastDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(forecastDate)) {
        const [year, month, day] = forecastDate.split('-');
        formattedDate = `${day}/${month}/${year}`;
      } else {
        // Tentar formatar como data
        formattedDate = formatDateDDMMYYYY(forecastDate) || 'Sem previsão';
      }
    }

    return (
      <div className="technician-forecast-group">
        <div className="forecast-group-header">
          <span className="forecast-group-title">{formattedDate}</span>
        </div>
        <div className="forecast-orders-container">
          {Object.entries(groupedByCity).map(([cidade, ordens]) => (
            <TechnicianCityGroup
              key={cidade}
              cidade={cidade}
              ordens={ordens}
              technician={technician}
              groupName={groupName}
              isDroppable={isDroppable}
              setIsDraggingOrder={setIsDraggingOrder}
              onBoardOrderDragStart={onBoardOrderDragStart}
              onBoardOrderDragEnd={onBoardOrderDragEnd}
              showDefeitoColumn={columnOrder.length === 1}
              codstatusRetorno={codstatusRetornoEmAberto}
              codstatusPedidoVinculadoDisponivel={codstatusPedidoVinculadoDisponivel}
              extraRetornoStatuses={extraRetornoStatusesEmAberto}
              selectedOrders={selectedOrders}
              setContextMenu={openBoardOrderContextMenu}
              handleOrderClick={handleOrderClick}
              userShowOSConfig={userShowOSConfig}
              setSelectedOrders={setSelectedOrders}
              defeitosData={defeitosData}
              loadingDefeitos={loadingDefeitos}
            />
          ))}
        </div>
      </div>
    );
  };

  const orderPassesTechnicianColumnFilters = React.useCallback((ordem) => {
    const f = selectedTechnicianColumnFilters;
    if (f.cidade.length > 0) {
      const cidade = ordem.TB02115_CIDADE || ordem.cidade || 'Não informado';
      if (!f.cidade.includes(cidade)) return false;
    }
    if (f.bairro.length > 0) {
      const bairro = ordem.TB02115_BAIRRO || ordem.bairro || 'Não informado';
      if (!f.bairro.includes(bairro)) return false;
    }
    if (f.cliente.length > 0) {
      const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME || 'Não informado';
      if (!f.cliente.includes(cliente)) return false;
    }
    if (f.tipoOS.length > 0) {
      if (!orderMatchesTipoOSFilter(ordem, f.tipoOS, getServiceTypeFromPreventiva)) return false;
    }
    if (f.sla.length > 0) {
      const sla = ordem.sla || 'Em dia';
      if (!f.sla.includes(sla)) return false;
    }
    if (f.equipamento.length > 0) {
      const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || '';
      if (!equipamento || !f.equipamento.includes(equipamento)) return false;
    }
    if (f.retorno != null && (codstatusRetornoEmAberto !== '' || extraRetornoStatusesEmAberto.length > 0)) {
      const isRetorno = isOrderRetornoByRequestStatus(ordem, codstatusRetornoEmAberto, extraRetornoStatusesEmAberto);
      const retornoFilter = f.retorno;
      if (retornoFilter === 'nao') {
        if (isRetorno) return false;
      } else if (retornoFilter && typeof retornoFilter === 'object' && (retornoFilter.aguardando || retornoFilter.liberado)) {
        if (!isRetorno) return false;
        const pedidoLiberado = isOrderPedidoLiberado(ordem, codstatusPedidoVinculadoDisponivel);
        if (retornoFilter.aguardando && retornoFilter.liberado) { /* manter */ }
        else if (retornoFilter.aguardando && pedidoLiberado) return false;
        else if (retornoFilter.liberado && !pedidoLiberado) return false;
      }
    }
    const dstr = (o, key) => String(o[key] ?? '').trim();
    if (f.defeitoDescricao.length > 0 && !f.defeitoDescricao.includes(dstr(ordem, 'defeito_descricao'))) return false;
    if (f.defeitoAlert.length > 0 && !f.defeitoAlert.includes(dstr(ordem, 'defeito_alert'))) return false;
    if (f.defeitoClassification.length > 0 && !f.defeitoClassification.includes(dstr(ordem, 'defeito_classification'))) return false;
    if (f.defeitoSeverity.length > 0 && !f.defeitoSeverity.includes(dstr(ordem, 'defeito_severity_level'))) return false;
    return true;
  }, [
    selectedTechnicianColumnFilters,
    codstatusRetornoEmAberto,
    extraRetornoStatusesEmAberto,
    codstatusPedidoVinculadoDisponivel
  ]);

  const orderMatchesTechnicianRetornoList = React.useCallback(
    (ordem) => boardCondtMatcher(ordem) && orderPassesTechnicianColumnFilters(ordem),
    [boardCondtMatcher, orderPassesTechnicianColumnFilters]
  );

  const TechnicianServiceGroup = ({
    groupName,
    orders,
    technician,
    allTechnicianOrdersForCondtTabs,
    isDroppable = true,
    setIsDraggingOrder,
    onBoardOrderDragStart,
    onBoardOrderDragEnd,
  }) => {
    const futuraHeaderTab = futuraRetornoHeaderTabByTechnician[technician] ?? null;
    const setFuturaHeaderTab = React.useCallback(
      (valueOrUpdater) => setFuturaRetornoTabForTechnician(technician, valueOrUpdater),
      [technician]
    );

    // Filtrar ordens por período se houver filtro ativo (apenas para FUTURA)
    const filteredOrders = React.useMemo(() => {
      if (groupName !== 'FUTURA') {
        return orders;
      }

      const applyDateRangeFilter = (list, range) => {
        if (!range || !range.startDate || !range.endDate) return list;
        const { startDate, endDate } = range;
        return list.filter((ordem) => {
          if (!ordem.schedule) {
            return false;
          }
          let dateStr = null;
          if (typeof ordem.schedule === 'string' && /^\d{4}-\d{2}-\d{2}/.test(ordem.schedule)) {
            dateStr = ordem.schedule.split('T')[0];
          } else {
            try {
              const scheduleDate = new Date(ordem.schedule);
              const year = scheduleDate.getUTCFullYear();
              const month = String(scheduleDate.getUTCMonth() + 1).padStart(2, '0');
              const day = String(scheduleDate.getUTCDate()).padStart(2, '0');
              dateStr = `${year}-${month}-${day}`;
            } catch (e) {
              return false;
            }
          }
          return dateStr >= startDate && dateStr <= endDate;
        });
      };

      let result = orders;

      if (selectedTechnicianColumnFilters.osFuturaRange) {
        result = applyDateRangeFilter(result, selectedTechnicianColumnFilters.osFuturaRange);
      }

      if (futuraDateFilter[technician]) {
        result = applyDateRangeFilter(result, futuraDateFilter[technician]);
      }

      return result;
    }, [orders, groupName, technician, futuraDateFilter, selectedTechnicianColumnFilters.osFuturaRange]);
    
    // Para a seção FUTURA, agrupar primeiro por previsão, depois por cidade
    const groupedByForecast = React.useMemo(() => {
      if (groupName !== 'FUTURA') {
        return null; // Não usar agrupamento por previsão para outras seções
      }

      const groups = {};
      filteredOrders.forEach(ordem => {
        // Usar schedule se existir, senão usar null para "Sem previsão"
        // Se schedule já está no formato YYYY-MM-DD, usar diretamente; caso contrário, converter
        let forecastKey = 'SEM_PREVISAO';
        if (ordem.schedule) {
          // Se schedule já é uma string no formato YYYY-MM-DD, usar diretamente
          if (typeof ordem.schedule === 'string' && /^\d{4}-\d{2}-\d{2}/.test(ordem.schedule)) {
            forecastKey = ordem.schedule.split('T')[0]; // Pegar apenas a parte da data se houver hora
          } else {
            // Se for um objeto Date ou outra string, converter
            try {
              const scheduleDate = new Date(ordem.schedule);
              // Usar UTC para evitar problemas de timezone
              const year = scheduleDate.getUTCFullYear();
              const month = String(scheduleDate.getUTCMonth() + 1).padStart(2, '0');
              const day = String(scheduleDate.getUTCDate()).padStart(2, '0');
              forecastKey = `${year}-${month}-${day}`;
            } catch (e) {
              forecastKey = 'SEM_PREVISAO';
            }
          }
        }
        
        // Se há filtro ativo, não incluir "SEM_PREVISAO"
        if (futuraDateFilter[technician] && forecastKey === 'SEM_PREVISAO') {
          return;
        }
        
        if (!groups[forecastKey]) {
          groups[forecastKey] = [];
        }
        groups[forecastKey].push(ordem);
      });

      // Ordenar as chaves: primeiro as datas (crescente), depois "SEM_PREVISAO" por último
      const sortedKeys = Object.keys(groups).sort((a, b) => {
        if (a === 'SEM_PREVISAO') return 1; // Sem previsão sempre por último
        if (b === 'SEM_PREVISAO') return -1;
        return a.localeCompare(b); // Ordenar datas em ordem crescente
      });

      return { groups, sortedKeys };
    }, [filteredOrders, groupName, technician, futuraDateFilter]);

    // Agrupar ordens por cidade (para seções que não são FUTURA).
    // Em serviço: processa primeiro OS em serviço/pausa, depois as de aguardando (ordem de inserção das cidades).
    const groupedByCity = React.useMemo(() => {
      if (groupName === 'FUTURA') {
        return null; // Não usar agrupamento por cidade direto para FUTURA
      }
      const groups = {};
      const ordered =
        groupName === 'Em serviço'
          ? [...filteredOrders].sort((a, b) => {
              const ra = a?.isAguardandoAssinatura ? 2 : a?.isAguardandoAtendimento ? 1 : 0;
              const rb = b?.isAguardandoAssinatura ? 2 : b?.isAguardandoAtendimento ? 1 : 0;
              return ra - rb;
            })
          : filteredOrders;
      ordered.forEach(ordem => {
        const cidade = ordem.cidade || 'Sem Cidade';
        if (!groups[cidade]) {
          groups[cidade] = [];
        }
        groups[cidade].push(ordem);
      });
      return groups;
    }, [filteredOrders, groupName]);

    const {
      showFuturaRetornoPendente,
      showFuturaRetornoLiberado,
      futuraRetornoHeaderLocked,
      futuraPendenteOrdersAll,
      futuraLiberadoOrdersAll,
      groupedRetornoByCity,
      groupedInboxFallback,
      inboxFallbackTab,
      headerFuturaCount
    } = useFuturaRetornoTechnicianLogic({
      groupName,
      ordersForCondtTabs: allTechnicianOrdersForCondtTabs,
      futuraHeaderTab,
      filteredOrders,
      matchesSearch: orderMatchesTechnicianRetornoList
    });

    const viewingRetornoPendente = showFuturaRetornoPendente || inboxFallbackTab === 'pendente';
    const viewingRetornoLiberado = showFuturaRetornoLiberado || inboxFallbackTab === 'liberado';
    const viewingRetorno = viewingRetornoPendente || viewingRetornoLiberado;
    const retornoTabForChrome = futuraHeaderTab ?? inboxFallbackTab;
    const futuraScheduleVisible = filteredOrders.length > 0;
    const retornoTabsOnly = viewingRetorno && !futuraScheduleVisible;

    const citySessionItems = React.useMemo(() => {
      if (!groupedByCity) return [];
      return Object.entries(groupedByCity).map(([cidade, ordens]) => ({
        key: cidade,
        cidade,
        ordens,
      }));
    }, [groupedByCity]);

    const forecastSessionItems = React.useMemo(() => {
      if (!groupedByForecast) return [];
      return groupedByForecast.sortedKeys.map((forecastKey) => ({
        key: forecastKey,
        forecastDate: forecastKey === 'SEM_PREVISAO' ? null : forecastKey,
        orders: groupedByForecast.groups[forecastKey],
      }));
    }, [groupedByForecast]);

    const serviceGroupDropActive = isDroppable && !futuraRetornoHeaderLocked;

    return (
      <div 
        className={`technician-service-group ${!serviceGroupDropActive ? 'no-drop' : ''}`}
        data-group={groupName}
        onDrop={(e) => {
          if (serviceGroupDropActive) {
            // Verificar se é drag de coluna - se for, não processar aqui (deixar borbulhar)
            const dragType = e.dataTransfer.getData('dragType');
            if (dragType === 'column') {
              return; // Deixar o evento borbulhar para a coluna processar
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            // Verificar se é um drop entre seções do mesmo técnico
            const fromTechnician = e.dataTransfer.getData('fromTechnician');
            const fromTechnicianName = e.dataTransfer.getData('fromTechnicianName');
            const fromGroup = e.dataTransfer.getData('fromGroup');
            const orderIds = getBoardDragOrderIds(e.dataTransfer, selectedOrders);
            
            if (fromTechnician === 'true' && fromTechnicianName && fromGroup) {
              // É um drop vindo de um técnico
              if (fromTechnicianName === technician && fromGroup !== groupName) {
              // É um drop entre seções do mesmo técnico
              handleDropBetweenTechnicianSections(technician, fromGroup, groupName, orderIds);
              } else if (fromTechnicianName !== technician) {
                // É um drop entre técnicos diferentes
                handleDropBetweenTechnicians(fromTechnicianName, technician, groupName, orderIds);
              }
              // mesma seção do mesmo técnico: ignorar
            } else {
              // É um drop da coluna "Em aberto" para o técnico
              handleDropToTechnique(technician, groupName, orderIds);
            }
          }
        }}
        onDragOver={(e) => {
          if (serviceGroupDropActive) {
            // Verificar se é drag de coluna - se for, não processar aqui
            const types = Array.from(e.dataTransfer.types || []);
            if (types.includes('columnIndex') || types.includes('dragType')) {
              return; // Deixar o evento borbulhar para a coluna processar
            }
            e.preventDefault();
          }
        }}
      >
        <div className="service-group-header">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap:
                groupName === 'FUTURA' &&
                futuraRetornoTabsEnabled &&
                (!viewingRetorno || retornoTabsOnly)
                  ? 'nowrap'
                  : 'wrap',
              flex: 1,
              minWidth: 0,
            }}
          >
            {!retornoTabsOnly && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                flexWrap:
                  groupName === 'FUTURA' &&
                  futuraRetornoTabsEnabled &&
                  !viewingRetorno
                    ? 'nowrap'
                    : 'wrap',
                flex: '1 1 auto',
                minWidth: 0,
                ...(futuraRetornoHeaderLocked &&
                !(
                  groupName === 'FUTURA' &&
                  futuraRetornoTabsEnabled &&
                  (showFuturaRetornoPendente || showFuturaRetornoLiberado)
                )
                  ? { opacity: 0.45, pointerEvents: 'none' }
                  : {}),
              }}
            >
              {groupName === 'FUTURA' && futuraRetornoTabsEnabled && viewingRetorno ? (
                <div className="service-group-futura-retorno-title-row">
                  <span className="service-group-title">
                    {viewingRetornoPendente ? 'RETORNOS PENDENTES' : 'RETORNOS LIBERADOS'}
                  </span>
                  {futuraRetornoHeaderLocked && futuraScheduleVisible ? (
                    <button
                      type="button"
                      className="service-group-futura-close"
                      aria-label="Voltar para visão FUTURA"
                      onClick={() => setFuturaHeaderTab(null)}
                    >
                      ×
                    </button>
                  ) : null}
                </div>
              ) : (
                <>
                  <span className="service-group-title">
                    {groupName}
                  </span>
                  <span className="service-group-count">{headerFuturaCount}</span>
                  {groupName === 'FUTURA' && orders.length > 0 && (
                    <FuturaDateFilterButton
                      technician={technician}
                      orders={orders}
                      currentFilter={futuraDateFilter[technician]}
                      isOpen={showFuturaDateFilter[technician]}
                      onToggle={() => {
                        setShowFuturaDateFilter(prev => ({
                          ...prev,
                          [technician]: !prev[technician]
                        }));
                      }}
                      onFilter={(startDate, endDate) => {
                        setFuturaDateFilter(prev => ({
                          ...prev,
                          [technician]: { startDate, endDate }
                        }));
                        setShowFuturaDateFilter(prev => ({
                          ...prev,
                          [technician]: false
                        }));
                      }}
                      onClear={() => {
                        setFuturaDateFilter(prev => {
                          const newFilter = { ...prev };
                          delete newFilter[technician];
                          return newFilter;
                        });
                        setShowFuturaDateFilter(prev => ({
                          ...prev,
                          [technician]: false
                        }));
                      }}
                      onClose={() => {
                        setShowFuturaDateFilter(prev => ({
                          ...prev,
                          [technician]: false
                        }));
                      }}
                    />
                  )}
                </>
              )}
            </div>
            )}
            {groupName === 'FUTURA' &&
              futuraRetornoTabsEnabled &&
              (!futuraRetornoHeaderLocked || !futuraScheduleVisible) && (
                <FuturaRetornoTechnicianTabs
                  futuraHeaderTab={retornoTabForChrome}
                  setFuturaHeaderTab={setFuturaHeaderTab}
                  futuraPendenteOrdersAll={futuraPendenteOrdersAll}
                  futuraLiberadoOrdersAll={futuraLiberadoOrdersAll}
                />
              )}
          </div>
        </div>
        {futuraRetornoHeaderLocked || groupedInboxFallback ? (
          <FuturaRetornoTechnicianOrdersPanel
            groupedRetornoByCity={futuraRetornoHeaderLocked ? groupedRetornoByCity : groupedInboxFallback}
            technician={technician}
            groupName={groupName}
            isDroppable={isDroppable && !futuraRetornoHeaderLocked}
            setIsDraggingOrder={setIsDraggingOrder}
            onBoardOrderDragStart={onBoardOrderDragStart}
            onBoardOrderDragEnd={onBoardOrderDragEnd}
            showDefeitoColumn={columnOrder.length === 1}
            codstatusRetornoEmAberto={codstatusRetornoEmAberto}
            codstatusPedidoVinculadoDisponivel={codstatusPedidoVinculadoDisponivel}
            extraRetornoStatusesEmAberto={extraRetornoStatusesEmAberto}
            selectedOrders={selectedOrders}
            setContextMenu={(menu) =>
              openBoardOrderContextMenu(
                viewingRetornoLiberado ? { ...menu, futuraRetornoTab: 'liberado' } : menu
              )
            }
            handleOrderClick={(ordem, tech, section) =>
              handleOrderClick(
                viewingRetornoLiberado ? { ...ordem, fromFuturaRetornoLiberado: true } : ordem,
                tech,
                section
              )
            }
            userShowOSConfig={userShowOSConfig}
            setSelectedOrders={setSelectedOrders}
            defeitosData={defeitosData}
            loadingDefeitos={loadingDefeitos}
          />
        ) : (
          <>
            {filteredOrders.length > 0 && (
              groupName === 'FUTURA' && groupedByForecast ? (
                <TechnicianSessionVirtualList
                  groupName={groupName}
                  items={forecastSessionItems}
                  estimateSize={estimateTechnicianForecastBlockSize}
                  getItemKey={(item) => item.key}
                >
                  {(item) => (
                    <TechnicianForecastGroup
                      forecastDate={item.forecastDate}
                      orders={item.orders}
                      technician={technician}
                      groupName={groupName}
                      isDroppable={isDroppable}
                      setIsDraggingOrder={setIsDraggingOrder}
                      onBoardOrderDragStart={onBoardOrderDragStart}
                      onBoardOrderDragEnd={onBoardOrderDragEnd}
                    />
                  )}
                </TechnicianSessionVirtualList>
              ) : (
                <TechnicianSessionVirtualList
                  groupName={groupName}
                  items={citySessionItems}
                  estimateSize={estimateTechnicianCityBlockSize}
                  getItemKey={(item) => item.key}
                >
                  {(item) => (
                    <TechnicianCityGroup
                      cidade={item.cidade}
                      ordens={item.ordens}
                      technician={technician}
                      groupName={groupName}
                      isDroppable={isDroppable}
                      setIsDraggingOrder={setIsDraggingOrder}
                      onBoardOrderDragStart={onBoardOrderDragStart}
                      onBoardOrderDragEnd={onBoardOrderDragEnd}
                      codstatusRetorno={codstatusRetornoEmAberto}
                      codstatusPedidoVinculadoDisponivel={codstatusPedidoVinculadoDisponivel}
                      extraRetornoStatuses={extraRetornoStatusesEmAberto}
                      selectedOrders={selectedOrders}
                      setContextMenu={openBoardOrderContextMenu}
                      handleOrderClick={handleOrderClick}
                      userShowOSConfig={userShowOSConfig}
                      setSelectedOrders={setSelectedOrders}
                      defeitosData={defeitosData}
                      loadingDefeitos={loadingDefeitos}
                    />
                  )}
                </TechnicianSessionVirtualList>
              )
            )}
            {filteredOrders.length === 0 && isDroppable && (
              <div className="empty-service-group">
                Arraste ordens aqui
              </div>
            )}
          </>
        )}
        

      </div>
    );
  };

  // Inicializar filtros para todos os técnicos quando technicianGroups mudar
  React.useEffect(() => {
    const technicianKeys = Object.keys(technicianGroups);
    if (technicianKeys.length > 0) {
      setTechnicianFilters(prev => {
        let hasChanges = false;
        const newFilters = { ...prev };
        
        technicianKeys.forEach(technician => {
          if (!prev[technician]) {
            hasChanges = true;
            // Todas as seções vêm habilitadas por padrão - usuário pode filtrar depois se quiser
            newFilters[technician] = {
              'Previsto para hoje': true,
              'Previstas para amanhã': true,
              'FUTURA': true
            };
          }
        });
        
        return hasChanges ? newFilters : prev;
      });
    }
  }, [technicianGroups]);

  // Sincronizar filtro geral de previsão com filtros individuais das colunas
  React.useEffect(() => {
    const technicianKeys = Object.keys(technicianGroups);
    const previsaoSelecionadas = selectedTechnicianColumnFilters.previsao || [];
    const hasPrevisaoFilter = previsaoSelecionadas.length > 0;
    
    setTechnicianFilters(prev => {
      let hasChanges = false;
      const newFilters = { ...prev };
      
      technicianKeys.forEach(technician => {
        // Sem filtro global (vazio): todas as seções de previsão visíveis.
        // Com filtro: só as chaves selecionadas.
        const sectionFlags = {
          'Previsto para hoje': hasPrevisaoFilter
            ? previsaoSelecionadas.includes('Previsto para hoje')
            : true,
          'Previstas para amanhã': hasPrevisaoFilter
            ? previsaoSelecionadas.includes('Previstas para amanhã')
            : true,
          'FUTURA': hasPrevisaoFilter ? previsaoSelecionadas.includes('FUTURA') : true,
        };

        const prevTech = newFilters[technician];
        if (
          !prevTech ||
          prevTech['Previsto para hoje'] !== sectionFlags['Previsto para hoje'] ||
          prevTech['Previstas para amanhã'] !== sectionFlags['Previstas para amanhã'] ||
          prevTech.FUTURA !== sectionFlags.FUTURA
        ) {
          hasChanges = true;
          newFilters[technician] = { ...(prevTech || {}), ...sectionFlags };
        }
      });
      
      return hasChanges ? newFilters : prev;
    });
  }, [selectedTechnicianColumnFilters.previsao, technicianGroups]);

  // Previsão: opções com OS aplicam sozinhas (seleção subtrativa — o usuário só remove).
  React.useEffect(() => {
    const technicianKeys = Object.keys(technicianGroups || {});
    if (!technicianKeys.length) return;

    const nextAvailable = getAvailablePrevisaoKeys(technicianGroups);
    const prevAvailable = prevAvailablePrevisaoRef.current;
    const newlyAppeared = nextAvailable.filter((k) => !prevAvailable.includes(k));
    prevAvailablePrevisaoRef.current = nextAvailable;

    setSelectedTechnicianColumnFilters((prev) => {
      const cur = Array.isArray(prev.previsao) ? prev.previsao : [];
      const nextPrevisao = nextPrevisaoSelection(cur, nextAvailable, newlyAppeared);
      if (previsaoSelectionEquals(cur, nextPrevisao)) return prev;
      return { ...prev, previsao: nextPrevisao };
    });
  }, [technicianGroups, selectedTechnicianColumnFilters.previsao]);

  // Função para toggle do filtro de técnico (memoizada)
  const toggleTechnicianFilter = React.useCallback((technician, groupName) => {
    setTechnicianFilters(prev => ({
      ...prev,
      [technician]: {
        ...prev[technician],
        [groupName]: !prev[technician]?.[groupName]
      }
    }));
  }, []);

  // Função para aplicar filtros de técnico (memoizada)
  const getFilteredTechnicianGroups = React.useCallback((technician) => {
    // Definir seções padrão que sempre devem aparecer
    const standardSections = ['Em deslocamento', 'Em serviço', 'Previsto para hoje', 'Previstas para amanhã', 'FUTURA'];
    
    // Função auxiliar para aplicar filtros globais das colunas de técnicos
    const applyGlobalFilters = (orders) => orders.filter(orderPassesTechnicianColumnFilters);
    
    if (!technicianGroups[technician] || !technicianFilters[technician]) {
      // Aplicar filtros globais e busca quando não há filtros de técnico
      const technicianData = normalizeTechnicianLiveServiceGroups(technicianGroups[technician] || {});
      const filteredData = {};
      
    // Garantir que todas as seções padrão apareçam, mesmo vazias
    standardSections.forEach(sectionName => {
      // Aplicar filtro de previsão primeiro (filtrar quais seções aparecem)
      // Seções ativas (deslocamento/serviço) não são afetadas pelo filtro de previsão
      if (selectedTechnicianColumnFilters.previsao.length > 0 && !isBoardLiveServiceGroup(sectionName)) {
        if (!selectedTechnicianColumnFilters.previsao.includes(sectionName)) {
          return;
        }
      }
      
      const sectionOrders = technicianData[sectionName] || [];
      const globallyFiltered = applyGlobalFilters(sectionOrders, sectionName);
      let sectionList = filterOrdersBySearch(globallyFiltered, searchTerm);
      if (slaFiltrarConfig?.deadlineMs != null) {
        sectionList = sectionList.filter((o) => isOrderWithinSlaFiltrarDeadline(o, slaFiltrarConfig.deadlineMs));
      }
      if (isBoardLiveServiceGroup(sectionName)) {
        if (sectionList.length > 0) {
          filteredData[sectionName] = sectionList;
        }
      } else {
        filteredData[sectionName] = sectionList;
      }
    });
      
      return filteredData;
    }

    const filtered = {};
    const technicianDataNormalized = normalizeTechnicianLiveServiceGroups(technicianGroups[technician] || {});
    
    // Garantir que todas as seções padrão apareçam, mesmo vazias
    standardSections.forEach(groupName => {
      // Aplicar filtro de previsão primeiro (filtrar quais seções aparecem)
      // Seções ativas (deslocamento/serviço) não são afetadas pelo filtro de previsão
      if (selectedTechnicianColumnFilters.previsao.length > 0 && !isBoardLiveServiceGroup(groupName)) {
        if (!selectedTechnicianColumnFilters.previsao.includes(groupName)) {
          return;
        }
      }
      
      const orders = technicianDataNormalized[groupName] || [];
      
      // Aplicar filtros globais primeiro
      let globallyFiltered = applyGlobalFilters(orders, groupName);
      if (slaFiltrarConfig?.deadlineMs != null) {
        globallyFiltered = globallyFiltered.filter((o) => isOrderWithinSlaFiltrarDeadline(o, slaFiltrarConfig.deadlineMs));
      }
      
      // Seções ativas só quando houver OS
      if (isBoardLiveServiceGroup(groupName)) {
        const list = filterOrdersBySearch(globallyFiltered, searchTerm);
        if (list.length > 0) {
          filtered[groupName] = list;
        }
      } else if (technicianFilters[technician][groupName]) {
        filtered[groupName] = filterOrdersBySearch(globallyFiltered, searchTerm);
      }
    });
    
    return filtered;
  }, [technicianGroups, technicianFilters, searchTerm, selectedTechnicianColumnFilters, orderPassesTechnicianColumnFilters, codstatusRetornoEmAberto, codstatusPedidoVinculadoDisponivel, slaFiltrarConfig]);

  // Com busca ativa: exibir apenas colunas de técnicos que tenham ao menos uma ordem no filtro (Em aberto permanece sempre visível)
  // Com "Somente técnicos com OS": ocultar colunas com total 0
  // Com filtro "OS futura" por período: exibir apenas técnicos que tenham OS futura no período
  const visibleTechnicianColumnsForBoard = React.useMemo(() => {
    let list = columnOrder;
    if (searchTerm && String(searchTerm).trim()) {
      list = list.filter(tech => {
        const data = getFilteredTechnicianGroups(tech);
        const total = Object.values(data || {}).reduce((sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0), 0);
        if (total > 0) return true;
        if (!futuraRetornoTabsEnabled) return false;
        const { pendente, liberado } = computeFuturaCondtTabListsWithMatcher(technicianGroups, tech, orderMatchesTechnicianRetornoList);
        return pendente.length + liberado.length > 0;
      });
    }
    if (slaFiltrarConfig?.deadlineMs != null) {
      list = list.filter(tech => {
        const data = getFilteredTechnicianGroups(tech);
        const total = Object.values(data || {}).reduce((sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0), 0);
        return total > 0;
      });
    }
    if (onlyTechniciansWithOS) {
      list = filterTechnicianColumnsByHasOrders(list, technicianGroups);
    }
    if (selectedTechnicianColumnFilters.osFuturaRange) {
      list = filterTechnicianColumnsByFuturaRange(list, technicianGroups, selectedTechnicianColumnFilters.osFuturaRange);
    }
    return list;
  }, [columnOrder, searchTerm, getFilteredTechnicianGroups, onlyTechniciansWithOS, technicianGroups, selectedTechnicianColumnFilters.osFuturaRange, slaFiltrarConfig, futuraRetornoTabsEnabled, orderMatchesTechnicianRetornoList]);

  React.useEffect(() => {
    if (!futuraRetornoTabsEnabled) return;
    if (!searchTerm || !String(searchTerm).trim()) return;
    if (!technicianGroups || !columnOrder?.length) return;

    columnOrder.forEach((technician) => {
      const { pendente, liberado } = computeFuturaCondtTabListsWithMatcher(
        technicianGroups,
        technician,
        orderMatchesTechnicianRetornoList
      );
      const next = pickFuturaRetornoTabForSearch(
        pendente,
        liberado,
        futuraRetornoHeaderTabByTechnician[technician] ?? null
      );
      const cur = futuraRetornoHeaderTabByTechnician[technician] ?? null;
      if (next !== cur) {
        setFuturaRetornoTabForTechnician(technician, next);
      }
    });
  }, [
    futuraRetornoTabsEnabled,
    searchTerm,
    technicianGroups,
    columnOrder,
    orderMatchesTechnicianRetornoList,
    futuraRetornoHeaderTabByTechnician
  ]);

  const minimizedTechSet = React.useMemo(() => new Set(minimizedTechnicianColumns), [minimizedTechnicianColumns]);

  const boardVisibleTechnicians = React.useMemo(
    () => visibleTechnicianColumnsForBoard.filter((t) => !minimizedTechSet.has(t)),
    [visibleTechnicianColumnsForBoard, minimizedTechSet]
  );

  // Empilha de forma adaptável ao filtro (2 ou 3). Sobra à direita fica solta.
  React.useEffect(() => {
    const size = normalizeTechnicianColumnStack(currentUser?.technician_column_stack);
    const stackPrefUserId = currentUser?.id || null;
    if (boardStackPrefAppliedUserRef.current !== stackPrefUserId) {
      boardStackPrefAppliedUserRef.current = stackPrefUserId;
    }
    setTechnicianColumnStacks((prev) => {
      const next = size >= 2
        ? applyVerticalGroupStacks(boardVisibleTechnicians, size)
        : pruneTechnicianColumnStacks(prev, boardVisibleTechnicians);
      if (areTechnicianColumnStacksEqual(prev, next)) return prev;
      return next;
    });
  }, [boardVisibleTechnicians, currentUser?.id, currentUser?.technician_column_stack]);

  const boardTechnicianColumnSlots = React.useMemo(
    () => getTechnicianColumnSlots(boardVisibleTechnicians, technicianColumnStacks),
    [boardVisibleTechnicians, technicianColumnStacks]
  );

  const boardVisibleTechnicianIds = React.useMemo(
    () =>
      boardVisibleTechnicians
        .map((name) => getTechnicianIdByName(name))
        .filter((id) => id != null && String(id).trim() !== '')
        .map((id) => String(id)),
    [boardVisibleTechnicians, getTechnicianIdByName]
  );
  const trackableTechnicianIds = useBoardTrackableTechnicians(
    boardVisibleTechnicianIds,
    currentUser?.go_id_produto
  );
  const lunchStartedAtByTechId = useBoardActiveLunchTechnicians(boardVisibleTechnicianIds, {
    enabled:
      activeSection === 'Board' &&
      !showConfigMenu &&
      !APP_FULL_PAGE_ROUTES.includes(location.pathname),
  });
  const avatarUrlByTechId = useBoardTechnicianAvatars(boardVisibleTechnicianIds, {
    enabled:
      activeSection === 'Board' &&
      !showConfigMenu &&
      !APP_FULL_PAGE_ROUTES.includes(location.pathname),
  });

  const futuraRetornoBellTechnicianScope = React.useMemo(
    () => (Array.isArray(columnOrder) ? columnOrder : []),
    [columnOrder]
  );

  const technicianGroupsForFuturaBell = React.useMemo(
    () => ({ ...technicianDataCache, ...technicianGroups }),
    [technicianDataCache, technicianGroups]
  );

  const futuraRetornoBellClientState = React.useMemo(
    () => computeFuturaRetornoBoardBellState(technicianGroupsForFuturaBell, futuraRetornoBellTechnicianScope, boardCondtMatcher),
    [technicianGroupsForFuturaBell, futuraRetornoBellTechnicianScope, boardCondtMatcher]
  );
  const futuraRetornoBellClientSummary = React.useMemo(
    () => computeFuturaRetornoBoardBellTechnicianSummary(technicianGroupsForFuturaBell, futuraRetornoBellTechnicianScope, boardCondtMatcher),
    [technicianGroupsForFuturaBell, futuraRetornoBellTechnicianScope, boardCondtMatcher]
  );

  const futuraRetornoBellForUi = React.useMemo(() => {
    const hasLocalBoardData = Object.keys(technicianGroupsForFuturaBell || {}).length > 0;
    if (!hasLocalBoardData && futuraRetornoBellApi.loaded) {
      return { mode: futuraRetornoBellApi.mode, rows: futuraRetornoBellApi.rows };
    }
    return {
      mode: futuraRetornoBellClientState.active ? futuraRetornoBellClientState.mode : null,
      rows: futuraRetornoBellClientSummary.rows
    };
  }, [
    technicianGroupsForFuturaBell,
    futuraRetornoBellApi.loaded,
    futuraRetornoBellApi.mode,
    futuraRetornoBellApi.rows,
    futuraRetornoBellClientState.active,
    futuraRetornoBellClientState.mode,
    futuraRetornoBellClientSummary.rows
  ]);

  const minimizedOrderedForBar = React.useMemo(
    () => columnOrder.filter((t) => minimizedTechSet.has(t)),
    [columnOrder, minimizedTechSet]
  );

  React.useEffect(() => {
    const allowed = new Set(visibleTechnicianColumnsForBoard);
    setMinimizedTechnicianColumns((prev) => {
      const next = prev.filter((t) => allowed.has(t));
      return next.length === prev.length ? prev : next;
    });
  }, [visibleTechnicianColumnsForBoard]);

  const minimizeTechnicianColumn = React.useCallback((name) => {
    setMinimizedTechnicianColumns((prev) => (prev.includes(name) ? prev : [...prev, name]));
  }, []);

  const restoreTechnicianColumn = React.useCallback((name) => {
    setMinimizedTechnicianColumns((prev) => prev.filter((t) => t !== name));
  }, []);

  const handleFuturaBellTechnicianColumnActivate = React.useCallback(
    (rawName) => {
      const trimmed = String(rawName || '').trim();
      if (!trimmed) return;

      setSearchTerm('');

      const tecnicoMatch = teamData?.tecnicos?.find(
        (t) =>
          t.nome === trimmed || (t.nome && trimmed && t.nome.toLowerCase() === trimmed.toLowerCase())
      );
      const canonical = tecnicoMatch?.nome || trimmed;

      setSelectedFilterItems((prev) => {
        const next = {
          coordenador: [...prev.coordenador],
          area: [...prev.area],
          tecnico: [...prev.tecnico]
        };
        if (tecnicoMatch) {
          const area = teamData.areas?.find((a) => a.id === tecnicoMatch.areaId);
          const coord = area ? teamData.coordenadores?.find((c) => c.id === area.coordenadorId) : null;
          if (coord?.nome && !next.coordenador.includes(coord.nome)) next.coordenador.push(coord.nome);
          if (area?.nome && !next.area.includes(area.nome)) next.area.push(area.nome);
          if (!next.tecnico.includes(canonical)) next.tecnico.push(canonical);
        } else if (!next.tecnico.includes(canonical)) {
          next.tecnico.push(canonical);
        }
        return next;
      });

      setPendingFuturaBellColumnFocus(canonical);
    },
    [teamData]
  );

  React.useEffect(() => {
    if (!pendingFuturaBellColumnFocus) return;
    const target = pendingFuturaBellColumnFocus;
    const visible = visibleTechnicianColumnsForBoard;
    const match = visible.find(
      (t) => t === target || (t && target && t.toLowerCase() === target.toLowerCase())
    );
    if (!match) return;
    setMinimizedTechnicianColumns(visible.filter((t) => t !== match));
    setPendingFuturaBellColumnFocus(null);
  }, [pendingFuturaBellColumnFocus, visibleTechnicianColumnsForBoard]);

  const getTechHojeCountForMinBar = React.useCallback(
    (tech) => {
      const g = getFilteredTechnicianGroups(tech);
      return g['Previsto para hoje']?.length || 0;
    },
    [getFilteredTechnicianGroups]
  );

  const getTechCompletedCountForMinBar = React.useCallback(
    (tech) => technicianCompletedCounts[tech] || 0,
    [technicianCompletedCounts]
  );

  // Áreas/técnicos do menu "Alterar técnico" / Encaminhar: hierarquia completa da equipe
  // (independente de coluna visível, de filtro só com OS e de seleção atual no board).
  const areasWithTechniciansForContextMenu = React.useMemo(
    () => buildAreasWithTechniciansFromTeamData(teamData),
    [teamData]
  );

  const orderDetailsCanEncaminharChamado = React.useMemo(() => {
    const activeOrder = selectedOrderForDetails || selectedOrderForDetailsV2 || selectedOrderForDetailsMock;
    if (!activeOrder) return false;
    // Não exige colunas de técnicos visíveis — lista vem da hierarquia de equipe.
    if (!areasWithTechniciansForContextMenu?.length) return false;
    const id = String(activeOrder.id ?? activeOrder.TB02115_CODIGO ?? '').trim();
    if (!id) return false;
    const found = resolveOrderDetailFromBoardCaches(id);
    const fg = String(activeOrder.forecastGroup || found?.forecastGroup || '').trim();
    const isEmAberto = fg.toLowerCase() === 'em aberto';
    const boardTech = activeOrder.detailModalBoardTechnician || found?.boardTechnician || '';
    if (!isEmAberto && !boardTech) return false;
    return true;
  }, [
    selectedOrderForDetails,
    selectedOrderForDetailsV2,
    selectedOrderForDetailsMock,
    areasWithTechniciansForContextMenu,
    resolveOrderDetailFromBoardCaches,
  ]);

  const renderBoardTechnicianColumn = ({ key, ...columnProps }) => (
    <TechnicianColumn
      key={key}
      ServiceGroup={TechnicianServiceGroup}
      getFilteredTechnicianGroups={getFilteredTechnicianGroups}
      technicianGroups={technicianGroups}
      selectedOrders={selectedOrders}
      handleDropBetweenTechnicianSections={handleDropBetweenTechnicianSections}
      handleDropBetweenTechnicians={handleDropBetweenTechnicians}
      handleDropToTechnique={handleDropToTechnique}
      handleBoardOrderDragStart={handleBoardOrderDragStart}
      handleBoardOrderDragEnd={handleBoardOrderDragEnd}
      technicianColumnScrollRefs={technicianColumnScrollRefs}
      technicianCompletedCounts={technicianCompletedCounts}
      technicianCompletedDetails={technicianCompletedDetails}
      isMenuOpen={Boolean(showTechnicianMenu[columnProps.technician])}
      currentUser={currentUser}
      getTechnicianIdByName={getTechnicianIdByName}
      avatarUrlByTechId={avatarUrlByTechId}
      trackableTechnicianIds={trackableTechnicianIds}
      lunchStartedAtByTechId={lunchStartedAtByTechId}
      setTechnicianPanelMock={setTechnicianPanelMock}
      setSelectedFilterItems={setSelectedFilterItems}
      isRefreshingColumn={refreshingTechnicianColumns.has(columnProps.technician)}
      handleTechnicianColumnUnstack={handleTechnicianColumnUnstack}
      handleTechnicianColumnStack={handleTechnicianColumnStack}
      toggleTechnicianMenu={toggleTechnicianMenu}
      updateTechnicianMenuPosition={updateTechnicianMenuPosition}
      handleColumnReorder={handleColumnReorder}
      boardTechnicianColumnSlots={boardTechnicianColumnSlots}
      columnOrder={columnOrder}
      {...columnProps}
    />
  );

  // Função utilitária para requisições com retry e timeout aumentado
  const fetchWithRetry = async (url, options = {}, description = 'requisição') => {
    const maxAttempts = 2; // Reduzir para 2 tentativas
    const timeoutMs = 45000; // 45 segundos (menor que o backend de 30s + 15s buffer)
    let lastError;
    
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        // Criar AbortController para timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
          controller.abort();
        }, timeoutMs);
        
        const response = await fetch(url, {
          ...options,
          signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        return response; // Sucesso, retornar resposta
        
      } catch (error) {
        lastError = error;
        console.error(`❌ Erro na tentativa ${attempt} para ${description}:`, error);
        
        // Se é um erro de abort (timeout), ou se é a última tentativa
        if (error.name === 'AbortError') {
          console.log(`⏰ Timeout na tentativa ${attempt}${attempt < maxAttempts ? ', retentando em 2 segundos...' : ''}`);
        }
        
        if (attempt === maxAttempts) {
          throw error; // Última tentativa falhou
        }
        
        // Aguardar 5 segundos antes da próxima tentativa (tempo para o banco se recuperar)
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
    }
    
    throw lastError || new Error('Falha em todas as tentativas de conexão');
  };

  // Componente do modal do roteiro de hoje
  const TodayRouteModal = ({ technician, isOpen, onClose }) => {
    // Estados para dados reais da API
    const [routeData, setRouteData] = useState([]);
    const [isLoadingRoute, setIsLoadingRoute] = useState(false);
    const [routeError, setRouteError] = useState(null);
    
    // Estados para ordens concluídas
    const [completedData, setCompletedData] = useState([]);
    const [isLoadingCompleted, setIsLoadingCompleted] = useState(false);
    const [completedError, setCompletedError] = useState(null);
    
    // Estados para roteiro (aba Roteiro)
    const [routeScheduleData, setRouteScheduleData] = useState([]);
    const [isLoadingRouteSchedule, setIsLoadingRouteSchedule] = useState(false);
    const [routeScheduleError, setRouteScheduleError] = useState(null);
    const [selectedRouteDate, setSelectedRouteDate] = useState('');
    
    // Estados para ordens finalizadas (aba Concluídas)
    const [finishedData, setFinishedData] = useState([]);
    const [isLoadingFinished, setIsLoadingFinished] = useState(false);
    const [finishedError, setFinishedError] = useState(null);
    const [selectedFinishedDate, setSelectedFinishedDate] = useState('');
    
    // Estados para reordenação
    const [draggedItem, setDraggedItem] = useState(null);
    const [showSequenceInput, setShowSequenceInput] = useState(null);
    const [sequenceInputValue, setSequenceInputValue] = useState('');
    const [isReordering, setIsReordering] = useState(false);
    const [retryAttempt, setRetryAttempt] = useState(0);
    
    // Estados para sidebar de detalhes
    const [showDetailsSidebar, setShowDetailsSidebar] = useState(false);
    const [selectedCompletedOrder, setSelectedCompletedOrder] = useState(null);
    const [pendingParts, setPendingParts] = useState([]);
    const [usedParts, setUsedParts] = useState([]);
    const [isLoadingParts, setIsLoadingParts] = useState(false);
    const [showDefeitoDetails, setShowDefeitoDetails] = useState(false);
    const [defeitoData, setDefeitoData] = useState(null);
    const [loadingDefeito, setLoadingDefeito] = useState(false);
    const [defeitoError, setDefeitoError] = useState(null);
    const [stockTooltip, setStockTooltip] = useState(null);
    const [stockData, setStockData] = useState(null);
    const [loadingStock, setLoadingStock] = useState(false);
    const [stockError, setStockError] = useState(null);
    const [stockProductName, setStockProductName] = useState(null);
    const [showSimilarProducts, setShowSimilarProducts] = useState(false);
    const [showStockByCompany, setShowStockByCompany] = useState(false);
    
    // Estados para histórico de peças trocadas
    const [showPartsHistory, setShowPartsHistory] = useState(false);
    const [partsHistory, setPartsHistory] = useState([]);
    const [loadingPartsHistory, setLoadingPartsHistory] = useState(false);
    const [partsHistoryError, setPartsHistoryError] = useState(null);
    
    // Estados para histórico de atendimentos
    const [showServiceHistory, setShowServiceHistory] = useState(false);
    const [serviceHistory, setServiceHistory] = useState([]);
    const [loadingServiceHistory, setLoadingServiceHistory] = useState(false);
    
    // Estado para controlar scrollbar visível durante scroll
    const [isListScrolling, setIsListScrolling] = useState(false);
    const listScrollRef = useRef(null);
    const [serviceHistoryError, setServiceHistoryError] = useState(null);
    
    // Estado para controlar a aba ativa
    const [activeTab, setActiveTab] = useState('route');
    
    // Estado para controlar visibilidade do date picker na aba Roteiro
    const [showRouteDatePicker, setShowRouteDatePicker] = useState(false);
    const [routeDatePickerValue, setRouteDatePickerValue] = useState('');
    
    // Estado para controlar colapso da coluna "Em aberto"
    const [isLeftColumnCollapsed, setIsLeftColumnCollapsed] = useState(false);
    
    // Estados para sidebar de detalhes na área "Check-out pendente"
    const [showRouteDetailsSidebar, setShowRouteDetailsSidebar] = useState(false);
    const [selectedRouteOrder, setSelectedRouteOrder] = useState(null);
    const [routeOrderDetailLoading, setRouteOrderDetailLoading] = useState(false);
    const [routePendingParts, setRoutePendingParts] = useState([]);
    const [routeUsedParts, setRouteUsedParts] = useState([]);
    const [isLoadingRouteParts, setIsLoadingRouteParts] = useState(false);
    const [showRouteDefeitoDetails, setShowRouteDefeitoDetails] = useState(false);
    const [routeDefeitoData, setRouteDefeitoData] = useState(null);
    const [loadingRouteDefeito, setLoadingRouteDefeito] = useState(false);
    const [routeDefeitoError, setRouteDefeitoError] = useState(null);
    const [routeStockTooltip, setRouteStockTooltip] = useState(null);
    const [routeStockData, setRouteStockData] = useState(null);
    const [loadingRouteStock, setLoadingRouteStock] = useState(false);
    const [routeStockError, setRouteStockError] = useState(null);
    const [routeStockProductName, setRouteStockProductName] = useState(null);
    const [showRouteSimilarProducts, setShowRouteSimilarProducts] = useState(false);
    const [showRouteStockByCompany, setShowRouteStockByCompany] = useState(false);
    const [showRoutePartsHistory, setShowRoutePartsHistory] = useState(false);
    const [routePartsHistory, setRoutePartsHistory] = useState([]);
    const [loadingRoutePartsHistory, setLoadingRoutePartsHistory] = useState(false);
    const [routePartsHistoryError, setRoutePartsHistoryError] = useState(null);
    const [showRouteServiceHistory, setShowRouteServiceHistory] = useState(false);
    const [routeServiceHistory, setRouteServiceHistory] = useState([]);
    const [loadingRouteServiceHistory, setLoadingRouteServiceHistory] = useState(false);
    const [routeServiceHistoryError, setRouteServiceHistoryError] = useState(null);

    // Função para calcular o tempo total das ordens concluídas
    const calculateTotalTime = (orders) => {
      let totalMinutes = 0;
      
      orders.forEach(order => {
        const timeStr = order.tempo;
        if (timeStr) {
          // Extrair horas e minutos do formato "1h15min" ou "45min"
          const hourMatch = timeStr.match(/(\d+)h/);
          const minuteMatch = timeStr.match(/(\d+)min/);
          
          const hours = hourMatch ? parseInt(hourMatch[1]) : 0;
          const minutes = minuteMatch ? parseInt(minuteMatch[1]) : 0;
          
          totalMinutes += hours * 60 + minutes;
        }
      });
      
      const totalHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      
      if (totalHours > 0 && remainingMinutes > 0) {
        return `${totalHours}h ${remainingMinutes}min`;
      } else if (totalHours > 0) {
        return `${totalHours}h`;
      } else {
        return `${remainingMinutes}min`;
      }
    };

    // Função para buscar dados da API
    const fetchTodayRoute = React.useCallback(async () => {
      if (!technician || !isOpen) return;
      
      try {
        setIsLoadingRoute(true);
        setRouteError(null);
        
        // Obter ID do técnico do mapeamento
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        // Buscar roteiro de hoje
        // Implementar retry com timeout aumentado
        const maxAttempts = 3;
        const timeoutMs = 60000; // 60 segundos
        let lastError;
        let response;
        
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            // Criar AbortController para timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
              controller.abort();
            }, timeoutMs);
            
            const token = localStorage.getItem('authToken');
            response = await fetch(`${API_BASE_URL}/api/orders/today-route/${technicianId}`, {
          method: 'GET',
          headers: {
                'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            break; // Sucesso, sair do loop
            
          } catch (error) {
            lastError = error;
            console.error(`❌ Erro na tentativa ${attempt}:`, error);
            
            // Se é um erro de abort (timeout), ou se é a última tentativa
            if (error.name === 'AbortError') {
              console.log(`⏰ Timeout na tentativa ${attempt}${attempt < maxAttempts ? ', retentando em 2 segundos...' : ''}`);
            }
            
            if (attempt === maxAttempts) {
              throw error; // Última tentativa falhou
            }
            
            // Aguardar 2 segundos antes da próxima tentativa
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }
        
        if (!response) {
          throw lastError || new Error('Falha em todas as tentativas de conexão');
        }
        if (!response.ok) {
          const errorText = await response.text();
          console.error(`❌ Resposta de erro da API: ${errorText}`);
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        
        if (!data.success) {
          throw new Error(data.message || 'Erro ao buscar roteiro');
        }
        
        setRouteData(data.data || []);
        
      } catch (error) {
        let errorMessage = error.message;
        if (error.name === 'AbortError') {
          errorMessage = `Timeout: A consulta está demorando mais que o esperado (mais de 60 segundos). Tente novamente em alguns instantes.`;
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = `Erro de conexão com o servidor (${API_BASE_URL})`;
        }
        
        setRouteError(errorMessage);
      } finally {
        setIsLoadingRoute(false);
      }
    }, [technician, isOpen, getTechnicianIdByName]);

    // Função para buscar ordens concluídas
    const fetchCompletedRoute = useCallback(async () => {
      try {
        setIsLoadingCompleted(true);
        setCompletedError(null);
        
        // Obter ID do técnico
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        // Implementar retry com timeout aumentado
        const maxAttempts = 3;
        const timeoutMs = 60000; // 60 segundos
        let lastError;
        let response;
        
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            // Criar AbortController para timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
              controller.abort();
            }, timeoutMs);
            
            const token = localStorage.getItem('authToken');
            response = await fetch(`${API_BASE_URL}/api/orders/completed-route/${technicianId}`, {
          method: 'GET',
          headers: {
                'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            break; // Sucesso, sair do loop
            
          } catch (error) {
            lastError = error;
            
            // Se é um erro de abort (timeout), ou se é a última tentativa
            if (error.name === 'AbortError') {
              // Timeout - continuar para próxima tentativa
            }
            
            if (attempt === maxAttempts) {
              throw error; // Última tentativa falhou
            }
            
            // Aguardar 2 segundos antes da próxima tentativa
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }
        
        if (!response) {
          throw lastError || new Error('Falha em todas as tentativas de conexão');
        }
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.message || 'Erro ao buscar ordens concluídas');
        }
        
        setCompletedData(result.data || []);
        
      } catch (error) {
        let errorMessage = error.message;
        if (error.name === 'AbortError') {
          errorMessage = `Timeout: A consulta está demorando mais que o esperado (mais de 60 segundos). Tente novamente em alguns instantes.`;
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = `Erro de conexão com o servidor (${API_BASE_URL})`;
        }
        
        setCompletedError(errorMessage);
        setCompletedData([]);
      } finally {
        setIsLoadingCompleted(false);
      }
    }, [technician, getTechnicianIdByName]);

    const formatDateISO = (date) => {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const year = d.getFullYear();
      const month = `${d.getMonth() + 1}`.padStart(2, '0');
      const day = `${d.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // Função para buscar roteiro (aba Roteiro)
    const fetchRouteSchedule = useCallback(async (dateParam) => {
      try {
        setIsLoadingRouteSchedule(true);
        setRouteScheduleError(null);
        
        if (!technician || !isOpen) return;
        
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        const token = localStorage.getItem('authToken');
        const queryDate = dateParam || selectedRouteDate || formatDateISO(new Date());
        const response = await fetch(`${API_BASE_URL}/api/orders/route/${technicianId}?date=${encodeURIComponent(queryDate)}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erro ao buscar roteiro: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
          setRouteScheduleData(result.data || []);
        } else {
          throw new Error(result.message || 'Erro ao buscar roteiro');
        }
      } catch (error) {
        setRouteScheduleError(error.message || 'Erro ao carregar roteiro');
        setRouteScheduleData([]);
      } finally {
        setIsLoadingRouteSchedule(false);
      }
    }, [technician, isOpen, getTechnicianIdByName, selectedRouteDate]);

    React.useEffect(() => {
      if (isOpen) {
        const todayIso = formatDateISO(new Date());
        setSelectedRouteDate(todayIso);
      }
    }, [isOpen]);
    
    // Fechar date picker ao clicar fora
    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (showRouteDatePicker && !event.target.closest('.route-date-picker-container') && !event.target.closest('.route-date-picker-icon')) {
          if (routeDatePickerValue) setSelectedRouteDate(routeDatePickerValue);
          setShowRouteDatePicker(false);
        }
      };
      
      if (showRouteDatePicker) {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }
    }, [showRouteDatePicker, routeDatePickerValue]);

    const routeScheduleFetchedRef = React.useRef(false);
    const lastRouteDateRef = React.useRef('');
    
    React.useEffect(() => {
      if (activeTab === 'route' && selectedRouteDate && isOpen) {
        // Só busca se a data mudou ou ainda não foi buscado
        if (lastRouteDateRef.current !== selectedRouteDate || !routeScheduleFetchedRef.current) {
          lastRouteDateRef.current = selectedRouteDate;
          routeScheduleFetchedRef.current = true;
          const timeoutId = setTimeout(() => {
            fetchRouteSchedule(selectedRouteDate);
          }, 100);
          return () => clearTimeout(timeoutId);
        }
      } else if (activeTab !== 'route') {
        routeScheduleFetchedRef.current = false;
        lastRouteDateRef.current = '';
      }
    }, [activeTab, selectedRouteDate, isOpen]);

    // Função para buscar ordens finalizadas (aba Concluídas)
    const fetchFinishedRoute = useCallback(async (dateParam) => {
      try {
        setIsLoadingFinished(true);
        setFinishedError(null);
        
        if (!technician || !isOpen) return;
        
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        const token = localStorage.getItem('authToken');
        const queryDate = dateParam || selectedFinishedDate || formatDateISO(new Date());
        const response = await fetch(`${API_BASE_URL}/api/orders/finished-route/${technicianId}?date=${encodeURIComponent(queryDate)}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erro ao buscar ordens finalizadas: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
          setFinishedData(result.data || []);
        } else {
          throw new Error(result.message || 'Erro ao buscar ordens finalizadas');
        }
      } catch (error) {
        setFinishedError(error.message || 'Erro ao carregar ordens finalizadas');
        setFinishedData([]);
      } finally {
        setIsLoadingFinished(false);
      }
    }, [technician, isOpen, getTechnicianIdByName, selectedFinishedDate]);

    React.useEffect(() => {
      if (isOpen) {
        // Define data padrão (hoje) ao abrir o modal
        const todayIso = formatDateISO(new Date());
        setSelectedFinishedDate(todayIso);
      }
    }, [isOpen]);

    // Filtrar automaticamente quando a data selecionada mudar na aba Produtividade
    React.useEffect(() => {
      if (activeTab === 'finished' && selectedFinishedDate && isOpen && !isLoadingFinished) {
        const timeoutId = setTimeout(() => {
          fetchFinishedRoute(selectedFinishedDate);
        }, 100);
        return () => clearTimeout(timeoutId);
      }
    }, [selectedFinishedDate, activeTab, isOpen]);

    // Função para calcular tempo de atendimento
    const calculateAttendanceTime = (horaInicial, horaFinal) => {
      if (!horaInicial || !horaFinal) {
        return 'N/A';
      }
      
      try {
        // Se for string de hora (hh:mm), converter para minutos
        const parseTimeString = (timeStr) => {
          if (typeof timeStr === 'string' && timeStr.includes(':')) {
            const [hours, minutes] = timeStr.split(':').map(Number);
            const totalMinutes = hours * 60 + minutes;
            return totalMinutes;
          }
          
          // Se for date/datetime, extrair a hora
          const date = new Date(timeStr);
          if (!isNaN(date.getTime())) {
            const totalMinutes = date.getHours() * 60 + date.getMinutes();
            return totalMinutes;
          }
          
          return null;
        };

        const inicioMinutos = parseTimeString(horaInicial);
        const fimMinutos = parseTimeString(horaFinal);
        
        if (inicioMinutos === null || fimMinutos === null) {
          return 'N/A';
        }
        
        let diffMinutes = fimMinutos - inicioMinutos;
        
        // Se a diferença for negativa, assumir que passou da meia-noite
        if (diffMinutes < 0) {
          diffMinutes += 24 * 60; // Adicionar 24 horas
        }
        
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        
        // Formato solicitado: hh:mm
        const result = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        
        return result;
        
      } catch (error) {
        return 'N/A';
      }
    };

    // Função para formatar horário
    const formatTime = (dateTime) => {
      if (!dateTime) {
        return 'N/A';
      }
      
      try {
        // Se já for uma string de hora (hh:mm), retornar como está
        if (typeof dateTime === 'string' && dateTime.match(/^\d{2}:\d{2}$/)) {
          return dateTime;
        }
        
        // Se for date/datetime, extrair a hora
        const date = new Date(dateTime);
        if (!isNaN(date.getTime())) {
          const result = date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit'
          });
          return result;
        }
        
        return 'N/A';
      } catch (error) {
        return 'N/A';
      }
    };

    // Função para calcular tempo total das ordens concluídas
    const calculateTotalCompletedTime = React.useMemo(() => {
      return (orders) => {
        if (!orders || orders.length === 0) return '00:00';
        
        let totalMinutes = 0;
        
        orders.forEach(ordem => {
          const tempoStr = calculateAttendanceTime(ordem.TB02122_HORAINI, ordem.TB02122_HORAFIM);
          
          if (tempoStr !== 'N/A' && tempoStr.includes(':')) {
            const [hours, minutes] = tempoStr.split(':').map(Number);
            const orderMinutes = hours * 60 + minutes;
            totalMinutes += orderMinutes;
          }
        });
        
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        return `${String(totalHours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
      };
    }, []);

    // Função para formatar horários juntos (inicial~final = tempo)
    const formatHorariosCompletos = (horarioInicial, horarioFinal) => {
      const inicial = formatTime(horarioInicial);
      const final = formatTime(horarioFinal);
      const tempo = calculateAttendanceTime(horarioInicial, horarioFinal);
      
      if (inicial === 'N/A' || final === 'N/A' || tempo === 'N/A') {
        return 'N/A';
      }
      
      return `${inicial}~${final} = ${tempo}`;
    };

    // Função para buscar peças (pendentes e utilizadas)
    const fetchOrderParts = async (orderNumber) => {
      try {
        setIsLoadingParts(true);
        
        const token = localStorage.getItem('authToken');
        
        const [pendingResponse, usedResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/orders/${orderNumber}/pending-parts`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }),
          fetch(`${API_BASE_URL}/api/orders/${orderNumber}/used-parts`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
        ]);
        
        if (!pendingResponse.ok) {
          // Erro ao buscar peças pendentes
        }
        if (!usedResponse.ok) {
          // Erro ao buscar peças utilizadas
        }
        
        const pendingResult = await pendingResponse.json();
        const usedResult = await usedResponse.json();
        
        const pendingData = (pendingResult.success && Array.isArray(pendingResult.data)) ? pendingResult.data : [];
        const usedData = (usedResult.success && Array.isArray(usedResult.data)) ? usedResult.data : [];
        
        setPendingParts(pendingData);
        setUsedParts(usedData);
        
      } catch (error) {
        setPendingParts([]);
        setUsedParts([]);
      } finally {
        setIsLoadingParts(false);
      }
    };

    // Função para buscar peças da ordem (para sidebar da aba Roteiro)
    const fetchRouteOrderParts = async (orderNumber) => {
      if (!orderNumber) return;
      
      setIsLoadingRouteParts(true);
      setRoutePendingParts([]);
      setRouteUsedParts([]);
      
      try {
        const token = localStorage.getItem('authToken');
        
        const [pendingResponse, usedResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/orders/${orderNumber}/pending-parts`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }),
          fetch(`${API_BASE_URL}/api/orders/${orderNumber}/used-parts`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
        ]);
        
        if (!pendingResponse.ok || !usedResponse.ok) {
          throw new Error(`Erro ao buscar peças: ${pendingResponse.status} / ${usedResponse.status}`);
        }
        
        const pendingResult = await pendingResponse.json();
        const usedResult = await usedResponse.json();
        
        const pendingData = (pendingResult.success && Array.isArray(pendingResult.data)) ? pendingResult.data : [];
        const usedData = (usedResult.success && Array.isArray(usedResult.data)) ? usedResult.data : [];
        
        setRoutePendingParts(pendingData);
        setRouteUsedParts(usedData);
      } catch (error) {
        setRoutePendingParts([]);
        setRouteUsedParts([]);
      } finally {
        setIsLoadingRouteParts(false);
      }
    };

    // Função para buscar histórico de peças (para sidebar da aba Roteiro)
    const fetchRoutePartsHistory = async (numeroSerie) => {
      if (!numeroSerie) {
        setRoutePartsHistoryError('Número de série não informado');
        return;
      }
      
      setLoadingRoutePartsHistory(true);
      setRoutePartsHistoryError(null);
      setRoutePartsHistory([]);
      
      try {
        const token = localStorage.getItem('authToken');
        
        const response = await fetch(`${API_BASE_URL}/api/orders/parts-history?numeroSerie=${encodeURIComponent(numeroSerie)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao buscar histórico de peças: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success && Array.isArray(result.data)) {
          setRoutePartsHistory(result.data);
        } else if (result.success && !result.data) {
          setRoutePartsHistory([]);
        } else {
          throw new Error(result.message || 'Erro ao buscar histórico');
        }
      } catch (error) {
        setRoutePartsHistoryError(error.message || 'Erro ao buscar histórico de peças');
        setRoutePartsHistory([]);
      } finally {
        setLoadingRoutePartsHistory(false);
      }
    };

    // Função para buscar histórico de atendimentos (para sidebar da aba Roteiro)
    const fetchRouteServiceHistory = async (numeroSerie) => {
      if (!numeroSerie) {
        setRouteServiceHistoryError('Número de série não informado');
        return;
      }
      
      setLoadingRouteServiceHistory(true);
      setRouteServiceHistoryError(null);
      setRouteServiceHistory([]);
      
      try {
        const token = localStorage.getItem('authToken');
        
        const response = await fetch(`${API_BASE_URL}/api/equipment/history/${encodeURIComponent(numeroSerie)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao buscar histórico de atendimentos: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success && Array.isArray(result.data)) {
          setRouteServiceHistory(result.data);
        } else if (result.success && !result.data) {
          setRouteServiceHistory([]);
        } else {
          throw new Error(result.message || 'Erro ao buscar histórico');
        }
      } catch (error) {
        setRouteServiceHistoryError(error.message || 'Erro ao carregar histórico');
        setRouteServiceHistory([]);
      } finally {
        setLoadingRouteServiceHistory(false);
      }
    };

    // Função para buscar detalhes do defeito (para sidebar da aba Roteiro)
    const fetchRouteDefeitoDetails = async (orderNumber) => {
      if (!orderNumber) return;
      
      setLoadingRouteDefeito(true);
      setRouteDefeitoError(null);
      setRouteDefeitoData(null);
      
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/api/orders/${orderNumber}/defeito`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erro ao buscar defeito: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
          setRouteDefeitoData(result.data);
        } else {
          throw new Error(result.message || 'Erro ao buscar defeito');
        }
      } catch (error) {
        setRouteDefeitoError(error.message || 'Erro ao carregar defeito');
        setRouteDefeitoData(null);
      } finally {
        setLoadingRouteDefeito(false);
      }
    };

    // Função para buscar estoque (para sidebar da aba Roteiro)
    const fetchRouteStockData = async (productCode, productName) => {
      if (!productCode) return;
      
      // Se já temos dados para este produto, apenas mostrar/esconder tooltip
      if (routeStockTooltip === productCode && routeStockData) {
        setRouteStockTooltip(null);
        setShowRouteSimilarProducts(false);
        setShowRouteStockByCompany(false);
        return;
      }
      
      setLoadingRouteStock(true);
      setRouteStockError(null);
      setRouteStockTooltip(productCode);
      setRouteStockProductName(productName || null);
      setShowRouteSimilarProducts(false);
      setShowRouteStockByCompany(false);
      
      try {
        const token = localStorage.getItem('authToken');
        
        const response = await fetch(`${API_BASE_URL}/api/products/${productCode}/stock`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao buscar estoque: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
          setRouteStockData(result);
        } else {
          setRouteStockError(result.message || 'Erro ao carregar dados de estoque');
        }
      } catch (error) {
        setRouteStockError('Erro ao carregar dados de estoque');
      } finally {
        setLoadingRouteStock(false);
      }
    };

    const closeRouteStockTooltip = () => {
      setRouteStockTooltip(null);
      setRouteStockData(null);
      setRouteStockProductName(null);
      setShowRouteSimilarProducts(false);
      setShowRouteStockByCompany(false);
    };

    const toggleRouteDefeitoDetails = () => {
      if (!showRouteDefeitoDetails && selectedRouteOrder) {
        fetchRouteDefeitoDetails(selectedRouteOrder.TB02115_CODIGO || selectedRouteOrder.TB02122_NUMOS);
      }
      setShowRouteDefeitoDetails(!showRouteDefeitoDetails);
    };

    // Função para abrir sidebar de detalhes na aba Roteiro (detalhe por API quando ordem é Check-Out ou Concluída)
    const openRouteDetailsSidebar = async (order) => {
      if (!isLeftColumnCollapsed) {
        setIsLeftColumnCollapsed(true);
      }
      setSelectedRouteOrder(order);
      setShowRouteDetailsSidebar(true);
      setShowRouteDefeitoDetails(false);
      setRouteDefeitoData(null);
      setRouteDefeitoError(null);
      setShowRoutePartsHistory(false);
      setRoutePartsHistory([]);
      setRoutePartsHistoryError(null);
      setShowRouteServiceHistory(false);
      setRouteServiceHistory([]);
      setRouteServiceHistoryError(null);
      closeRouteStockTooltip();
      fetchRouteOrderParts(order.TB02115_CODIGO || order.TB02122_NUMOS);
      const isClosedOrder = (order.TB02122_DATAFIM != null && order.TB02122_DATAFIM !== '') || (order.TB02115_DTFECHA != null && order.TB02115_DTFECHA !== '');
      if (isClosedOrder) {
        const numeroOS = order.TB02115_CODIGO || order.TB02122_NUMOS;
        if (numeroOS) {
          setRouteOrderDetailLoading(true);
          try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${API_BASE_URL}/api/orders/today-route-detail/${encodeURIComponent(numeroOS)}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success && data.data) {
              setSelectedRouteOrder(data.data);
              setRouteDefeitoData((data.data.TB01048_NOME || data.data.TB02116_OBS)
                ? { defeito: data.data.TB01048_NOME || 'N/A', observacao: data.data.TB02116_OBS || 'N/A' }
                : null);
            }
          } catch (e) {
            console.warn('Erro ao carregar detalhe da ordem:', e);
          } finally {
            setRouteOrderDetailLoading(false);
          }
        }
      }
    };

    // Função para fechar sidebar de detalhes na aba Check-out pendente
    const closeRouteDetailsSidebar = () => {
      if (isLeftColumnCollapsed) {
        setIsLeftColumnCollapsed(false);
      }
      setShowRouteDetailsSidebar(false);
      setSelectedRouteOrder(null);
      setRouteOrderDetailLoading(false);
      setRoutePendingParts([]);
      setRouteUsedParts([]);
      setShowRouteDefeitoDetails(false);
      setRouteDefeitoData(null);
      setRouteDefeitoError(null);
      setShowRoutePartsHistory(false);
      setRoutePartsHistory([]);
      setShowRouteServiceHistory(false);
      setRouteServiceHistory([]);
      closeRouteStockTooltip();
    };

    // Função para abrir sidebar de detalhes
    const openDetailsSidebar = (order) => {
      setSelectedCompletedOrder(order);
      setShowDetailsSidebar(true);
      setShowDefeitoDetails(false);
      setDefeitoData(null);
      setDefeitoError(null);
      // Fechar todos os históricos ao abrir uma nova OS
      setShowPartsHistory(false);
      setPartsHistory([]);
      setPartsHistoryError(null);
      setShowServiceHistory(false);
      setServiceHistory([]);
      setServiceHistoryError(null);
      fetchOrderParts(order.TB02122_NUMOS);
    };

    // Função para fechar sidebar de detalhes
    const closeDetailsSidebar = () => {
      setShowDetailsSidebar(false);
      setSelectedCompletedOrder(null);
      setPendingParts([]);
      setUsedParts([]);
      setShowDefeitoDetails(false);
      setDefeitoData(null);
      setDefeitoError(null);
      setShowPartsHistory(false);
      setPartsHistory([]);
      setPartsHistoryError(null);
      // Fechar histórico de atendimentos também
      setShowServiceHistory(false);
      setServiceHistory([]);
      setServiceHistoryError(null);
      closeStockTooltip();
    };

    // Função para buscar histórico de peças trocadas
    const fetchPartsHistory = async (numeroSerie) => {
      if (!numeroSerie) {
        setPartsHistoryError('Número de série não informado');
        return;
      }

        setLoadingPartsHistory(true);
        setPartsHistoryError(null);
        
      try {
        const token = localStorage.getItem('authToken');
        
        const response = await fetch(`${API_BASE_URL}/api/orders/parts-history?numeroSerie=${encodeURIComponent(numeroSerie)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao buscar histórico de peças: ${response.status}`);
        }
        
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setPartsHistory(result.data);
        } else {
          setPartsHistory([]);
        }
      } catch (error) {
        setPartsHistoryError(error.message || 'Erro ao buscar histórico de peças');
        setPartsHistory([]);
      } finally {
        setLoadingPartsHistory(false);
      }
    };

    // Função para buscar histórico de atendimentos
    const fetchServiceHistory = async (numeroSerie) => {
      if (!numeroSerie) {
        setServiceHistoryError('Número de série não informado');
        return;
      }

      setLoadingServiceHistory(true);
      setServiceHistoryError(null);

      try {
        const token = localStorage.getItem('authToken');

        const response = await fetch(`${API_BASE_URL}/api/equipment/history/${encodeURIComponent(numeroSerie)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao buscar histórico de atendimentos: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setServiceHistory(result.data);
        } else {
          setServiceHistory([]);
        }
      } catch (error) {
        setServiceHistoryError(error.message || 'Erro ao buscar histórico de atendimentos');
        setServiceHistory([]);
      } finally {
        setLoadingServiceHistory(false);
      }
    };

    // Função para formatar números com máscara de milhar (preservando sinal)
    const formatNumber = (num) => {
      const n = Number(num);
      if (!n) return '0';
      const isNegative = n < 0;
      const absStr = Math.abs(n).toString();
      const formatted = absStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return isNegative ? `-${formatted}` : formatted;
    };

    // Função para buscar detalhes do defeito
    const fetchDefeitoDetails = async (orderNumber) => {
      // Se já temos dados e é da mesma ordem, não buscar novamente
      if (defeitoData && selectedCompletedOrder && selectedCompletedOrder.TB02122_NUMOS === orderNumber) {
        return;
      }
      
      setLoadingDefeito(true);
      setDefeitoError(null);
      
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/api/orders/${orderNumber}/defeito`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const result = await response.json();
        
        if (result.success) {
          setDefeitoData(result.data);
        } else {
          setDefeitoError(result.message || 'Erro ao carregar detalhes do defeito');
        }
      } catch (error) {
        setDefeitoError('Erro ao carregar detalhes do defeito');
      } finally {
        setLoadingDefeito(false);
      }
    };

    // Função para alternar exibição dos detalhes do defeito
    const toggleDefeitoDetails = () => {
      if (!showDefeitoDetails && selectedCompletedOrder) {
        fetchDefeitoDetails(selectedCompletedOrder.TB02122_NUMOS);
      }
      setShowDefeitoDetails(!showDefeitoDetails);
    };

    // Função para buscar dados de estoque
    const fetchStockData = async (productCode, productName) => {
      // Se já temos dados para este produto, apenas mostrar/esconder tooltip
      if (stockTooltip === productCode && stockData) {
        setStockTooltip(null);
        setShowSimilarProducts(false);
        setShowStockByCompany(false);
        return;
      }

      setLoadingStock(true);
      setStockError(null);
      setStockTooltip(productCode);
      setStockProductName(productName || null);
      setShowSimilarProducts(false);
      setShowStockByCompany(false);
      
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/api/products/${productCode}/stock`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const result = await response.json();
        
        if (result.success) {
          setStockData(result);
        } else {
          setStockError(result.message || 'Erro ao carregar dados de estoque');
        }
      } catch (error) {
        setStockError('Erro ao carregar dados de estoque');
      } finally {
        setLoadingStock(false);
      }
    };

    // Função para fechar tooltip de estoque
    const closeStockTooltip = () => {
      setStockTooltip(null);
      setStockData(null);
      setStockError(null);
      setStockProductName(null);
      setShowSimilarProducts(false);
      setShowStockByCompany(false);
    };

    // Efeito para buscar dados quando modal abre
    React.useEffect(() => {
      if (isOpen && technician) {
        fetchTodayRoute();
        fetchCompletedRoute();
        fetchFinishedRoute();
      }
    }, [isOpen, technician, fetchTodayRoute, fetchCompletedRoute, fetchFinishedRoute]);

    // Função para formatar data/hora (CALC_RESTANTE)
    const formatDateTime = (dateTimeString) => {
      if (!dateTimeString) return 'N/A';
      
      try {
        const date = new Date(dateTimeString);
        if (isNaN(date.getTime())) return 'N/A';
        
        // Formatar como dd/MM/yyyy hh:mm
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (error) {
        return 'N/A';
      }
    };

    // Função para obter número da ordem com cor
    const getOrderNumber = (ordem) => {
      // Verificar se a ordem não tem sequência definida (null, undefined, 0, ou string vazia)
      if (!ordem.TB02115_ORDEM || ordem.TB02115_ORDEM === 0 || ordem.TB02115_ORDEM === '0') {
        return { number: '-', isRed: true };
      }
      return { number: ordem.TB02115_ORDEM, isRed: false };
    };

    // Função para obter equipamento com fallback
    const getEquipment = (ordem) => {
      return ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || 'N/A';
    };

    // Função para obter série/patrimônio
    const getSeriePatrimonio = (ordem) => {
      const serie = ordem.TB02115_NUMSERIE || '';
      const patrimonio = ordem.TB02112_PAT || '';
      
      if (serie && patrimonio) {
        return `${serie} / ${patrimonio}`;
      } else if (serie) {
        return serie;
      } else if (patrimonio) {
        return patrimonio;
      }
      return 'N/A';
    };

    // Função para atualizar sequência individual de uma ordem
    const updateSequence = async (osCode, newSequence) => {
      try {
        setIsReordering(true);
        setRetryAttempt(0);
        
        // Obter ID do técnico
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        const requestBody = {
          technicianId,
          osCode,
          newSequence
        };
        
        // Fazer requisição com retry customizado - versão com reorganização
        const maxAttempts = 2;
        const timeoutMs = 40000; // 40 segundos (compatível com backend de 30s)
        let lastError;
        let response;
        
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            setRetryAttempt(attempt);
            
            // Criar AbortController para timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
              controller.abort();
            }, timeoutMs);
            
            const token = localStorage.getItem('authToken');
            response = await fetch(`${API_BASE_URL}/api/orders/update-sequence`, {
          method: 'POST',
          headers: {
                'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
              body: JSON.stringify(requestBody),
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            break; // Sucesso, sair do loop
            
          } catch (error) {
            lastError = error;
            
            if (error.name === 'AbortError') {
              // Timeout - continuar para próxima tentativa
            }
            
            if (attempt === maxAttempts) {
              throw error; // Última tentativa falhou
            }
            
            // Aguardar 5 segundos antes da próxima tentativa
            await new Promise(resolve => setTimeout(resolve, 5000));
          }
        }
        
        if (!response) {
          throw lastError || new Error('Falha em todas as tentativas de conexão');
        }
        
        if (!response.ok) {
          const errorText = await response.text();
          
          // Tentar parsear como JSON para obter detalhes
          try {
            const errorData = JSON.parse(errorText);
            throw new Error(errorData.message || `Erro HTTP ${response.status}: ${response.statusText}`);
          } catch (parseError) {
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText}`);
          }
        }
        
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.message || 'Erro ao atualizar sequência');
        }
        
        // Recarregar dados
        await fetchTodayRoute();
        
      } catch (error) {
        let errorMessage = error.message;
        let shouldRetry = false;
        
        if (error.name === 'AbortError') {
          errorMessage = `Timeout: A operação está demorando mais que o esperado (mais de 60 segundos). Tente novamente em alguns instantes.`;
          shouldRetry = true;
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = `Erro de conexão com o servidor (${API_BASE_URL})`;
          shouldRetry = true;
        } else if (error.message.includes('408')) {
          errorMessage = `Timeout na operação - tente novamente em alguns segundos.`;
          shouldRetry = true;
        } else if (error.message.includes('409')) {
          errorMessage = `Conflito de concorrência - aguarde alguns segundos e tente novamente.`;
          shouldRetry = true;
        } else if (error.message.includes('503')) {
          errorMessage = `Conexão com o banco foi perdida - tente novamente.`;
          shouldRetry = true;
        }
        
        setRouteError(`Erro ao definir ordem: ${errorMessage}`);
        throw error; // Re-throw para que a função chamadora possa tratar
      } finally {
        setIsReordering(false);
        setRetryAttempt(0);
      }
    };

    // Função para reordenar itens (mantida para compatibilidade com drag & drop)
    const reorderItems = async (reorderedData) => {
      try {
        setIsReordering(true);
        
        // Obter ID do técnico
        const technicianId = getTechnicianIdByName(technician);
        if (!technicianId) {
          throw new Error(`ID do técnico ${technician} não encontrado`);
        }
        
        const requestBody = {
            technicianId,
            reorderedItems: reorderedData
        };
        
        const token = localStorage.getItem('authToken');
        const response = await fetchWithRetry(
          `${API_BASE_URL}/api/orders/reorder-sequence`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
          },
          'reordenação de sequência'
        );
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.message || 'Erro ao reordenar sequências');
        }
        
        // Recarregar dados
        await fetchTodayRoute();
        
      } catch (error) {
        let errorMessage = error.message;
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = `Erro de conexão com o servidor (${API_BASE_URL})`;
        }
        
        setRouteError(`Erro ao definir ordem: ${errorMessage}`);
      } finally {
        setIsReordering(false);
      }
    };

    // Função para lidar com drag start
    const handleDragStart = (e, ordem, index) => {
      if (ordem.Tipo !== 'Roteirizado') return;
      
      setDraggedItem({ ordem, index });
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/html', e.target.outerHTML);
    };

    // Função para lidar com drag over
    const handleDragOver = (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
    };

    // Função para lidar com drop
    const handleDrop = (e, targetIndex) => {
      e.preventDefault();
      
      if (!draggedItem) return;
      
      const sourceIndex = draggedItem.index;
      if (sourceIndex === targetIndex) {
        setDraggedItem(null);
        return;
      }
      
      // Criar nova lista reordenada
      const newData = [...routeData];
      const [removed] = newData.splice(sourceIndex, 1);
      newData.splice(targetIndex, 0, removed);
      
      // Recalcular sequências apenas para itens roteirizados
      const reorderedItems = [];
      let sequence = 1;
      
      newData.forEach((item) => {
        if (item.Tipo === 'Roteirizado') {
          if (item.TB02115_ORDEM !== sequence) {
            reorderedItems.push({
              osCode: item.TB02115_CODIGO,
              newSequence: sequence
            });
          }
          sequence++;
        }
      });
      
      if (reorderedItems.length > 0) {
        reorderItems(reorderedItems);
      }
      
      setDraggedItem(null);
    };

    // Função para lidar com clique em ordem (roteirizada ou não)
    const handleOrderClick = (ordem) => {
      // Se já está mostrando o input para esta ordem, não fazer nada
      if (showSequenceInput === ordem.TB02115_CODIGO) return;
      
      // Abrir input de sequência para qualquer ordem (roteirizada ou não)
      setShowSequenceInput(ordem.TB02115_CODIGO);
      // Se a ordem já tem sequência, preencher o input com ela
      setSequenceInputValue(ordem.TB02115_ORDEM ? ordem.TB02115_ORDEM.toString() : '');
    };

    // Função para salvar nova sequência
    const handleSaveSequence = async () => {
      try {
        if (!showSequenceInput || !sequenceInputValue) {
          return;
        }
      
      const newSequence = parseInt(sequenceInputValue);
      if (isNaN(newSequence) || newSequence < 1) {
        alert('Por favor, digite um número válido maior que 0');
        return;
      }
      
      // Encontrar a ordem
      const ordem = routeData.find(item => item.TB02115_CODIGO === showSequenceInput);
        if (!ordem) {
          alert('Erro: Ordem de serviço não encontrada');
          return;
        }
        
        // Chamar função para atualizar sequência
        await updateSequence(ordem.TB02115_CODIGO, newSequence);
        
      setShowSequenceInput(null);
      setSequenceInputValue('');
        
      } catch (error) {
        alert(`Erro ao definir ordem: ${error.message}`);
      }
    };

    // Dados mock para teste visual
    const mockOpenOrders = [
      {
        id: 1,
        orderNumber: "OS001",
        os: "OS-2024-001",
        cliente: "Empresa ABC Ltda",
        endereco: "Rua das Flores, 123 - Centro - São Paulo/SP",
        equipamento: "Impressora HP LaserJet Pro",
        motivoOS: "Manutenção preventiva mensal",
        seriePatrimonio: "SN123456 / PAT789",
        previsao: "09:00"
      },
      {
        id: 2,
        orderNumber: "OS002",
        os: "OS-2024-002",
        cliente: "Comércio XYZ",
        endereco: "Av. Principal, 456 - Vila Nova - São Paulo/SP",
        equipamento: "Multifuncional Canon",
        motivoOS: "Substituição de toner",
        seriePatrimonio: "SN789012 / PAT456",
        previsao: "10:30"
      }
    ];

    const mockCompletedOrders = [
      {
        id: 3,
        os: "OS-2024-003",
        cliente: "Escritório Central",
        endereco: "Rua do Comércio, 789 - Centro - São Paulo/SP",
        equipamento: "Scanner Epson",
        motivoOS: "Configuração de rede",
        seriePatrimonio: "SN345678 / PAT123",
        condicao: "Funcionando",
        horarioInicial: "08:00",
        horarioFinal: "09:15",
        tempo: "1h15min",
        hasPendingParts: true,
        laudo: "Equipamento funcionando normalmente após configuração da rede. Cliente satisfeito com o serviço.",
        contadores: {
          pb: 1250,
          cor: 890,
          dig: 2340,
          a3pb: 156,
          a3cor: 89
        },
        pecasPendentes: [
          { codigo: "TON001", nome: "Toner Preto", quantidade: 2 },
          { codigo: "TON002", nome: "Toner Colorido", quantidade: 1 }
        ],
        pecasTrocadas: [
          { codigo: "ROL001", nome: "Rolo de Transferência", quantidade: 1 }
        ]
      },
      {
        id: 4,
        os: "OS-2024-004",
        cliente: "Loja de Informática",
        endereco: "Shopping Center, Loja 45 - São Paulo/SP",
        equipamento: "Impressora Térmica",
        motivoOS: "Limpeza e manutenção",
        seriePatrimonio: "SN567890 / PAT321",
        condicao: "Funcionando",
        horarioInicial: "11:00",
        horarioFinal: "11:45",
        tempo: "45min",
        hasPendingParts: false,
        laudo: "Equipamento limpo e funcionando perfeitamente. Nenhuma peça necessária.",
        contadores: {
          pb: 0,
          cor: 0,
          dig: 0,
          a3pb: 0,
          a3cor: 0
        },
        pecasPendentes: [],
        pecasTrocadas: []
      }
    ];

    // Função para agrupar ordens concluídas por condição e ordenar por quantidade
    const groupCompletedOrdersByCondition = (orders) => {
      const grouped = {};
      orders.forEach(order => {
        const condition = order.TB01055_NOME || 'Sem condição';
        if (!grouped[condition]) {
          grouped[condition] = [];
        }
        grouped[condition].push(order);
      });
      
      // Converter para array e ordenar por quantidade de ordens (maior primeiro)
      return Object.entries(grouped)
        .map(([condition, orders]) => ({ condition, orders }))
        .sort((a, b) => b.orders.length - a.orders.length);
    };

    const groupedCompletedOrders = groupCompletedOrdersByCondition(completedData);

    // Função para formatar data sem problemas de fuso horário (usa data local)
    const formatDateLocal = (date) => {
      if (!date) return '';
      // Usar métodos locais para evitar problemas de fuso
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    // Função para formatar data e hora sem problemas de fuso horário (usa data/hora local)
    const formatDateTimeLocal = () => {
      const now = new Date();
      // Usar métodos locais para evitar problemas de fuso
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    // Função para gerar e imprimir o relatório
    const handlePrintRoute = async () => {
      // Ordenar dados por TB02115_ORDEM (crescente)
      const sortedData = [...routeData].sort((a, b) => {
        const orderA = a.TB02115_ORDEM || 0;
        const orderB = b.TB02115_ORDEM || 0;
        return orderA - orderB;
      });

      const token = localStorage.getItem('authToken');
      const printData = await enrichRouteOrdersDefeitoObs(sortedData, API_BASE_URL, token);

      // Criar conteúdo HTML do relatório
      const today = new Date();
      const reportDate = formatDateLocal(today);
      const reportDateTime = formatDateTimeLocal();

      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>Roteiro de Atendimento Técnico</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 1.5cm;
            }
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            body {
              font-family: 'Geist Variable', 'Geist', system-ui, sans-serif;
              font-size: 10px;
              color: #2d3748;
              line-height: 1.3;
            }
            .report-header {
              text-align: left;
              margin-bottom: 10px;
            }
            .report-header h1 {
              font-size: 16px;
              font-weight: 600;
              color: #2d3748;
              margin-bottom: 8px;
            }
            .report-technician {
              text-align: left;
              font-size: 13px;
              font-weight: 500;
              color: #4a5568;
              margin-bottom: 12px;
              padding-bottom: 12px;
              border-bottom: 2px solid #7c4dff;
            }
            .report-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 15px;
              table-layout: fixed;
            }
            .report-table thead {
              background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
              border-bottom: 2px solid #e2e8f0;
            }
            .report-table th {
              padding: 8px 6px;
              text-align: left;
              font-weight: 600;
              color: #2d3748;
              font-size: 9px;
              text-transform: uppercase;
              letter-spacing: 0.3px;
              border-bottom: 2px solid #e2e8f0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .report-table td {
              padding: 6px;
              border-bottom: 1px solid #f1f5f9;
              font-size: 9px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .report-table tbody tr:hover {
              background-color: #f8fafc;
            }
            .report-total {
              margin-top: 12px;
              padding-top: 8px;
              border-top: 2px solid #e2e8f0;
              font-weight: 600;
              font-size: 10px;
              color: #2d3748;
            }
            .report-footer {
              margin-top: 20px;
              padding-top: 8px;
              border-top: 1px solid #e2e8f0;
              text-align: right;
              font-size: 8px;
              color: #64748b;
            }
            .col-number { width: 4%; }
            .col-os { width: 5%; }
            .col-pedido { width: 5%; }
            .col-cliente { width: 17%; }
            .col-equipamento { width: 23%; }
            .col-serie { width: 7%; }
            .col-patrimonio { width: 7%; }
            .col-cidade { width: 11%; }
            .col-bairro { width: 11%; }
            .col-previsao { width: 10%; }
            ${ROUTE_PRINT_DEFEITO_CSS}
          </style>
        </head>
        <body>
          <div class="report-header">
            <h1>Roteiro de atendimento técnico - ${reportDate}</h1>
            <div class="report-technician">
              ${technician}
            </div>
          </div>
          <table class="report-table">
            <thead>
              <tr>
                <th class="col-number">#</th>
                <th class="col-os">OS</th>
                <th class="col-pedido">PEDIDO</th>
                <th class="col-cliente">Cliente</th>
                <th class="col-equipamento">Equipamento</th>
                <th class="col-serie">Série</th>
                <th class="col-patrimonio">Patrimônio</th>
                <th class="col-cidade">Cidade</th>
                <th class="col-bairro">Bairro</th>
                <th class="col-previsao">Previsão</th>
              </tr>
            </thead>
            <tbody>
              ${printData.map((ordem) => {
                const orderNumber = getOrderNumber(ordem);
                return `
                  <tr>
                    <td>${orderNumber.number}</td>
                    <td>${ordem.TB02115_CODIGO || 'N/A'}</td>
                    <td>${ordem.PEDIDO_VINCULADO || ordem.pedidoVinculado || 'N/A'}</td>
                    <td>${ordem.TB01008_NOME || 'N/A'}</td>
                    <td>${getEquipment(ordem)}</td>
                    <td>${ordem.TB02115_NUMSERIE || 'N/A'}</td>
                    <td>${ordem.TB02112_PAT || 'N/A'}</td>
                    <td>${ordem.TB02115_CIDADE || 'N/A'}</td>
                    <td>${ordem.TB02115_BAIRRO || 'N/A'}</td>
                    <td>${formatDateTime(ordem.CALC_PREVISAO)}</td>
                  </tr>
                  ${buildRouteDefeitoPrintRows(ordem)}
                `;
              }).join('')}
            </tbody>
          </table>
          <div class="report-total">
            Total de ordens de serviço: ${printData.length}
          </div>
          <div class="report-footer">
            Relatório emitido em ${reportDateTime}
          </div>
        </body>
        </html>
      `;

      // Criar janela de impressão
      const printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();
      
      // Aguardar carregamento e imprimir
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
        }, 250);
      };
    };

    // Calendário de data única para o picker da aba Roteiro (estilo Board: grade + Aplicar)
    const RouteSingleDateCalendar = ({ selectedDate, onDateSelect, minDate, maxDate }) => {
      const todayStr = new Date().toISOString().split('T')[0];
      const [currentMonth, setCurrentMonth] = React.useState(() => {
        const base = selectedDate ? new Date(selectedDate + 'T12:00:00') : new Date();
        return { year: base.getFullYear(), month: base.getMonth() };
      });
      const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
      const daysInMonth = new Date(currentMonth.year, currentMonth.month + 1, 0).getDate();
      const firstDayOfMonth = new Date(currentMonth.year, currentMonth.month, 1).getDay();
      const getDateStr = (day) => `${currentMonth.year}-${String(currentMonth.month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const isDisabled = (dateStr) => (minDate && dateStr < minDate) || (maxDate && dateStr > maxDate);
      const prevMonth = () => setCurrentMonth(currentMonth.month === 0 ? { year: currentMonth.year - 1, month: 11 } : { year: currentMonth.year, month: currentMonth.month - 1 });
      const nextMonth = () => setCurrentMonth(currentMonth.month === 11 ? { year: currentMonth.year + 1, month: 0 } : { year: currentMonth.year, month: currentMonth.month + 1 });
      const days = [];
      for (let i = 0; i < firstDayOfMonth; i++) days.push(null);
      for (let d = 1; d <= daysInMonth; d++) days.push(d);
      return (
        <div className="route-single-date-calendar">
          <div className="route-single-calendar-header">
            <button type="button" className="route-single-calendar-nav" onClick={prevMonth}><i className="bi bi-chevron-left"></i></button>
            <span className="route-single-calendar-month">{monthNames[currentMonth.month]} {currentMonth.year}</span>
            <button type="button" className="route-single-calendar-nav" onClick={nextMonth}><i className="bi bi-chevron-right"></i></button>
          </div>
          <div className="route-single-calendar-weekdays">
            {dayNames.map(day => <div key={day} className="route-single-calendar-weekday">{day}</div>)}
          </div>
          <div className="route-single-calendar-days">
            {days.map((day, idx) => {
              if (day === null) return <div key={`e-${idx}`} className="route-single-calendar-day empty"></div>;
              const dateStr = getDateStr(day);
              const disabled = isDisabled(dateStr);
              const selected = dateStr === selectedDate;
              const isToday = dateStr === todayStr;
              return (
                <div
                  key={dateStr}
                  className={`route-single-calendar-day ${disabled ? 'disabled' : ''} ${selected ? 'selected' : ''} ${isToday ? 'today' : ''}`}
                  onClick={() => !disabled && onDateSelect(dateStr)}
                >
                  {day}
                </div>
              );
            })}
          </div>
        </div>
      );
    };

    if (!isOpen) return null;

    return (
      <>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content today-route-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>
                Roteiro de Hoje - {technician}
              </h2>
              <button className="modal-close" onClick={onClose}>
                <i className="bi bi-x"></i>
              </button>
            </div>
            
            <div className="modal-body">
              {/* Sistema de Abas */}
              <div className="route-tabs">
                <button 
                  className={`route-tab ${activeTab === 'route' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('route');
                    if (!isLoadingRouteSchedule) {
                      fetchRouteSchedule();
                    }
                  }}
                >
                  Roteiro
                  <span className="route-tab-count">{routeScheduleData.length}</span>
                </button>
                <button 
                  className={`route-tab ${activeTab === 'open' ? 'active' : ''}`}
                  onClick={() => setActiveTab('open')}
                  title="Ordens de serviço PREVISTO PARA HOJE"
                >
                  Em aberto
                  <span className="route-tab-count">{routeData.length}</span>
                </button>
                <button 
                  className={`route-tab ${activeTab === 'completed' ? 'active' : ''}`}
                  onClick={() => setActiveTab('completed')}
                >
                  Check-out pendente
                  <span className="route-tab-count">{completedData.length}</span>
                </button>
                <button 
                  className={`route-tab ${activeTab === 'finished' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('finished');
                    if (!isLoadingFinished) {
                      fetchFinishedRoute();
                    }
                  }}
                >
                  Produtividade
                </button>
                <button
                  className={`route-tab-print ${activeTab === 'open' ? '' : 'disabled'}`}
                  onClick={() => activeTab === 'open' && handlePrintRoute()}
                  disabled={activeTab !== 'open'}
                  title={activeTab === 'open' ? 'Imprimir roteiro' : 'Disponível apenas na aba "Em aberto"'}
                >
                  <i className="bi bi-printer"></i>
                </button>
              </div>

              {/* Conteúdo das Abas */}
              <div className="route-tab-content">
                {/* Aba Roteiro */}
                {activeTab === 'route' && (
                  <div className="route-section route-schedule-container">

                    {isLoadingRouteSchedule && (
                      <div className="today-route-skeleton route-schedule-wrapper" aria-busy="true" aria-label="Carregando roteiro">
                        <div className="today-route-skeleton-left route-schedule-left">
                          <div className="today-route-skeleton-title" />
                          <div className="today-route-skeleton-list">
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                              <div key={i} className="today-route-skeleton-row" />
                            ))}
                          </div>
                        </div>
                        <div className="today-route-skeleton-right route-schedule-right">
                          <div className="today-route-skeleton-header" />
                          <div className="today-route-skeleton-cards">
                            {[1, 2, 3].map((i) => (
                              <div key={i} className="today-route-skeleton-card">
                                <div className="today-route-skeleton-card-header" />
                                <div className="today-route-skeleton-card-line" />
                                <div className="today-route-skeleton-card-line today-route-skeleton-card-line-short" />
                                <div className="today-route-skeleton-card-line" />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {routeScheduleError && (
                      <div className="error-container">
                        <span>❌ Erro ao buscar roteiro: {routeScheduleError}</span>
                      </div>
                    )}
                    
                    {!isLoadingRouteSchedule && !routeScheduleError && (
                      <div className="route-schedule-wrapper">
                        {/* Divisão 30% esquerda / 70% direita */}
                        <div className={`route-schedule-left ${isLeftColumnCollapsed ? 'collapsed' : ''}`}>
                          {isLeftColumnCollapsed ? (
                            <div style={{ 
                              width: '100%', 
                              height: '100%', 
                              display: 'flex', 
                              flexDirection: 'column',
                              alignItems: 'center',
                              paddingTop: '20px'
                            }}>
                              <button
                                type="button"
                                className="route-schedule-collapse-btn"
                                onClick={() => setIsLeftColumnCollapsed(false)}
                                title="Visualizar EM aberto e fechadas"
                              >
                                <i className="bi bi-chevron-right"></i>
                              </button>
                            </div>
                          ) : (
                            <>
                              <div className="route-schedule-title" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <span>Em aberto</span>
                            <i 
                              className="bi bi-calendar3 route-date-picker-icon"
                              onClick={() => {
                                if (!showRouteDatePicker) {
                                  setRouteDatePickerValue(selectedRouteDate || (() => {
                                    const d = new Date();
                                    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                                  })());
                                }
                                setShowRouteDatePicker(!showRouteDatePicker);
                              }}
                              style={{
                                marginLeft: '7px',
                                fontSize: '13px',
                                color: '#7c4dff',
                                cursor: 'pointer',
                                padding: '2px'
                              }}
                              title="Selecionar data"
                            ></i>
                            <span className="route-schedule-sep" style={{ marginLeft: '7px', marginRight: '7px' }}>|</span>
                            <span className="route-schedule-meta">
                              Em aberto: {routeScheduleData.filter(order => 
                                (order.Tipo === 'Roteirizado' && (!order.TB02122_HORAINI || order.TB02122_HORAINI === '')) ||
                                order.Tipo === 'Em aberto - Fora do roteiro'
                              ).length}
                            </span>
                            {showRouteDatePicker && (
                              <div className="route-date-picker-container route-date-picker-modal" style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                marginTop: '3px',
                                zIndex: 1000
                              }}>
                                <div className="route-date-picker-header">
                                  <span>Data</span>
                                  <button type="button" className="route-date-picker-close" onClick={() => setShowRouteDatePicker(false)} aria-label="Fechar">
                                    <i className="bi bi-x"></i>
                                  </button>
                                </div>
                                <div className="route-date-picker-body">
                                  <RouteSingleDateCalendar
                                    selectedDate={routeDatePickerValue}
                                    onDateSelect={setRouteDatePickerValue}
                                    minDate={(() => { const d = new Date(); d.setFullYear(d.getFullYear() - 1); return d.toISOString().split('T')[0]; })()}
                                    maxDate={(() => { const d = new Date(); d.setFullYear(d.getFullYear() + 1); return d.toISOString().split('T')[0]; })()}
                                  />
                                  <div className="route-date-picker-actions">
                                    <button
                                      type="button"
                                      className="route-date-picker-apply"
                                      onClick={() => {
                                        if (routeDatePickerValue) setSelectedRouteDate(routeDatePickerValue);
                                        setShowRouteDatePicker(false);
                                      }}
                                      disabled={!routeDatePickerValue}
                                    >
                                      Aplicar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div 
                            ref={listScrollRef}
                            className={`route-schedule-list ${isListScrolling ? 'scrolling' : ''}`}
                            onScroll={(e) => {
                              const target = e.target;
                              setIsListScrolling(target.scrollTop > 0);
                            }}
                          >
                            {(() => {
                              // Filtrar ordens "Roteirizado" com TB02122_HORAINI nulo (Em aberto)
                              const roteirizadoAberto = routeScheduleData.filter(order => 
                                order.Tipo === 'Roteirizado' && 
                                (!order.TB02122_HORAINI || order.TB02122_HORAINI === '')
                              );
                              
                              // Filtrar ordens "Em aberto - Fora do roteiro" (TB02115_ORDEM = 0)
                              const foraRoteiro = routeScheduleData.filter(order => 
                                order.Tipo === 'Em aberto - Fora do roteiro'
                              );
                              
                              // Ordenar roteirizado por TB02115_ORDEM crescente
                              const sortedRoteirizado = [...roteirizadoAberto].sort((a, b) => {
                                const ordemA = a.TB02115_ORDEM || 0;
                                const ordemB = b.TB02115_ORDEM || 0;
                                return ordemA - ordemB;
                              });

                              // Função para agrupar por cidade e cliente
                              const groupByCityAndClient = (orders) => {
                                return orders.reduce((acc, order) => {
                                  const cidade = order.TB02115_CIDADE || 'Sem cidade';
                                  const cliente = getBoardClienteExibicao(order) || 'Sem cliente';
                                  
                                  if (!acc[cidade]) acc[cidade] = {};
                                  if (!acc[cidade][cliente]) acc[cidade][cliente] = [];
                                  acc[cidade][cliente].push(order);
                                  return acc;
                                }, {});
                              };

                              const groupedRoteirizado = groupByCityAndClient(sortedRoteirizado);
                              const groupedForaRoteiro = groupByCityAndClient(foraRoteiro);

                              // Renderizar grupo "Roteirizado"
                              const renderGroup = (grouped, groupTitle) => {
                                if (Object.keys(grouped).length === 0) return null;
                                
                                return (
                                  <>
                                    <div className="route-schedule-group-label">
                                      {groupTitle}
                                    </div>
                                    {Object.keys(grouped).sort().map(cidade => {
                                      const clientesNaCidade = Object.keys(grouped[cidade]);
                                      const temMultiplosClientes = clientesNaCidade.length > 1;
                                      
                                      // Calcular total de ordens na cidade
                                      const totalOrdensCidade = clientesNaCidade.reduce((total, cliente) => {
                                        return total + grouped[cidade][cliente].length;
                                      }, 0);
                                      
                                      return (
                                      <div key={cidade} className="route-schedule-city-card">
                                        <div className="route-schedule-city-header" style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                          <span>{cidade}</span>
                                          {temMultiplosClientes && (
                                            <span className="route-schedule-count-badge">
                                              {totalOrdensCidade}
                                            </span>
                                          )}
                                        </div>
                                        <div className="route-schedule-city-content">
                                          {clientesNaCidade.sort().map(cliente => {
                                            const totalOrdensCliente = grouped[cidade][cliente].length;
                                            const temMultiplasOrdens = totalOrdensCliente > 1;
                                            
                                            return (
                                            <div key={cliente} className={`route-schedule-client-group ${temMultiplosClientes ? 'client-card' : ''}`}>
                                              <div className="route-schedule-client-name" style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                <span>{cliente}</span>
                                                {temMultiplasOrdens && (
                                                  <span className="route-schedule-count-badge route-schedule-count-badge--neutral">
                                                    {totalOrdensCliente}
                                                  </span>
                                                )}
                                              </div>
                                              {grouped[cidade][cliente].map((order, idx) => {
                                                const produto = order.TB01010_RESUMIDO || order.TB01010_NOME || 'N/A';
                                                const patOrSerie = order.TB02112_PAT || order.TB02115_NUMSERIE || '';
                                                const hasMultiple = grouped[cidade][cliente].length > 1;
                                                const isLast = idx === grouped[cidade][cliente].length - 1;
                                                return (
                                                  <div 
                                                    key={`${order.TB02115_CODIGO}-${idx}`}
                                                    className={`route-schedule-item ${hasMultiple && !isLast ? 'with-border' : ''}`}
                                                    title={order.TB02112_PAT ? order.TB02115_NUMSERIE : ''}
                                                  >
                                                    <span className="route-schedule-item-ordem-wrap">
                                                      {order.isRetorno && (
                                                        <span className="order-retorno-icon-wrap order-retorno-icon-wrap--route-modal" title="Retorno" aria-hidden>
                                                          <i className="bi bi-bell order-retorno-icon" />
                                                        </span>
                                                      )}
                                                      <span className="route-schedule-item-ordem">#{order.TB02115_ORDEM}</span>
                                                    </span>
                                                    <span className="route-schedule-item-codigo">{order.TB02115_CODIGO}</span>
                                                    <span className="route-schedule-item-produto">{produto}</span>
                                                    <span className="route-schedule-item-pat">{patOrSerie}</span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    );
                                  })}
                                  </>
                                );
                              };

                              // Renderizar ambos os grupos
                              const roteirizadoContent = renderGroup(groupedRoteirizado, 'Roteirizado');
                              const foraRoteiroContent = renderGroup(groupedForaRoteiro, 'Não roteirizado');

                              if (!roteirizadoContent && !foraRoteiroContent) {
                                return (
                                  <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8', fontSize: '11px' }}>
                                    Nenhuma ordem em aberto encontrada
                                  </div>
                                );
                              }

                              return (
                                <>
                                  {roteirizadoContent}
                                  {foraRoteiroContent}
                                </>
                              );
                            })()}
                          </div>
                            </>
                          )}
                          {/* Botão na linha separadora - visível apenas quando expandido */}
                          {!isLeftColumnCollapsed && (
                            <div style={{
                              position: 'absolute',
                              right: '-10px',
                              top: '0px',
                              zIndex: 1000,
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'center',
                              width: '19px',
                              paddingTop: '6px',
                              pointerEvents: 'none'
                            }}>
                              <button
                                type="button"
                                className="route-schedule-collapse-btn route-schedule-collapse-btn--panel"
                                onClick={() => setIsLeftColumnCollapsed(true)}
                                title="Visualizar somente Check-out pendente"
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="route-schedule-right" style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', flex: 1 }}>
                          <div
                            className={`route-schedule-main-pane${showRouteDetailsSidebar ? ' with-sidebar' : ''}`}
                            style={{ 
                            flex: showRouteDetailsSidebar ? (showRoutePartsHistory || showRouteServiceHistory ? '0 0 calc(70% - 384px)' : '0 0 70%') : '1', 
                            display: 'flex', 
                            flexDirection: 'column', 
                            overflow: 'hidden',
                            transition: 'all 0.3s ease',
                            minWidth: 0
                          }}>
                          <div className="route-schedule-title" style={{ position: 'relative', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                            <span>Fechadas</span>
                            <span className="route-schedule-sep">|</span>
                            <span className="route-schedule-meta">
                              Total: {routeScheduleData.filter(order => 
                                (order.Tipo === 'Roteirizado' && order.TB02122_HORAINI != null && order.TB02122_HORAINI !== '') ||
                                order.Tipo === 'Não Roteirizado'
                              ).length} ({routeScheduleData.filter(order => 
                                order.Tipo === 'Não Roteirizado'
                              ).length} fora do roteiro)
                            </span>
                            <span className="route-schedule-sep route-schedule-sep--soft">|</span>
                            <span className="route-schedule-meta">
                              Progresso: {routeScheduleData.length > 0 ? Math.round((routeScheduleData.filter(order => 
                                order.Tipo === 'Roteirizado' && order.TB02122_HORAINI != null && order.TB02122_HORAINI !== ''
                              ).length / routeScheduleData.length) * 100) : 0}%
                            </span>
                            <span className="route-schedule-sep route-schedule-sep--soft">|</span>
                            <span className="header-time-produced route-schedule-meta" style={{ fontSize: '12px' }}>
                              Tempo produzido: {calculateTotalCompletedTime(routeScheduleData.filter(order => 
                                (order.Tipo === 'Roteirizado' && order.TB02122_HORAINI != null && order.TB02122_HORAINI !== '') ||
                                order.Tipo === 'Não Roteirizado'
                              ))}
                            </span>
                          </div>
                          {isLoadingRouteSchedule && (
                            <div className="loading-container">
                              <div className="loading-spinner"></div>
                              <span>Carregando ordens fechadas...</span>
                            </div>
                          )}
                          {routeScheduleError && (
                            <div className="error-container">
                              <span>❌ Erro ao buscar ordens: {routeScheduleError}</span>
                            </div>
                          )}
                          {!isLoadingRouteSchedule && !routeScheduleError && (() => {
                            // Filtrar ordens "Roteirizado" com TB02122_HORAINI não nulo
                            const roteirizadoFechado = routeScheduleData.filter(order => 
                              order.Tipo === 'Roteirizado' && 
                              order.TB02122_HORAINI != null && 
                              order.TB02122_HORAINI !== ''
                            );
                            
                            // Filtrar ordens "Não Roteirizado"
                            const naoRoteirizado = routeScheduleData.filter(order => 
                              order.Tipo === 'Não Roteirizado'
                            );
                            
                            // Combinar ambas
                            const completedOrders = [...roteirizadoFechado, ...naoRoteirizado];
                            
                            // Agrupar por TB01055_NOME
                            const groupedCompleted = completedOrders.reduce((acc, order) => {
                              const condition = order.TB01055_NOME || 'Sem condição';
                              if (!acc[condition]) acc[condition] = [];
                              acc[condition].push(order);
                              return acc;
                            }, {});
                            
                            const groupedArray = Object.entries(groupedCompleted)
                              .map(([condition, orders]) => ({ condition, orders }))
                              .sort((a, b) => b.orders.length - a.orders.length);
                            
                            return groupedArray.length === 0 ? (
                              <div className="route-schedule-empty">
                                Nenhuma ordem fechada encontrada
                              </div>
                            ) : (
                              <div className="route-schedule-closed-grid">
                                {groupedArray.map(({ condition, orders }) => (
                                  <div key={condition} className="route-schedule-condition-card">
                                    <div className="route-schedule-condition-header">
                                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {condition}
                                      </span>
                                      <span className="route-schedule-count-badge route-schedule-count-badge--sm">
                                        {orders.length}
                                      </span>
                                    </div>
                                    <div className="route-schedule-condition-orders">
                                      {orders.map((ordem, index) => {
                                        const horarioFinal = formatTime(ordem.TB02122_HORAFIM);
                                        const isNaoRoteirizado = ordem.Tipo === 'Não Roteirizado';
                                        
                                        // Função para formatar data no formato dd/MM/yyyy sem alteração de fuso horário
                                        const formatDateDDMMYYYYRoute = (dateValue) => {
                                          if (!dateValue) return '';
                                          const date = new Date(dateValue);
                                          // Usar métodos locais para evitar problemas de timezone
                                          const day = String(date.getDate()).padStart(2, '0');
                                          const month = String(date.getMonth() + 1).padStart(2, '0');
                                          const year = date.getFullYear();
                                          return `${day}/${month}/${year}`;
                                        };
                                        
                                        const dataFormatadaRoute = formatDateDDMMYYYYRoute(ordem.TB02122_DATAFIM);
                                        
                                        const isSelected = showRouteDetailsSidebar && selectedRouteOrder && (selectedRouteOrder.TB02122_CODIGO === ordem.TB02122_CODIGO || selectedRouteOrder.TB02115_CODIGO === ordem.TB02115_CODIGO);
                                        
                                        return (
                                          <div 
                                            key={`${ordem.TB02122_CODIGO || ordem.TB02115_CODIGO}-${index}`} 
                                            className={`route-schedule-closed-order${isSelected ? ' is-selected' : ''}`}
                                            onClick={() => openRouteDetailsSidebar(ordem)}
                                          >
                                            <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8.5px', alignItems: 'start' }}>
                                              <div style={{ display: 'flex', flexDirection: 'column', gap: '2.55px', minWidth: '59.5px' }}>
                                                <div className="route-schedule-closed-order-code">
                                                  {ordem.TB02115_CODIGO || 'N/A'}
                                                </div>
                                                {ordem.TB02112_PAT && (
                                                  <div className="route-schedule-closed-order-muted">
                                                    {ordem.TB02112_PAT}
                                                  </div>
                                                )}
                                                <div className="route-schedule-closed-order-time">
                                                  {horarioFinal}
                                                </div>
                                              </div>
                                              <div style={{ display: 'flex', flexDirection: 'column', gap: '2.55px', minWidth: 0, flex: 1, paddingBottom: !ordem.TB02112_PAT ? '18px' : '0' }}>
                                                <div className="route-schedule-closed-order-name">
                                                  {ordem.TB01010_NOME || 'N/A'}
                                                </div>
                                                <div className="route-schedule-closed-order-muted" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                  {getBoardClienteExibicao(ordem) || 'N/A'}
                                                </div>
                                              </div>
                                            </div>
                                            {/* Tags no canto inferior */}
                                            <div style={{
                                              position: 'absolute',
                                              bottom: '0',
                                              right: '0',
                                              display: 'flex',
                                              gap: '3.4px',
                                              alignItems: 'flex-end'
                                            }}>
                                              {/* Tag "Fora do roteiro" à esquerda (quando aplicável) */}
                                              {isNaoRoteirizado && (
                                                <div className="route-schedule-tag-fora">
                                                  Fora do roteiro
                                                </div>
                                              )}
                                              {/* Tag "Concluída" - quando TB02115_DTFECHA não é nulo (cor verde) */}
                                              {ordem.TB02115_DTFECHA && ordem.TB02115_DTFECHA !== null && (
                                                <div style={{
                                                  background: '#10b981',
                                                  color: '#ffffff',
                                                  fontSize: '7.65px',
                                                  fontWeight: 600,
                                                  padding: '2.55px 5.1px',
                                                  borderTopLeftRadius: '5.1px',
                                                  borderBottomRightRadius: '5.1px',
                                                  fontFamily: "'Geist Variable', 'Geist'"
                                                }}>
                                                  Concluída
                                                </div>
                                              )}
                                              {/* Tag "Check-Out" - quando TB02122_DATAFIM não é nulo E TB02115_DTFECHA é nulo (cor verde mais claro) */}
                                              {ordem.TB02122_DATAFIM && ordem.TB02122_DATAFIM !== null && (!ordem.TB02115_DTFECHA || ordem.TB02115_DTFECHA === null) && (
                                                <div style={{
                                                  background: '#aaf0d1',
                                                  color: '#343434',
                                                  fontSize: '7.65px',
                                                  fontWeight: 600,
                                                  padding: '2.55px 5.1px',
                                                  borderTopLeftRadius: '5.1px',
                                                  borderBottomRightRadius: '5.1px',
                                                  fontFamily: "'Geist Variable', 'Geist'"
                                                }}>
                                                  Check-Out
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            );
                          })()}
                          </div>
                          {/* Coluna de Histórico de Atendimentos - Renderizada antes da sidebar de detalhes */}
                          {showRouteDetailsSidebar && showRouteServiceHistory && selectedRouteOrder && (
                            <div className="completed-parts-history-sidebar">
                              <div className="completed-parts-history-header">
                                <h4>Histórico de Atendimentos</h4>
                                <button 
                                  className="completed-parts-history-close" 
                                  onClick={() => setShowRouteServiceHistory(false)}
                                >
                                  <i className="bi bi-x"></i>
                                </button>
                              </div>
                              
                              <div className="completed-parts-history-content">
                                {loadingRouteServiceHistory ? (
                                  <div className="loading-container">
                                    <div className="loading-spinner"></div>
                                    <div>Carregando histórico...</div>
                                  </div>
                                ) : routeServiceHistoryError ? (
                                  <div className="error-message">
                                    <i className="bi bi-exclamation-triangle"></i>
                                    {routeServiceHistoryError}
                                  </div>
                                ) : routeServiceHistory.length === 0 ? (
                                  <div className="no-data-message">
                                    Nenhum histórico de atendimentos encontrado.
                                  </div>
                                ) : (
                                  <div className="service-history-container">
                                    {routeServiceHistory.map((item) => {
                                      const formatDate = (dateStr) => {
                                        if (!dateStr) return 'N/A';
                                        const date = new Date(dateStr);
                                        if (isNaN(date.getTime())) return 'N/A';
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const year = date.getFullYear();
                                        return `${day}/${month}/${year}`;
                                      };
                                      
                                      const formatCounter = (value) => {
                                        if (!value || value === '0' || value === 0) return '-';
                                        return typeof value === 'string' ? value : value.toLocaleString('pt-BR');
                                      };
                                      
                                      const getConditionClass = (condicao) => {
                                        if (!condicao) return '';
                                        const condicaoLower = condicao.toLowerCase();
                                        if (condicaoLower.includes('reparado')) return 'reparado';
                                        if (condicaoLower.includes('funcionando')) return 'funcionando';
                                        if (condicaoLower.includes('manutenção') || condicaoLower.includes('manutencao')) return 'manutencao';
                                        if (condicaoLower.includes('substituído') || condicaoLower.includes('substituido')) return 'substituido';
                                        return '';
                                      };
                                      
                                      return (
                                        <div key={item.id || item.TB02122_CODIGO} className="service-history-item">
                                          <div className="equipment-history-header">
                                            <div className="equipment-history-date">{item.data || formatDate(item.dataAtendimento || item.TB02122_DATAFIM)}</div>
                                            <div className="equipment-history-os">
                                              <span className="equipment-history-os-number">{item.numeroOS || item.os || item.TB02122_NUMOS || 'N/A'}</span>
                                              <span className={`equipment-history-os-type ${(item.tipoOS || item.tipo || '').toLowerCase()}`}>
                                                {item.tipoOS || item.tipo || 'N/A'}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="equipment-history-tech">Técnico: {item.tecnico || 'N/A'}</div>
                                          
                                          <div className="equipment-history-detail">
                                            <div className="equipment-history-detail-item compact">
                                              <span className="equipment-history-detail-label">Defeito:</span>
                                              <span className="equipment-history-detail-value">
                                                {item.defeito || item.motivoOS || item.TB02115_NOME || 'Não informado'}
                                              </span>
                                            </div>
                                            {item.observacao && (
                                              <div className="equipment-history-detail-item compact">
                                                <div className="equipment-history-laudo">
                                                  {item.observacao}
                                                </div>
                                              </div>
                                            )}
                                            <div className="equipment-history-detail-item compact">
                                              <span className="equipment-history-detail-label">Condição:</span>
                                              <span className={`equipment-history-detail-value ${getConditionClass(item.condicao)}`}>
                                                {item.condicao || item.TB01055_NOME || 'N/A'}
                                              </span>
                                            </div>
                                            
                                            {item.laudo && (
                                              <div className="equipment-history-detail-item laudo-item">
                                                <span className="equipment-history-detail-label">Laudo:</span>
                                                <div className="equipment-history-laudo">
                                                  {item.laudo}
                                                </div>
                                              </div>
                                            )}
                                            
                                            {item.contadores && (
                                              <div className="equipment-history-detail-item counters-detail-item">
                                                <span className="equipment-history-detail-label">Contadores:</span>
                                                <div className="equipment-history-counters">
                                                  <div className="counters-compact-table">
                                                    <div className="counters-compact-header">
                                                      <div className="counter-compact-col">P&B</div>
                                                      <div className="counter-compact-col">Color</div>
                                                      <div className="counter-compact-col">DG</div>
                                                      <div className="counter-compact-col">GF P&B</div>
                                                      <div className="counter-compact-col">GF Color</div>
                                                    </div>
                                                    <div className="counters-compact-body">
                                                      <div className="counter-compact-row">
                                                        <div className="counter-compact-col">{formatCounter(item.contadores?.pb)}</div>
                                                        <div className="counter-compact-col">{formatCounter(item.contadores?.color)}</div>
                                                        <div className="counter-compact-col">{formatCounter(item.contadores?.dg)}</div>
                                                        <div className="counter-compact-col">{formatCounter(item.contadores?.gfPb)}</div>
                                                        <div className="counter-compact-col">{formatCounter(item.contadores?.gfColor)}</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Coluna de Histórico de Peças Trocadas - Renderizada antes da sidebar de detalhes */}
                          {showRouteDetailsSidebar && showRoutePartsHistory && selectedRouteOrder && (
                            <div className="completed-parts-history-sidebar">
                              <div className="completed-parts-history-header">
                                <h4>Histórico de Peças Trocadas</h4>
                                <button 
                                  className="completed-parts-history-close" 
                                  onClick={() => setShowRoutePartsHistory(false)}
                                >
                                  <i className="bi bi-x"></i>
                                </button>
                              </div>
                              
                              <div className="completed-parts-history-content">
                                {loadingRoutePartsHistory ? (
                                  <div className="loading-container">
                                    <div className="loading-spinner"></div>
                                    <div>Carregando histórico...</div>
                                  </div>
                                ) : routePartsHistoryError ? (
                                  <div className="error-message">
                                    <i className="bi bi-exclamation-triangle"></i>
                                    {routePartsHistoryError}
                                  </div>
                                ) : routePartsHistory.length === 0 ? (
                                  <div className="no-data-message">
                                    Nenhum histórico de peças trocadas encontrado.
                                  </div>
                                ) : (
                                  <div className="parts-history-table-wrapper">
                                    <div className="parts-history-table-container">
                                      <table className="parts-history-table">
                                        <thead>
                                          <tr>
                                            <th>Pedido</th>
                                            <th>Data</th>
                                            <th>Código</th>
                                            <th>Ref.</th>
                                            <th>Produto</th>
                                            <th className="parts-history-qty-header">Qtde</th>
                                            <th>OS</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {routePartsHistory.map((item, index) => {
                                            const isPendingPart = routePendingParts.some(part => part.codigo === item.TB02022_PRODUTO);
                                            
                                            const formatDate = (dateStr) => {
                                              if (!dateStr) return 'N/A';
                                              const date = new Date(dateStr);
                                              if (isNaN(date.getTime())) return 'N/A';
                                              const day = String(date.getDate()).padStart(2, '0');
                                              const month = String(date.getMonth() + 1).padStart(2, '0');
                                              const year = date.getFullYear();
                                              return `${day}/${month}/${year}`;
                                            };
                                            
                                            const tooltipText = `Cont. PB: ${formatNumber(item.TB02021_CONTPB || 0)}\nCont. Cor: ${formatNumber(item.TB02021_CONTCOLOR || 0)}\nCont. Total: ${formatNumber(item.TB02021_CONTTOTAL || 0)}\nVida útil: ${formatNumber(item.TB01010_COPIA || 0)}`;
                                            
                                            return (
                                              <tr key={index} className={isPendingPart ? 'parts-history-row-pending' : ''}>
                                                <td title={tooltipText}>{item.TB02022_CODIGO || 'N/A'}</td>
                                                <td>{formatDate(item.TB02021_DATA)}</td>
                                                <td className={isPendingPart ? 'parts-history-code-pending' : ''}>{item.TB02022_PRODUTO || 'N/A'}</td>
                                                <td>{item.TB01010_REFERENCIA || 'N/A'}</td>
                                                <td className={isPendingPart ? 'parts-history-name-pending' : ''}>{item.TB01010_NOME || 'N/A'}</td>
                                                <td className="parts-history-qty-cell">{Math.floor(item.TB02022_QTPROD || 0)}</td>
                                                <td>{item.TB02021_OS || 'N/A'}</td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Sidebar de detalhes */}
                          {showRouteDetailsSidebar && selectedRouteOrder && (
                            <div className={`completed-details-sidebar ${showRoutePartsHistory || showRouteServiceHistory ? 'with-history' : ''}`} style={{ flex: '0 0 30%' }}>
                              <div className="completed-details-sidebar-header">
                                <div className="completed-details-header-top">
                                  <div className="completed-details-header-left">
                                    <h3>
                                      Detalhes da OS {selectedRouteOrder.TB02115_CODIGO || selectedRouteOrder.TB02122_NUMOS || 'N/A'}
                                      {selectedRouteOrder.TB02115_DTFECHA && (
                                        <span className="completed-details-tag">Concluída</span>
                                      )}
                                    </h3>
                                    <div className="completed-details-header-buttons">
                                      <button 
                                        className="completed-details-history-btn-small"
                                        onClick={() => {
                                          if (showRouteServiceHistory) {
                                            setShowRouteServiceHistory(false);
                                          }
                                          if (!showRoutePartsHistory) {
                                            fetchRoutePartsHistory(selectedRouteOrder.TB02122_NUMSERIE || selectedRouteOrder.TB02115_NUMSERIE);
                                          }
                                          setShowRoutePartsHistory(!showRoutePartsHistory);
                                        }}
                                        title={showRoutePartsHistory ? "Ocultar histórico de peças trocadas" : "Ver histórico de peças trocadas"}
                                      >
                                        <i className={`bi bi-${showRoutePartsHistory ? 'x' : 'clock-history'}`}></i>
                                        Histórico de peças trocadas
                                      </button>
                                      <button 
                                        className="completed-details-history-btn-small"
                                        onClick={() => {
                                          if (showRoutePartsHistory) {
                                            setShowRoutePartsHistory(false);
                                          }
                                          if (!showRouteServiceHistory) {
                                            fetchRouteServiceHistory(selectedRouteOrder.TB02122_NUMSERIE || selectedRouteOrder.TB02115_NUMSERIE);
                                          }
                                          setShowRouteServiceHistory(!showRouteServiceHistory);
                                        }}
                                        title={showRouteServiceHistory ? "Ocultar histórico de atendimentos" : "Ver histórico de atendimentos"}
                                      >
                                        <i className={`bi bi-${showRouteServiceHistory ? 'x' : 'calendar-check'}`}></i>
                                        Histórico de atendimentos
                                      </button>
                                    </div>
                                  </div>
                                  <button className="completed-details-sidebar-close" onClick={closeRouteDetailsSidebar}>
                                    <i className="bi bi-x"></i>
                                  </button>
                                </div>
                              </div>
            
                              <div className="completed-details-sidebar-content">
                                {routeOrderDetailLoading ? (
                                  <div style={{ padding: '24px', textAlign: 'center', color: '#64748b' }}>
                                    <i className="bi bi-arrow-repeat spin" style={{ fontSize: '18px', marginRight: '8px' }}></i>
                                    Carregando detalhes...
                                  </div>
                                ) : (
                                <>
                                {/* Tooltip de Estoque */}
                                {routeStockTooltip && (
                                  <div className="stock-tooltip">
                                    <div className="stock-tooltip-header">
                                      <div className="stock-tooltip-title-section">
                                        <span>{routeStockProductName || 'Disponibilidade em Estoque'}</span>
                                        {routeStockData && routeStockData.totals && (
                                          <span className="stock-tooltip-total">
                                            Total: {formatNumber(routeStockData.totals.total)}
                                          </span>
                                        )}
                                      </div>
                                      <button 
                                        className="stock-tooltip-close"
                                        onClick={closeRouteStockTooltip}
                                      >
                                        <i className="bi bi-x"></i>
                                      </button>
                                    </div>

                                    {loadingRouteStock ? (
                                      <div className="stock-tooltip-loading">
                                        <i className="bi bi-clock-history"></i> Carregando...
                                      </div>
                                    ) : routeStockError ? (
                                      <div className="stock-tooltip-error">
                                        <i className="bi bi-exclamation-triangle"></i> {routeStockError}
                                      </div>
                                    ) : routeStockData && routeStockData.data ? (
                                      <div className="stock-tooltip-content">
                                        <table className="stock-table">
                                          <thead>
                                            <tr>
                                              <th>Tipo</th>
                                              <th className="stock-table-center">Comércio</th>
                                              <th className="stock-table-center">Imobilizado</th>
                                              <th className="stock-table-center">RMA</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr className="stock-totals-row">
                                              <td><strong>Total</strong></td>
                                              <td className="stock-table-center">
                                                <strong>{formatNumber(routeStockData.totals?.comercio || 0)}</strong>
                                              </td>
                                              <td className="stock-table-center">
                                                <strong>{formatNumber(routeStockData.totals?.imobilizado || 0)}</strong>
                                              </td>
                                              <td className="stock-table-center">
                                                <strong>{formatNumber(routeStockData.totals?.rma || 0)}</strong>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                        {routeStockData.data && routeStockData.data.length > 0 && (
                                          <>
                                            <div className="stock-actions-row">
                                              <button
                                                className="stock-action-btn"
                                                onClick={() => setShowRouteStockByCompany(!showRouteStockByCompany)}
                                              >
                                                <i className={`bi bi-${showRouteStockByCompany ? 'dash' : 'plus'}`}></i>
                                                Estoque por empresa
                                              </button>
                                              
                                              {routeStockData.similarProducts && routeStockData.similarProducts.length > 0 && (
                                                <button
                                                  className="stock-action-btn"
                                                  onClick={() => setShowRouteSimilarProducts(!showRouteSimilarProducts)}
                                                >
                                                  <i className={`bi bi-chevron-${showRouteSimilarProducts ? 'up' : 'down'}`}></i>
                                                  Produtos semelhantes
                                                </button>
                                              )}
                                            </div>

                                            {showRouteStockByCompany && routeStockData.data && routeStockData.data.length > 0 && (
                                              <div className="stock-by-company-content">
                                                <table className="stock-table">
                                                  <thead>
                                                    <tr>
                                                      <th>Emp</th>
                                                      <th className="stock-table-center">Comércio</th>
                                                      <th className="stock-table-center">Imobilizado</th>
                                                      <th className="stock-table-center">RMA</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {routeStockData.data.map((item, idx) => (
                                                      <tr key={idx}>
                                                        <td title={item.empresaNome || ''}>{item.empresa || 'N/A'}</td>
                                                        <td className={`stock-table-center ${item.comercio < 0 ? 'stock-negative' : ''}`}>
                                                          {formatNumber(item.comercio)}
                                                        </td>
                                                        <td className={`stock-table-center ${item.imobilizado < 0 ? 'stock-negative' : ''}`}>
                                                          {formatNumber(item.imobilizado)}
                                                        </td>
                                                        <td className={`stock-table-center ${item.rma < 0 ? 'stock-negative' : ''}`}>
                                                          {formatNumber(item.rma)}
                                                        </td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </table>
                                              </div>
                                            )}

                                            {showRouteSimilarProducts && routeStockData.similarProducts && routeStockData.similarProducts.length > 0 && (
                                              <div className="stock-similar-products-section">
                                                <div className="stock-similar-products-content">
                                                  <table className="stock-table similar-products-table">
                                                    <thead>
                                                      <tr>
                                                        <th>Código</th>
                                                        <th>Ref.</th>
                                                        <th>Produto</th>
                                                        <th className="stock-table-center">Comércio</th>
                                                        <th className="stock-table-center">Imobilizado</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {routeStockData.similarProducts.map((product, idx) => (
                                                        <tr key={idx}>
                                                          <td>{product.codigo || 'N/A'}</td>
                                                          <td>{product.referencia || 'N/A'}</td>
                                                          <td>{product.nome || 'N/A'}</td>
                                                          <td className={`stock-table-center ${product.comercio < 0 ? 'stock-negative' : ''}`}>
                                                            {formatNumber(product.comercio || 0)}
                                                          </td>
                                                          <td className={`stock-table-center ${product.imobilizado < 0 ? 'stock-negative' : ''}`}>
                                                            {formatNumber(product.imobilizado || 0)}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                                
                                {/* Informações Básicas */}
                                <div className="completed-details-section">
                                  <div className="completed-details-grid">
                                    <div className="completed-details-item">
                                      <div className="completed-details-label">Série</div>
                                      <div className="completed-details-value">{selectedRouteOrder.TB02122_NUMSERIE || selectedRouteOrder.TB02115_NUMSERIE || 'N/A'}</div>
                                    </div>
                                    <div className="completed-details-item">
                                      <div className="completed-details-label">Patrimônio</div>
                                      <div className="completed-details-value">{selectedRouteOrder.TB02112_PAT || 'N/A'}</div>
                                    </div>
                                    <div className="completed-details-item completed-details-full-width">
                                      <div className="completed-details-label">Defeito</div>
                                      <div className="completed-details-defeito-wrapper">
                                        <div className="completed-details-value">{selectedRouteOrder.TB02115_NOME || 'N/A'}</div>
                                        {selectedRouteOrder.TB02115_NOME && (
                                          <button 
                                            className="completed-details-defeito-btn"
                                            onClick={toggleRouteDefeitoDetails}
                                            title={showRouteDefeitoDetails ? "Ocultar detalhes do defeito" : "Ver detalhes do defeito"}
                                          >
                                            <i className={`bi bi-chevron-${showRouteDefeitoDetails ? 'up' : 'down'}`}></i>
                                            {showRouteDefeitoDetails ? 'Ocultar defeito' : 'Ver defeito'}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    
                                    {/* Seção expandível dos detalhes do defeito */}
                                    {showRouteDefeitoDetails && (
                                      <div className="completed-details-defeito-section">
                                        {loadingRouteDefeito && (
                                          <div className="defeito-loading">
                                            <i className="bi bi-clock-history"></i> Carregando detalhes do defeito...
                                          </div>
                                        )}
                                        
                                        {routeDefeitoError && (
                                          <div className="defeito-error">
                                            <i className="bi bi-exclamation-triangle"></i> {routeDefeitoError}
                                          </div>
                                        )}
                                        
                                        {routeDefeitoData && !loadingRouteDefeito && !routeDefeitoError && (
                                          <div className="defeito-table-container">
                                            <table className="defeito-table">
                                              <thead>
                                                <tr>
                                                  <th>Defeito</th>
                                                  <th>Observação</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td>{routeDefeitoData.defeito || 'N/A'}</td>
                                                  <td>{routeDefeitoData.observacao || 'N/A'}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    
                                    <div className="completed-details-item completed-details-full-width">
                                      <div className="completed-details-label">Horários</div>
                                      <div className="completed-details-value">{formatHorariosCompletos(selectedRouteOrder.TB02122_HORAINI, selectedRouteOrder.TB02122_HORAFIM)}</div>
                                    </div>
                                  </div>
                                </div>

                                {/* Laudo */}
                                <div className="completed-details-section">
                                  <div className="completed-details-section-title">Laudo</div>
                                  <div className="completed-details-item completed-details-full-width">
                                    <div className="completed-details-value" style={{ fontWeight: 'normal', lineHeight: '1.6' }}>
                                      {selectedRouteOrder.TB02122_OBS || 'Nenhum laudo registrado'}
                                    </div>
                                    {/* Condição de Intervenção */}
                                    <div style={{ marginTop: '12px' }}>
                                      <select 
                                        className="completed-details-condition-select"
                                        value={selectedRouteOrder.TB01055_NOME || ''}
                                        disabled={true}
                                      >
                                        <option value={selectedRouteOrder.TB01055_NOME || ''}>
                                          {selectedRouteOrder.TB01055_NOME || 'Nenhuma condição registrada'}
                                        </option>
                                      </select>
                                      <div className="completed-details-condition-note">
                                        Edição futura disponível
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Contadores */}
                                <div className="completed-details-section">
                                  <div className="completed-details-section-title">Contadores</div>
                                  <div className="completed-details-counters-row">
                                    <div className="completed-details-counter-item">
                                      <div className="completed-details-label">P&B</div>
                                      <div className="completed-details-value">{formatNumber(selectedRouteOrder.TB02122_CONTADOR)}</div>
                                    </div>
                                    <div className="completed-details-counter-item">
                                      <div className="completed-details-label">Cor</div>
                                      <div className="completed-details-value">{formatNumber(selectedRouteOrder.TB02122_CONTADORC)}</div>
                                    </div>
                                    <div className="completed-details-counter-item">
                                      <div className="completed-details-label">Dig.</div>
                                      <div className="completed-details-value">{formatNumber(selectedRouteOrder.TB02122_CONTADORDG)}</div>
                                    </div>
                                    <div className="completed-details-counter-item">
                                      <div className="completed-details-label">A3 P&B</div>
                                      <div className="completed-details-value">{formatNumber(selectedRouteOrder.TB02122_CONTADORGF)}</div>
                                    </div>
                                    <div className="completed-details-counter-item">
                                      <div className="completed-details-label">A3 Cor</div>
                                      <div className="completed-details-value">{formatNumber(selectedRouteOrder.TB02122_CONTADORGFC)}</div>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Peças Pendentes */}
                                {routePendingParts.length > 0 && (
                                  <div className="details-section parts-section-bordered">
                                    <h4>Peças Pendentes</h4>
                                    {isLoadingRouteParts ? (
                                      <div className="loading-message">Carregando peças...</div>
                                    ) : (
                                      <table className="parts-table">
                                        <thead>
                                          <tr>
                                            <th>Código</th>
                                            <th>Ref.</th>
                                            <th>Nome</th>
                                            <th>Qtde</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {routePendingParts.map((peca, index) => (
                                            <tr
                                              key={index}
                                              className={routeStockTooltip === peca.codigo ? 'pending-part-row pending-part-row-selected' : 'pending-part-row'}
                                            >
                                              <td>{peca.codigo}</td>
                                              <td>{peca.referencia || 'N/A'}</td>
                                              <td>{peca.nome}</td>
                                              <td className="parts-qty-cell">
                                                <span>{peca.quantidade}</span>
                                                <button
                                                  className="parts-stock-icon"
                                                  onClick={() => fetchRouteStockData(peca.codigo, peca.nome)}
                                                  title="Ver disponibilidade em estoque"
                                                >
                                                  <i className="bi bi-box"></i>
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                                )}
                                
                                {/* Peças Utilizadas */}
                                {routeUsedParts.length > 0 && (
                                  <div className="details-section parts-section-bordered">
                                    <h4>Peças Utilizadas</h4>
                                    {isLoadingRouteParts ? (
                                      <div className="loading-message">Carregando peças...</div>
                                    ) : (
                                      <table className="parts-table">
                                        <thead>
                                          <tr>
                                            <th>Código</th>
                                            <th>Ref.</th>
                                            <th>Nome</th>
                                            <th>Qtde</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {routeUsedParts.map((peca, index) => (
                                            <tr key={index}>
                                              <td>{peca.codigo}</td>
                                              <td>{peca.referencia || 'N/A'}</td>
                                              <td>{peca.nome}</td>
                                              <td>{peca.quantidade}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                                )}
                                
                                {/* Mensagens quando não há peças */}
                                {!isLoadingRouteParts && routePendingParts.length === 0 && routeUsedParts.length === 0 && (
                                  <div className="details-section">
                                    <div className="no-parts-message">
                                      Nenhuma peça pendente ou utilizada registrada para esta ordem.
                                    </div>
                                  </div>
                                )}
                                </>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Aba Em Aberto */}
                {activeTab === 'open' && (
                  <div className="route-section">
                
                {isLoadingRoute && (
                  <div className="loading-indicator">
                    <i className="bi bi-arrow-repeat spin"></i>
                    <span>Carregando roteiro...</span>
                  </div>
                )}
                
                {isReordering && (
                  <div className="loading-indicator processing">
                    <i className="bi bi-arrow-repeat spin"></i>
                    <span>
                      Atualizando sequências... Por favor, aguarde.
                      {retryAttempt > 1 && ` (Tentativa ${retryAttempt}/2)`}
                    </span>
                  </div>
                )}
                
                {routeError && (
                  <div className="error-message">
                    <i className="bi bi-exclamation-triangle"></i>
                    <span>Erro: {routeError}</span>
                  </div>
                )}
                
                {!isLoadingRoute && !routeError && (
                <div className="route-table-container" style={{ opacity: isReordering ? 0.6 : 1, pointerEvents: isReordering ? 'none' : 'auto' }}>
                  <table className="route-table">
                    <thead>
                      <tr>
                        <th className="text-left">#</th>
                        <th>OS</th>
                        <th>PEDIDO</th>
                        <th>Cliente</th>
                        <th>Equipamento</th>
                        <th>Série</th>
                        <th>Patrimônio</th>
                        <th>Cidade</th>
                        <th>Bairro</th>
                        <th className="text-left">Previsão</th>
                      </tr>
                    </thead>
                    <tbody>
                        {routeData.map((ordem, index) => {
                          const orderNumber = getOrderNumber(ordem);
                          const isRoteirizado = ordem.Tipo === 'Roteirizado';
                          const isNaoRoteirizado = ordem.Tipo === 'Não roteirizado';
                          
                          return (
                            <tr 
                              key={`${ordem.TB02115_CODIGO}-${index}`} 
                              className={`route-table-row open ${isRoteirizado ? 'draggable' : ''} clickable`}
                              draggable={isRoteirizado}
                              onDragStart={(e) => handleDragStart(e, ordem, index)}
                              onDragOver={handleDragOver}
                              onDrop={(e) => handleDrop(e, index)}
                              onClick={() => !isReordering && handleOrderClick(ordem)}
                              style={{ 
                                cursor: isReordering ? 'wait' : 'pointer',
                                opacity: isReordering ? 0.7 : 1
                              }}
                            >
                              <td className={`order-number ${orderNumber.isRed ? 'order-red' : ''}`}>
                                {showSequenceInput === ordem.TB02115_CODIGO ? (
                                  <div className="sequence-input-container">
                                    <input
                                      type="number"
                                      value={sequenceInputValue}
                                      onChange={(e) => setSequenceInputValue(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !isReordering) handleSaveSequence();
                                        if (e.key === 'Escape' && !isReordering) setShowSequenceInput(null);
                                      }}
                                      className="sequence-input"
                                      placeholder="Seq."
                                      min="1"
                                      autoFocus
                                      disabled={isReordering}
                                    />
                                    <button 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveSequence();
                                      }}
                                      className="sequence-save-btn"
                                      disabled={isReordering}
                                      title={isReordering ? "Processando..." : "Confirmar ordem"}
                                    >
                                      {isReordering ? (
                                        <i className="bi bi-arrow-repeat spin" style={{ fontSize: '10px' }}></i>
                                      ) : (
                                        "✓"
                                      )}
                                    </button>
                                    <button 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (!isReordering) setShowSequenceInput(null);
                                      }}
                                      className="sequence-cancel-btn"
                                      disabled={isReordering}
                                      title={isReordering ? "Processando..." : "Cancelar"}
                                    >
                                      ×
                                    </button>
                                  </div>
                                ) : (
                                  orderNumber.number
                                )}
                              </td>
                              <td className="order-os">{ordem.TB02115_CODIGO}</td>
                              <td className="order-pedido">{ordem.PEDIDO_VINCULADO || ordem.pedidoVinculado || 'N/A'}</td>
                              <td
                                className="order-cliente"
                                title={[getBoardClienteTooltipNome(ordem), ordem.ENDERECO || 'Endereço não informado'].filter(Boolean).join('\n')}
                              >
                                {getBoardClienteExibicao(ordem)}
                              </td>
                              <td className="order-equipamento" title={ordem.TB02115_NOME || 'Motivo não informado'}>
                                {getEquipment(ordem)}
                              </td>
                              <td className="order-serie">{ordem.TB02115_NUMSERIE || 'N/A'}</td>
                              <td className="order-patrimonio">{ordem.TB02112_PAT || 'N/A'}</td>
                              <td className="order-cidade">{ordem.TB02115_CIDADE || 'N/A'}</td>
                              <td className="order-bairro">{ordem.TB02115_BAIRRO || 'N/A'}</td>
                              <td className="order-previsao text-left">{formatDateTime(ordem.CALC_PREVISAO)}</td>
                        </tr>
                          );
                        })}
                        {routeData.length === 0 && (
                          <tr>
                            <td colSpan="10" className="empty-message">
                              Nenhuma ordem encontrada para hoje
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
                )}
              </div>
                )}

                {/* Aba Check-out pendente */}
                {activeTab === 'completed' && (
                  <div className="route-section completed-tab-container">
                    <div className={`completed-content-wrapper ${showDetailsSidebar ? 'with-sidebar' : ''} ${showDetailsSidebar && (showPartsHistory || showServiceHistory) ? 'with-history' : ''}`}>
                      <div className="completed-orders-area">
                {isLoadingCompleted && (
                  <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <span>Carregando ordens concluídas...</span>
                  </div>
                )}
                
                {completedError && (
                  <div className="error-container">
                    <span>❌ Erro ao buscar ordens concluídas: {completedError}</span>
                  </div>
                )}
                
                {!isLoadingCompleted && !completedError && (
                          <div className="completed-groups-container">
                        {groupedCompletedOrders.length === 0 ? (
                          <div className="empty-message" style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>
                            Nenhuma ordem concluída encontrada para hoje
                          </div>
                        ) : (
                          groupedCompletedOrders.map(({ condition, orders }) => (
                            <div key={condition} className="completed-orders-group">
                              <div className="completed-group-header">
                                <span className="completed-group-title">{condition}</span>
                                <span className="completed-group-count">{orders.length}</span>
                              </div>
                              <div className="completed-orders-list">
                                {orders.map((ordem, index) => {
                                  const equipamento = ordem.TB01010_NOME || 'N/A';
                          const seriePatrimonio = [ordem.TB02122_NUMSERIE, ordem.TB02112_PAT].filter(Boolean).join(' / ') || 'N/A';
                                  const horarioFinal = formatTime(ordem.TB02122_HORAFIM);
                                  
                                  // Função para formatar data no formato dd/MM/yyyy sem alteração de fuso horário
                                  const formatDateDDMMYYYY = (dateValue) => {
                                    if (!dateValue) return '';
                                    const date = new Date(dateValue);
                                    // Usar métodos locais para evitar problemas de timezone
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    const year = date.getFullYear();
                                    return `${day}/${month}/${year}`;
                                  };
                                  
                                  const dataFormatada = formatDateDDMMYYYY(ordem.TB02122_DATAFIM);
                                  
                                  const isSelected = showDetailsSidebar && selectedCompletedOrder && selectedCompletedOrder.TB02122_CODIGO === ordem.TB02122_CODIGO;
                          
                          return (
                                    <div 
                                      key={`${ordem.TB02122_CODIGO}-${index}`} 
                                      className={`completed-order-card ${isSelected ? 'selected' : ''}`}
                                      onClick={() => openDetailsSidebar(ordem)}
                                    >
                                      <div className="completed-order-main">
                                        <div className="completed-order-os-section">
                                          <div className="completed-order-os">{ordem.TB02122_NUMOS}</div>
                                          {ordem.TB02112_PAT && (
                                            <div className="completed-order-patrimonio">{ordem.TB02112_PAT}</div>
                                          )}
                                          <div className="completed-order-time">{horarioFinal}</div>
                                        </div>
                                        <div className="completed-order-info">
                                          <div className="completed-order-equipment">{equipamento}</div>
                                          <div className="completed-order-client">{getBoardClienteExibicao(ordem)}</div>
                                        </div>
                                      </div>
                                      {dataFormatada && (
                                        <div className="completed-order-tag checkout-tag">{dataFormatada}</div>
                                      )}
                                    </div>
                          );
                        })}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                      </div>
                      
                      {/* Coluna de Histórico de Atendimentos ou Peças Trocadas - Renderizada antes da sidebar de detalhes */}
                      {showDetailsSidebar && showServiceHistory && selectedCompletedOrder && (
                        <div className="completed-parts-history-sidebar">
                          <div className="completed-parts-history-header">
                            <h4>Histórico de Atendimentos</h4>
                            <button 
                              className="completed-parts-history-close" 
                              onClick={() => setShowServiceHistory(false)}
                            >
                              <i className="bi bi-x"></i>
                            </button>
                          </div>
                          
                          <div className="completed-parts-history-content">
                            {loadingServiceHistory ? (
                              <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <div>Carregando histórico...</div>
                              </div>
                            ) : serviceHistoryError ? (
                              <div className="error-message">
                                <i className="bi bi-exclamation-triangle"></i>
                                {serviceHistoryError}
                              </div>
                            ) : serviceHistory.length === 0 ? (
                              <div className="no-data-message">
                                Nenhum histórico de atendimentos encontrado.
                              </div>
                            ) : (
                              <div className="service-history-container">
                                {serviceHistory.map((item) => {
                                  const formatDate = (dateStr) => {
                                    if (!dateStr) return 'N/A';
                                    const date = new Date(dateStr);
                                    if (isNaN(date.getTime())) return 'N/A';
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    const year = date.getFullYear();
                                    return `${day}/${month}/${year}`;
                                  };
                                  
                                  const formatCounter = (value) => {
                                    if (!value || value === '0' || value === 0) return '-';
                                    return typeof value === 'string' ? value : value.toLocaleString('pt-BR');
                                  };
                                  
                                  const getConditionClass = (condicao) => {
                                    if (!condicao) return '';
                                    const condicaoLower = condicao.toLowerCase();
                                    if (condicaoLower.includes('reparado')) return 'reparado';
                                    if (condicaoLower.includes('funcionando')) return 'funcionando';
                                    if (condicaoLower.includes('manutenção') || condicaoLower.includes('manutencao')) return 'manutencao';
                                    if (condicaoLower.includes('substituído') || condicaoLower.includes('substituido')) return 'substituido';
                                    return '';
                                  };
                                  
                                  return (
                                    <div key={item.id} className="service-history-item">
                                      <div className="equipment-history-header">
                                        <div className="equipment-history-date">{item.data || formatDate(item.dataAtendimento)}</div>
                                        <div className="equipment-history-os">
                                          <span className="equipment-history-os-number">{item.numeroOS || item.os}</span>
                                          <span className={`equipment-history-os-type ${(item.tipoOS || item.tipo || '').toLowerCase()}`}>
                                            {item.tipoOS || item.tipo || 'N/A'}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="equipment-history-tech">Técnico: {item.tecnico || 'N/A'}</div>
                                      
                                      <div className="equipment-history-detail">
                                        <div className="equipment-history-detail-item compact">
                                          <span className="equipment-history-detail-label">Defeito:</span>
                                          <span className="equipment-history-detail-value">
                                            {item.defeito || item.motivoOS || 'Não informado'}
                                          </span>
                                        </div>
                                        {item.observacao && (
                                          <div className="equipment-history-detail-item compact">
                                            <div className="equipment-history-laudo">
                                              {item.observacao}
                                            </div>
                                          </div>
                                        )}
                                        <div className="equipment-history-detail-item compact">
                                          <span className="equipment-history-detail-label">Condição:</span>
                                          <span className={`equipment-history-detail-value ${getConditionClass(item.condicao)}`}>
                                            {item.condicao || 'N/A'}
                                          </span>
                                        </div>
                                        
                                        {item.laudo && (
                                          <div className="equipment-history-detail-item laudo-item">
                                            <span className="equipment-history-detail-label">Laudo:</span>
                                            <div className="equipment-history-laudo">
                                              {item.laudo}
                                            </div>
                                          </div>
                                        )}
                                        
                                        {item.contadores && (
                                          <div className="equipment-history-detail-item counters-detail-item">
                                            <span className="equipment-history-detail-label">Contadores:</span>
                                            <div className="equipment-history-counters">
                                              <div className="counters-compact-table">
                                                <div className="counters-compact-header">
                                                  <div className="counter-compact-col">P&B</div>
                                                  <div className="counter-compact-col">Color</div>
                                                  <div className="counter-compact-col">DG</div>
                                                  <div className="counter-compact-col">GF P&B</div>
                                                  <div className="counter-compact-col">GF Color</div>
                                                </div>
                                                <div className="counters-compact-body">
                                                  <div className="counter-compact-row">
                                                    <div className="counter-compact-col">{formatCounter(item.contadores?.pb)}</div>
                                                    <div className="counter-compact-col">{formatCounter(item.contadores?.color)}</div>
                                                    <div className="counter-compact-col">{formatCounter(item.contadores?.dg)}</div>
                                                    <div className="counter-compact-col">{formatCounter(item.contadores?.gfPb)}</div>
                                                    <div className="counter-compact-col">{formatCounter(item.contadores?.gfColor)}</div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Coluna de Histórico de Peças Trocadas - Renderizada antes da sidebar de detalhes */}
                      {showDetailsSidebar && showPartsHistory && selectedCompletedOrder && (
                        <div className="completed-parts-history-sidebar">
                          <div className="completed-parts-history-header">
                            <h4>Histórico de Peças Trocadas</h4>
                            <button 
                              className="completed-parts-history-close" 
                              onClick={() => setShowPartsHistory(false)}
                            >
                              <i className="bi bi-x"></i>
                            </button>
                          </div>
                          
                          <div className="completed-parts-history-content">
                            {loadingPartsHistory ? (
                              <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <div>Carregando histórico...</div>
                              </div>
                            ) : partsHistoryError ? (
                              <div className="error-message">
                                <i className="bi bi-exclamation-triangle"></i>
                                {partsHistoryError}
                              </div>
                            ) : partsHistory.length === 0 ? (
                              <div className="no-data-message">
                                Nenhum histórico de peças trocadas encontrado.
                              </div>
                            ) : (
                              <div className="parts-history-table-wrapper">
                                <div className="parts-history-table-container">
                                  <table className="parts-history-table">
                                    <thead>
                                      <tr>
                                        <th>Pedido</th>
                                        <th>Data</th>
                                        <th>Código</th>
                                        <th>Ref.</th>
                                        <th>Produto</th>
                                        <th className="parts-history-qty-header">Qtde</th>
                                        <th>OS</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {partsHistory.map((item, index) => {
                                        // Verificar se o produto coincide com alguma peça pendente
                                        const isPendingPart = pendingParts.some(part => part.codigo === item.TB02022_PRODUTO);
                                        
                                        // Formatar data
                                        const formatDate = (dateStr) => {
                                          if (!dateStr) return 'N/A';
                                          const date = new Date(dateStr);
                                          if (isNaN(date.getTime())) return 'N/A';
                                          const day = String(date.getDate()).padStart(2, '0');
                                          const month = String(date.getMonth() + 1).padStart(2, '0');
                                          const year = date.getFullYear();
                                          return `${day}/${month}/${year}`;
                                        };
                                        
                                        // Criar tooltip com informações dos contadores e vida útil
                                        const tooltipText = `Cont. PB: ${formatNumber(item.TB02021_CONTPB || 0)}\nCont. Cor: ${formatNumber(item.TB02021_CONTCOLOR || 0)}\nCont. Total: ${formatNumber(item.TB02021_CONTTOTAL || 0)}\nVida útil: ${formatNumber(item.TB01010_COPIA || 0)}`;
                                        
                                        return (
                                          <tr key={index} className={isPendingPart ? 'parts-history-row-pending' : ''}>
                                            <td title={tooltipText}>{item.TB02022_CODIGO || 'N/A'}</td>
                                            <td>{formatDate(item.TB02021_DATA)}</td>
                                            <td className={isPendingPart ? 'parts-history-code-pending' : ''}>{item.TB02022_PRODUTO || 'N/A'}</td>
                                            <td>{item.TB01010_REFERENCIA || 'N/A'}</td>
                                            <td className={isPendingPart ? 'parts-history-name-pending' : ''}>{item.TB01010_NOME || 'N/A'}</td>
                                            <td className="parts-history-qty-cell">{Math.floor(item.TB02022_QTPROD || 0)}</td>
                                            <td>{item.TB02021_OS || 'N/A'}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </div>
                </div>
                )}

        {/* Sidebar de Detalhes */}
                      {showDetailsSidebar && selectedCompletedOrder && (
                        <div className={`completed-details-sidebar ${showPartsHistory || showServiceHistory ? 'with-history' : ''}`}>
                          <div className="completed-details-sidebar-header">
                            <div className="completed-details-header-top">
                              <div className="completed-details-header-left">
                              <h3>
                                Detalhes da OS {selectedCompletedOrder.TB02122_NUMOS}
                                {selectedCompletedOrder.TB02115_DTFECHA && (
                                  <span className="completed-details-tag">Concluída</span>
                                )}
                              </h3>
                                <div className="completed-details-header-buttons">
                              <button 
                                    className="completed-details-history-btn-small"
                                onClick={() => {
                                      if (showServiceHistory) {
                                        setShowServiceHistory(false);
                                      }
                                  if (!showPartsHistory) {
                                        fetchPartsHistory(selectedCompletedOrder.TB02122_NUMSERIE);
                                  }
                                  setShowPartsHistory(!showPartsHistory);
                                }}
                                title={showPartsHistory ? "Ocultar histórico de peças trocadas" : "Ver histórico de peças trocadas"}
                              >
                                <i className={`bi bi-${showPartsHistory ? 'x' : 'clock-history'}`}></i>
                                    Histórico de peças trocadas
                                  </button>
                                  <button 
                                    className="completed-details-history-btn-small"
                                    onClick={() => {
                                      if (showPartsHistory) {
                                        setShowPartsHistory(false);
                                      }
                                      if (!showServiceHistory) {
                                        fetchServiceHistory(selectedCompletedOrder.TB02122_NUMSERIE);
                                      }
                                      setShowServiceHistory(!showServiceHistory);
                                    }}
                                    title={showServiceHistory ? "Ocultar histórico de atendimentos" : "Ver histórico de atendimentos"}
                                  >
                                    <i className={`bi bi-${showServiceHistory ? 'x' : 'calendar-check'}`}></i>
                                    Histórico de atendimentos
                              </button>
                                </div>
                            </div>
                            <button className="completed-details-sidebar-close" onClick={closeDetailsSidebar}>
                              <i className="bi bi-x"></i>
                            </button>
                            </div>
                          </div>
            
                          <div className="completed-details-sidebar-content">
                            {/* Tooltip de Estoque – posicionado ao lado esquerdo da coluna de detalhes */}
                            {stockTooltip && (
                              <div className="stock-tooltip">
                                <div className="stock-tooltip-header">
                                  <div className="stock-tooltip-title-section">
                                    <span>{stockProductName || 'Disponibilidade em Estoque'}</span>
                                    {stockData && stockData.totals && (
                                      <span className="stock-tooltip-total">
                                        Total: {formatNumber(stockData.totals.total)}
                                      </span>
                                    )}
                                  </div>
                                  <button 
                                    className="stock-tooltip-close"
                                    onClick={closeStockTooltip}
                                  >
                                    <i className="bi bi-x"></i>
                                  </button>
              </div>

                                {loadingStock ? (
                                  <div className="stock-tooltip-loading">
                                    <i className="bi bi-clock-history"></i> Carregando...
                                  </div>
                                ) : stockError ? (
                                  <div className="stock-tooltip-error">
                                    <i className="bi bi-exclamation-triangle"></i> {stockError}
                                  </div>
                                ) : stockData && stockData.data ? (
                                  <div className="stock-tooltip-content">
                                    {/* Resumo por total */}
                                    <table className="stock-table">
                  <thead>
                    <tr>
                                          <th>Tipo</th>
                                          <th className="stock-table-center">Comércio</th>
                                          <th className="stock-table-center">Imobilizado</th>
                                          <th className="stock-table-center">RMA</th>
                    </tr>
                  </thead>
                  <tbody>
                                        <tr className="stock-totals-row">
                                          <td><strong>Total</strong></td>
                                          <td className="stock-table-center">
                                            <strong>{formatNumber(stockData.totals?.comercio || 0)}</strong>
                                          </td>
                                          <td className="stock-table-center">
                                            <strong>{formatNumber(stockData.totals?.imobilizado || 0)}</strong>
                                          </td>
                                          <td className="stock-table-center">
                                            <strong>{formatNumber(stockData.totals?.rma || 0)}</strong>
                                          </td>
                    </tr>
                  </tbody>
                </table>

                                    {/* Detalhe por empresa (colapsável) */}
                                    {stockData.data && stockData.data.length > 0 && (
                                      <>
                                        <div className="stock-actions-row">
                                          <button
                                            className="stock-action-btn"
                                            onClick={() => setShowStockByCompany(!showStockByCompany)}
                                          >
                                            <i className={`bi bi-${showStockByCompany ? 'dash' : 'plus'}`}></i>
                                            Estoque por empresa
                                          </button>
                                          
                                          {stockData.similarProducts && stockData.similarProducts.length > 0 && (
                                            <button
                                              className="stock-action-btn"
                                              onClick={() => setShowSimilarProducts(!showSimilarProducts)}
                                            >
                                              <i className={`bi bi-chevron-${showSimilarProducts ? 'up' : 'down'}`}></i>
                                              Produtos semelhantes
                                            </button>
                                          )}
              </div>

                                        {/* Detalhe por empresa */}
                                        {showStockByCompany && stockData.data && stockData.data.length > 0 && (
                                          <div className="stock-by-company-content">
                                            <table className="stock-table">
                    <thead>
                      <tr>
                                                  <th>Emp</th>
                                                  <th className="stock-table-center">Comércio</th>
                                                  <th className="stock-table-center">Imobilizado</th>
                                                  <th className="stock-table-center">RMA</th>
                      </tr>
                    </thead>
                    <tbody>
                                                {stockData.data.map((item, idx) => (
                                                  <tr key={idx}>
                                                    <td title={item.empresaNome || ''}>{item.empresa || 'N/A'}</td>
                                                    <td className={`stock-table-center ${item.comercio < 0 ? 'stock-negative' : ''}`}>
                                                      {formatNumber(item.comercio)}
                                                    </td>
                                                    <td className={`stock-table-center ${item.imobilizado < 0 ? 'stock-negative' : ''}`}>
                                                      {formatNumber(item.imobilizado)}
                                                    </td>
                                                    <td className={`stock-table-center ${item.rma < 0 ? 'stock-negative' : ''}`}>
                                                      {formatNumber(item.rma)}
                                                    </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                                        )}
                                      </>
                                    )}

                                    {/* Produtos semelhantes */}
                                    {showSimilarProducts && stockData.similarProducts && stockData.similarProducts.length > 0 && (
                                      <div className="stock-similar-products-section">
                                        <div className="stock-similar-products-content">
                                          <table className="stock-table similar-products-table">
                    <thead>
                      <tr>
                        <th>Código</th>
                                                <th>Ref.</th>
                                                <th>Produto</th>
                                                <th className="stock-table-center">Comércio</th>
                                                <th className="stock-table-center">Imobilizado</th>
                      </tr>
                    </thead>
                    <tbody>
                                              {stockData.similarProducts.map((product, idx) => (
                                                <tr key={idx}>
                                                  <td>{product.codigo || 'N/A'}</td>
                                                  <td>{product.referencia || 'N/A'}</td>
                                                  <td>{product.nome || 'N/A'}</td>
                                                  <td className={`stock-table-center ${product.comercio < 0 ? 'stock-negative' : ''}`}>
                                                    {formatNumber(product.comercio || 0)}
                                                  </td>
                                                  <td className={`stock-table-center ${product.imobilizado < 0 ? 'stock-negative' : ''}`}>
                                                    {formatNumber(product.imobilizado || 0)}
                                                  </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                                        </div>
                </div>
              )}
            </div>
                                ) : null}
          </div>
        )}
        
                            {/* Informações Básicas */}
                            <div className="completed-details-section">
                              <div className="completed-details-grid">
                                <div className="completed-details-item">
                                  <div className="completed-details-label">Série</div>
                                  <div className="completed-details-value">{selectedCompletedOrder.TB02122_NUMSERIE || 'N/A'}</div>
                                </div>
                                <div className="completed-details-item">
                                  <div className="completed-details-label">Patrimônio</div>
                                  <div className="completed-details-value">{selectedCompletedOrder.TB02112_PAT || 'N/A'}</div>
                                </div>
                                <div className="completed-details-item completed-details-full-width">
                                  <div className="completed-details-label">Defeito</div>
                                  <div className="completed-details-defeito-wrapper">
                                    <div className="completed-details-value">{selectedCompletedOrder.TB02115_NOME || 'N/A'}</div>
                                    {selectedCompletedOrder.TB02115_NOME && (
                                      <button 
                                        className="completed-details-defeito-btn"
                                        onClick={toggleDefeitoDetails}
                                        title={showDefeitoDetails ? "Ocultar detalhes do defeito" : "Ver detalhes do defeito"}
                                      >
                                        <i className={`bi bi-chevron-${showDefeitoDetails ? 'up' : 'down'}`}></i>
                                        {showDefeitoDetails ? 'Ocultar defeito' : 'Ver defeito'}
                </button>
                                    )}
                                  </div>
              </div>
              
                                {/* Seção expandível dos detalhes do defeito */}
                                {showDefeitoDetails && (
                                  <div className="completed-details-defeito-section">
                                    {loadingDefeito && (
                                      <div className="defeito-loading">
                                        <i className="bi bi-clock-history"></i> Carregando detalhes do defeito...
                                      </div>
                                    )}
                                    
                                    {defeitoError && (
                                      <div className="defeito-error">
                                        <i className="bi bi-exclamation-triangle"></i> {defeitoError}
                                      </div>
                                    )}
                                    
                                    {defeitoData && !loadingDefeito && !defeitoError && (
                                      <div className="defeito-table-container">
                                        <table className="defeito-table">
                                          <thead>
                                            <tr>
                                              <th>Defeito</th>
                                              <th>Observação</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>{defeitoData.defeito || 'N/A'}</td>
                                              <td>{defeitoData.observacao || 'N/A'}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </div>
                                )}
                                
                                <div className="completed-details-item completed-details-full-width">
                                  <div className="completed-details-label">Horários</div>
                                  <div className="completed-details-value">{formatHorariosCompletos(selectedCompletedOrder.TB02122_HORAINI, selectedCompletedOrder.TB02122_HORAFIM)}</div>
                                </div>
                              </div>
                            </div>

                {/* Laudo */}
                            <div className="completed-details-section">
                              <div className="completed-details-section-title">Laudo</div>
                              <div className="completed-details-item completed-details-full-width">
                                <div className="completed-details-value" style={{ fontWeight: 'normal', lineHeight: '1.6' }}>
                    {selectedCompletedOrder.TB02122_OBS || 'Nenhum laudo registrado'}
                                </div>
                                {/* Condição de Intervenção */}
                                <div style={{ marginTop: '12px' }}>
                                  <select 
                                    className="completed-details-condition-select"
                                    value={selectedCompletedOrder.TB01055_NOME || ''}
                                    disabled={true}
                                  >
                                    <option value={selectedCompletedOrder.TB01055_NOME || ''}>
                                      {selectedCompletedOrder.TB01055_NOME || 'Nenhuma condição registrada'}
                                    </option>
                                  </select>
                                  <div className="completed-details-condition-note">
                                    Edição futura disponível
                                  </div>
                                </div>
                  </div>
                </div>
                
                {/* Contadores */}
                            <div className="completed-details-section">
                              <div className="completed-details-section-title">Contadores</div>
                              <div className="completed-details-counters-row">
                                <div className="completed-details-counter-item">
                                  <div className="completed-details-label">P&B</div>
                                  <div className="completed-details-value">{formatNumber(selectedCompletedOrder.TB02122_CONTADOR)}</div>
                    </div>
                                <div className="completed-details-counter-item">
                                  <div className="completed-details-label">Cor</div>
                                  <div className="completed-details-value">{formatNumber(selectedCompletedOrder.TB02122_CONTADORC)}</div>
                    </div>
                                <div className="completed-details-counter-item">
                                  <div className="completed-details-label">Dig.</div>
                                  <div className="completed-details-value">{formatNumber(selectedCompletedOrder.TB02122_CONTADORDG)}</div>
                    </div>
                                <div className="completed-details-counter-item">
                                  <div className="completed-details-label">A3 P&B</div>
                                  <div className="completed-details-value">{formatNumber(selectedCompletedOrder.TB02122_CONTADORGF)}</div>
                    </div>
                                <div className="completed-details-counter-item">
                                  <div className="completed-details-label">A3 Cor</div>
                                  <div className="completed-details-value">{formatNumber(selectedCompletedOrder.TB02122_CONTADORGFC)}</div>
                    </div>
                  </div>
                </div>
                
                {/* Peças Pendentes */}
                {pendingParts.length > 0 && (
                              <div className="details-section parts-section-bordered">
                    <h4>Peças Pendentes</h4>
                    {isLoadingParts ? (
                      <div className="loading-message">Carregando peças...</div>
                    ) : (
                      <table className="parts-table">
                        <thead>
                          <tr>
                            <th>Código</th>
                                        <th>Ref.</th>
                            <th>Nome</th>
                                        <th>Qtde</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pendingParts.map((peca, index) => (
                                        <tr
                                          key={index}
                                          className={stockTooltip === peca.codigo ? 'pending-part-row pending-part-row-selected' : 'pending-part-row'}
                                        >
                              <td>{peca.codigo}</td>
                                          <td>{peca.referencia || 'N/A'}</td>
                              <td>{peca.nome}</td>
                                          <td className="parts-qty-cell">
                                            <span>{peca.quantidade}</span>
                                            <button
                                              className="parts-stock-icon"
                                              onClick={() => fetchStockData(peca.codigo, peca.nome)}
                                              title="Ver disponibilidade em estoque"
                                            >
                                              <i className="bi bi-box"></i>
                                            </button>
                                          </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                
                {/* Peças Utilizadas */}
                {usedParts.length > 0 && (
                              <div className="details-section parts-section-bordered">
                    <h4>Peças Utilizadas</h4>
                    {isLoadingParts ? (
                      <div className="loading-message">Carregando peças...</div>
                    ) : (
                      <table className="parts-table">
                        <thead>
                          <tr>
                            <th>Código</th>
                                        <th>Ref.</th>
                            <th>Nome</th>
                                        <th>Qtde</th>
                          </tr>
                        </thead>
                        <tbody>
                          {usedParts.map((peca, index) => (
                            <tr key={index}>
                              <td>{peca.codigo}</td>
                                          <td>{peca.referencia || 'N/A'}</td>
                              <td>{peca.nome}</td>
                              <td>{peca.quantidade}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                
                {/* Mensagens quando não há peças */}
                {!isLoadingParts && pendingParts.length === 0 && usedParts.length === 0 && (
                  <div className="details-section">
                    <div className="no-parts-message">
                      Nenhuma peça pendente ou utilizada registrada para esta ordem.
                    </div>
                  </div>
                )}
              </div>
                        </div>
                      )}
            </div>
                  </div>
                )}

                {/* Aba Produtividade */}
                {activeTab === 'finished' && (
                  <div className="route-section finished-tab-container">
                    {/* Barra de filtro de data de conclusão */}
                    <div className="finished-date-filter">
                      <span className="finished-date-filter-label">Selecione o dia:</span>
                      <input
                        type="date"
                        className="finished-date-filter-input"
                        value={selectedFinishedDate}
                        onChange={(e) => setSelectedFinishedDate(e.target.value)}
                        max={formatDateISO(new Date())}
                      />
                      <span className="finished-date-filter-sep">|</span>
                      <span className="finished-date-filter-meta">
                        OS atendidas: {finishedData.length}
                      </span>
                      <span className="finished-date-filter-meta">
                        Tempo produzido: {calculateTotalCompletedTime(finishedData)}
                      </span>
                    </div>

                    {isLoadingFinished && (
                      <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <span>Carregando ordens finalizadas...</span>
                      </div>
                    )}
                    
                    {finishedError && (
                      <div className="error-container">
                        <span>❌ Erro ao buscar ordens finalizadas: {finishedError}</span>
                      </div>
                    )}
                    
                    {!isLoadingFinished && !finishedError && (
                      <div className="finished-timeline-container">
                        {finishedData.length === 0 ? (
                          <div className="empty-message" style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>
                            Nenhuma ordem finalizada encontrada para a data selecionada
                          </div>
                        ) : (
                          <TimelineChart orders={finishedData} />
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        
      </>
    );
  };

  // Componente de Gráfico Timeline para produtividade
  const TimelineChart = ({ orders }) => {
    const timelineRef = useRef(null);
    const timelineInstanceRef = useRef(null);

    useEffect(() => {
      if (!timelineRef.current || orders.length === 0) return;

      // Criar data de hoje para usar como base
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Preparar dados para o timeline
      const items = orders.map((order, index) => {
        // Converter horários para Date
        const parseTime = (timeStr) => {
          if (!timeStr) return null;
          
          try {
            // Se for string no formato "HH:mm" ou "HH:mm:ss"
            if (typeof timeStr === 'string') {
              // Remover espaços e dividir por ':'
              const parts = timeStr.trim().split(':');
              if (parts.length >= 2) {
                const hours = parseInt(parts[0], 10);
                const minutes = parseInt(parts[1], 10);
                if (!isNaN(hours) && !isNaN(minutes)) {
                  const date = new Date(today);
                  date.setHours(hours, minutes, 0, 0);
                  return date;
                }
              }
            }
            
            // Se for Date object
            if (timeStr instanceof Date) {
              const date = new Date(today);
              date.setHours(timeStr.getHours(), timeStr.getMinutes(), 0, 0);
              return date;
            }
          } catch (error) {
            console.error('Erro ao parsear horário:', timeStr, error);
          }
          
          return null;
        };

        const startTime = parseTime(order.TB02122_HORAINI);
        const endTime = parseTime(order.TB02122_HORAFIM);

        if (!startTime || !endTime) {
          console.warn('Horários inválidos para OS:', order.TB02122_NUMOS, {
            inicio: order.TB02122_HORAINI,
            fim: order.TB02122_HORAFIM
          });
          return null;
        }

        // Garantir que o fim seja depois do início
        if (endTime <= startTime) {
          console.warn('Horário final deve ser maior que inicial para OS:', order.TB02122_NUMOS);
          return null;
        }

        const orderId = order.TB02122_CODIGO || `order-${index}`;
        const osNumber = order.TB02122_NUMOS || `OS ${index + 1}`;
        
        // Calcular tempo de atendimento
        const calculateTime = (start, end) => {
          if (!start || !end) return 'N/A';
          const diffMs = end.getTime() - start.getTime();
          const diffMinutes = Math.floor(diffMs / 60000);
          const hours = Math.floor(diffMinutes / 60);
          const minutes = diffMinutes % 60;
          if (hours > 0) {
            return `${hours}h ${minutes}min`;
          }
          return `${minutes}min`;
        };
        
        const formatTime = (date) => {
          if (!date) return 'N/A';
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        };
        
        const timeDuration = calculateTime(startTime, endTime);
        const timeStart = formatTime(startTime);
        const timeEnd = formatTime(endTime);
        
        // Determinar status baseado no TIPO
        const orderType = order.TIPO || 1;
        const statusText = orderType === 1 ? 'Concluída' : 'Check-Out';
        
        // Montar tooltip com todos os dados
        const tooltipText = [
          `${getBoardClienteExibicao(order) || 'Cliente não informado'} - ${osNumber}`,
          `Equipamento: ${order.TB01010_NOME || 'N/A'}`,
          `Série: ${order.TB02122_NUMSERIE || 'N/A'}`,
          `Patrimônio: ${order.TB02112_PAT || 'N/A'}`,
          `Condição: ${order.TB01055_NOME || 'N/A'}`,
          `Horário: ${timeStart} - ${timeEnd}`,
          `Tempo: ${timeDuration}`,
          `Status: ${statusText}`
        ].join('\n');
        
        // Aplicar className baseado no TIPO
        const className = orderType === 2 ? 'timeline-order-item timeline-order-item-checkout' : 'timeline-order-item';
        
        const item = {
          id: `item-${orderId}`,
          content: osNumber,
          start: startTime,
          end: endTime,
          title: tooltipText, // Tooltip completo
          className: className,
          type: 'range',
          group: orderId
        };
        
        return item;
      }).filter(Boolean);

      // Configuração do timeline
      const options = {
        stack: false,
        orientation: 'top',
        editable: false,
        selectable: true,
        showCurrentTime: false,
        zoomMin: 1000 * 60 * 60, // 1 hora mínimo
        zoomMax: 1000 * 60 * 60 * 24, // 24 horas máximo
        format: {
          minorLabels: {
            minute: 'HH:mm',
            hour: 'HH:mm'
          },
          majorLabels: {
            hour: 'HH:mm',
            weekday: 'ddd D/M'
          }
        },
        timeAxis: {
          scale: 'hour',
          step: 1
        },
        tooltip: {
          followMouse: true,
          overflowMethod: 'cap'
        }
      };

      // Criar grupos (uma linha por OS) - ordenar por horário de início
      // Agrupar items por group (orderId) e ordenar por horário de início
      const groupMap = new Map();
      items.forEach(item => {
        if (!groupMap.has(item.group)) {
          groupMap.set(item.group, {
            id: item.group,
            content: item.content,
            startTime: item.start.getTime()
          });
        }
      });
      
      const groups = Array.from(groupMap.values())
        .sort((a, b) => a.startTime - b.startTime)
        .map((group, index) => ({
          id: group.id,
          content: group.content,
          order: index
        }));
      
      // Adicionar um grupo vazio no final para criar espaço para o tooltip
      const emptyGroupId = 'empty-tooltip-space';
      groups.push({
        id: emptyGroupId,
        content: '',
        order: groups.length
      });
      
      // Adicionar um item vazio invisível no final para criar espaço
      // Calcular a duração média das OS para criar um item do mesmo tamanho
      const lastItem = items[items.length - 1];
      if (lastItem && items.length > 0) {
        // Calcular duração média das OS
        const durations = items
          .filter(item => item.start && item.end)
          .map(item => item.end.getTime() - item.start.getTime());
        const avgDuration = durations.length > 0 
          ? durations.reduce((a, b) => a + b, 0) / durations.length 
          : 1000 * 60 * 60; // Fallback: 1 hora
        
        const emptyItem = {
          id: 'empty-tooltip-item',
          content: '',
          start: lastItem.end,
          end: new Date(lastItem.end.getTime() + avgDuration), // Mesma duração média das OS
          title: '',
          className: 'timeline-empty-item',
          type: 'range',
          group: emptyGroupId
        };
        items.push(emptyItem);
      }

      // Criar ou atualizar timeline
      if (!timelineInstanceRef.current) {
        timelineInstanceRef.current = new Timeline(timelineRef.current, items, groups, options);
      } else {
        timelineInstanceRef.current.setItems(items);
        timelineInstanceRef.current.setGroups(groups);
      }

      // Calcular horário mínimo e máximo dos dados
      const allTimes = items.flatMap(item => [item.start, item.end]);
      const minDataTime = allTimes.length > 0 ? new Date(Math.min(...allTimes.map(d => d.getTime()))) : new Date(today);
      const maxDataTime = allTimes.length > 0 ? new Date(Math.max(...allTimes.map(d => d.getTime()))) : new Date(today);
      
      // Ajustar janela para mostrar os dados com margem
      const minTime = new Date(minDataTime);
      minTime.setHours(Math.max(0, minDataTime.getHours() - 1), 0, 0, 0);
      const maxTime = new Date(maxDataTime);
      maxTime.setHours(Math.min(23, maxDataTime.getHours() + 1), 59, 59, 999);
      
      timelineInstanceRef.current.setWindow(minTime, maxTime);

      // Cleanup
      return () => {
        if (timelineInstanceRef.current) {
          timelineInstanceRef.current.destroy();
          timelineInstanceRef.current = null;
        }
      };
    }, [orders]);

    return (
      <div className="timeline-wrapper">
        <div ref={timelineRef} className="timeline-chart" style={{ height: `${Math.max(500, orders.length * 60 + 100)}px` }}></div>
      </div>
    );
  };

  const orderPassesEmAbertoFiltersExceptDefeito = React.useCallback(
    (ordem, skipDefeitoKey) => {
      const f = selectedColumnFilters;
      const dstr = (o, key) => String(o[key] ?? '').trim();
      if (f.bairro.length > 0) {
        const b = ordem.TB02115_BAIRRO || '';
        if (!f.bairro.includes(b)) return false;
      }
      if (f.cliente.length > 0) {
        const c = ordem.cliente || ordem.TB01008_NOME;
        if (!f.cliente.includes(c)) return false;
      }
      if (f.tipoOS.length > 0) {
        if (!orderMatchesTipoOSFilter(ordem, f.tipoOS, getServiceTypeFromPreventiva)) return false;
      }
      if (f.sla.length > 0) {
        const sla = ordem.sla || 'Em dia';
        if (!f.sla.includes(sla)) return false;
      }
      if (f.equipamento.length > 0) {
        const eq = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
        if (!f.equipamento.includes(eq)) return false;
      }
      if (f.status.length > 0) {
        const st = ordem.TB01073_NOME || '';
        if (!f.status.includes(st)) return false;
      }
      if (f.tecnicoInicial && f.tecnicoInicial.length > 0) {
        const t = ordem.TB01024_NOME || 'SEM TÉCNICO';
        if (!f.tecnicoInicial.includes(t)) return false;
      }
      if (skipDefeitoKey !== 'defeitoDescricao' && f.defeitoDescricao.length > 0) {
        const v = dstr(ordem, 'defeito_descricao');
        if (!f.defeitoDescricao.includes(v)) return false;
      }
      if (skipDefeitoKey !== 'defeitoAlert' && f.defeitoAlert.length > 0) {
        const v = dstr(ordem, 'defeito_alert');
        if (!f.defeitoAlert.includes(v)) return false;
      }
      if (skipDefeitoKey !== 'defeitoClassification' && f.defeitoClassification.length > 0) {
        const v = dstr(ordem, 'defeito_classification');
        if (!f.defeitoClassification.includes(v)) return false;
      }
      if (skipDefeitoKey !== 'defeitoSeverity' && f.defeitoSeverity.length > 0) {
        const v = dstr(ordem, 'defeito_severity_level');
        if (!f.defeitoSeverity.includes(v)) return false;
      }
      return true;
    },
    [selectedColumnFilters]
  );

  const buildDefeitoDimensionCounts = React.useCallback(
    (skipKey, field) => {
      const filtered = getFilteredOrders;
      const acc = {};
      filtered.forEach((item) => {
        if (selectedColumnFilters.cidade.length > 0 && !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        (item.ordens || []).forEach((ordem) => {
          if (!orderPassesEmAbertoFiltersExceptDefeito(ordem, skipKey)) return;
          const v = String(ordem[field] ?? '').trim();
          if (!v) return;
          acc[v] = (acc[v] || 0) + 1;
        });
      });
      return Object.entries(acc)
        .map(([value, count]) => ({ value, count }))
        .sort((a, b) => a.value.localeCompare(b.value));
    },
    [getFilteredOrders, selectedColumnFilters, orderPassesEmAbertoFiltersExceptDefeito]
  );

  const defeitoDescricaoWithCounts = React.useMemo(
    () => buildDefeitoDimensionCounts('defeitoDescricao', 'defeito_descricao'),
    [buildDefeitoDimensionCounts]
  );
  const defeitoAlertWithCounts = React.useMemo(
    () => buildDefeitoDimensionCounts('defeitoAlert', 'defeito_alert'),
    [buildDefeitoDimensionCounts]
  );
  const defeitoClassificationWithCounts = React.useMemo(
    () => buildDefeitoDimensionCounts('defeitoClassification', 'defeito_classification'),
    [buildDefeitoDimensionCounts]
  );
  const defeitoSeverityWithCounts = React.useMemo(
    () => buildDefeitoDimensionCounts('defeitoSeverity', 'defeito_severity_level'),
    [buildDefeitoDimensionCounts]
  );

  const getEmAbertoCountsForPicker = React.useCallback(
    (excludeFilterType) =>
      computeEmAbertoPickerCounts({
        groupedOrders: getFilteredOrders,
        filters: selectedColumnFilters,
        excludeFilterType,
        getTipoVisual: (ordem) =>
          getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA || 'N'),
        allowedTipoLetters: boardAllowedTipoLetters,
      }),
    [getFilteredOrders, selectedColumnFilters, boardAllowedTipoLetters]
  );

  // Calcular dados com contagens para usar em ambos os componentes
  const citiesWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const cityData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        if (item.cidade && item.cidade.trim() !== '') {
          // Aplicar filtros de bairro, cliente, tipo de OS, SLA e equipamento
          let ordensToCount = item.ordens || [];
          if (selectedColumnFilters.bairro.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const bairro = ordem.TB02115_BAIRRO || '';
              return selectedColumnFilters.bairro.includes(bairro);
            });
          }
          if (selectedColumnFilters.cliente.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              return selectedColumnFilters.cliente.includes(cliente);
            });
          }
          if (selectedColumnFilters.tipoOS.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              return selectedColumnFilters.tipoOS.includes(tipoVisual);
            });
          }
          if (selectedColumnFilters.sla.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const sla = ordem.sla || 'Em dia';
              return selectedColumnFilters.sla.includes(sla);
            });
          }
          if (selectedColumnFilters.equipamento.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              return selectedColumnFilters.equipamento.includes(equipamento);
            });
          }
          if (selectedColumnFilters.status.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const status = ordem.TB01073_NOME || '';
              return selectedColumnFilters.status.includes(status);
            });
          }
          if (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
              return selectedColumnFilters.tecnicoInicial.includes(tecnicoInicial);
            });
          }
          
          if (ordensToCount.length > 0) {
            const estado = (item.ordens && item.ordens[0]) ? (item.ordens[0].TB02115_ESTADO || item.ordens[0].estado || '') : '';
            if (!cityData[item.cidade]) {
              cityData[item.cidade] = { count: 0, estado };
            }
            cityData[item.cidade].count += ordensToCount.length;
          }
        }
      });
    } else {
      filtered.forEach(item => {
        if (item.cidade && item.cidade.trim() !== '') {
          // Aplicar filtros de bairro, cliente, tipo de OS, SLA e equipamento
          let ordensToCount = item.ordens || [];
          if (selectedColumnFilters.bairro.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const bairro = ordem.TB02115_BAIRRO || '';
              return selectedColumnFilters.bairro.includes(bairro);
            });
          }
          if (selectedColumnFilters.cliente.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              return selectedColumnFilters.cliente.includes(cliente);
            });
          }
          if (selectedColumnFilters.tipoOS.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              return selectedColumnFilters.tipoOS.includes(tipoVisual);
            });
          }
          if (selectedColumnFilters.sla.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const sla = ordem.sla || 'Em dia';
              return selectedColumnFilters.sla.includes(sla);
            });
          }
          if (selectedColumnFilters.equipamento.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              return selectedColumnFilters.equipamento.includes(equipamento);
            });
          }
          if (selectedColumnFilters.status.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const status = ordem.TB01073_NOME || '';
              return selectedColumnFilters.status.includes(status);
            });
          }
          if (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length > 0) {
            ordensToCount = ordensToCount.filter(ordem => {
              const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
              return selectedColumnFilters.tecnicoInicial.includes(tecnicoInicial);
            });
          }
          
          if (ordensToCount.length > 0) {
            const estado = (item.ordens && item.ordens[0]) ? (item.ordens[0].TB02115_ESTADO || item.ordens[0].estado || '') : '';
            if (!cityData[item.cidade]) {
              cityData[item.cidade] = { count: 0, estado };
            }
            cityData[item.cidade].count += ordensToCount.length;
          }
        }
      });
    }
    
    return Object.entries(cityData)
      .map(([cidade, { count, estado }]) => ({ cidade, count, estado: estado || '' }))
      .sort((a, b) => (a.estado || '').localeCompare(b.estado || '') || a.cidade.localeCompare(b.cidade));
    }, [getFilteredOrders, dataSource, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.tipoOS, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial]);

  const bairrosWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const bairroData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtro de cidade aplicado, considerar apenas essa cidade
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return; // Pular esta cidade se não está nos filtros
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const bairro = ordem.TB02115_BAIRRO || '';
            if (bairro.trim() !== '') {
              if (!bairroData[bairro]) {
                bairroData[bairro] = 0;
              }
              bairroData[bairro] += 1;
            }
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtro de cidade aplicado, considerar apenas essa cidade
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return; // Pular esta cidade se não está nos filtros
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const bairro = ordem.TB02115_BAIRRO || '';
            if (bairro.trim() !== '') {
              if (!bairroData[bairro]) {
                bairroData[bairro] = 0;
              }
              bairroData[bairro] += 1;
            }
          });
        }
      });
    }
    
    return Object.entries(bairroData)
      .map(([bairro, count]) => ({ bairro, count }))
      .sort((a, b) => a.bairro.localeCompare(b.bairro));
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.cliente, selectedColumnFilters.tipoOS, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial]);

  const clientesWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const clienteData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtro de cidade aplicado, considerar apenas essa cidade
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return; // Pular esta cidade se não está nos filtros
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
            if (cliente && cliente.trim() !== '') {
              if (!clienteData[cliente]) {
                clienteData[cliente] = 0;
              }
              clienteData[cliente] += 1;
            }
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtro de cidade aplicado, considerar apenas essa cidade
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return; // Pular esta cidade se não está nos filtros
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
          // Se há filtro de SLA aplicado, considerar apenas esses SLAs
          if (selectedColumnFilters.sla.length > 0) {
            const sla = ordem.sla || 'Em dia';
            if (!selectedColumnFilters.sla.includes(sla)) {
              return;
            }
          }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
            if (cliente && cliente.trim() !== '') {
              if (!clienteData[cliente]) {
                clienteData[cliente] = 0;
              }
              clienteData[cliente] += 1;
            }
          });
        }
      });
    }
    
    return Object.entries(clienteData)
      .map(([cliente, count]) => ({ cliente, count }))
      .sort((a, b) => a.cliente.localeCompare(b.cliente));
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.tipoOS, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial]);

  const statusWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const statusData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            const status = ordem.TB01073_NOME || '';
            if (status.trim() !== '') {
              if (!statusData[status]) {
                statusData[status] = 0;
              }
              statusData[status] += 1;
            }
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            const status = ordem.TB01073_NOME || '';
            if (status.trim() !== '') {
              if (!statusData[status]) {
                statusData[status] = 0;
              }
              statusData[status] += 1;
            }
          });
        }
      });
    }
    
    return Object.entries(statusData)
      .map(([status, count]) => ({ status, count }))
      .sort((a, b) => a.status.localeCompare(b.status));
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.tipoOS, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.tecnicoInicial]);

  const tecnicoInicialWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const tecnicoInicialData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            // Obter técnico inicial (TB01024_NOME) ou "SEM TÉCNICO" se nulo
            const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
            if (!tecnicoInicialData[tecnicoInicial]) {
              tecnicoInicialData[tecnicoInicial] = 0;
            }
            tecnicoInicialData[tecnicoInicial] += 1;
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            // Obter técnico inicial (TB01024_NOME) ou "SEM TÉCNICO" se nulo
            const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
            if (!tecnicoInicialData[tecnicoInicial]) {
              tecnicoInicialData[tecnicoInicial] = 0;
            }
            tecnicoInicialData[tecnicoInicial] += 1;
          });
        }
      });
    }
    
    return Object.entries(tecnicoInicialData)
      .map(([tecnicoInicial, count]) => ({ tecnicoInicial, count }))
      .sort((a, b) => {
        // Colocar "SEM TÉCNICO" no final
        if (a.tecnicoInicial === 'SEM TÉCNICO') return 1;
        if (b.tecnicoInicial === 'SEM TÉCNICO') return -1;
        return a.tecnicoInicial.localeCompare(b.tecnicoInicial);
      });
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.tipoOS, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.status]);

  const slasWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const slaData = {};
    
    // Definir todos os SLAs possíveis para garantir ordem consistente
    // Canônico: vencido/vencendo/ok (compatível com o backend)
    const allSLAs = ['vencido', 'vencendo', 'ok'];
    allSLAs.forEach(sla => {
      slaData[sla] = 0;
    });
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const sla = normalizeSlaForFilter(ordem.sla || 'Em dia');
            if (slaData.hasOwnProperty(sla)) slaData[sla] += 1;
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de tipo de OS aplicado, considerar apenas esses tipos
            if (selectedColumnFilters.tipoOS.length > 0) {
              const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
              const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
              if (!selectedColumnFilters.tipoOS.includes(tipoVisual)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const sla = normalizeSlaForFilter(ordem.sla || 'Em dia');
            if (slaData.hasOwnProperty(sla)) slaData[sla] += 1;
          });
        }
      });
    }
    
    return allSLAs
      .map(sla => ({ sla, count: slaData[sla] }))
      .filter(item => item.count > 0); // Mostrar apenas SLAs que têm ordens
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.tipoOS, selectedColumnFilters.equipamento, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial]);

  const tiposOSWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const tipoData = {};
    
    // Definir todos os tipos de OS possíveis usando as letras do banco
    // E=ESTOQUE, B=BALCÃO, A=AFERIÇÃO, R=RETORNO-RECARGA, D=DESINSTALAÇÃO, I=INSTALAÇÃO, S=PREVENTIVA, C=CORRETIVA (N no banco)
    const allTipos = ['E', 'B', 'A', 'R', 'D', 'I', 'S', 'C'];
    allTipos.forEach(tipo => {
      tipoData[tipo] = 0;
    });
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
            const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
            if (tipoData.hasOwnProperty(tipoVisual)) {
              tipoData[tipoVisual] += 1;
            }
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
          // Se há filtro de SLA aplicado, considerar apenas esses SLAs
          if (selectedColumnFilters.sla.length > 0) {
            const sla = ordem.sla || 'Em dia';
            if (!selectedColumnFilters.sla.includes(sla)) {
              return;
            }
          }
            
            // Se há filtro de equipamento aplicado, considerar apenas esses equipamentos
            if (selectedColumnFilters.equipamento.length > 0) {
              const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME;
              if (!selectedColumnFilters.equipamento.includes(equipamento)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            const tipoOriginal = ordem.TB02115_PREVENTIVA || 'N';
            const tipoVisual = getServiceTypeFromPreventiva(tipoOriginal);
            if (tipoData.hasOwnProperty(tipoVisual)) {
              tipoData[tipoVisual] += 1;
            }
          });
        }
      });
    }
    
    return allTipos
      .map(tipo => ({ tipo, count: tipoData[tipo] }))
      .filter(item => item.count > 0) // Mostrar apenas tipos que têm ordens
      .filter((item) => !boardAllowedTipoLetters || boardAllowedTipoLetters.includes(item.tipo));
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.sla, selectedColumnFilters.equipamento, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial, boardAllowedTipoLetters]);

  const equipamentosWithCounts = React.useMemo(() => {
    const filtered = getFilteredOrders;
    const equipamentoData = {};
    
    if (dataSource === 'sql_server' && filtered.length > 0) {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
          // Se há filtro de SLA aplicado, considerar apenas esses SLAs
          if (selectedColumnFilters.sla.length > 0) {
            const sla = ordem.sla || 'Em dia';
            if (!selectedColumnFilters.sla.includes(sla)) {
              return;
            }
          }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            // Se há filtro de técnico inicial aplicado, considerar apenas esses técnicos
            if (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length > 0) {
              const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
              if (!selectedColumnFilters.tecnicoInicial.includes(tecnicoInicial)) {
                return;
              }
            }
            
            const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || '';
            if (equipamento) {
              equipamentoData[equipamento] = (equipamentoData[equipamento] || 0) + 1;
            }
          });
        }
      });
    } else {
      filtered.forEach(item => {
        // Se há filtros de cidade aplicados, considerar apenas essas cidades
        if (selectedColumnFilters.cidade.length > 0 && 
            !selectedColumnFilters.cidade.includes(item.cidade)) {
          return;
        }
        
        if (item.ordens) {
          item.ordens.forEach(ordem => {
            // Se há filtro de bairro aplicado, considerar apenas esses bairros
            if (selectedColumnFilters.bairro.length > 0) {
              const bairro = ordem.TB02115_BAIRRO || '';
              if (!selectedColumnFilters.bairro.includes(bairro)) {
                return;
              }
            }
            
            // Se há filtro de cliente aplicado, considerar apenas esses clientes
            if (selectedColumnFilters.cliente.length > 0) {
              const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME;
              if (!selectedColumnFilters.cliente.includes(cliente)) {
                return;
              }
            }
            
            // Se há filtro de SLA aplicado, considerar apenas esses SLAs
            if (selectedColumnFilters.sla.length > 0) {
              const sla = ordem.sla || 'Em dia';
              if (!selectedColumnFilters.sla.includes(sla)) {
                return;
              }
            }
            
            // Se há filtro de status aplicado, considerar apenas esses status
            if (selectedColumnFilters.status.length > 0) {
              const status = ordem.TB01073_NOME || '';
              if (!selectedColumnFilters.status.includes(status)) {
                return;
              }
            }
            
            // Se há filtro de técnico inicial aplicado, considerar apenas esses técnicos
            if (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length > 0) {
              const tecnicoInicial = ordem.TB01024_NOME || 'SEM TÉCNICO';
              if (!selectedColumnFilters.tecnicoInicial.includes(tecnicoInicial)) {
                return;
              }
            }
            
            const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || '';
            if (equipamento) {
              equipamentoData[equipamento] = (equipamentoData[equipamento] || 0) + 1;
            }
          });
        }
      });
    }
    
    return Object.keys(equipamentoData)
      .map(equipamento => ({ equipamento, count: equipamentoData[equipamento] }))
      .filter(item => item.count > 0)
      .sort((a, b) => b.count - a.count); // Ordenar por quantidade decrescente
  }, [getFilteredOrders, dataSource, selectedColumnFilters.cidade, selectedColumnFilters.bairro, selectedColumnFilters.cliente, selectedColumnFilters.sla, selectedColumnFilters.status, selectedColumnFilters.tecnicoInicial]);


  // Função auxiliar para obter ordens filtradas pelos outros filtros (exceto o filtro sendo calculado)
  const getFilteredTechnicianOrdersForCounts = React.useCallback((excludeFilterType = null) => {
    const allOrders = [];
    
    // Coletar todas as ordens das colunas de técnicos
    Object.values(technicianGroups).forEach(groups => {
      Object.keys(groups).forEach(groupName => {
        // Se excludeFilterType for 'previsao', pular seções de previsão não selecionadas
        // Seções ativas (deslocamento/serviço) não devem ser afetadas pelo filtro de previsão
        if (excludeFilterType !== 'previsao' && selectedTechnicianColumnFilters.previsao.length > 0 && !isBoardLiveServiceGroup(groupName)) {
          // Aplicar filtro de previsão (filtrar quais seções aparecem)
          if (!selectedTechnicianColumnFilters.previsao.includes(groupName)) {
            return; // Pular esta seção
          }
        }
        
        // Coletar ordens desta seção
        const sectionOrders = groups[groupName] || [];
        allOrders.push(...sectionOrders);
      });
    });
    
    // Aplicar filtros globais (exceto o filtro sendo calculado)
    return allOrders.filter(ordem => {
      // Filtro de cidade (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'cidade' && selectedTechnicianColumnFilters.cidade.length > 0) {
        const cidade = ordem.TB02115_CIDADE || ordem.cidade || 'Não informado';
        if (!selectedTechnicianColumnFilters.cidade.includes(cidade)) {
          return false;
        }
      }
      
      // Filtro de bairro (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'bairro' && selectedTechnicianColumnFilters.bairro.length > 0) {
        const bairro = ordem.TB02115_BAIRRO || ordem.bairro || 'Não informado';
        if (!selectedTechnicianColumnFilters.bairro.includes(bairro)) {
          return false;
        }
      }
      
      // Filtro de cliente (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'cliente' && selectedTechnicianColumnFilters.cliente.length > 0) {
        const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME || 'Não informado';
        if (!selectedTechnicianColumnFilters.cliente.includes(cliente)) {
          return false;
        }
      }
      
      // Filtro de tipo de OS (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'tipoOS' && selectedTechnicianColumnFilters.tipoOS.length > 0) {
        if (!orderMatchesTipoOSFilter(ordem, selectedTechnicianColumnFilters.tipoOS, getServiceTypeFromPreventiva)) {
          return false;
        }
      }
      
      // Filtro de SLA (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'sla' && selectedTechnicianColumnFilters.sla.length > 0) {
        const sla = ordem.sla || 'Em dia';
        if (!selectedTechnicianColumnFilters.sla.includes(sla)) {
          return false;
        }
      }
      
      // Filtro de equipamento (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'equipamento' && selectedTechnicianColumnFilters.equipamento.length > 0) {
        const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || '';
        if (!equipamento || !selectedTechnicianColumnFilters.equipamento.includes(equipamento)) {
          return false;
        }
      }
      
      // Filtro de retorno (exceto se for o filtro sendo calculado)
      if (excludeFilterType !== 'retorno' && selectedTechnicianColumnFilters.retorno != null && (codstatusRetornoEmAberto !== '' || extraRetornoStatusesEmAberto.length > 0)) {
        const isRetorno = isOrderRetornoByRequestStatus(ordem, codstatusRetornoEmAberto, extraRetornoStatusesEmAberto);
        const retornoFilter = selectedTechnicianColumnFilters.retorno;
        if (retornoFilter === 'nao') {
          if (isRetorno) return false;
        } else if (retornoFilter && typeof retornoFilter === 'object' && (retornoFilter.aguardando || retornoFilter.liberado)) {
          if (!isRetorno) return false;
          const pedidoLiberado = isOrderPedidoLiberado(ordem, codstatusPedidoVinculadoDisponivel);
          if (retornoFilter.aguardando && retornoFilter.liberado) { /* manter todas */ }
          else if (retornoFilter.aguardando && pedidoLiberado) return false;
          else if (retornoFilter.liberado && !pedidoLiberado) return false;
        }
      }
      
      const dstrT = (o, key) => String(o[key] ?? '').trim();
      if (excludeFilterType !== 'defeitoDescricao' && selectedTechnicianColumnFilters.defeitoDescricao.length > 0) {
        const v = dstrT(ordem, 'defeito_descricao');
        if (!selectedTechnicianColumnFilters.defeitoDescricao.includes(v)) return false;
      }
      if (excludeFilterType !== 'defeitoAlert' && selectedTechnicianColumnFilters.defeitoAlert.length > 0) {
        const v = dstrT(ordem, 'defeito_alert');
        if (!selectedTechnicianColumnFilters.defeitoAlert.includes(v)) return false;
      }
      if (excludeFilterType !== 'defeitoClassification' && selectedTechnicianColumnFilters.defeitoClassification.length > 0) {
        const v = dstrT(ordem, 'defeito_classification');
        if (!selectedTechnicianColumnFilters.defeitoClassification.includes(v)) return false;
      }
      if (excludeFilterType !== 'defeitoSeverity' && selectedTechnicianColumnFilters.defeitoSeverity.length > 0) {
        const v = dstrT(ordem, 'defeito_severity_level');
        if (!selectedTechnicianColumnFilters.defeitoSeverity.includes(v)) return false;
      }
      
      return true;
    });
      }, [technicianGroups, selectedTechnicianColumnFilters, codstatusRetornoEmAberto, extraRetornoStatusesEmAberto, codstatusPedidoVinculadoDisponivel]);

  const futuraOrdersBoardSearch = React.useMemo(() => {
    const all = [];
    Object.values(technicianGroups || {}).forEach((groups) => {
      if (groups?.FUTURA && Array.isArray(groups.FUTURA)) {
        all.push(...groups.FUTURA);
      }
    });
    return all;
  }, [technicianGroups]);

  const OrderSidebar = ({ order, selectedPedidoCodigo, isOpen, onClose }) => {
    if (!isOpen || !order) return null;

    const displayCodigo = selectedPedidoCodigo || order.pedidoVinculado || '';

    return (
      <div className={`order-sidebar ${isOpen ? 'order-sidebar-open' : ''}`}>
        <div className="order-sidebar-header">
          <div className="order-sidebar-title">
            <h3>Detalhes do Pedido</h3>
            <span className="order-sidebar-subtitle">Pedido: {displayCodigo}</span>
          </div>
          <button 
            className="order-sidebar-close-btn"
            onClick={onClose}
            title="Fechar"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        
        <div className="order-sidebar-content">
          {loadingPedido && (
            <div className="order-sidebar-section">
              <div style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                <i className="bi bi-clock-history"></i> Carregando dados do pedido...
              </div>
            </div>
          )}
          
          {pedidoError && (
            <div className="order-sidebar-section">
              <div style={{ textAlign: 'center', padding: '20px', color: '#dc2626', backgroundColor: '#fef2f2', borderRadius: '6px' }}>
                <i className="bi bi-exclamation-triangle"></i> {pedidoError}
              </div>
            </div>
          )}
          
          {!loadingPedido && !pedidoError && (
            <>
              <div className="order-sidebar-section">
                <h4>Informações do Pedido</h4>
                <div className="order-sidebar-info">
                  <div className="order-sidebar-info-item">
                    <span className="order-sidebar-label">Nota Fiscal:</span>
                    <span className="order-sidebar-value">
                      {pedidoDetails?.notaFiscal || 'Não disponível'}
                </span>
                  </div>
                </div>
              </div>
              
              <div className="order-sidebar-section">
                <h4>Status</h4>
                <div className="order-sidebar-status-inline">
                  <span className="order-sidebar-status-badge">
                    {pedidoDetails?.status || 'Carregando...'}
                  </span>
                  <button 
                    className="timeline-btn"
                    onClick={() => toggleTimeline(displayCodigo)}
                    title={showTimeline ? "Ocultar linha do tempo" : "Exibir linha do tempo"}
                    disabled={loadingPedido}
                  >
                    <i className="bi bi-clock-history"></i>
                  </button>
                </div>
              </div>
              
              {/* Seção da linha do tempo */}
              {showTimeline && (
                <div className="order-sidebar-section">
                  <h4>Linha do Tempo</h4>
                  {loadingTimeline && (
                    <div className="timeline-loading">
                      <i className="bi bi-clock-history"></i> Carregando linha do tempo...
              </div>
            )}
                  
                  {timelineError && (
                    <div className="timeline-error">
                      <i className="bi bi-exclamation-triangle"></i> {timelineError}
          </div>
        )}
                  
                  {timelineData && timelineData.length > 0 && (
                    <div className="timeline-container">
                      {timelineData.map((item, index) => (
                        <div key={index} className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <div className="timeline-date">
                              {formatDateTimeBR(item.TB02130_DATA)}
                            </div>
                            <div className="timeline-status">
                              <span className="timeline-status-code">{item.TB02130_STATUS}</span>
                              <span className="timeline-status-name">{item.TB02130_NOME}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {timelineData && timelineData.length === 0 && (
                    <div className="timeline-empty">
                      <p>Nenhum registro de histórico encontrado</p>
                    </div>
                  )}
                </div>
              )}
              
              <div className="order-sidebar-section">
                <h4>Produtos</h4>
                <div className="order-sidebar-products">
                  <div className="products-table">
                    <div className="products-header">
                      <div className="product-col-codigo">Código</div>
                      <div className="product-col-referencia">Referência</div>
                      <div className="product-col-produto">Produto</div>
                      <div className="product-col-quantidade">Qtd</div>
                    </div>
                    <div className="products-body">
                      {pedidoDetails?.produtos && pedidoDetails.produtos.length > 0 ? (
                        pedidoDetails.produtos.map((produto, index) => (
                          <div key={index} className="product-row">
                            <div className="product-col-codigo">{produto.codigo}</div>
                            <div className="product-col-referencia">{produto.referencia}</div>
                            <div className="product-col-produto" title={produto.nome}>
                              {produto.nome}
                            </div>
                            <div className="product-col-quantidade">{produto.quantidade}</div>
                          </div>
                        ))
                      ) : (
                        <div className="products-empty">
                          <p>{pedidoDetails ? 'Nenhum produto encontrado' : 'Aguardando dados...'}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="order-sidebar-section">
                <h4>Observações</h4>
                <div className="order-sidebar-notes">
                  <p>{pedidoDetails?.observacoes || 'Sem observações'}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const EquipmentSidebar = ({ order, isOpen, onClose }) => {
    // Estados para controlar dados e loading (movidos para antes do return condicional)
    const [expandedCard, setExpandedCard] = useState(null);
    const [lastServiceData, setLastServiceData] = useState(null);
    const [historyData, setHistoryData] = useState([]);
    const [defeitoData, setDefeitoData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Carregar dados do equipamento quando o sidebar abrir
    useEffect(() => {
      if (isOpen && order && order.numeroSerie) {
        fetchEquipmentData();
      }
    }, [isOpen, order]);

    // Return condicional movido para após os hooks
    if (!isOpen || !order) return null;

    const fetchEquipmentData = async () => {
      if (!order.numeroSerie) {
        setError('Número de série não disponível');
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        // Buscar último atendimento, histórico e defeito em paralelo
        const token = localStorage.getItem('authToken');
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        
        const numeroOSAtual = order.id ?? order.numeroOS ?? order.TB02115_CODIGO;
        const [lastServiceResponse, historyResponse, defeitoResponse] = await Promise.all([
          fetch(
            `${API_BASE_URL}/api/equipment/last-service/${order.numeroSerie}?numeroOS=${encodeURIComponent(
              String(numeroOSAtual || '')
            )}`,
            { headers }
          ),
          fetch(`${API_BASE_URL}/api/equipment/history/${order.numeroSerie}`, { headers }),
          fetch(`${API_BASE_URL}/api/orders/${order.id}/defeito`, { headers })
        ]);

        if (!lastServiceResponse.ok || !historyResponse.ok) {
          throw new Error('Erro ao buscar dados do equipamento');
        }

        const lastServiceResult = await lastServiceResponse.json();
        const historyResult = await historyResponse.json();
        const defeitoResult = defeitoResponse.ok ? await defeitoResponse.json() : null;

        if (lastServiceResult.success) {
          setLastServiceData(lastServiceResult.data);
        }

        if (historyResult.success) {
          setHistoryData(historyResult.data || []);
        }

        if (defeitoResult && defeitoResult.success) {
          setDefeitoData(defeitoResult.data);
        }

      } catch (err) {
        console.error('Erro ao buscar dados do equipamento:', err);
        setError('Erro ao carregar dados do equipamento');
      } finally {
        setIsLoading(false);
      }
    };

    // Função para formatar contadores
    const formatCounter = (value) => {
      if (!value || value === '0' || value === 0) return '-';
      return typeof value === 'string' ? value : value.toLocaleString('pt-BR');
    };

    const toggleCardExpansion = (cardId) => {
      setExpandedCard(expandedCard === cardId ? null : cardId);
    };

    const getConditionClass = (condicao) => {
      const condicaoLower = condicao.toLowerCase();
      if (condicaoLower.includes('reparado')) return 'reparado';
      if (condicaoLower.includes('funcionando')) return 'funcionando';
      if (condicaoLower.includes('manutenção') || condicaoLower.includes('manutencao')) return 'manutencao';
      if (condicaoLower.includes('substituído') || condicaoLower.includes('substituido')) return 'substituido';
      return '';
    };

    const ultimaOSNorm =
      lastServiceData?.ultimaOS != null ? String(lastServiceData.ultimaOS).trim() : '';
    const historyForList =
      ultimaOSNorm === ''
        ? historyData
        : historyData.filter((item) => String(item.numeroOS ?? '').trim() !== ultimaOSNorm);

    return (
      <div className={`equipment-sidebar ${isOpen ? 'equipment-sidebar-open' : ''}`}>
        <div className="equipment-sidebar-header">
          <div className="equipment-sidebar-title">
            <h3>{order.equipamento}</h3>
            <span className="equipment-sidebar-subtitle">Série: {order.numeroSerie || order.serie || 'N/A'}</span>
            <span className="equipment-sidebar-info-small">
              Instalação: {lastServiceData?.dataInstalacao || 'N/A'}
            </span>
            <span className="equipment-sidebar-info-small">
              Patrimônio: {order.patrimonio || 'N/A'}
            </span>
          </div>
          <button 
            className="equipment-sidebar-close-btn"
            onClick={onClose}
            title="Fechar"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        
        <div className="equipment-sidebar-content">
          {isLoading && (
            <div className="equipment-sidebar-loading">
              <i className="bi bi-hourglass-split"></i>
              <span>Carregando dados do equipamento...</span>
            </div>
          )}

          {error && (
            <div className="equipment-sidebar-error">
              <i className="bi bi-exclamation-triangle"></i>
              <span>{error}</span>
            </div>
          )}

          {!isLoading && !error && (
            <>
              <div className="equipment-sidebar-section">
                <h4>Último atendimento</h4>
                {lastServiceData ? (
                  <div className="equipment-sidebar-info">
                    <div className="equipment-sidebar-info-item compact">
                      <span className="equipment-sidebar-label">Data:</span>
                      <span className="equipment-sidebar-value">{lastServiceData.ultimaData}</span>
                    </div>
                    <div className="equipment-sidebar-info-item compact">
                      <span className="equipment-sidebar-label">Ordem de serviço:</span>
                      <span className="equipment-sidebar-value">
                        {lastServiceData.ultimaOS} ({lastServiceData.ultimoTipo})
                      </span>
                    </div>
                    <div className="equipment-sidebar-info-item compact">
                      <span className="equipment-sidebar-label">Defeito:</span>
                      <span className="equipment-sidebar-value">
                        {lastServiceData.defeito || defeitoData?.defeito || order.motivoOS || 'Não informado'}
                      </span>
                    </div>
                    {(lastServiceData.obsDefeito || defeitoData?.observacao) && (
                      <div className="equipment-sidebar-info-item compact">
                        <div className="equipment-history-laudo">
                          {lastServiceData.obsDefeito || defeitoData?.observacao}
                        </div>
                      </div>
                    )}
                    <div className="equipment-sidebar-info-item compact">
                      <span className="equipment-sidebar-label">Técnico:</span>
                      <span className="equipment-sidebar-value">{lastServiceData.ultimoTecnico}</span>
                    </div>
                    <div className="equipment-sidebar-info-item laudo-item">
                      <div className="equipment-laudo-header">
                        <span className="equipment-sidebar-label">Laudo:</span>
                        {lastServiceData.ultimaCondicao && (
                          <span className={`equipment-condition-tag ${getConditionClass(lastServiceData.ultimaCondicao)}`}>
                            {lastServiceData.ultimaCondicao}
                          </span>
                        )}
                      </div>
                      <div className="equipment-history-laudo">
                        {lastServiceData.ultimoLaudo || 'Nenhum laudo registrado'}
                      </div>
                    </div>
                    <div className="equipment-sidebar-info-item counters-item">
                      <span className="equipment-sidebar-label">Contadores:</span>
                      <div className="equipment-sidebar-counters">
                        <div className="counters-table">
                          <div className="counters-header">
                            <div className="counter-col">P&B</div>
                            <div className="counter-col">Color</div>
                            <div className="counter-col">DG</div>
                            <div className="counter-col">GF P&B</div>
                            <div className="counter-col">GF Color</div>
                          </div>
                          <div className="counters-body">
                            <div className="counter-row">
                              <div className="counter-col">{formatCounter(lastServiceData.contadores?.pb)}</div>
                              <div className="counter-col">{formatCounter(lastServiceData.contadores?.color)}</div>
                              <div className="counter-col">{formatCounter(lastServiceData.contadores?.dg)}</div>
                              <div className="counter-col">{formatCounter(lastServiceData.contadores?.gfPb)}</div>
                              <div className="counter-col">{formatCounter(lastServiceData.contadores?.gfColor)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
          </div>
        ) : (
                  <div className="equipment-sidebar-no-data">
                    <i className="bi bi-info-circle"></i>
                    <span>Nenhum atendimento encontrado para este equipamento</span>
                  </div>
                )}
              </div>

              <div className="equipment-sidebar-section">
                <h4>Histórico de Atendimentos</h4>
                <div className="equipment-history">
                  {historyForList.length > 0 ? (
                    historyForList.map((item) => (
                      <div 
                        key={item.id} 
                        className={`equipment-history-item ${expandedCard === item.id ? 'expanded' : ''}`}
                        onClick={() => toggleCardExpansion(item.id)}
                      >
                        <div className="equipment-history-header">
                          <div className="equipment-history-date">{item.data}</div>
                          <div className="equipment-history-os">
                            <span className="equipment-history-os-number">{item.numeroOS}</span>
                            <span className={`equipment-history-os-type ${(item.tipoOS || '').toLowerCase()}`}>
                              {item.tipoOS}
                            </span>
                          </div>
                        </div>
                        <div className="equipment-history-tech">Técnico: {item.tecnico}</div>
                        <div className="equipment-history-click-hint">Clique para ver detalhes</div>
                        
                        {expandedCard === item.id && (
                          <div className="equipment-history-expanded">
                            <button 
                              className="equipment-history-collapse-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedCard(null);
                              }}
                              title="Recolher"
                            >
                              <i className="bi bi-chevron-up"></i>
                            </button>
                            
                            <div className="equipment-history-detail">
                              <div className="equipment-history-detail-item compact">
                                <span className="equipment-history-detail-label">Defeito:</span>
                                <span className="equipment-history-detail-value">
                                  {item.defeito || item.motivoOS || 'Não informado'}
                                </span>
                              </div>
                              {item.observacao && (
                                <div className="equipment-history-detail-item compact">
                                  <div className="equipment-history-laudo">
                                    {item.observacao}
                                  </div>
                                </div>
                              )}
                              <div className="equipment-history-detail-item compact">
                                <span className="equipment-history-detail-label">Condição:</span>
                                <span className="equipment-history-detail-value">{item.condicao}</span>
                              </div>
                              
                              <div className="equipment-history-detail-item laudo-item">
                                <span className="equipment-history-detail-label">Laudo:</span>
                                <div className="equipment-history-laudo">
                                  {item.laudo || 'Nenhum laudo registrado'}
                                </div>
                              </div>
                              
                              <div className="equipment-history-detail-item counters-detail-item">
                                <span className="equipment-history-detail-label">Contadores:</span>
                                <div className="equipment-history-counters">
                                  <div className="counters-compact-table">
                                    <div className="counters-compact-header">
                                      <div className="counter-compact-col">P&B</div>
                                      <div className="counter-compact-col">Color</div>
                                      <div className="counter-compact-col">DG</div>
                                      <div className="counter-compact-col">GF P&B</div>
                                      <div className="counter-compact-col">GF Color</div>
                                    </div>
                                    <div className="counters-compact-body">
                                      <div className="counter-compact-row">
                                        <div className="counter-compact-col">{formatCounter(item.contadores?.pb)}</div>
                                        <div className="counter-compact-col">{formatCounter(item.contadores?.color)}</div>
                                        <div className="counter-compact-col">{formatCounter(item.contadores?.dg)}</div>
                                        <div className="counter-compact-col">{formatCounter(item.contadores?.gfPb)}</div>
                                        <div className="counter-compact-col">{formatCounter(item.contadores?.gfColor)}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="equipment-sidebar-no-data">
                      <i className="bi bi-info-circle"></i>
                      <span>Nenhum histórico de atendimento encontrado</span>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  // Rotas de recuperação precisam aparecer mesmo autenticado
  if (location.pathname === '/avaliar') {
    return <CxPublicRatingPage />;
  }

  if (location.pathname === '/roteiro-tecnico') {
    return <TechnicianPublicRoadmapPage />;
  }

  if (location.pathname === '/redefinir-senha') {
    return <RedefinirSenha />;
  }

  if (location.pathname === '/oauth/google/popup') {
    return <GoogleOauthPopup />;
  }

  // Se não estiver autenticado, login ou esqueceu senha
  if (!isAuthenticated) {
    if (authChecking) {
      return (
        <div
          className="post-login-loading-overlay post-login-loading-overlay--steps-only"
          role="status"
          aria-busy="true"
          aria-label="Verificando sessão"
        />
      );
    }
    if (location.pathname === '/esqueceusenha') {
      return <EsqueceuSenha />;
    }
    return <LoginNovo onLoginSuccess={handleLoginSuccess} />;
  }

  const appThemeClass = theme === 'dark' ? 'theme-dark' : '';
  const isCustomersOnlyMode =
    Number(currentUser?.customers_chat_only) === 1 ||
    Number(currentUser?.customers_users_reg_only) === 1;
  const isFinanceiroOnlyNav = isFinanceiroOnlyMode(currentUser);
  const configUsesSectionTopBar =
    showConfigMenu &&
    currentUser &&
    currentUser.type === '1' &&
    CONFIG_BAR_ROUTES.includes(location.pathname) &&
    Boolean(activeConfigSection);

  return (
    <>
      <SessionExpiredModal
        open={showSessionExpiredModal}
        onClose={handleSessionExpiredDismiss}
        onLoginAgain={handleSessionExpiredDismiss}
      />
      <OryaVirtualTour
        enabled={isAuthenticated && !isCustomersOnlyMode && !isFinanceiroOnlyNav}
        onOpenDocumentation={handleOryaTourOpenDocumentation}
      />
      <div className={`app ${appThemeClass} ${isInitialLoading ? 'loading' : ''}${configUsesSectionTopBar ? ' config-section-topbar-chrome' : ''}`}>
        <header className="main-header">
        <div
          className="main-header-brand"
          style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          {companyLogoUrl ? (
            <img
              src={companyLogoUrl}
              alt=""
              className="main-header-company-logo"
            />
          ) : (
            <div style={{
              width: '22px',
              height: '22px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              borderRadius: '50%',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              verticalAlign: 'middle'
            }}>
              <i className="bi bi-gear-fill" style={{ fontSize: '13px', color: 'white', lineHeight: '1', display: 'flex', alignItems: 'center' }}></i>
            </div>
          )}
          <div className="company-name">{companyName}</div>
          {Number(currentUser?.customers_chat_only) === 1 &&
          Number(currentUser?.customers_users_reg_only) === 1 ? (
            <div
              id={CUSTOMERS_ONLY_TABS_HOST_ID}
              className="customers-only-nav-tabs-host"
            />
          ) : null}
        </div>
        <nav className="main-nav">
          {/* Menu Board - não exibido para Técnicos (type = 3) nem modo só chat/cadastro */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && currentUser.type !== '3' && currentUser.type !== 3 && (
          <button 
            className={`nav-item ${activeSection === 'Board' && !APP_FULL_PAGE_ROUTES.includes(location.pathname) ? 'active' : ''}`}
            onClick={() => {
              if (APP_FULL_PAGE_ROUTES.includes(location.pathname)) navigate('/app');
              setActiveSection('Board');
              setCadastrosNavOpen(false);
              setFinanceiroNavOpen(false);
              setEstoqueNavOpen(false);
              setShowConfigMenu(false);
            }}
          >
            Board
          </button>
          )}

          {/* Menu Fechamento (direto) - type 0/1/2 e asstec_closeos = 1 */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && ['0','1','2'].includes(String(currentUser.type)) && currentUser.asstec_closeos === 1 && (
            <button
              type="button"
              className={`nav-item fechamento-nav-trigger ${location.pathname === '/fechamento' ? 'active' : ''}`}
              style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 6 }}
              onClick={() => {
                navigate('/fechamento');
                setCadastrosNavOpen(false);
                setFinanceiroNavOpen(false);
                setEstoqueNavOpen(false);
                setShowConfigMenu(false);
              }}
            >
              Fechamento
              {fechamentoCount > 0 && (
                <span className="column-filter-badge fechamento-nav-badge">
                  {fechamentoCount > 99 ? '99+' : fechamentoCount}
                </span>
              )}
            </button>
          )}

          {/* Menu Cadastros (dropdown) — Administradores e Gerentes Técnicos */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && (currentUser.type === '1' || currentUser.type === '2') && (
          <div className="cadastros-nav-dropdown" style={{ position: 'relative' }}>
            <button
              type="button"
              className={`nav-item cadastros-nav-trigger ${
                CADASTROS_ROUTES.includes(location.pathname) ? 'active' : ''
              }`}
              style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}
              onClick={() => {
                setCadastrosNavOpen((o) => !o);
                setAnalisesNavOpen(false);
                setFinanceiroNavOpen(false);
                setEstoqueNavOpen(false);
              }}
              aria-expanded={cadastrosNavOpen}
              aria-haspopup="true"
            >
              Cadastros
              <span className="fechamento-nav-trigger-right">
                <ChevronDown size={16} className={`fechamento-nav-chevron ${cadastrosNavOpen ? 'open' : ''}`} />
              </span>
            </button>
            {cadastrosNavOpen && (
              <div className="analises-nav-content">
                <div className="analises-nav-group">
                  <span className="analises-nav-group-title">Assistência técnica</span>
                  {/*
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === '/cadastros/tecnicos' ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/cadastros/tecnicos');
                      setCadastrosNavOpen(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <Wrench size={18} strokeWidth={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Gestão de técnicos</span>
                      <span className="fechamento-nav-link-subtitle">Hierarquia, automações e especialidade</span>
                    </span>
                  </button>
                  */}
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === '/cadastros/equipe' ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/cadastros/equipe');
                      setCadastrosNavOpen(false);
                      setAnalisesNavOpen(false);
                      setShowConfigMenu(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <Users size={18} strokeWidth={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Gestão de equipe</span>
                      <span className="fechamento-nav-link-subtitle">
                        Áreas, coordenadores, técnicos e especialidade
                      </span>
                    </span>
                  </button>
                  {canAccessCompatibilidadeEquipamentos(currentUser) ? (
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === '/cadastros/compatibilidade-equipamentos' ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/cadastros/compatibilidade-equipamentos');
                      setCadastrosNavOpen(false);
                      setAnalisesNavOpen(false);
                      setShowConfigMenu(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <HardDrive size={18} strokeWidth={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Compatibilidade</span>
                      <span className="fechamento-nav-link-subtitle">
                        Definição de compatibilidade de equipamentos
                      </span>
                    </span>
                  </button>
                  ) : null}
                </div>
              </div>
            )}
          </div>
          )}

          {/* Menu Oficina - apenas para Técnicos (type = 3) */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && (currentUser.type === '3' || currentUser.type === 3) && (
          <button 
            className={`nav-item ${activeSection === 'Oficina' && !APP_FULL_PAGE_ROUTES.includes(location.pathname) ? 'active' : ''}`}
            onClick={() => {
              if (APP_FULL_PAGE_ROUTES.includes(location.pathname)) navigate('/app');
              setActiveSection('Oficina');
              setCadastrosNavOpen(false);
              setFinanceiroNavOpen(false);
              setEstoqueNavOpen(false);
              setShowConfigMenu(false);
            }}
          >
            Oficina
          </button>
          )}

          {/* Menu Análises (dropdown) - Admin/Gerente Técnico ou Coordenador com Criar relatórios */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && canShowAnalisesNav(currentUser) && (
          <div className="analises-nav-dropdown" style={{ position: 'relative' }}>
            <button
              type="button"
              className={`nav-item analises-nav-trigger ${location.pathname === '/relatorios' || location.pathname === '/monitoramento' || location.pathname.startsWith('/analise/experiencia-cliente') ? 'active' : ''}`}
              style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}
              onClick={() => {
                setAnalisesNavOpen((o) => !o);
                setCadastrosNavOpen(false);
                setFinanceiroNavOpen(false);
                setEstoqueNavOpen(false);
              }}
              aria-expanded={analisesNavOpen}
              aria-haspopup="true"
            >
              Análises
              <span className="fechamento-nav-trigger-right">
                <ChevronDown size={16} className={`fechamento-nav-chevron ${analisesNavOpen ? 'open' : ''}`} />
              </span>
            </button>
            {analisesNavOpen && (
              <div className="analises-nav-content">
                <div className="analises-nav-group">
                  <span className="analises-nav-group-title">Consultas</span>
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === '/relatorios' ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/relatorios');
                      setActiveSection('Análises');
                      setAnalisesNavOpen(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <IconFileAnalytics size={18} stroke={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Consultas e relatórios</span>
                      <span className="fechamento-nav-link-subtitle">Crie relatórios personalizados</span>
                    </span>
                  </button>
                  {canAccessExperienciaClienteModule(currentUser) ? (
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname.startsWith('/analise/experiencia-cliente') ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/analise/experiencia-cliente');
                      setActiveSection('Análises');
                      setAnalisesNavOpen(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <Sparkles size={18} strokeWidth={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Experiência do cliente</span>
                      <span className="fechamento-nav-link-subtitle">Análise e gestão das avaliações de atendimento</span>
                    </span>
                  </button>
                  ) : null}
                </div>
                {canAccessFullAnalisesMenu(currentUser) ? (
                <div className="analises-nav-group">
                  <span className="analises-nav-group-title">Painéis</span>
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === '/monitoramento' ? 'active' : ''}`}
                    onClick={() => {
                      navigate('/monitoramento');
                      setActiveSection('Análises');
                      setAnalisesNavOpen(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <MonitorCheck size={18} strokeWidth={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Acompanhamento técnico</span>
                      <span className="fechamento-nav-link-subtitle">Visualize os painéis de monitoramento técnico</span>
                    </span>
                  </button>
                </div>
                ) : null}
              </div>
            )}
          </div>
          )}

          {/* Menu Estoque (dropdown) — Admin/Gerente Técnico + Licença App Go */}
          {!isCustomersOnlyMode && !isFinanceiroOnlyNav && currentUser && canAccessFullAnalisesMenu(currentUser) && hasGoAppLicense(currentUser) && (
          <div className="estoque-nav-dropdown" style={{ position: 'relative' }}>
            <button
              type="button"
              className={`nav-item estoque-nav-trigger ${
                ESTOQUE_ROUTES.includes(location.pathname) ? 'active' : ''
              }`}
              style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}
              onClick={() => {
                setEstoqueNavOpen((o) => !o);
                setAnalisesNavOpen(false);
                setCadastrosNavOpen(false);
                setFinanceiroNavOpen(false);
              }}
              aria-expanded={estoqueNavOpen}
              aria-haspopup="true"
            >
              Estoque
              <span className="fechamento-nav-trigger-right">
                <ChevronDown size={16} className={`fechamento-nav-chevron ${estoqueNavOpen ? 'open' : ''}`} />
              </span>
            </button>
            {estoqueNavOpen && (
              <div className="analises-nav-content">
                <div className="analises-nav-group">
                  <span className="analises-nav-group-title">Kit técnico</span>
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === ESTOQUE_KIT_TECNICO_ROUTE ? 'active' : ''}`}
                    onClick={() => {
                      navigate(ESTOQUE_KIT_TECNICO_ROUTE);
                      setEstoqueNavOpen(false);
                      setShowConfigMenu(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <IconPackages size={18} stroke={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Kit técnico</span>
                      <span className="fechamento-nav-link-subtitle">Gerenciamento de Kits Técnicos</span>
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
          )}

          {/* Menu Financeiro (dropdown) — Admin/Gerente com ao menos 1 permissão de reembolso */}
          {!isCustomersOnlyMode && canAccessFinanceiroMenu(currentUser) && (
          <div className="financeiro-nav-dropdown" style={{ position: 'relative' }}>
            <button
              type="button"
              className={`nav-item financeiro-nav-trigger ${
                FINANCEIRO_ROUTES.includes(location.pathname) ? 'active' : ''
              }`}
              style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}
              onClick={() => {
                setFinanceiroNavOpen((o) => !o);
                setAnalisesNavOpen(false);
                setCadastrosNavOpen(false);
                setEstoqueNavOpen(false);
              }}
              aria-expanded={financeiroNavOpen}
              aria-haspopup="true"
            >
              Financeiro
              <span className="fechamento-nav-trigger-right">
                <ChevronDown size={16} className={`fechamento-nav-chevron ${financeiroNavOpen ? 'open' : ''}`} />
              </span>
            </button>
            {financeiroNavOpen && (
              <div className="analises-nav-content">
                <div className="analises-nav-group">
                  <span className="analises-nav-group-title">Reembolsos</span>
                  <button
                    type="button"
                    className={`analises-nav-link ${location.pathname === FINANCEIRO_REEMBOLSOS_ROUTE ? 'active' : ''}`}
                    onClick={() => {
                      navigate(FINANCEIRO_REEMBOLSOS_ROUTE);
                      setFinanceiroNavOpen(false);
                      setShowConfigMenu(false);
                    }}
                  >
                    <span className="analises-nav-link-icon" aria-hidden="true">
                      <IconWallet size={18} stroke={1.75} />
                    </span>
                    <span className="fechamento-nav-link-text">
                      <span className="fechamento-nav-link-title">Gestão de reembolsos</span>
                      <span className="fechamento-nav-link-subtitle">Despesas, comprovantes e reembolsos</span>
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
          )}
        </nav>
        <div className="header-actions">
          {/* Changelog (Latest Updates) - à esquerda do menu do usuário */}
          {currentUser && (
            <div className="changelog-dropdown-wrap">
              <ChangelogDropdown
                apiBaseUrl={API_BASE_URL}
                isOpen={showChangelogMenu}
                onToggle={() => {
                  setShowLogoutMenu(false);
                  setShowChangelogMenu(!showChangelogMenu);
                }}
              />
            </div>
          )}
          
          {/* Componente de usuário logado */}
          {currentUser && (() => {
            const userDisplayName =
              currentUser.name || currentUser.username || currentUser.user || 'Usuário';
            const connectionStatus = isCustomersOnlyMode
              ? { kind: 'connected', label: 'On-line', title: 'Conectado' }
              : getHeaderConnectionStatus(isLoadingData, dataSource);

            return (
            <div className="user-info">
              <button 
                className="user-button"
                onClick={() => {
                  setShowChangelogMenu(false);
                  setShowLogoutMenu(!showLogoutMenu);
                }}
                aria-label={`Menu do usuário: ${userDisplayName}`}
                aria-expanded={showLogoutMenu}
              >
                <span className="user-badge">
                  <span
                    className={`user-badge-avatar-wrap user-badge-avatar-wrap--${connectionStatus.kind}`}
                  >
                    {renderProfileAvatar(
                      currentUser.profilePhotoUrl,
                      userDisplayName,
                      'profile-avatar-img--header'
                    )}
                    <span className="user-badge-status-dot" aria-hidden="true" />
                  </span>
                  <i className="bi bi-chevron-down user-badge-chevron" aria-hidden="true" />
                </span>
              </button>
              
              {showLogoutMenu && (
                <div className="logout-menu ec-actions-menu" role="menu" aria-label="Menu do usuário">
                  <div className="logout-menu-profile">
                    <span
                      className={`logout-menu-profile-avatar-wrap logout-menu-profile-avatar-wrap--${connectionStatus.kind}`}
                    >
                      {renderProfileAvatar(
                        currentUser.profilePhotoUrl,
                        userDisplayName,
                        'profile-avatar-img--menu'
                      )}
                      <span className="user-badge-status-dot" aria-hidden="true" />
                    </span>
                    <div className="logout-menu-profile-text">
                      <span className="logout-menu-profile-name">{userDisplayName}</span>
                      <span
                        className={`logout-menu-profile-status logout-menu-profile-status--${connectionStatus.kind}`}
                      >
                        {connectionStatus.label}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="logout-menu-profile-btn"
                      onClick={() => {
                        setShowUserProfileModal(true);
                        setShowLogoutMenu(false);
                      }}
                    >
                      Perfil
                    </button>
                  </div>

                  <div className="logout-menu-separator" role="separator" />

                  {currentUser && currentUser.type === '1' && (
                    <button
                      type="button"
                      className="ec-actions-menu-item"
                      role="menuitem"
                      onClick={() => {
                        setShowLogoutMenu(false);
                        navigate(CONFIG_ROUTE_HOME);
                      }}
                    >
                      <Bolt size={16} strokeWidth={1.5} aria-hidden />
                      Configurações
                    </button>
                  )}
                  <button
                    type="button"
                    className="ec-actions-menu-item"
                    role="menuitem"
                    onClick={() => {
                      setShowConfigMenu(false);
                      setShowLogoutMenu(false);
                      navigate('/aprender');
                    }}
                  >
                    <GraduationCap size={16} strokeWidth={1.5} aria-hidden />
                    Aprender
                  </button>
                  {currentUser && currentUser.canny_linked && currentUser.canny_user_id && (
                  <button
                    type="button"
                    className="ec-actions-menu-item"
                    role="menuitem"
                    onClick={() => {
                      setShowLogoutMenu(false);
                      setShowConfigMenu(false);
                      navigate('/hubfeedback');
                    }}
                  >
                    <MessageCircleCode size={16} strokeWidth={1.5} aria-hidden />
                    Hub de Feedback
                  </button>
                  )}
                  <UserAppearanceMenuItem
                    preference={currentUser.blacktheme}
                    onSelect={handleSetThemePreference}
                  />
                  <button
                    type="button"
                    className="ec-actions-menu-item"
                    role="menuitem"
                    onClick={handleLogout}
                  >
                    <LogOut size={16} strokeWidth={1.5} aria-hidden />
                    Sair do sistema
                  </button>
                </div>
              )}
            </div>
            );
          })()}
        </div>
      </header>

      {/* Faixa full-width da seção aberta (substitui a config-bar horizontal) */}
      {configUsesSectionTopBar ? (
        <ConfigSectionTopBar
          sectionId={activeConfigSection}
          hubPath={CONFIG_ROUTE_HOME}
          currentUser={currentUser}
        />
      ) : null}

      {/* Hub de configurações — /configuracoes (sem config-bar) */}
      {showConfigMenu &&
        currentUser &&
        currentUser.type === '1' &&
        isConfigHomePath(location.pathname) && (
        <ConfigHubView currentUser={currentUser} onNavigate={(path) => navigate(path)} />
      )}

      {/* Conteúdo das configurações - apenas para administradores */}
      {showConfigMenu && currentUser && currentUser.type === '1' && activeConfigSection === 'process' && (
        <div className="config-content config-content-process">
          <ProcessConfig userDisplayName={currentUser?.name || currentUser?.username || ''} />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && hasGoAppLicense(currentUser) && activeConfigSection === 'go' && (
        <div className="config-content config-content-go">
          <GoConfig />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && activeConfigSection === 'users' && (
        <div className="config-content config-content-users">
          <ConfigOryaAssistant
            userDisplayName={currentUser?.name || currentUser?.username || ''}
            configSection="users"
            hideFab
          />
          <UserManagement 
            users={users}
            setUsers={setUsers}
            isLoadingUsers={isLoadingUsers}
            setIsLoadingUsers={setIsLoadingUsers}
            showUserForm={showUserForm}
            setShowUserForm={setShowUserForm}
            editingUser={editingUser}
            setEditingUser={setEditingUser}
            showPasswordUser={showPasswordUser}
            setShowPasswordUser={setShowPasswordUser}
            userFormData={userFormData}
            setUserFormData={setUserFormData}
            userFormErrors={userFormErrors}
            setUserFormErrors={setUserFormErrors}
            userOSTypes={userOSTypes}
            setUserOSTypes={setUserOSTypes}
            clientId={currentUser?.clientId}
            verveCustomersModule={currentUser?.verve_customers_module}
            goAppModule={currentUser?.has_go_app}
            onProfilePhotoSaved={async (savedUserId) => {
              if (savedUserId !== currentUser?.id) return;
              try {
                const token = localStorage.getItem('authToken');
                const verifyRes = await fetch(`${API_BASE_URL}/api/auth/verify`, {
                  headers: { Authorization: `Bearer ${token}` }
                });
                const verifyData = await verifyRes.json();
                if (verifyData.success && verifyData.user) {
                  let user = verifyData.user;
                  if (user.profilePhotoUrl) {
                    /* já no verify */
                  } else if (user.hasProfilePhoto) {
                    const photoUrl = await fetchUserProfilePhotoUrl(user.id);
                    user = { ...user, profilePhotoUrl: photoUrl };
                  } else {
                    user = { ...user, profilePhotoUrl: null };
                  }
                  setCurrentUser(user);
                  localStorage.setItem('userData', JSON.stringify(user));
                }
              } catch (_) { /* ignore */ }
            }}
          />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && Number(currentUser.verve_customers_module) === 1 && activeConfigSection === 'usersCustomers' && (
        <div className="config-content config-content-users">
          <UsersCustomersView />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && activeConfigSection === 'company' && (
        <div className="config-content config-content-company">
          <ConfigOryaAssistant
            userDisplayName={currentUser?.name || currentUser?.username || ''}
            configSection="company"
            hideFab
          />
          <CompanyConfig key="company-config" />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && Number(currentUser.verve_customers_module) === 1 && activeConfigSection === 'integrations' && (
        <div className="config-content config-content-integrations">
          <IntegracoesPage
            categoryId={location.pathname === INTEGRACOES_ROUTE_AREA_TECNICA ? 2 : 1}
          />
        </div>
      )}

      {showConfigMenu && currentUser && currentUser.type === '1' && activeConfigSection === 'painelControle' && (
        <div className="config-content config-content-users">
          <PainelControleView currentUser={currentUser} />
        </div>
      )}

      <Routes>
        <Route path={CONFIG_ROUTE_HOME} element={<></>} />
        <Route path={CONFIG_ROUTE_PROCESSOS} element={<></>} />
        <Route path={CONFIG_ROUTE_GO} element={<></>} />
        <Route path={CONFIG_ROUTE_USUARIOS} element={<></>} />
        <Route path={CONFIG_ROUTE_CUSTOMERS} element={<></>} />
        <Route path={CONFIG_ROUTE_EMPRESA} element={<></>} />
        <Route path={CONFIG_ROUTE_PAINEL_CONTROLE} element={<></>} />
        <Route path={INTEGRACOES_ROUTE_BASE} element={<></>} />
        <Route path={INTEGRACOES_ROUTE_LOGISTICA} element={<></>} />
        <Route path={INTEGRACOES_ROUTE_AREA_TECNICA} element={<></>} />
        <Route path="/integracoes" element={<></>} />
        <Route path="/integracoes/1" element={<></>} />
        <Route path="/integracoes/2" element={<></>} />
        <Route
          path="/fechamento"
          element={
            !showConfigMenu &&
            (() => {
              const canAccessFechamento = currentUser && ['0', '1', '2'].includes(String(currentUser.type)) && currentUser.asstec_closeos === 1;
              if (!canAccessFechamento) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Fechamento.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return <FechamentoPage />;
            })()
          }
        />
        <Route
          path="/hubfeedback"
          element={
            (() => {
              const canAccessHubFeedback = currentUser && currentUser.canny_linked && currentUser.canny_user_id;
              if (!canAccessHubFeedback) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 18, color: '#1e293b', marginBottom: 8, fontWeight: 600 }}>Acesso não permitido</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Somente usuários com permissão para sugerir melhorias (Verve/Canny) podem acessar o Hub de Feedback.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return <HubFeedbackView />;
            })()
          }
        />
        <Route
          path="/monitoramento"
          element={
            !showConfigMenu &&
            (() => {
              const isTecnico = currentUser && (currentUser.type === '3' || currentUser.type === 3);
              const relatoriosOnlyCoord =
                canAccessRelatoriosAsCoordenador(currentUser) && !canAccessFullAnalisesMenu(currentUser);
              if (isTecnico) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Técnicos não possuem acesso ao módulo Monitoramento.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              if (relatoriosOnlyCoord) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Monitoramento.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return <MonitoramentoPage currentUser={currentUser} />;
            })()
          }
        />
        <Route
          path="/relatorios"
          element={
            !showConfigMenu &&
            (() => {
              if (!canAccessRelatoriosModule(currentUser)) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Relatórios.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return (
                <React.Suspense fallback={<div className="relatorios-page app-route-fallback">Carregando...</div>}>
                  <RelatoriosPage currentUser={currentUser} />
                </React.Suspense>
              );
            })()
          }
        />
        <Route
          path="/analise/experiencia-cliente"
          element={
            !showConfigMenu &&
            (() => {
              const canAccess = canAccessExperienciaClienteModule(currentUser);
              if (!canAccess) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Experiência do cliente.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return (
                <React.Suspense fallback={<div className="ec-page app-route-fallback">Carregando...</div>}>
                  <ExperienciaClientePage />
                </React.Suspense>
              );
            })()
          }
        />
        <Route
          path="/analise/experiencia-cliente/av-pendentes"
          element={
            !showConfigMenu &&
            (() => {
              const canAccess = canAccessExperienciaClienteModule(currentUser);
              if (!canAccess) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Experiência do cliente.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return (
                <React.Suspense fallback={<div className="ec-page app-route-fallback">Carregando...</div>}>
                  <ExperienciaClienteAvPendentesPage />
                </React.Suspense>
              );
            })()
          }
        />
        <Route
          path={FINANCEIRO_REEMBOLSOS_ROUTE}
          element={
            !showConfigMenu &&
            (() => {
              const canAccessFinanceiro = canAccessFinanceiroMenu(currentUser);
              if (!canAccessFinanceiro) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Gestão de reembolsos.</div>
                    {!isFinanceiroOnlyMode(currentUser) && (
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                    )}
                  </div>
                );
              }
              return <GestaoReembolsosPage currentUser={currentUser} />;
            })()
          }
        />
        <Route
          path={ESTOQUE_KIT_TECNICO_ROUTE}
          element={
            !showConfigMenu &&
            (() => {
              const canAccessEstoque =
                canAccessFullAnalisesMenu(currentUser) && hasGoAppLicense(currentUser);
              if (!canAccessEstoque) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso ao módulo Kit técnico.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return <KitTecnicoPage />;
            })()
          }
        />
        {/*
        <Route
          path="/cadastros/tecnicos"
          element={
            !showConfigMenu &&
            (() => {
              const canAccessCadastrosTecnicos = currentUser && (currentUser.type === '1' || currentUser.type === '2');
              if (!canAccessCadastrosTecnicos) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso a Cadastros — Gestão de técnicos.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return <GestaoTecnicosPage />;
            })()
          }
        />
        */}
        <Route
          path="/cadastros/equipe"
          element={
            !showConfigMenu &&
            (() => {
              const canAccessCadastrosEquipe = currentUser && (currentUser.type === '1' || currentUser.type === '2');
              if (!canAccessCadastrosEquipe) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>Você não possui acesso a Cadastros — Gestão de equipe.</div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>Voltar ao início</button>
                  </div>
                );
              }
              return (
                <>
                  <ConfigOryaAssistant
                    userDisplayName={currentUser?.name || currentUser?.username || ''}
                    configSection="equipe"
                    hideFab
                  />
                  <Equipe2View apiBaseUrl={API_BASE_URL} />
                </>
              );
            })()
          }
        />
        <Route path="/cadastros/equipe2" element={<Navigate to="/cadastros/equipe" replace />} />
        <Route
          path="/cadastros/compatibilidade-equipamentos"
          element={
            !showConfigMenu &&
            (() => {
              const canAccess = canAccessCompatibilidadeEquipamentos(currentUser);
              if (!canAccess) {
                return (
                  <div className="fechamento-403-wrap">
                    <div style={{ fontSize: 48, marginBottom: 16 }}>403</div>
                    <div style={{ fontSize: 16, color: '#64748b', marginBottom: 24, textAlign: 'center' }}>
                      Você não possui acesso a Cadastros — Compatibilidade.
                    </div>
                    <button type="button" className="config-nav-item" onClick={() => navigate('/app')} style={{ padding: '10px 20px' }}>
                      Voltar ao início
                    </button>
                  </div>
                );
              }
              return (
                <>
                  <ConfigOryaAssistant
                    userDisplayName={currentUser?.name || currentUser?.username || ''}
                    configSection="compatibilidade"
                    hideFab
                  />
                  <CompatibilidadeEquipamentosPage goPremium={isGoPremiumLicense(currentUser)} />
                </>
              );
            })()
          }
        />
        <Route
          path="/aprender"
          element={
            !showConfigMenu && (
              <React.Suspense fallback={<div className="aprender-page app-route-fallback">Carregando...</div>}>
                <DocumentationView />
              </React.Suspense>
            )
          }
        />
        <Route
          path="*"
          element={
            !showConfigMenu && (
              isCustomersOnlyMode ? (
                <CustomersOnlyModeShell
                  chatOnly={Number(currentUser?.customers_chat_only) === 1}
                  cadastroOnly={Number(currentUser?.customers_users_reg_only) === 1}
                  underHeader
                  onOpenOrderDetails={(orderId, opts) =>
                    handleOpenOrderDetailsV2FromContext(
                      orderId,
                      { source: 'open', ...opts },
                      setSelectedOrderForDetailsMock
                    )
                  }
                  onEncaminharOs={(osId, meta) => {
                    const id = String(osId || '').trim();
                    if (!id) return;
                    setBoardEncaminharFlow({
                      orderIds: [id],
                      source: 'open',
                      fromTechnician: '',
                      fromGroup: 'Em Aberto',
                      chatConversationId:
                        meta?.conversationId != null
                          ? String(meta.conversationId)
                          : null,
                    });
                  }}
                />
              ) : isFinanceiroOnlyNav ? (
                <Navigate to={FINANCEIRO_REEMBOLSOS_ROUTE} replace />
              ) : (typeof window !== 'undefined' && APP_FULL_PAGE_ROUTES.includes(window.location.pathname) && location.pathname !== window.location.pathname)
                ? <div className="app-route-fallback">Carregando...</div>
                : <>
      {activeSection === 'Board' && (
        <>
          <div className="filters-bar">
            <div className="filter-buttons">
              <div className="filter-group board-toolbar-filter-group">
                {/*
                <ToolbarFilterChipDropdown
                  label="Coordenador"
                  options={getFilterOptions('coordenador')}
                  selected={selectedFilterItems.coordenador}
                  disabled={isLoadingCoordinators}
                  isOpen={openModal === 'coordenador'}
                  onOpenChange={(open) => setOpenModal(open ? 'coordenador' : null)}
                  pickerMode="simple"
                  pickerWidth={238}
                  pickerMaxHeight={320}
                  searchPlaceholder="Buscar"
                  countLabel="coordenadores"
                  listAriaLabel="Coordenadores"
                  popoverClassName="board-search-filters-popover--coordenador"
                  headerBanner={
                    currentUser?.coordinator ? (
                      <>
                        <strong>Modo Coordenador:</strong> Você só pode selecionar a si mesmo neste
                        filtro.
                      </>
                    ) : null
                  }
                  isOptionDisabled={(item) => {
                    if (!currentUser?.coordinator) return false;
                    const userName = currentUser.name || currentUser.username;
                    return item.value !== userName;
                  }}
                  onToggleItem={(optionValue) => {
                    if (currentUser?.coordinator) {
                      const userName = currentUser.name || currentUser.username;
                      if (optionValue !== userName) return;
                    }
                    const currentSelected = selectedFilterItems.coordenador || [];
                    const newSelection = currentSelected.includes(optionValue)
                      ? currentSelected.filter((i) => i !== optionValue)
                      : [...currentSelected, optionValue];
                    const updatedFilters = applyAutomaticFilters('coordenador', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onToggleAll={() => {
                    const coordOptions = getFilterOptions('coordenador');
                    const selectable = currentUser?.coordinator
                      ? coordOptions.filter(
                          (o) => o === (currentUser.name || currentUser.username)
                        )
                      : coordOptions;
                    const allMarked =
                      selectable.length > 0 &&
                      selectable.every((o) => selectedFilterItems.coordenador.includes(o));
                    const newSelection = allMarked
                      ? selectedFilterItems.coordenador.filter((c) => !selectable.includes(c))
                      : Array.from(
                          new Set([...selectedFilterItems.coordenador, ...selectable])
                        );
                    const updatedFilters = applyAutomaticFilters('coordenador', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onClear={() => {
                    const updatedFilters = applyAutomaticFilters('coordenador', []);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: [],
                      ...updatedFilters,
                    });
                  }}
                  onApply={() => setOpenModal(null)}
                  emptyMessage="Nenhum coordenador encontrado"
                />
                */}
                <BoardToolbarCoordenadorClickUpChip
                  options={getFilterOptions('coordenador')}
                  selected={selectedFilterItems.coordenador}
                  disabled={isLoadingCoordinators}
                  isOpen={openModal === 'coordenador'}
                  onOpenChange={(open) => setOpenModal(open ? 'coordenador' : null)}
                  headerBanner={
                    currentUser?.coordinator ? (
                      <>
                        <strong>Modo Coordenador:</strong> Você só pode selecionar a si mesmo neste
                        filtro.
                      </>
                    ) : null
                  }
                  isOptionDisabled={(item) => {
                    if (!currentUser?.coordinator) return false;
                    const userName = currentUser.name || currentUser.username;
                    return item.value !== userName;
                  }}
                  onToggleItem={(optionValue) => {
                    if (currentUser?.coordinator) {
                      const userName = currentUser.name || currentUser.username;
                      if (optionValue !== userName) return;
                    }
                    const currentSelected = selectedFilterItems.coordenador || [];
                    const newSelection = currentSelected.includes(optionValue)
                      ? currentSelected.filter((i) => i !== optionValue)
                      : [...currentSelected, optionValue];
                    const updatedFilters = applyAutomaticFilters('coordenador', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onToggleAll={() => {
                    const coordOptions = getFilterOptions('coordenador');
                    const selectable = currentUser?.coordinator
                      ? coordOptions.filter(
                          (o) => o === (currentUser.name || currentUser.username)
                        )
                      : coordOptions;
                    const allMarked =
                      selectable.length > 0 &&
                      selectable.every((o) => selectedFilterItems.coordenador.includes(o));
                    const newSelection = allMarked
                      ? selectedFilterItems.coordenador.filter((c) => !selectable.includes(c))
                      : Array.from(
                          new Set([...selectedFilterItems.coordenador, ...selectable])
                        );
                    const updatedFilters = applyAutomaticFilters('coordenador', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onClear={() => {
                    const updatedFilters = applyAutomaticFilters('coordenador', []);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      coordenador: [],
                      ...updatedFilters,
                    });
                  }}
                  onApply={() => setOpenModal(null)}
                />
              </div>

              <div className="filter-group board-toolbar-filter-group">
                {/*
                <ToolbarFilterChipDropdown
                  label="Área"
                  options={getFilterOptions('area')}
                  selected={selectedFilterItems.area}
                  disabled={isLoadingCoordinators || isLoadingAreas}
                  isOpen={openModal === 'area'}
                  onOpenChange={(open) => setOpenModal(open ? 'area' : null)}
                  pickerMode="simple"
                  pickerWidth={238}
                  pickerMaxHeight={320}
                  searchPlaceholder="Buscar"
                  countLabel="áreas"
                  listAriaLabel="Áreas"
                  popoverClassName="board-search-filters-popover--area"
                  onToggleItem={(optionValue) => {
                    const currentSelected = selectedFilterItems.area || [];
                    const newSelection = currentSelected.includes(optionValue)
                      ? currentSelected.filter((i) => i !== optionValue)
                      : [...currentSelected, optionValue];
                    const updatedFilters = applyAutomaticFilters('area', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      area: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  emptyMessage="Nenhuma área encontrada"
                />
                */}
                <BoardToolbarAreaClickUpChip
                  options={getFilterOptions('area')}
                  selected={selectedFilterItems.area}
                  disabled={isLoadingCoordinators || isLoadingAreas}
                  isOpen={openModal === 'area'}
                  onOpenChange={(open) => setOpenModal(open ? 'area' : null)}
                  onToggleItem={(optionValue) => {
                    const currentSelected = selectedFilterItems.area || [];
                    const newSelection = currentSelected.includes(optionValue)
                      ? currentSelected.filter((i) => i !== optionValue)
                      : [...currentSelected, optionValue];
                    const updatedFilters = applyAutomaticFilters('area', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      area: newSelection,
                      ...updatedFilters,
                    });
                  }}
                />
              </div>

              <div className="filter-group board-toolbar-filter-group">
                {/*
                <ToolbarFilterChipDropdown
                  label="Técnicos"
                  options={getFilterOptions('tecnico')}
                  selected={selectedFilterItems.tecnico}
                  disabled={isLoadingTechnicians || isLoadingAreas}
                  isOpen={openModal === 'tecnico'}
                  onOpenChange={(open) => setOpenModal(open ? 'tecnico' : null)}
                  pickerMode="simple"
                  pickerWidth={238}
                  pickerMaxHeight={320}
                  searchPlaceholder="Buscar"
                  countLabel="técnicos"
                  listAriaLabel="Técnicos"
                  popoverClassName="board-search-filters-popover--tecnico"
                  showSimpleBulkMenu
                  onToggleAll={(keys, allMarked) => {
                    const current = selectedFilterItems.tecnico || [];
                    const newSelection = allMarked
                      ? current.filter((t) => !keys.includes(t))
                      : Array.from(new Set([...current, ...keys]));
                    if (!allMarked) {
                      keys.forEach((name) => {
                        if (
                          !current.includes(name) &&
                          getTechnicianOrderCount(technicianGroups, name) === 0
                        ) {
                          setOnlyTechniciansWithOS(false);
                        }
                      });
                    }
                    const updatedFilters = applyAutomaticFilters('tecnico', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      tecnico: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onToggleItem={(optionValue) => {
                    const currentSelected = selectedFilterItems.tecnico || [];
                    const isAdding = !currentSelected.includes(optionValue);
                    const newSelection = isAdding
                      ? [...currentSelected, optionValue]
                      : currentSelected.filter((i) => i !== optionValue);
                    if (
                      isAdding &&
                      getTechnicianOrderCount(technicianGroups, optionValue) === 0
                    ) {
                      setOnlyTechniciansWithOS(false);
                    }
                    const updatedFilters = applyAutomaticFilters('tecnico', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      tecnico: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  emptyMessage="Nenhum técnico encontrado"
                />
                */}
                <BoardToolbarTecnicosClickUpChip
                  options={getFilterOptions('tecnico')}
                  selected={selectedFilterItems.tecnico}
                  disabled={isLoadingTechnicians || isLoadingAreas}
                  isOpen={openModal === 'tecnico'}
                  onOpenChange={(open) => setOpenModal(open ? 'tecnico' : null)}
                  onToggleAll={(keys, allMarked) => {
                    const current = selectedFilterItems.tecnico || [];
                    const newSelection = allMarked
                      ? current.filter((t) => !keys.includes(t))
                      : Array.from(new Set([...current, ...keys]));
                    if (!allMarked) {
                      keys.forEach((name) => {
                        if (
                          !current.includes(name) &&
                          getTechnicianOrderCount(technicianGroups, name) === 0
                        ) {
                          setOnlyTechniciansWithOS(false);
                        }
                      });
                    }
                    const updatedFilters = applyAutomaticFilters('tecnico', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      tecnico: newSelection,
                      ...updatedFilters,
                    });
                  }}
                  onToggleItem={(optionValue) => {
                    const currentSelected = selectedFilterItems.tecnico || [];
                    const isAdding = !currentSelected.includes(optionValue);
                    const newSelection = isAdding
                      ? [...currentSelected, optionValue]
                      : currentSelected.filter((i) => i !== optionValue);
                    if (
                      isAdding &&
                      getTechnicianOrderCount(technicianGroups, optionValue) === 0
                    ) {
                      setOnlyTechniciansWithOS(false);
                    }
                    const updatedFilters = applyAutomaticFilters('tecnico', newSelection);
                    setSelectedFilterItems({
                      ...selectedFilterItems,
                      tecnico: newSelection,
                      ...updatedFilters,
                    });
                  }}
                />
              </div>

            </div>

            <div className="search-container board-toolbar-right">
              <div className="board-toolbar-actions-group">
              {currentUser && (
                <>
                  {Number(currentUser.verve_customers_module) === 1 &&
                  currentUser.type !== '3' &&
                  currentUser.type !== 3 ? (
                    <BoardChatToolbarButton
                      onOpenOrderDetails={(orderId, opts) =>
                        handleOpenOrderDetailsV2FromContext(
                          orderId,
                          { source: 'open', ...opts },
                          setSelectedOrderForDetailsMock
                        )
                      }
                      onEncaminharOs={(osId, meta) => {
                        const id = String(osId || '').trim();
                        if (!id) return;
                        setBoardEncaminharFlow({
                          orderIds: [id],
                          source: 'open',
                          fromTechnician: '',
                          fromGroup: 'Em Aberto',
                          chatConversationId:
                            meta?.conversationId != null
                              ? String(meta.conversationId)
                              : null,
                        });
                      }}
                      canAccessCadastro={
                        Number(currentUser.customers_users_reg) === 1 ||
                        Number(currentUser.customers_users_reg_only) === 1
                      }
                      openOrderGroups={availableOrdersState}
                      emAbertoStatusFilter={selectedColumnFilters.status}
                      onMenuOpenChange={(open) => {
                        if (open) {
                          setShowRefreshContextMenu(false);
                          setShowFuturaBellMenu(false);
                        }
                      }}
                      onFilterNovosChamados={(statusNome) => {
                        const nome = String(statusNome || '').trim();
                        setSelectedColumnFilters((prev) => ({
                          ...prev,
                          status: nome ? [nome] : [],
                        }));
                      }}
                    />
                  ) : null}
                  <BoardToolbarRefreshClickUpButton
                    onClick={() => refreshData(false)}
                    disabled={isRefreshing}
                    isRefreshing={isRefreshing}
                  />
                </>
              )}
              <BoardToolbarMenuClickUpButton
                onClick={() => {
                  setShowFuturaBellMenu(false);
                  setShowRefreshContextMenu((prev) => !prev);
                }}
                disabled={isRefreshing && !isAutoRefreshing}
                isRefreshing={isRefreshing && !isAutoRefreshing}
                isOpen={showRefreshContextMenu}
                isAutoRefreshEnabled={isAutoRefreshEnabled}
                timerElementRef={timerElementRef}
              />
              {currentUser && futuraRetornoTabsEnabled ? (
                <FuturaRetornoBoardBellFilterButton
                  tabsEnabled
                  mode={futuraRetornoBellForUi.mode}
                  techniciansSummary={futuraRetornoBellForUi.rows}
                  onTechnicianColumnActivate={handleFuturaBellTechnicianColumnActivate}
                  open={showFuturaBellMenu}
                  onOpenChange={(next) => {
                    if (next) setShowRefreshContextMenu(false);
                    setShowFuturaBellMenu(next);
                  }}
                />
              ) : null}

                {/* Dropdown de opções de atualização */}
                {showRefreshContextMenu && (
                  <div className="refresh-context-menu">
                    <div className="refresh-context-menu-section-title">Ordens de Serviço</div>
                    {/* Backup: Abrir OS v1 — reativar se necessário
                    {currentUser && currentUser.asstec_openos === 1 && (
                    <div
                      className="refresh-context-menu-item"
                      onClick={() => {
                        setShowRefreshContextMenu(false);
                        setShowOpenOSModal(true);
                      }}
                    >
                      <span className="refresh-context-menu-item-main">
                        <Headset size={16} aria-hidden />
                        <span>Abrir OS</span>
                      </span>
                      <span className="refresh-context-menu-kbd-wrap" aria-hidden>
                        <kbd className="refresh-context-menu-kbd">Ctrl</kbd>
                        <span className="refresh-context-menu-kbd-sep">+</span>
                        <kbd className="refresh-context-menu-kbd">O</kbd>
                      </span>
                    </div>
                    )}
                    */}
                    {currentUser && currentUser.asstec_openos === 1 && (
                    <div
                      className="refresh-context-menu-item"
                      onClick={() => {
                        setShowRefreshContextMenu(false);
                        setShowOpenOsV2Mock(true);
                      }}
                    >
                      <span className="refresh-context-menu-item-main">
                        <Headset size={16} aria-hidden />
                        <span>Abrir OS</span>
                      </span>
                      <span className="refresh-context-menu-kbd-wrap" aria-hidden>
                        <kbd className="refresh-context-menu-kbd">Ctrl</kbd>
                        <span className="refresh-context-menu-kbd-sep">+</span>
                        <kbd className="refresh-context-menu-kbd">O</kbd>
                      </span>
                    </div>
                    )}
                    <div className="refresh-context-menu-checkbox-wrap">
                      <BoardOnlyTechniciansWithOSCheckbox
                        checked={onlyTechniciansWithOS}
                        onChange={setOnlyTechniciansWithOS}
                        disabled={boardVisibleTechnicians.length === 0}
                      />
                    </div>
                    <BoardFiltrarSLATrigger
                      filterActive={!!slaFiltrarConfig}
                      disabled={slaFiltrarLoading}
                      onOpen={() => {
                        setShowRefreshContextMenu(false);
                        setShowFiltrarSLAModal(true);
                      }}
                    />
                    <BoardTechnicianViewSubmenu
                      onOpen={() => {
                        setShowRefreshContextMenu(false);
                        setShowTechnicianViewModal(true);
                      }}
                    />

                    <div className="refresh-context-menu-section-title">Equipamentos</div>
                    <div
                      className="refresh-context-menu-item"
                      onClick={() => {
                        setShowRefreshContextMenu(false);
                        setEquipmentConsultSearchMountKey((k) => k + 1);
                        setShowEquipmentConsultSearchModal(true);
                      }}
                    >
                      <span className="refresh-context-menu-item-main">
                        <ScanSearch size={16} aria-hidden />
                        <span>Consultar equipamento</span>
                      </span>
                      <span className="refresh-context-menu-kbd-wrap" aria-hidden>
                        <kbd className="refresh-context-menu-kbd">Ctrl</kbd>
                        <span className="refresh-context-menu-kbd-sep">+</span>
                        <kbd className="refresh-context-menu-kbd">E</kbd>
                      </span>
                    </div>

                    <div className="refresh-context-menu-section-title">Consultas</div>
                    <div
                      className="refresh-context-menu-item"
                      onClick={() => {
                        setShowRefreshContextMenu(false);
                        navigate(ROADMAP_SCHEDULE_ROUTE);
                      }}
                    >
                      <span className="refresh-context-menu-item-main">
                        <CalendarClock size={16} aria-hidden />
                        <span>Agendamentos</span>
                      </span>
                    </div>

                    <div className="refresh-context-menu-section-title">Atualização</div>
                    <div
                      className="refresh-context-menu-item refresh-context-menu-item--check"
                      onClick={() => {
                        const nextValue = !isAutoRefreshEnabled;
                        setIsAutoRefreshEnabled(nextValue);
                        if (nextValue) {
                          setAutoRefreshRemaining(4 * 60);
                        }
                        setShowRefreshContextMenu(false);
                      }}
                    >
                      <input
                        type="checkbox"
                        className="refresh-context-menu-check-native"
                        checked={isAutoRefreshEnabled}
                        onChange={(e) => {
                          const nextValue = e.target.checked;
                          setIsAutoRefreshEnabled(nextValue);
                          if (nextValue) {
                            setAutoRefreshRemaining(4 * 60);
                          }
                        }}
                        tabIndex={-1}
                        aria-hidden
                      />
                      <span className="refresh-context-menu-check-box" aria-hidden />
                      <span>Atualizar de 4 em 4 minutos</span>
                    </div>
                  </div>
                )}
              </div>
              <span className="board-toolbar-separator" aria-hidden="true">|</span>
              <BoardSearchWithFilters
                useClickUpToolbarUi
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                selectedColumnFilters={selectedColumnFilters}
                setSelectedColumnFilters={setSelectedColumnFilters}
                selectedTechnicianColumnFilters={selectedTechnicianColumnFilters}
                setSelectedTechnicianColumnFilters={setSelectedTechnicianColumnFilters}
                initialColumnFiltersState={initialColumnFiltersState}
                initialTechnicianColumnFiltersState={initialTechnicianColumnFiltersState}
                citiesWithCounts={citiesWithCounts}
                bairrosWithCounts={bairrosWithCounts}
                clientesWithCounts={clientesWithCounts}
                tiposOSWithCounts={tiposOSWithCounts}
                slasWithCounts={slasWithCounts}
                equipamentosWithCounts={equipamentosWithCounts}
                statusWithCounts={statusWithCounts}
                tecnicoInicialWithCounts={tecnicoInicialWithCounts}
                defeitoDescricaoWithCounts={defeitoDescricaoWithCounts}
                defeitoAlertWithCounts={defeitoAlertWithCounts}
                defeitoClassificationWithCounts={defeitoClassificationWithCounts}
                defeitoSeverityWithCounts={defeitoSeverityWithCounts}
                technicianGroups={technicianGroups}
                getTechnicianOrdersForCounts={getFilteredTechnicianOrdersForCounts}
                getEmAbertoCountsForPicker={getEmAbertoCountsForPicker}
                futuraOrders={futuraOrdersBoardSearch}
                retornoCountConfig={{
                  codstatusRetorno: codstatusRetornoEmAberto,
                  extraRetornoStatuses: extraRetornoStatusesEmAberto,
                  codstatusPedidoVinculado: codstatusPedidoVinculadoDisponivel,
                }}
                hasVisibleTechnicianColumns={boardVisibleTechnicians.length > 0}
              />
            </div>

            {/* Indicador de loading para operações de drag & drop */}
            {isDragDropProcessing && (
              <div
                className={`drag-drop-loading-overlay${selectedOrderForDetails || selectedOrderForDetailsV2 ? ' drag-drop-loading-overlay--above-order-details' : ''}`}
              >
                <div className="drag-drop-loading-modal">
                  <div className="loading-spinner"></div>
                  <div className="loading-text">
                    <h3>{dragDropMessage}</h3>
                    {dragDropProgress.total > 0 && (
                      <div className="progress-info">
                        <div className="progress-bar">
                          <div 
                            className="progress-fill" 
                            style={{ width: `${(dragDropProgress.current / dragDropProgress.total) * 100}%` }}
                          ></div>
                        </div>
                        <span className="progress-text">
                          {dragDropProgress.current} de {dragDropProgress.total} processadas
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          </div>

          <div className="board-section board-section--footer-bar" style={{ position: 'relative' }}>
            <div className="board-section-kanban-wrap">
            {slaFiltrarLoading && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'rgba(255,255,255,0.85)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1000,
                  borderRadius: '8px'
                }}
              >
                <span style={{ fontFamily: "'Geist Variable', 'Geist', system-ui, sans-serif", fontSize: '13px', color: '#4a5568' }}>
                  Processando...
                </span>
                <span style={{ width: 18, height: 18, border: '2px solid #e2e8f0', borderTopColor: '#7c4dff', borderRadius: '50%', animation: 'spin 0.8s linear infinite', display: 'inline-block', marginLeft: 8 }} />
              </div>
            )}
            <div className="kanban-board">
              {/* Coluna fixa "Em aberto" */}
              <OpenColumnBoard
                orderCount={openColumnOrderCount}
                customersCount={openColumnCustomersCount}
                isRefreshing={isRefreshingOpenColumn}
                isDragOver={isDragOverOpen}
                hasStatusColumn={showStatusColumnEmAberto}
                collapsed={openColumnCollapsed}
                onCollapsedChange={(next) => {
                  setOpenColumnCollapsed(next);
                  persistBoardViewPrefs(API_BASE_URL, {
                    open_column_minimized: next ? 1 : 0,
                  });
                  setCurrentUser((prev) => {
                    if (!prev) return prev;
                    const updated = { ...prev, open_column_minimized: next ? 1 : 0 };
                    try {
                      localStorage.setItem('userData', JSON.stringify(updated));
                    } catch (_) { /* ignore */ }
                    return updated;
                  });
                }}
                bodyScrollRef={openColumnScrollRef}
                onDrop={(e) => {
                  e.preventDefault();
                  console.log(`🎯 Drop detectado na coluna "Em aberto"`);
                  const fromTechnician = e.dataTransfer.getData('fromTechnician');
                  const fromTechnicianName = e.dataTransfer.getData('fromTechnicianName');
                  const fromGroup = e.dataTransfer.getData('fromGroup');
                  const ordersToReturn = getBoardDragOrderIds(e.dataTransfer, selectedOrders);
                  console.log(`📋 Dados recebidos: orderIds=${ordersToReturn.join(',')}, fromTechnician=${fromTechnician}`);

                  if (fromTechnician === 'true' && ordersToReturn.length > 0) {
                    ordersToReturn.forEach((id) => {
                      logDragDrop({
                        userId: currentUser?.id,
                        userName: currentUser?.name || currentUser?.username,
                        tenantId: currentUser?.clientId ?? 1,
                        ordemId: id,
                        origem: fromTechnicianName || 'Técnico',
                        destino: 'Em aberto',
                        sessaoOrigem: fromGroup || null,
                        sessaoDestino: null,
                        tecnicoCurrent: fromTechnicianName || null,
                        tecnicoNovo: null,
                      });
                    });
                    handleReturnToOpen(ordersToReturn);
                  } else {
                    console.log(`❌ Drop ignorado: fromTechnician=${fromTechnician}, orderIds=${ordersToReturn.join(',')}`);
                  }
                  setIsDragOverOpen(false);
                }}
                onDragOver={(e) => {
                  const types = Array.from(e.dataTransfer.types || []);
                  const isColumnReorder = types.includes('columnIndex') && types.includes('dragType');
                  if (isColumnReorder) return;
                  e.preventDefault();
                  setIsDragOverOpen(true);
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = e.clientX;
                  const y = e.clientY;
                  if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
                    setIsDragOverOpen(false);
                  }
                }}
                onDragEnd={() => {
                  setIsDragOverOpen(false);
                }}
              >
                <OpenColumnVirtualCityList
                  groups={getGroupedByCity}
                  scrollElementRef={openColumnScrollRef}
                >
                  {(group) => (
                    <OpenColumnCityGroup
                      cidade={group.cidade}
                      ordens={group.ordens}
                      codstatusRetorno={codstatusRetornoEmAberto}
                      extraRetornoStatuses={extraRetornoStatusesEmAberto}
                      openCityDropdown={openCityDropdown}
                      onToggleCityDropdown={(c) => setOpenCityDropdown((prev) => (prev === c ? null : c))}
                      selectedOrders={selectedOrders}
                      onSelectAllOrdersFromCity={selectAllOrdersFromCity}
                      onOrderClick={(ordem) => handleOrderClick(ordem)}
                      onSetContextMenu={openBoardOrderContextMenu}
                      onDragStartEnsureSelection={(id) => setSelectedOrders([id])}
                      onBoardOrderDragStart={handleBoardOrderDragStart}
                      onBoardOrderDragEnd={handleBoardOrderDragEnd}
                      userShowOSConfig={userShowOSConfig}
                      onBoardCellTooltip={setBoardCellTooltip}
                      showStatusColumnEmAberto={showStatusColumnEmAberto}
                    />
                  )}
                </OpenColumnVirtualCityList>
              </OpenColumnBoard>

              {/* Área scrollável para colunas de técnicos */}
              <div className="kanban-scrollable-area">
                {/* Mostrar colunas de técnicos apenas quando há filtros de equipe ativos; com busca, só colunas com resultados */}
                {hasActiveTeamFilters && isBoardColumnsHydrating && (
                  <BoardTechnicianColumnsSkeleton />
                )}
                {hasActiveTeamFilters && !isBoardColumnsHydrating && boardTechnicianColumnSlots.map((technician, index) => {
                  const stackedMembers = normalizeStackMembers(technicianColumnStacks[technician]);
                  const stackTechs = [technician, ...stackedMembers];
                  if (stackTechs.length < 2) {
                    return renderBoardTechnicianColumn({
                      key: technician,
                      technician,
                      orders: techniqueColumns[technician] || [],
                      index,
                      visibleTechniciansForDragOrder: boardTechnicianColumnSlots,
                      onMinimizeTechnician: minimizeTechnicianColumn,
                    });
                  }
                  return (
                    <TechnicianStackedColumnResizable
                      key={`${technician}__stack`}
                      hostKey={technician}
                      panels={stackTechs.map((stackTech, stackIndex) =>
                        renderBoardTechnicianColumn({
                          key: `${technician}__${stackTech}`,
                          technician: stackTech,
                          orders: techniqueColumns[stackTech] || [],
                          index,
                          visibleTechniciansForDragOrder: boardTechnicianColumnSlots,
                          onMinimizeTechnician: minimizeTechnicianColumn,
                          isStackHalf: true,
                          isStackBottom: stackIndex === stackTechs.length - 1,
                          hostTechnicianForUnstack:
                            stackIndex === stackTechs.length - 1 ? technician : null,
                        })
                      )}
                    />
                  );
                })}

                {/* Indicador quando não há filtros de equipe ativos */}
                {!hasActiveTeamFilters && (
                  <div className="technician-columns-placeholder">
                    <div className="placeholder-content">
                      <i className="bi bi-people"></i>
                      <p className="placeholder-title">Colunas de Técnicos</p>
                      <p className="placeholder-description">
                        Aplique filtros de <strong>Coordenador</strong>, <strong>Área</strong> ou <strong>Técnicos</strong> 
                        para visualizar as colunas dos técnicos relacionados
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            </div>
            <div className="board-min-bar-shell">
            <BoardMinimizedTechniciansBar
              minimizedOrdered={minimizedOrderedForBar}
              getHojeCount={getTechHojeCountForMinBar}
              getCompletedCount={getTechCompletedCountForMinBar}
              onRestore={restoreTechnicianColumn}
            />
            </div>
          </div>
        </>
      )}

      {/* Seção Monitoramento */}
      {activeSection === 'Monitoramento' && (
        <MonitoramentoPage currentUser={currentUser} />
      )}

      {/* Seção Oficina */}
      {activeSection === 'Oficina' && (
        <OficinaView 
          apiBaseUrl={API_BASE_URL} 
          onDataSourceReady={() => {
            if (currentUser?.type === '3' || currentUser?.type === 3) {
              setDataSource('sql_server');
            }
          }}
        />
      )}
              </>
            )
          }
        />
      </Routes>

      {/* Renderizar todos os modais de menu de técnicos */}
      <TechnicianMenuModals
        showTechnicianMenu={showTechnicianMenu}
        technicianMenuPositions={technicianMenuPositions}
        technicianMenuPrevisaoOpen={technicianMenuPrevisaoOpen}
        setShowTechnicianMenu={setShowTechnicianMenu}
        setTechnicianMenuPrevisaoOpen={setTechnicianMenuPrevisaoOpen}
        technicianFilters={technicianFilters}
        toggleTechnicianFilter={toggleTechnicianFilter}
        onRefreshTechnician={refreshTechnicianData}
        onViewTechnicianRoute={handleViewTechnicianRoute}
        onOpenTodayRoute={(technician) => {
          setShowTodayRouteModal((prev) => ({ ...prev, [technician]: true }));
        }}
        onOpenNovoPainel={(technician, opts) => {
          setTechnicianPanelMock({
            open: true,
            technician,
            initialTab: opts?.tab || null,
            initialMapMode: opts?.mapMode || null,
          });
        }}
        user={currentUser}
      />

      {/* Modal do roteiro de hoje */}
      {Object.entries(showTodayRouteModal).map(([technician, isOpen]) => {
        if (!isOpen) return null;
        
        return (
          <TodayRouteModal
            key={technician}
            technician={technician}
            isOpen={isOpen}
            onClose={() => setShowTodayRouteModal(prev => ({ ...prev, [technician]: false }))}
          />
        );
      })}

      <TechnicianPanelMockModal
        isOpen={Boolean(technicianPanelMock.open)}
        technician={technicianPanelMock.technician}
        technicianId={
          technicianPanelMock.technician
            ? getTechnicianIdByName(technicianPanelMock.technician)
            : null
        }
        openCount={
          technicianPanelMock.technician
            ? (technicianGroups[technicianPanelMock.technician]?.['Previsto para hoje']?.length || 0)
            : 0
        }
        closedCount={
          technicianPanelMock.technician
            ? (technicianCompletedCounts[technicianPanelMock.technician] || 0)
            : 0
        }
        goIdProduto={currentUser?.go_id_produto ?? null}
        chatUserName={currentUser?.name || currentUser?.username || ''}
        initialTab={technicianPanelMock.initialTab || null}
        initialMapMode={technicianPanelMock.initialMapMode || null}
        onClose={() =>
          setTechnicianPanelMock({ open: false, technician: null, initialTab: null, initialMapMode: null })
        }
      />

      {currentUser ? <RoadmapSchedulePage currentUser={currentUser} /> : null}

      {/* Modal de rota do técnico */}
      <RouteModal 
        isOpen={showRouteModal}
        routeData={routeModalData}
        loading={routeModalLoading}
        error={routeModalError}
        onClose={handleCloseRouteModal}
      />

      <OrderDetailsMockOverlay
        isOpen={!!selectedOrderForDetailsMock}
        order={selectedOrderForDetailsMock}
        statusUptodate={boardStatusUptodate}
        onClose={() => setSelectedOrderForDetailsMock(null)}
        codstatusRetorno={codstatusRetornoEmAberto}
        onDadosEquipamento={(orderData) => {
          setSelectedEquipmentData(orderData);
          setShowEquipmentSidebar(true);
        }}
        canEncaminharChamado={orderDetailsCanEncaminharChamado}
        onEncaminharChamado={(_anchor) => {
          const cfg = buildEncaminharPanelConfig(
            selectedOrderForDetailsMock,
            areasWithTechniciansForContextMenu,
            resolveOrderDetailFromBoardCaches
          );
          if (!cfg) return;
          setOrderDetailsEncaminharV2Panel(null);
          setBoardEncaminharFlow({
            orderIds: (cfg.orderIds || [cfg.orderId]).map((id) => String(id)),
            source: cfg.source || 'open',
            fromTechnician: cfg.fromTechnician || '',
            fromGroup: cfg.fromGroup || (cfg.source === 'open' ? 'Em Aberto' : 'Previsto para hoje'),
          });
        }}
        encaminharPanel={orderDetailsEncaminharV2Panel}
        onEncaminharPanelClose={() => setOrderDetailsEncaminharV2Panel(null)}
        onEncaminharConfirm={({ technicianName, sessaoId, groupName }) => {
          if (!orderDetailsEncaminharV2Panel) return;
          const { orderIds, fromTechnician, fromGroup, source } = orderDetailsEncaminharV2Panel;
          setOrderDetailsEncaminharV2Panel(null);
          if (sessaoId === 'futura') {
            handleOpenFutureModalContextMenu({
              technicianName,
              orderIds,
              fromGroup: fromGroup || 'Previsto para hoje',
              fromTechnicianName: fromTechnician,
            });
            return;
          }
          if (source === 'open') {
            handleDropToTechnique(technicianName, groupName, orderIds);
          } else {
            handleMoveOrderContextMenu(orderIds, fromTechnician, fromGroup, technicianName, groupName);
          }
        }}
        onMotivoUpdated={(novoMotivo) => {
          setSelectedOrderForDetailsMock((prev) =>
            prev ? { ...prev, motivoOS: novoMotivo, TB02115_NOME: novoMotivo } : null
          );
        }}
        onAddressUpdated={(addr) => {
          if (!addr) return;
          setSelectedOrderForDetailsMock((prev) =>
            prev
              ? {
                  ...prev,
                  TB02115_END: addr.logradouro,
                  TB02115_NUM: addr.numero,
                  TB02115_COMP: addr.complemento,
                  TB02115_BAIRRO: addr.bairro,
                  TB02115_CIDADE: addr.cidade,
                  TB02115_ESTADO: addr.estado,
                  TB02115_CEP: addr.cep,
                  endereco: addr.endereco || prev.endereco,
                  cidade: addr.cidade || prev.cidade,
                }
              : null
          );
        }}
        onLocalizacaoUpdated={(localizacao) => {
          setSelectedOrderForDetailsMock((prev) =>
            prev ? { ...prev, TB02115_LOCAL: localizacao ?? '' } : null
          );
        }}
        onSolicitanteUpdated={(saved) => {
          if (!saved) return;
          setSelectedOrderForDetailsMock((prev) =>
            prev
              ? {
                  ...prev,
                  solicitante: saved.solicitanteExibicao || saved.solicitante || prev.solicitante,
                  TB02115_FONE2: saved.fone2 || null,
                  TB02115_CELULAR: saved.celular || null,
                }
              : null
          );
        }}
        isAdminUser={currentUser?.type === '1' || currentUser?.type === 1}
        hasCustomersModule={Number(currentUser?.verve_customers_module) === 1}
        onTipoUpdated={(code, label) => {
          setSelectedOrderForDetailsMock((prev) =>
            prev
              ? {
                  ...prev,
                  tipo: code,
                  TB02115_PREVENTIVA: code,
                  tipoLabel: label,
                }
              : null
          );
        }}
        onReturnToPendenteSuccess={async ({ technician }) => {
          if (technician) {
            setFuturaRetornoHeaderTabByTechnician((prev) => ({
              ...prev,
              [technician]: 'pendente',
            }));
          }
          window.setTimeout(() => setSelectedOrderForDetailsMock(null), 900);
          if (technician) {
            try {
              await refreshTechnicianData(technician);
            } catch (_) {
              /* silencioso */
            }
          }
        }}
      />

      {/* Modal de detalhes da ordem de serviço */}
      {selectedOrderForDetailsV2 && (
        <OrderDetailsModalV2
          order={selectedOrderForDetailsV2}
          statusUptodate={boardStatusUptodate}
          onClose={() => setSelectedOrderForDetailsV2(null)}
          codstatusRetorno={codstatusRetornoEmAberto}
          onDadosEquipamento={(orderData) => {
            setSelectedEquipmentData(orderData);
            setShowEquipmentSidebar(true);
          }}
          canEncaminharChamado={orderDetailsCanEncaminharChamado}
          onEncaminharChamado={(_anchor) => {
            // Mesmas premissas do botão direito: todos os técnicos da equipe, com/sem OS e coluna.
            const cfg = buildEncaminharPanelConfig(
              selectedOrderForDetailsV2,
              areasWithTechniciansForContextMenu,
              resolveOrderDetailFromBoardCaches
            );
            if (!cfg) return;
            // Fecha painel legado se houver e dispara o mesmo fluxo do Encaminhar (board).
            setOrderDetailsEncaminharV2Panel(null);
            setBoardEncaminharFlow({
              orderIds: (cfg.orderIds || [cfg.orderId]).map((id) => String(id)),
              source: cfg.source || 'open',
              fromTechnician: cfg.fromTechnician || '',
              fromGroup: cfg.fromGroup || (cfg.source === 'open' ? 'Em Aberto' : 'Previsto para hoje'),
            });
          }}
          encaminharPanel={orderDetailsEncaminharV2Panel}
          onEncaminharPanelClose={() => setOrderDetailsEncaminharV2Panel(null)}
          onEncaminharConfirm={({ technicianName, sessaoId, groupName }) => {
            if (!orderDetailsEncaminharV2Panel) return;
            const { orderIds, fromTechnician, fromGroup, source } = orderDetailsEncaminharV2Panel;
            setOrderDetailsEncaminharV2Panel(null);
            if (sessaoId === 'futura') {
              handleOpenFutureModalContextMenu({
                technicianName,
                orderIds,
                fromGroup: fromGroup || 'Previsto para hoje',
                fromTechnicianName: fromTechnician,
              });
              return;
            }
            if (source === 'open') {
              handleDropToTechnique(technicianName, groupName, orderIds);
            } else {
              handleMoveOrderContextMenu(orderIds, fromTechnician, fromGroup, technicianName, groupName);
            }
          }}
          onMotivoUpdated={(novoMotivo) => {
            setSelectedOrderForDetailsV2((prev) =>
              prev ? { ...prev, motivoOS: novoMotivo, TB02115_NOME: novoMotivo } : null
            );
          }}
          isAdminUser={currentUser?.type === '1' || currentUser?.type === 1}
          hasCustomersModule={Number(currentUser?.verve_customers_module) === 1}
          onTipoUpdated={(code, label) => {
            setSelectedOrderForDetailsV2((prev) =>
              prev
                ? {
                    ...prev,
                    tipo: code,
                    TB02115_PREVENTIVA: code,
                    tipoLabel: label,
                  }
                : null
            );
          }}
          onReturnToPendenteSuccess={async ({ technician }) => {
            if (technician) {
              setFuturaRetornoHeaderTabByTechnician((prev) => ({
                ...prev,
                [technician]: 'pendente',
              }));
            }
            window.setTimeout(() => setSelectedOrderForDetailsV2(null), 900);
            if (technician) {
              try {
                await refreshTechnicianData(technician);
              } catch (_) {
                /* silencioso */
              }
            }
          }}
        />
      )}

      {/* Modal v1 — rollback: descomentar bloco abaixo e restaurar duplo clique em handleOrderClick
      {selectedOrderForDetails && (
        <OrderDetailsModal
          order={selectedOrderForDetails}
          statusUptodate={boardStatusUptodate}
          onClose={() => setSelectedOrderForDetails(null)}
          onMotivoUpdated={(novoMotivo) => {
            setSelectedOrderForDetails((prev) =>
              prev ? { ...prev, motivoOS: novoMotivo, TB02115_NOME: novoMotivo } : null
            );
          }}
          codstatusRetorno={codstatusRetornoEmAberto}
          onConsultarPedido={(pedidoCodigo) => {
            setSelectedPedidoCodigo(pedidoCodigo);
            setSelectedOrderData(selectedOrderForDetails);
            setShowOrderSidebar(true);
            fetchPedidoDetails(pedidoCodigo);
          }}
          onDadosEquipamento={(orderData) => {
            setSelectedEquipmentData(orderData);
            setShowEquipmentSidebar(true);
          }}
          canEncaminharChamado={orderDetailsCanEncaminharChamado}
          onEncaminharChamado={(rect) => {
            setOrderDetailsEncaminharMenu({ x: rect.left, y: rect.top - 4 });
          }}
        />
      )}
      */}

      {orderDetailsEncaminharMenu && selectedOrderForDetails && !selectedOrderForDetailsV2 && (() => {
        const orderRef = selectedOrderForDetails || selectedOrderForDetailsV2;
        const id = String(orderRef.id ?? orderRef.TB02115_CODIGO ?? '').trim();
        if (!id) return null;
        const found = resolveOrderDetailFromBoardCaches(id);
        const fg = String(orderRef.forecastGroup || found?.forecastGroup || '').trim();
        const isEmAberto = fg.toLowerCase() === 'em aberto';
        const boardTech = orderRef.detailModalBoardTechnician || found?.boardTechnician || '';
        if (!isEmAberto && !boardTech) return null;
        const source = isEmAberto ? 'open' : 'technician';
        const areasMapped = (areasWithTechniciansForContextMenu || []).map((area) => {
          if (source === 'open') {
            return {
              ...area,
              technicians: (area.technicians || []).filter((name) => Boolean(name && String(name).trim())),
            };
          }
          return {
            ...area,
            technicians: (area.technicians || []).filter((name) => {
              if (!name) return false;
              const normalizedName = String(name).trim().toLowerCase();
              const normalizedCurrent = String(boardTech || '').trim().toLowerCase();
              return normalizedName && normalizedName !== normalizedCurrent;
            }),
          };
        }).filter((area) => (area.technicians || []).length > 0);
        if (!areasMapped.length) return null;
        const encaminharItem = getAlterarTecnicoMenuItem({
          areasWithTechnicians: areasMapped,
          orderIds: [id],
          fromTechnician: source === 'open' ? '' : boardTech,
          fromGroup: fg || undefined,
          menuId: 'encaminhar-chamado',
          menuLabel: 'Encaminhar chamado',
          menuIconNode: <Forward size={14} strokeWidth={2} aria-hidden />,
          onMoveOrder: (orderIds, fromTech, fromGroup, toTech, toGroupName) => {
            setOrderDetailsEncaminharMenu(null);
            if (source === 'open') {
              handleDropToTechnique(toTech, toGroupName, orderIds);
            } else {
              handleMoveOrderContextMenu(orderIds, fromTech, fromGroup, toTech, toGroupName);
            }
          },
          onOpenFutureModal: (data) => {
            setOrderDetailsEncaminharMenu(null);
            handleOpenFutureModalContextMenu(data);
          },
          disabled: false,
        });
        const isV2Encaminhar = Boolean(orderDetailsEncaminharMenu.openSubmenuOnClick);
        const items =
          isV2Encaminhar && encaminharItem.subItems?.length
            ? encaminharItem.subItems
            : [encaminharItem];
        return (
          <BoardOrderContextMenu
            key={`encaminhar-detail-${id}`}
            visible
            x={orderDetailsEncaminharMenu.x}
            y={orderDetailsEncaminharMenu.y}
            menuZIndex={26010}
            submenuGap={0}
            submenuCloseDelayMs={320}
            submenuPreferLeft={Boolean(orderDetailsEncaminharMenu.preferLeft)}
            submenuOpenOnClick={Boolean(orderDetailsEncaminharMenu.openSubmenuOnClick)}
            menuClassName={isV2Encaminhar ? 'board-order-context-menu--mono' : ''}
            initialOpenSubmenuId={
              orderDetailsEncaminharMenu.openSubmenuOnClick ? null : 'encaminhar-chamado'
            }
            portalRoot={typeof document !== 'undefined' ? document.body : null}
            items={items}
            onClose={() => setOrderDetailsEncaminharMenu(null)}
          />
        );
      })()}

      {/* Barra lateral do pedido */}
      <OrderSidebar 
        order={selectedOrderData}
        selectedPedidoCodigo={selectedPedidoCodigo}
        isOpen={showOrderSidebar}
        onClose={() => {
          setShowOrderSidebar(false);
          setSelectedPedidoCodigo(null);
          setPedidoDetails(null);
          setPedidoError(null);
          setLoadingPedido(false);
          setShowTimeline(false);
          setTimelineData(null);
          setTimelineError(null);
          setLoadingTimeline(false);
        }}
      />

      {/* Barra lateral do equipamento */}
      <EquipmentSidebar 
        order={selectedEquipmentData}
        isOpen={showEquipmentSidebar}
        onClose={() => {
          setShowEquipmentSidebar(false);
          setSelectedEquipmentData(null);
        }}
      />

      {/* Dentro de .app para herdar tokens theme-dark */}
      <OpenOSModal 
        isOpen={showOpenOSModal} 
        onClose={() => {
          setShowOpenOSModal(false);
        }}
        API_BASE_URL={API_BASE_URL}
        onViewBoardOrderDetails={handleViewOrderDetailsFromOpenOsModal}
        onOSCreated={(osData) => {
          // Se a OS foi programada, atualizar coluna do técnico
          // Caso contrário, atualizar coluna "Em aberto"
          if (osData && osData.scheduled && osData.technicianId) {
            refreshTechnicianColumn(osData.technicianId);
          } else {
            refreshOpenOrders();
          }
        }}
      />

      <OpenOsV2MockOverlay
        isOpen={!!showOpenOsV2Mock && Number(currentUser && currentUser.asstec_openos) === 1}
        goIdProduto={currentUser?.go_id_produto ?? null}
        restrictOpenOsByUserTypes={Number(currentUser?.asstec_openos_type_only) === 1}
        userOsTypesLoad={currentUser?.os_types || null}
        onClose={() => setShowOpenOsV2Mock(false)}
        onViewOs={(orderId, ctx) =>
          handleOpenOrderDetailsV2FromContext(orderId, ctx || { source: 'open' }, setSelectedOrderForDetailsMock)
        }
        onOSCreated={(osData) => {
          if (osData && osData.scheduled && osData.technicianId) {
            refreshTechnicianColumn(osData.technicianId);
          } else {
            refreshOpenOrders();
          }
        }}
      />

      </div>

      {/* Modal de status das ordens */}
      <OrderStatusModal 
        isOpen={showOrderStatusModal}
        results={orderStatusResults}
        summary={orderStatusSummary}
        onClose={() => {
          setShowOrderStatusModal(false);
          setSelectedOrderForDetails(null);
          setSelectedOrderForDetailsV2(null);
          setOrderDetailsEncaminharMenu(null);
        }}
      />

      <BoardDragValidationModal
        isOpen={showBoardDragValidationModal}
        messages={boardDragValidationMessages}
        confirmMode={boardDragValidationMode === 'confirm'}
        onCancel={() => {
          previstoGoSyncAckRef.current = false;
          closeBoardDragValidationModal();
        }}
        onConfirm={() => {
          if (boardDragValidationMode === 'confirm') {
            const resume = boardDragConfirmResumeRef.current;
            boardDragConfirmResumeRef.current = null;
            setShowBoardDragValidationModal(false);
            setBoardDragValidationMessages([]);
            setBoardDragValidationMode('alert');
            if (typeof resume === 'function') {
              previstoGoSyncAckRef.current = true;
              resume();
            }
            return;
          }
          closeBoardDragValidationModal();
        }}
      />

      {/* Modal de seleção de data para área Futura */}
      <FutureDateModal
        isOpen={showFutureDateModal}
        data={futureDateModalData}
        overlayClassName="future-date-modal-overlay"
        onClose={() => {
          setShowFutureDateModal(false);
          setFutureDateModalData(null);
          setSelectedFutureDate(null);
          setNoDateSelected(false);
        }}
        onConfirm={(futureDateConfirmRef.current = async function handleFutureDateConfirm(date, noDate, notes, snapOverride) {
          const modalSnap = snapOverride || futureDateModalData;
          if (!modalSnap) return;

          const standbyNotes = String(notes || '').trim();
          if (noDate && standbyNotes.length < 10) {
            alert('Informe observações com no mínimo 10 caracteres.');
            return;
          }

          const { technicianName, technicianId, orderIds, fromGroup, isReprogramacao } = modalSnap;
          let futuraOrderIds = [...orderIds];
          let futuraSpecialtyRejected = [];

          // Se não há data e não foi marcado "sem data", não fazer nada
          if (!noDate && !date) {
            return;
          }

          // Saindo de Previsto para hoje → FUTURA: gate App Go offline
          if (fromGroup === 'Previsto para hoje') {
            if (!previstoGoSyncAckRef.current) {
              try {
                const goSync = await validateBoardDragPrevistoGoSync({
                  orderIds: futuraOrderIds,
                  targetSection: 'FUTURA',
                  technicianId,
                });
                if (goSync.blocked) {
                  openPrevistoGoSyncConfirm(goSync.messages, () => {
                    previstoGoSyncAckRef.current = true;
                    handleFutureDateConfirm(date, noDate, notes);
                  });
                  return;
                }
              } catch (_goErr) {
                /* segue — backend reforça no update-status */
              }
            }
          }

          // Fechar de imediato: evita bloquear a UI enquanto processa (loading/status ficam por baixo)
          setShowFutureDateModal(false);
          setFutureDateModalData(null);
          setSelectedFutureDate(null);
          setNoDateSelected(false);

          // Pré-atendimento chat: só marca encaminhado após confirmar data/técnico neste modal.
          if (modalSnap.chatConversationId && orderIds[0]) {
            try {
              await patchConversationOs(
                String(modalSnap.chatConversationId),
                String(orderIds[0]),
                { status: 'forwarded' }
              );
              notifyConversationOsUpdated(
                modalSnap.chatConversationId,
                orderIds[0],
                'forwarded'
              );
            } catch {
              /* silencioso */
            }
          }

          setIsDragDropProcessing(true);
          setDragDropProgress({ current: 0, total: orderIds.length });
          setDragDropMessage(`Processando ${orderIds.length} ordens...`);
          
          try {
            const token = localStorage.getItem('authToken');
            const sessionUserId = resolveSessionUserId(currentUser);

            // Se for reprogramação e não há data, apenas deletar da LCMY_REG_OS_STANDBY
            if (isReprogramacao && noDate) {
              console.log('🗑️ Reprogramação: removendo previsão (sem data)');
              setDragDropMessage(`Removendo previsão de ${orderIds.length} ordem(ns)...`);
              
              const removePromises = orderIds.map(async (orderId) => {
                try {
                  const removeResponse = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
                    method: 'DELETE',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      os: orderId,
                      id_tech: technicianId
                    })
                  });
                  
                  const removeResult = await removeResponse.json();
                  if (!removeResult.success) {
                    console.warn(`⚠️ Aviso ao remover previsão para ordem ${orderId}:`, removeResult.message);
                  } else {
                    console.log(`✅ Previsão removida para ordem ${orderId}`);
                  }
                  return removeResult;
                } catch (error) {
                  console.warn(`⚠️ Erro ao remover previsão para ordem ${orderId}:`, error);
                  return { success: false, error: error.message };
                }
              });
              
              await Promise.all(removePromises);

              if (!sessionUserId) {
                alert('Erro: ID do usuário não encontrado. Por favor, faça login novamente.');
                setIsDragDropProcessing(false);
                return;
              }

              setDragDropMessage(`Gravando observações em ${orderIds.length} ordem(ns)...`);
              await Promise.all(
                orderIds.map(async (orderId) => {
                  const insertResponse = await fetch(`${API_BASE_URL}/api/orders/add-standby`, {
                    method: 'POST',
                    headers: {
                      Authorization: `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      os: orderId,
                      id_tech: technicianId,
                      schedule: null,
                      id_user: sessionUserId,
                      notes: standbyNotes,
                    }),
                  });
                  const insertResult = await insertResponse.json();
                  if (!insertResult.success) {
                    throw new Error(insertResult.message || `Erro ao gravar OS ${orderId}`);
                  }
                  return insertResult;
                })
              );
              
              // Atualizar estado local - remover schedule das ordens
              const newTechnicianGroups = { ...technicianGroups };
              orderIds.forEach(orderId => {
                if (newTechnicianGroups[technicianName] && newTechnicianGroups[technicianName]['FUTURA']) {
                  const orderIndex = newTechnicianGroups[technicianName]['FUTURA'].findIndex(order => order.id === orderId);
                  if (orderIndex !== -1) {
                    const updatedOrder = { ...newTechnicianGroups[technicianName]['FUTURA'][orderIndex] };
                    delete updatedOrder.schedule;
                    newTechnicianGroups[technicianName]['FUTURA'][orderIndex] = updatedOrder;
                  }
                }
              });
              
              setTechnicianGroups(newTechnicianGroups);
              setIsDragDropProcessing(false);
              setShowFutureDateModal(false);
              setFutureDateModalData(null);
              return;
            }
            
            // Se for reprogramação e há data, atualizar na LCMY_REG_OS_STANDBY
            if (isReprogramacao && date) {
              console.log('🔄 Reprogramação: atualizando previsão');
              setDragDropMessage(`Atualizando previsão de ${orderIds.length} ordem(ns)...`);

              if (!sessionUserId) {
                console.error('❌ ID do usuário não encontrado na sessão');
                alert('Erro: ID do usuário não encontrado. Por favor, faça login novamente.');
                setIsDragDropProcessing(false);
                return;
              }

              // Converter data para formato datetime
              const [year, month, day] = date.split('-').map(Number);
              const scheduleDateUTC = new Date(Date.UTC(year, month - 1, day, 12, 0, 0, 0));
              const scheduleISOString = scheduleDateUTC.toISOString();
              
              // Remover registro antigo e inserir novo (upsert)
              const updatePromises = orderIds.map(async (orderId) => {
                try {
                  // Primeiro, remover registro antigo se existir
                  await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
                    method: 'DELETE',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      os: orderId,
                      id_tech: technicianId
                    })
                  });
                  
                  // Depois, inserir novo registro
                  const insertResponse = await fetch(`${API_BASE_URL}/api/orders/add-standby`, {
                    method: 'POST',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      os: orderId,
                      id_tech: technicianId,
                      schedule: scheduleISOString,
                      id_user: sessionUserId,
                      notes: standbyNotes
                    })
                  });
                  
                  const insertResult = await insertResponse.json();
                  if (!insertResult.success) {
                    console.error(`❌ Erro ao atualizar previsão para ordem ${orderId}:`, insertResult.message);
                    throw new Error(insertResult.message);
                  }
                  
                  console.log(`✅ Previsão atualizada para ordem ${orderId}`);
                  return insertResult;
                } catch (error) {
                  console.error(`❌ Erro ao atualizar previsão para ordem ${orderId}:`, error);
                  throw error;
                }
              });
              
              await Promise.all(updatePromises);
              
              // Atualizar estado local - atualizar schedule das ordens
              const newTechnicianGroups = { ...technicianGroups };
              const scheduleDateString = date; // date já está no formato YYYY-MM-DD
              
              orderIds.forEach(orderId => {
                if (newTechnicianGroups[technicianName] && newTechnicianGroups[technicianName]['FUTURA']) {
                  const orderIndex = newTechnicianGroups[technicianName]['FUTURA'].findIndex(order => order.id === orderId);
                  if (orderIndex !== -1) {
                    const updatedOrder = { ...newTechnicianGroups[technicianName]['FUTURA'][orderIndex] };
                    updatedOrder.schedule = scheduleDateString;
                    newTechnicianGroups[technicianName]['FUTURA'][orderIndex] = updatedOrder;
                  }
                }
              });
              
              setTechnicianGroups(newTechnicianGroups);
              setIsDragDropProcessing(false);
              setShowFutureDateModal(false);
              setFutureDateModalData(null);
              return;
            }

            if (!isReprogramacao) {
              const tidFutura = technicianId || getTechnicianIdByName(technicianName);
              if (tidFutura) {
                try {
                  const specF = await validateBoardDragSpecialty(tidFutura, futuraOrderIds);
                  futuraSpecialtyRejected = specF.rejectedOrderIds || [];
                  if (Array.isArray(specF.allowedOrderIds)) {
                    futuraOrderIds = specF.allowedOrderIds;
                  }
                } catch (_e) {
                  futuraSpecialtyRejected = [];
                }
              }
              if (futuraOrderIds.length === 0) {
                if (futuraSpecialtyRejected.length > 0) {
                  setOrderStatusResults(futuraSpecialtyRejected.map((oid) => ({
                    orderId: oid,
                    status: 'error',
                    errorMessage: BOARD_SPECIALTY_DRAG_MSG,
                    cliente: 'N/A',
                    tecnico: technicianName,
                    targetSection: 'FUTURA'
                  })));
                  setOrderStatusSummary({
                    targetSection: 'FUTURA',
                    technicianName
                  });
                  setShowOrderStatusModal(true);
                }
                setIsDragDropProcessing(false);
                setShowFutureDateModal(false);
                setFutureDateModalData(null);
                setSelectedFutureDate(null);
                setNoDateSelected(false);
                return;
              }
              setDragDropProgress({ current: 0, total: futuraOrderIds.length });
              setDragDropMessage(`Processando ${futuraOrderIds.length} ordens...`);
            }
            
            // Roteirizada (hoje ou amanhã) → FUTURA: limpar LCMY_REG_ROADMAP
            if (fromGroup === 'Previstas para amanhã' || fromGroup === 'Previsto para hoje') {
              setDragDropMessage(`Removendo roteirização de ${futuraOrderIds.length} ordem(ns)...`);
              
              const removeRoadmapPromises = futuraOrderIds.map(async (orderId) => {
                try {
                  const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
                    method: 'DELETE',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      orderNumber: orderId
                    })
                  });
                  
                  const result = await response.json();
                  
                  if (!result.success) {
                    console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
                  }
                  return result;
                } catch (error) {
                  console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
                  return { success: false, error: error.message };
                }
              });
              
              await Promise.all(removeRoadmapPromises);
            }
            
            // Verificar se vem de outro técnico e deletar da LCMY_REG_ROADMAP
            const fromTechnicianName = modalSnap?.fromTechnicianName;
            const isFromAnotherTechnician = fromTechnicianName && fromTechnicianName !== technicianName;
            if (isFromAnotherTechnician) {
              setDragDropMessage(`Removendo roteirização de ${futuraOrderIds.length} ordem(ns)...`);
              
              const removeRoadmapPromises = futuraOrderIds.map(async (orderId) => {
                try {
                  const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
                    method: 'DELETE',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      orderNumber: orderId
                    })
                  });
                  
                  const result = await response.json();
                  
                  if (!result.success) {
                    console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
                  }
                  return result;
                } catch (error) {
                  console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
                  return { success: false, error: error.message };
                }
              });
              
              await Promise.all(removeRoadmapPromises);
            }
            
            // Se foi marcado "sem data", apenas atualizar status normalmente
            if (noDate) {
              // Verificar se a ordem vem de outro técnico e tinha previsão (precisa remover registro antigo)
              const fromTechnicianName = modalSnap?.fromTechnicianName;
              const isFromAnotherTechnician = fromTechnicianName && fromTechnicianName !== technicianName;
              const isFromFutura = fromGroup === 'FUTURA' || fromGroup === 'Futura';
              
              // Se vem de FUTURA de outro técnico, remover registro antigo
              if (isFromAnotherTechnician && isFromFutura) {
                const fromTechnicianId = getTechnicianIdByName(fromTechnicianName);
                console.log(`🗑️ Removendo registros antigos de LCMY_REG_OS_STANDBY do técnico de origem (${fromTechnicianName}, ID: ${fromTechnicianId})`);
                
                const removePromises = futuraOrderIds.map(async (orderId) => {
                  try {
                    console.log(`🗑️ Removendo standby antigo (sem data): os=${orderId}, id_tech=${fromTechnicianId}`);
                    const removeResponse = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
                      method: 'DELETE',
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        os: orderId,
                        id_tech: fromTechnicianId
                      })
                    });
                    
                    const removeResult = await removeResponse.json();
                    if (!removeResult.success) {
                      console.warn(`⚠️ Aviso ao remover standby antigo para ordem ${orderId}:`, removeResult.message);
                    } else {
                      console.log(`✅ Standby antigo removido para ordem ${orderId}`);
                    }
                    return removeResult;
                  } catch (error) {
                    console.warn(`⚠️ Erro ao remover standby antigo para ordem ${orderId}:`, error);
                    return { success: false, error: error.message };
                  }
                });
                
                await Promise.all(removePromises);
              }
              
              const requestPayload = attachPrevistoGoSyncAck({
                orderIds: futuraOrderIds,
                targetSection: 'FUTURA',
                technicianId: technicianId
              });
              
              const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestPayload)
              });
              
              const result = await response.json();
              
              if (result.success) {
                if (!sessionUserId) {
                  alert('Erro: ID do usuário não encontrado. Por favor, faça login novamente.');
                  return;
                }
                try {
                  setDragDropMessage(`Gravando observações (sem data certa) em ${futuraOrderIds.length} ordem(ns)...`);
                  await Promise.all(
                    futuraOrderIds.map(async (orderId) => {
                      const ins = await fetch(`${API_BASE_URL}/api/orders/add-standby`, {
                        method: 'POST',
                        headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          os: orderId,
                          id_tech: technicianId,
                          schedule: null,
                          id_user: sessionUserId,
                          notes: standbyNotes,
                        }),
                      });
                      const insResult = await ins.json();
                      if (!insResult.success) {
                        throw new Error(insResult.message || `Erro ao gravar OS ${orderId}`);
                      }
                      return insResult;
                    })
                  );
                } catch (e) {
                  console.error(e);
                  // Propaga para o catch externo (modal de status) — FutureDate já foi fechado
                  throw e;
                }

                // Atualizar estado local
                const newTechnicianGroups = { ...technicianGroups };
                const realOrdersData = [];
                
                // Verificar se a ordem vem da coluna "Em Aberto" ou de outro técnico
                const isFromOpenColumn = fromGroup === 'Em Aberto' || fromGroup === 'Em aberto';
                const fromTechnicianNameForNoDate = modalSnap?.fromTechnicianName;
                const isFromAnotherTechnicianForNoDate = fromTechnicianNameForNoDate && fromTechnicianNameForNoDate !== technicianName;
                const fromTechnicianName = modalSnap?.fromTechnicianName; // Técnico de origem quando vem de outro técnico
                const isFromAnotherTechnician = fromTechnicianName && fromTechnicianName !== technicianName;
                
                futuraOrderIds.forEach(orderId => {
                  let orderToMove = null;
                  
                  if (isFromOpenColumn) {
                    // Buscar a ordem na coluna "Em aberto"
                    availableOrdersState.forEach(cityGroup => {
                      cityGroup.ordens.forEach(ordem => {
                        if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                          // Criar objeto completo da ordem
                          orderToMove = {
                            id: ordem.id || ordem.TB02115_CODIGO,
                            cliente: ordem.cliente || ordem.TB01008_NOME,
                            equipamento: ordem.equipamento || ordem.TB01010_NOME,
                            tipo: ordem.tipo || getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA),
                            sla: ordem.sla || getSLAFromCalcRestante(ordem.CALC_RESTANTE, ordem.CALC_PREVISAO),
                            cidade: cityGroup.cidade,
                            pedidoVinculado: ordem.pedidoVinculado,
                            numeroSerie: ordem.numeroSerie,
                            serie: ordem.serie,
                            patrimonio: ordem.patrimonio,
                            endereco: ordem.endereco,
                            dataAbertura: ordem.dataAbertura,
                            tecnico: ordem.tecnico,
                            coordenador: ordem.coordenador,
                            area: ordem.area,
                            bairro: ordem.bairro,
                            estado: ordem.estado,
                            contrato: ordem.contrato,
                            TB02115_CODIGO: ordem.TB02115_CODIGO,
                            TB01008_NOME: ordem.TB01008_NOME,
                            TB01010_NOME: ordem.TB01010_NOME,
                            TB01010_RESUMIDO: ordem.TB01010_RESUMIDO,
                            TB02115_PREVENTIVA: ordem.TB02115_PREVENTIVA,
                            TB02115_BAIRRO: ordem.TB02115_BAIRRO,
                            CALC_RESTANTE: ordem.CALC_RESTANTE,
                            TB01047_NOME: ordem.TB01047_NOME,
                            TB01018_NOME: ordem.TB01018_NOME,
                            TB01073_NOME: ordem.TB01073_NOME,
                            TB02115_CIDADE: ordem.TB02115_CIDADE,
                            TB02115_ESTADO: ordem.TB02115_ESTADO
                          };
                        }
                      });
                    });
                  } else if (isFromAnotherTechnician) {
                    // Buscar a ordem no técnico de origem
                    if (newTechnicianGroups[fromTechnicianName] && newTechnicianGroups[fromTechnicianName][fromGroup]) {
                      const orderIndex = newTechnicianGroups[fromTechnicianName][fromGroup].findIndex(order => order.id === orderId);
                      if (orderIndex !== -1) {
                        orderToMove = newTechnicianGroups[fromTechnicianName][fromGroup][orderIndex];
                        newTechnicianGroups[fromTechnicianName][fromGroup] = newTechnicianGroups[fromTechnicianName][fromGroup].filter(
                          order => order.id !== orderId
                        );
                      }
                    }
                  } else {
                    // Buscar a ordem no grupo do mesmo técnico
                    if (newTechnicianGroups[technicianName] && newTechnicianGroups[technicianName][fromGroup]) {
                      const orderIndex = newTechnicianGroups[technicianName][fromGroup].findIndex(order => order.id === orderId);
                      if (orderIndex !== -1) {
                        orderToMove = newTechnicianGroups[technicianName][fromGroup][orderIndex];
                        newTechnicianGroups[technicianName][fromGroup] = newTechnicianGroups[technicianName][fromGroup].filter(
                          order => order.id !== orderId
                        );
                      }
                    }
                  }
                  
                  if (orderToMove) {
                    if (!newTechnicianGroups[technicianName]) {
                      newTechnicianGroups[technicianName] = {
                        'Em deslocamento': [],
                        'Em serviço': [],
                        'Previsto para hoje': [],
                        'Previstas para amanhã': [],
                        'FUTURA': []
                      };
                    }
                    if (!newTechnicianGroups[technicianName]['FUTURA']) {
                      newTechnicianGroups[technicianName]['FUTURA'] = [];
                    }
                    newTechnicianGroups[technicianName]['FUTURA'].push(orderToMove);
                    realOrdersData.push(orderToMove);
                  }
                });
                
                // Se veio da coluna "Em aberto", remover de lá também
                if (isFromOpenColumn) {
                  const newAvailableOrders = availableOrdersState.map(item => ({
                    ...item,
                    ordens: item.ordens.filter(ordem => 
                      !futuraOrderIds.includes(ordem.id || ordem.TB02115_CODIGO)
                    )
                  })).filter(item => item.ordens.length > 0);
                  
                  setAvailableOrdersState(newAvailableOrders);
                }
                
                setTechnicianGroups(newTechnicianGroups);
                setSelectedOrders([]);
                if (futuraSpecialtyRejected.length > 0) {
                  setOrderStatusResults(futuraSpecialtyRejected.map((oid) => ({
                    orderId: oid,
                    status: 'error',
                    errorMessage: BOARD_SPECIALTY_DRAG_MSG,
                    cliente: 'N/A',
                    tecnico: technicianName,
                    targetSection: 'FUTURA'
                  })));
                  setOrderStatusSummary({
                    targetSection: 'FUTURA',
                    technicianName
                  });
                  setShowOrderStatusModal(true);
                }
              } else {
                // update-status falhou (sem data certa)
                if (result.blocked && Array.isArray(result.messages) && result.messages.length > 0) {
                  setBoardDragValidationMessages(result.messages);
                  setShowBoardDragValidationModal(true);
                } else {
                  const errorResults = futuraOrderIds.map((orderId) => ({
                    orderId,
                    status: 'error',
                    errorMessage: result.message || 'Erro ao mover para FUTURA',
                    cliente: 'N/A',
                    tecnico: technicianName,
                    targetSection: 'FUTURA'
                  }));
                  setOrderStatusResults(errorResults);
                  setOrderStatusSummary({
                    targetSection: 'FUTURA',
                    technicianName
                  });
                  setShowOrderStatusModal(true);
                }
              }
            } else {
              // Se há data, inserir na tabela LCMY_REG_OS_STANDBY
              if (!sessionUserId) {
                console.error('❌ ID do usuário não encontrado na sessão');
                alert('Erro: ID do usuário não encontrado. Por favor, faça login novamente.');
                setIsDragDropProcessing(false);
                return;
              }

              // Converter data para formato datetime sem problemas de timezone
              // O input type="date" retorna no formato YYYY-MM-DD
              // Criar data em UTC para evitar problemas de fuso horário
              const [year, month, day] = date.split('-').map(Number);
              const scheduleDateUTC = new Date(Date.UTC(year, month - 1, day, 12, 0, 0, 0)); // Usar meio-dia UTC para evitar problemas de timezone
              
              // Enviar no formato ISO string (ja em UTC)
              const scheduleISOString = scheduleDateUTC.toISOString();

              // Roteirizada (hoje ou amanhã) → FUTURA com data: limpar LCMY_REG_ROADMAP
              if (fromGroup === 'Previstas para amanhã' || fromGroup === 'Previsto para hoje') {
                setDragDropMessage(`Removendo roteirização de ${futuraOrderIds.length} ordem(ns)...`);
                
                const removeRoadmapPromises = futuraOrderIds.map(async (orderId) => {
                  try {
                    const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
                      method: 'DELETE',
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        orderNumber: orderId
                      })
                    });
                    
                    const result = await response.json();
                    
                    if (!result.success) {
                      console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
                    }
                    return result;
                  } catch (error) {
                    console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
                    return { success: false, error: error.message };
                  }
                });
                
                await Promise.all(removeRoadmapPromises);
              }
              
              // Verificar se a ordem vem de outro técnico e tinha previsão (precisa remover registro antigo)
              const fromTechnicianName = modalSnap?.fromTechnicianName;
              const isFromAnotherTechnician = fromTechnicianName && fromTechnicianName !== technicianName;
              const isFromFutura = fromGroup === 'FUTURA' || fromGroup === 'Futura';
              
              // Se vem de outro técnico, deletar da LCMY_REG_ROADMAP
              if (isFromAnotherTechnician) {
                setDragDropMessage(`Removendo roteirização de ${futuraOrderIds.length} ordem(ns)...`);
                
                const removeRoadmapPromises = futuraOrderIds.map(async (orderId) => {
                  try {
                    const response = await fetch(`${API_BASE_URL}/api/route/remove-order-by-os`, {
                      method: 'DELETE',
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        orderNumber: orderId
                      })
                    });
                    
                    const result = await response.json();
                    
                    if (!result.success) {
                      console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, result.message);
                    }
                    return result;
                  } catch (error) {
                    console.error(`❌ Erro ao remover roteirização para ordem ${orderId}:`, error);
                    return { success: false, error: error.message };
                  }
                });
                
                await Promise.all(removeRoadmapPromises);
              }
              
              // Se vem de FUTURA (de outro técnico ou do mesmo técnico), remover registro antigo antes de inserir novo
              // Isso garante que não haja duplicidade de registros na tabela LCMY_REG_OS_STANDBY
              if (isFromFutura) {
                let technicianIdToRemove = null;
                
                if (isFromAnotherTechnician) {
                  // Vem de outro técnico - remover do técnico de origem
                  technicianIdToRemove = getTechnicianIdByName(fromTechnicianName);
                  console.log(`🗑️ Removendo registros antigos de LCMY_REG_OS_STANDBY do técnico de origem (${fromTechnicianName}, ID: ${technicianIdToRemove})`);
                } else {
                  // Vem do mesmo técnico (mudando apenas a data) - remover do mesmo técnico
                  technicianIdToRemove = technicianId;
                  console.log(`🗑️ Removendo registros antigos de LCMY_REG_OS_STANDBY do mesmo técnico (${technicianName}, ID: ${technicianIdToRemove}) para atualizar previsão`);
                }
                
                const removePromises = futuraOrderIds.map(async (orderId) => {
                  try {
                    console.log(`🗑️ Removendo standby antigo: os=${orderId}, id_tech=${technicianIdToRemove}`);
                    const removeResponse = await fetch(`${API_BASE_URL}/api/orders/remove-standby`, {
                      method: 'DELETE',
                      headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        os: orderId,
                        id_tech: technicianIdToRemove
                      })
                    });
                    
                    const removeResult = await removeResponse.json();
                    console.log(`📋 Resposta da remoção para ordem ${orderId}:`, removeResult);
                    
                    if (!removeResult.success) {
                      console.warn(`⚠️ Aviso ao remover standby antigo para ordem ${orderId}:`, removeResult.message);
                      // Não lançar erro, apenas avisar, pois pode não existir registro antigo
                    } else {
                      console.log(`✅ Standby antigo removido para ordem ${orderId}, linhas afetadas: ${removeResult.rowsAffected}`);
                    }
                    return removeResult;
                  } catch (error) {
                    console.warn(`⚠️ Erro ao remover standby antigo para ordem ${orderId}:`, error);
                    // Não lançar erro, apenas avisar
                    return { success: false, error: error.message };
                  }
                });
                
                await Promise.all(removePromises);
                console.log('✅ Remoção de registros antigos concluída');
              }
              
              // Inserir cada ordem na tabela
              const insertPromises = futuraOrderIds.map(async (orderId, index) => {
                setDragDropProgress({ current: index + 1, total: futuraOrderIds.length });
                setDragDropMessage(`Inserindo ordem ${orderId}...`);
                
                const response = await fetch(`${API_BASE_URL}/api/orders/add-standby`, {
                  method: 'POST',
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    os: orderId,
                    id_tech: technicianId,
                    schedule: scheduleISOString,
                    id_user: sessionUserId,
                    notes: standbyNotes
                  })
                });
                
                const result = await response.json();
                if (!result.success) {
                  console.error(`❌ Erro ao inserir ordem ${orderId}:`, result.message);
                  throw new Error(`Erro ao inserir ordem ${orderId}: ${result.message}`);
                }
                return result;
              });
              
              // Aguardar todas as inserções
              await Promise.all(insertPromises);
              
              // Atualizar status normalmente também
              const requestPayload = attachPrevistoGoSyncAck({
                orderIds: futuraOrderIds,
                targetSection: 'FUTURA',
                technicianId: technicianId
              });
              
              const response = await fetch(`${API_BASE_URL}/api/orders/update-status`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestPayload)
              });
              
              const result = await response.json();
              
              if (result.success) {
                // Atualizar estado local
                const newTechnicianGroups = { ...technicianGroups };
                const realOrdersData = [];
                
                // Criar data de schedule no formato correto (YYYY-MM-DD) para evitar problemas de timezone
                // Usar a mesma data que foi enviada ao backend
                const scheduleDateString = date; // date já está no formato YYYY-MM-DD
                
                // Verificar se a ordem vem da coluna "Em Aberto" ou de outro técnico
                const isFromOpenColumn = fromGroup === 'Em Aberto' || fromGroup === 'Em aberto';
                const fromTechnicianName = modalSnap?.fromTechnicianName; // Técnico de origem quando vem de outro técnico
                const isFromAnotherTechnician = fromTechnicianName && fromTechnicianName !== technicianName;
                
                futuraOrderIds.forEach(orderId => {
                  let orderToMove = null;
                  
                  if (isFromOpenColumn) {
                    // Buscar a ordem na coluna "Em aberto"
                    availableOrdersState.forEach(cityGroup => {
                      cityGroup.ordens.forEach(ordem => {
                        if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                          // Criar objeto completo da ordem
                          orderToMove = {
                            id: ordem.id || ordem.TB02115_CODIGO,
                            cliente: ordem.cliente || ordem.TB01008_NOME,
                            equipamento: ordem.equipamento || ordem.TB01010_NOME,
                            tipo: ordem.tipo || getServiceTypeFromPreventiva(ordem.TB02115_PREVENTIVA),
                            sla: ordem.sla || getSLAFromCalcRestante(ordem.CALC_RESTANTE, ordem.CALC_PREVISAO),
                            cidade: cityGroup.cidade,
                            pedidoVinculado: ordem.pedidoVinculado,
                            numeroSerie: ordem.numeroSerie,
                            serie: ordem.serie,
                            patrimonio: ordem.patrimonio,
                            endereco: ordem.endereco,
                            dataAbertura: ordem.dataAbertura,
                            tecnico: ordem.tecnico,
                            coordenador: ordem.coordenador,
                            area: ordem.area,
                            bairro: ordem.bairro,
                            estado: ordem.estado,
                            contrato: ordem.contrato,
                            schedule: scheduleDateString, // Incluir schedule no formato YYYY-MM-DD
                            TB02115_CODIGO: ordem.TB02115_CODIGO,
                            TB01008_NOME: ordem.TB01008_NOME,
                            TB01010_NOME: ordem.TB01010_NOME,
                            TB01010_RESUMIDO: ordem.TB01010_RESUMIDO,
                            TB02115_PREVENTIVA: ordem.TB02115_PREVENTIVA,
                            TB02115_BAIRRO: ordem.TB02115_BAIRRO,
                            CALC_RESTANTE: ordem.CALC_RESTANTE,
                            TB01047_NOME: ordem.TB01047_NOME,
                            TB01018_NOME: ordem.TB01018_NOME,
                            TB01073_NOME: ordem.TB01073_NOME,
                            TB02115_CIDADE: ordem.TB02115_CIDADE,
                            TB02115_ESTADO: ordem.TB02115_ESTADO
                          };
                        }
                      });
                    });
                  } else if (isFromAnotherTechnician) {
                    // Buscar a ordem no técnico de origem
                    if (newTechnicianGroups[fromTechnicianName] && newTechnicianGroups[fromTechnicianName][fromGroup]) {
                      const orderIndex = newTechnicianGroups[fromTechnicianName][fromGroup].findIndex(order => order.id === orderId);
                      if (orderIndex !== -1) {
                        orderToMove = { ...newTechnicianGroups[fromTechnicianName][fromGroup][orderIndex] };
                        // Adicionar schedule ao objeto existente
                        orderToMove.schedule = scheduleDateString;
                        newTechnicianGroups[fromTechnicianName][fromGroup] = newTechnicianGroups[fromTechnicianName][fromGroup].filter(
                          order => order.id !== orderId
                        );
                      }
                    }
                  } else {
                    // Buscar a ordem no grupo do mesmo técnico
                    if (newTechnicianGroups[technicianName] && newTechnicianGroups[technicianName][fromGroup]) {
                      const orderIndex = newTechnicianGroups[technicianName][fromGroup].findIndex(order => order.id === orderId);
                      if (orderIndex !== -1) {
                        orderToMove = { ...newTechnicianGroups[technicianName][fromGroup][orderIndex] };
                        // Adicionar schedule ao objeto existente
                        orderToMove.schedule = scheduleDateString;
                        newTechnicianGroups[technicianName][fromGroup] = newTechnicianGroups[technicianName][fromGroup].filter(
                          order => order.id !== orderId
                        );
                      }
                    }
                  }
                  
                  if (orderToMove) {
                    if (!newTechnicianGroups[technicianName]) {
                      newTechnicianGroups[technicianName] = {
                        'Em deslocamento': [],
                        'Em serviço': [],
                        'Previsto para hoje': [],
                        'Previstas para amanhã': [],
                        'FUTURA': []
                      };
                    }
                    if (!newTechnicianGroups[technicianName]['FUTURA']) {
                      newTechnicianGroups[technicianName]['FUTURA'] = [];
                    }
                    newTechnicianGroups[technicianName]['FUTURA'].push(orderToMove);
                    realOrdersData.push(orderToMove);
                  }
                });
                
                // Se veio da coluna "Em aberto", remover de lá também
                if (isFromOpenColumn) {
                  const newAvailableOrders = availableOrdersState.map(item => ({
                    ...item,
                    ordens: item.ordens.filter(ordem => 
                      !futuraOrderIds.includes(ordem.id || ordem.TB02115_CODIGO)
                    )
                  })).filter(item => item.ordens.length > 0);
                  
                  setAvailableOrdersState(newAvailableOrders);
                }
                
                setTechnicianGroups(newTechnicianGroups);
                setSelectedOrders([]);
                
                // Preparar dados para o modal de confirmação
                const orderResults = [];
                
                // Processar resultados do backend
                if (result.data && result.data.results && Array.isArray(result.data.results)) {
                  // Processar resultados de sucesso
                  result.data.results.forEach(item => {
                    // Buscar informações da ordem
                    let cliente = 'N/A';
                    let tecnicoOrigem = null;
                    
                    // Buscar informações nos grupos de técnicos
                    Object.keys(technicianGroups).forEach(techName => {
                      Object.keys(technicianGroups[techName] || {}).forEach(sectionName => {
                        const order = technicianGroups[techName][sectionName]?.find(o => o.id === item.orderId);
                        if (order) {
                          cliente = order.cliente || order.TB01008_NOME || 'N/A';
                          if (isFromAnotherTechnician) {
                            tecnicoOrigem = fromTechnicianName;
                          }
                        }
                      });
                    });
                    
                    // Se não encontrou, buscar na coluna "Em aberto"
                    if (cliente === 'N/A') {
                      availableOrdersState.forEach(cityGroup => {
                        cityGroup.ordens.forEach(ordem => {
                          if ((ordem.id || ordem.TB02115_CODIGO) === item.orderId) {
                            cliente = ordem.cliente || ordem.TB01008_NOME || 'N/A';
                          }
                        });
                      });
                    }
                    
                    orderResults.push({
                      orderId: item.orderId,
                      status: 'success',
                      errorMessage: null,
                      cliente: cliente,
                      tecnico: tecnicoOrigem || 'N/A',
                      targetSection: 'FUTURA'
                    });
                  });
                }
                
                // Processar erros do backend
                if (result.data && result.data.errors && Array.isArray(result.data.errors)) {
                  result.data.errors.forEach(item => {
                    orderResults.push({
                      orderId: item.orderId,
                      status: 'error',
                      errorMessage: item.error,
                      cliente: 'N/A',
                      tecnico: isFromAnotherTechnician ? fromTechnicianName : 'N/A',
                      targetSection: 'FUTURA'
                    });
                  });
                }
                
                // Se não há resultados estruturados, criar baseado no sucesso geral
                if (orderResults.length === 0 && result.success) {
                  futuraOrderIds.forEach(orderId => {
                    let cliente = 'N/A';
                    let tecnicoOrigem = null;
                    
                    // Buscar informações nos grupos de técnicos
                    Object.keys(technicianGroups).forEach(techName => {
                      Object.keys(technicianGroups[techName] || {}).forEach(sectionName => {
                        const order = technicianGroups[techName][sectionName]?.find(o => o.id === orderId);
                        if (order) {
                          cliente = order.cliente || order.TB01008_NOME || 'N/A';
                          if (isFromAnotherTechnician) {
                            tecnicoOrigem = fromTechnicianName;
                          }
                        }
                      });
                    });
                    
                    // Se não encontrou, buscar na coluna "Em aberto"
                    if (cliente === 'N/A') {
                      availableOrdersState.forEach(cityGroup => {
                        cityGroup.ordens.forEach(ordem => {
                          if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                            cliente = ordem.cliente || ordem.TB01008_NOME || 'N/A';
                          }
                        });
                      });
                    }
                    
                    orderResults.push({
                      orderId: orderId,
                      status: 'success',
                      errorMessage: null,
                      cliente: cliente,
                      tecnico: tecnicoOrigem || 'N/A',
                      targetSection: 'FUTURA'
                    });
                  });
                }
                
                const specialtyRowsFutura = futuraSpecialtyRejected.map((oid) => ({
                  orderId: oid,
                  status: 'error',
                  errorMessage: BOARD_SPECIALTY_DRAG_MSG,
                  cliente: 'N/A',
                  tecnico: technicianName,
                  targetSection: 'FUTURA'
                }));

                // Mostrar modal de confirmação
                if (orderResults.length > 0 || specialtyRowsFutura.length > 0) {
                  setOrderStatusResults([...orderResults, ...specialtyRowsFutura]);
                  setOrderStatusSummary({
                    targetSection: 'FUTURA',
                    technicianName: technicianName
                  });
                  setShowOrderStatusModal(true);
                }
              } else {
                // Se houve erro, preparar resultados de erro
                if (result.blocked && Array.isArray(result.messages) && result.messages.length > 0) {
                  setBoardDragValidationMessages(result.messages);
                  setShowBoardDragValidationModal(true);
                } else {
                const errorResults = futuraOrderIds.map(orderId => {
                  let cliente = 'N/A';
                  
                  // Buscar informações da ordem
                  Object.keys(technicianGroups).forEach(techName => {
                    Object.keys(technicianGroups[techName] || {}).forEach(sectionName => {
                      const order = technicianGroups[techName][sectionName]?.find(o => o.id === orderId);
                      if (order) {
                        cliente = order.cliente || order.TB01008_NOME || 'N/A';
                      }
                    });
                  });
                  
                  if (cliente === 'N/A') {
                    availableOrdersState.forEach(cityGroup => {
                      cityGroup.ordens.forEach(ordem => {
                        if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                          cliente = ordem.cliente || ordem.TB01008_NOME || 'N/A';
                        }
                      });
                    });
                  }
                  
                  return {
                    orderId: orderId,
                    status: 'error',
                    errorMessage: result.message || 'Erro desconhecido',
                    cliente: cliente,
                    tecnico: isFromAnotherTechnician ? fromTechnicianName : 'N/A',
                    targetSection: 'FUTURA'
                  };
                });
                
                setOrderStatusResults(errorResults);
                setOrderStatusSummary({
                  targetSection: 'FUTURA',
                  technicianName: technicianName
                });
                setShowOrderStatusModal(true);
                }
              }
            }
            
            // Fechar modal de previsão
            setShowFutureDateModal(false);
            setFutureDateModalData(null);
            setSelectedFutureDate(null);
            setNoDateSelected(false);
            
          } catch (error) {
            console.error('❌ Erro ao processar ordens:', error);
            
            // Preparar resultados de erro para o modal
            const errorResults = futuraOrderIds.map(orderId => {
              let cliente = 'N/A';
              
              // Buscar informações da ordem
              Object.keys(technicianGroups).forEach(techName => {
                Object.keys(technicianGroups[techName] || {}).forEach(sectionName => {
                  const order = technicianGroups[techName][sectionName]?.find(o => o.id === orderId);
                  if (order) {
                    cliente = order.cliente || order.TB01008_NOME || 'N/A';
                  }
                });
              });
              
              if (cliente === 'N/A') {
                availableOrdersState.forEach(cityGroup => {
                  cityGroup.ordens.forEach(ordem => {
                    if ((ordem.id || ordem.TB02115_CODIGO) === orderId) {
                      cliente = ordem.cliente || ordem.TB01008_NOME || 'N/A';
                    }
                  });
                });
              }
              
              return {
                orderId: orderId,
                status: 'error',
                errorMessage: error.message || 'Erro desconhecido',
                cliente: cliente,
                tecnico: modalSnap?.fromTechnicianName || 'N/A',
                targetSection: 'FUTURA'
              };
            });
            
            setOrderStatusResults(errorResults);
            setOrderStatusSummary({
              targetSection: 'FUTURA',
              technicianName: technicianName
            });
            setShowOrderStatusModal(true);
          } finally {
            setIsDragDropProcessing(false);
          }
        })}
      />

      <UserProfileModal
        isOpen={showUserProfileModal}
        onClose={() => setShowUserProfileModal(false)}
        currentUser={currentUser}
        onSaved={(updates) => {
          setCurrentUser((prev) => {
            const next = { ...prev, ...updates };
            try {
              const stored = JSON.parse(localStorage.getItem('userData') || '{}');
              localStorage.setItem('userData', JSON.stringify({ ...stored, ...updates }));
            } catch (_) { /* ignore */ }
            return next;
          });
        }}
      />

      {/* Modal de carregamento para atualização de dados (apenas quando não for automática) */}
      {/* Garantir que o modal NUNCA apareça durante auto-refresh */}
      <RefreshLoadingModal 
        isOpen={isRefreshing && !isAutoRefreshing}
        progress={refreshProgress}
      />

      <BoardTechnicianViewModal
        open={showTechnicianViewModal}
        onClose={() => setShowTechnicianViewModal(false)}
        technicianCount={boardVisibleTechnicians.length}
        currentStackSize={getTechnicianStackGroupSize(technicianColumnStacks)}
        openColumnCollapsed={openColumnCollapsed}
        onApply={({ stackSize, minimizeOpenColumn }) => {
          const nextSize = normalizeTechnicianColumnStack(stackSize);
          if (nextSize >= 3) {
            setTechnicianColumnStacks(applyVerticalGroupStacks(boardVisibleTechnicians, 3));
          } else if (nextSize === 2) {
            setTechnicianColumnStacks(applyVerticalGroupStacks(boardVisibleTechnicians, 2));
          } else {
            setTechnicianColumnStacks({});
          }
          setOpenColumnCollapsed(minimizeOpenColumn);
          setCurrentUser((prev) => {
            if (!prev) return prev;
            const next = {
              ...prev,
              technician_column_stack: nextSize,
              open_column_minimized: minimizeOpenColumn ? 1 : 0,
            };
            try {
              localStorage.setItem('userData', JSON.stringify(next));
            } catch (_) { /* ignore */ }
            return next;
          });
          persistBoardViewPrefs(API_BASE_URL, {
            technician_column_stack: nextSize,
            open_column_minimized: minimizeOpenColumn ? 1 : 0,
          });
        }}
      />

      <BoardFiltrarSLAModal
        open={showFiltrarSLAModal}
        onClose={() => setShowFiltrarSLAModal(false)}
        filterActive={!!slaFiltrarConfig}
        onApply={(cfg) => {
          setSlaFiltrarLoading(true);
          setSlaFiltrarConfig(cfg);
        }}
        onClear={() => setSlaFiltrarConfig(null)}
      />

      {/* Modal de Abrir OS - Versão Migrada */}
      <EquipmentConsultSearchModal
        key={equipmentConsultSearchMountKey}
        open={showEquipmentConsultSearchModal}
        onClose={() => setShowEquipmentConsultSearchModal(false)}
        onSelectEquipment={(suggestion) => {
          setShowEquipmentConsultSearchModal(false);
          setEquipmentConsultSelection({
            serie: suggestion.serie,
            patrimonio: suggestion.patrimonio,
            produto: suggestion.produto
          });
          setShowEquipmentConsultDetailModal(true);
        }}
      />
      <EquipmentConsultDetailModal
        open={showEquipmentConsultDetailModal}
        selection={equipmentConsultSelection}
        onClose={() => {
          setShowEquipmentConsultDetailModal(false);
          setEquipmentConsultSelection(null);
        }}
      />

      <CheckoutViewModal
        isOpen={showCheckoutModal}
        onClose={() => setShowCheckoutModal(false)}
      />
      
      {/* NOTA: Modal antigo removido completamente após validação final */}
      {/* O código foi migrado para features/new-os/components/OpenOSModal.js */}
      {/* Bloco removido: ~4670 linhas de código comentado */}
      
      {/* Overlay de exclusão de OS (Board) */}
      <BoardOrderDeleteOverlay
        visible={deleteOverlay.visible}
        status={deleteOverlay.status}
        message={deleteOverlay.message}
        onDismiss={() => setDeleteOverlay({ visible: false, status: 'loading', message: '' })}
      />

      {/* Menu de contexto para ordens (Em aberto e colunas de técnicos) */}
      {contextMenu && (() => {
        // Ordens a mover em "Alterar técnico": só as selecionadas que estão na mesma coluna do técnico do contexto
        const orderIdsToMove = contextMenu.source === 'technician' && contextMenu.technician
          ? (() => {
              const groups = technicianGroupsRef.current ?? technicianGroups;
              const order = columnOrderRef.current ?? columnOrder;
              const resolveKey = (name) => {
                const n = normalizeTechnicianName(name);
                const k = Object.keys(groups || {}).find(key => normalizeTechnicianName(key) === n);
                if (k) return k;
                const col = (order || []).find(t => normalizeTechnicianName(t) === n);
                return col || name;
              };
              const techKey = resolveKey(contextMenu.technician);
              const techData = groups?.[techKey];
              if (!techData) return [contextMenu.orderId];
              const matchOrder = (o, id) => String(o.id) === String(id) || String(o.TB02115_CODIGO) === String(id);
              const inColumn = selectedOrders.filter(orderId =>
                Object.values(techData).some(arr => Array.isArray(arr) && arr.some(o => matchOrder(o, orderId)))
              );
              return inColumn.length > 0 ? inColumn : [contextMenu.orderId];
            })()
          : contextMenu.source === 'open'
            ? (() => {
                const isContextSelected = selectedOrders.some((id) => String(id) === String(contextMenu.orderId));
                return isContextSelected && selectedOrders.length > 0 ? selectedOrders : [contextMenu.orderId];
              })()
          : [contextMenu.orderId];
        const areasForContextMove = (areasWithTechniciansForContextMenu || [])
          .map((area) => {
            if (contextMenu.source === 'open') {
              return {
                ...area,
                technicians: (area.technicians || []).filter((name) => Boolean(name && String(name).trim())),
              };
            }
            return {
              ...area,
              technicians: (area.technicians || []).filter((name) => {
                if (!name) return false;
                const normalizedName = String(name).trim().toLowerCase();
                const normalizedCurrent = String(contextMenu.technician || '').trim().toLowerCase();
                return normalizedName && normalizedName !== normalizedCurrent;
              }),
            };
          })
          .filter((area) => (area.technicians || []).length > 0);

        const boardContextMenuPrimary = [
          {
            id: 'ver-detalhe',
            label: 'Ver detalhe',
            icon: 'bi bi-layout-text-window-reverse',
            onClick: () => handleOpenOrderDetailsV2FromContext(
              contextMenu.orderId,
              contextMenu,
              setSelectedOrderForDetailsMock
            ),
          },
          ...(Number(currentUser?.asstec_deleteos) === 1
            ? [{
                id: 'excluir-os',
                label: 'Excluir OS',
                icon: 'bi bi-trash',
                variant: 'destructive',
                disabled: contextMenu.source === 'technician' && isExcluirOSDisabledForGroup(contextMenu.groupName),
                onClick: () => handleExcluirOS(contextMenu.orderId, contextMenu.source, contextMenu.technician, contextMenu.groupName),
              }]
            : []),
          ...(contextMenu.source === 'technician' && contextMenu.groupName === 'FUTURA'
            ? [{
                id: 'reprogramar-previsao',
                label: 'Reprogramar previsão',
                icon: 'bi bi-calendar3',
                onClick: () => handleReprogramarPrevisao(contextMenu.orderId, contextMenu.technician, contextMenu.groupName),
              }]
            : []),
        ];
        const boardContextMenuMoves = [
          ...(contextMenu.source === 'open' && areasWithTechniciansForContextMenu?.length > 0
            ? [{
                id: 'encaminhar-chamado-em-aberto',
                label: 'Encaminhar chamado',
                iconNode: <Forward size={14} strokeWidth={2} aria-hidden />,
                onClick: () => {
                  closeBoardOrderContextMenu();
                  setBoardEncaminharFlow({
                    orderIds: orderIdsToMove.map((id) => String(id)),
                    source: 'open',
                    fromTechnician: contextMenu.technician || '',
                    fromGroup: contextMenu.groupName || 'Em Aberto',
                  });
                },
              }]
            : []),
          ...((contextMenu.source === 'technician' || contextMenu.source === 'open') && areasWithTechniciansForContextMenu?.length > 0
            ? [getAlterarTecnicoMenuItem({
                areasWithTechnicians: areasForContextMove,
                orderIds: orderIdsToMove,
                fromTechnician: contextMenu.technician,
                fromGroup: contextMenu.groupName,
                onMoveOrder: (orderIds, fromTech, fromGroup, toTech, toGroupName) => {
                  if (contextMenu.source === 'open') {
                    closeBoardOrderContextMenu();
                    handleDropToTechnique(toTech, toGroupName, orderIds);
                    return;
                  }
                  handleMoveOrderContextMenu(orderIds, fromTech, fromGroup, toTech, toGroupName);
                },
                onOpenFutureModal: handleOpenFutureModalContextMenu,
                // Sem multi-seleção: usa a OS do botão direito (orderIdsToMove já faz fallback)
                disabled: false,
              })]
            : []),
        ];
        const boardContextMenuItems = [
          ...boardContextMenuPrimary,
          ...(boardContextMenuMoves.length
            ? [{ id: 'sep-board-context-moves', type: 'separator' }, ...boardContextMenuMoves]
            : []),
        ];

        return (
          <BoardOrderContextMenu
            visible={!!contextMenu}
            x={contextMenu.x}
            y={contextMenu.y}
            portalRoot={typeof document !== 'undefined' ? document.body : null}
            submenuGap={0}
            onClose={closeBoardOrderContextMenu}
            items={boardContextMenuItems}
          />
        );
      })()}

      <BoardEncaminharAgendaOverlay
        open={Boolean(boardEncaminharFlow)}
        hideApenasTecnico={Boolean(boardEncaminharFlow?.chatConversationId)}
        overlayZIndex={selectedOrderForDetailsMock ? 100050 : undefined}
        excludeTechnicianName={
          boardEncaminharFlow?.source === 'technician'
            ? boardEncaminharFlow?.fromTechnician
            : ''
        }
        orderIds={boardEncaminharFlow?.orderIds || []}
        scheduleOriginAddress={boardEncaminharRouteOrigin.address}
        scheduleOriginCity={boardEncaminharRouteOrigin.city}
        onClose={() => setBoardEncaminharFlow(null)}
        onConfirm={async ({ technicianName, technicianId, scheduleType, groupName, scheduleDate, semPrevisao, standbyNotes }) => {
          const flow = boardEncaminharFlow;
          const orderIds = flow?.orderIds || [];
          if (!technicianName || !orderIds.length) {
            setBoardEncaminharFlow(null);
            return;
          }
          const fromTechnician = flow?.fromTechnician || '';
          const fromGroup = flow?.fromGroup || (flow?.source === 'technician' ? 'Previsto para hoje' : 'Em Aberto');
          const isFromTechnician = flow?.source === 'technician' && fromTechnician;
          const chatConversationId = flow?.chatConversationId
            ? String(flow.chatConversationId)
            : null;
          const chatOsId = chatConversationId ? String(orderIds[0] || '').trim() : '';
          setBoardEncaminharFlow(null);
          if (scheduleType === 'future') {
            const snap = {
              technicianName,
              technicianId: technicianId || getTechnicianIdByName(technicianName),
              orderIds: [...orderIds],
              fromGroup: fromGroup || 'Em Aberto',
              chatConversationId,
            };
            if (isFromTechnician) snap.fromTechnicianName = fromTechnician;
            setSelectedOrders([]);
            await futureDateConfirmRef.current?.(
              semPrevisao ? null : (scheduleDate || null),
              Boolean(semPrevisao),
              standbyNotes || '',
              snap
            );
            return;
          }
          if (isFromTechnician) {
            handleMoveOrderContextMenu(orderIds, fromTechnician, fromGroup, technicianName, groupName);
          } else {
            await handleDropToTechnique(technicianName, groupName, orderIds);
          }
          if (chatConversationId && chatOsId) {
            try {
              await patchConversationOs(chatConversationId, chatOsId, {
                status: 'forwarded',
              });
              notifyConversationOsUpdated(chatConversationId, chatOsId, 'forwarded');
            } catch {
              /* silencioso */
            }
          }
        }}
      />
      
      {isInitialLoading && (
        <div
          className="post-login-loading-overlay post-login-loading-overlay--steps-only"
          role="alertdialog"
          aria-busy="true"
          aria-label="Carregando dados"
        >
          <div className="post-login-loading-content">
            <LoadingStepsList
              className="post-login-loading-steps"
              steps={loadingSteps.map((step) => ({
                id: step.id,
                label: step.name,
                status: mapAppLoadingStepStatus(step.status),
              }))}
            />
            {loadingHasError && loadingErrorMessage && (
              <p className="post-login-loading-error">{loadingErrorMessage}</p>
            )}
          </div>
        </div>
      )}
      {boardCellTooltip && ReactDOM.createPortal(
        <div
          className="board-cell-tooltip-portal"
          style={{
            position: 'fixed',
            left: boardCellTooltip.x,
            top: boardCellTooltip.y,
            transform: 'translateX(-50%)',
            zIndex: 99999,
            pointerEvents: 'none',
          }}
        >
          <span className="board-cell-tooltip-arrow" />
          <span className="board-cell-tooltip-text">{boardCellTooltip.text}</span>
        </div>,
        document.body
      )}
      <FuturaDateFilterPeriodPortal />
    </>
  );
}

export default App;
